/*
* @license
* Palo Alto Theme (c)
*
* This file is included for advanced development by
* Shopify Agencies.  Modified versions of the theme
* code are not supported by Shopify or Presidio Creative.
*
* In order to use this file you will need to change
* theme.js to theme.dev.js in /layout/theme.liquid
*
*/
(function(scrollLock, Flickity, themeCurrency, Ajaxinate) {
    'use strict';
    (function() {
        const env = {
            "NODE_ENV": "production"
        };
        try {
            if (process) {
                process.env = Object.assign({}, process.env);
                Object.assign(process.env, env);
                return
            }
        } catch (e) {}
        globalThis.process = {
            env: env
        }
    }
    )();
    window.theme = window.theme || {};
    window.theme.sizes = {
        mobile: 480,
        small: 768,
        large: 1024,
        widescreen: 1440,
    };
    window.theme.keyboardKeys = {
        TAB: 'Tab',
        ENTER: 'Enter',
        NUMPADENTER: 'NumpadEnter',
        ESCAPE: 'Escape',
        SPACE: 'Space',
        LEFTARROW: 'ArrowLeft',
        RIGHTARROW: 'ArrowRight',
    };
    window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function debounce(fn, time) {
        let timeout;
        return function() {
            if (fn) {
                const functionCall = () => fn.apply(this, arguments);
                clearTimeout(timeout);
                timeout = setTimeout(functionCall, time)
            }
        }
    }
    const selectors$1e = {
        body: 'body',
        main: '[data-main]',
        header: '[data-site-header]',
        preventTransparentHeader: '[data-prevent-transparent-header]',
    };
    const classes$11 = {
        supportsTransparentHeader: 'supports-transparent-header',
        siteHeaderTransparent: 'site-header--transparent',
        isFirstSectionTransparent: 'is-first-section-transparent',
    };
    const attributes$Q = {
        transparent: 'data-transparent',
    };
    const initTransparentHeader = () => {
        const body = document.querySelector(selectors$1e.body);
        const header = body.querySelector(selectors$1e.header);
        if (!header)
            return;
        const headerTransparent = header.getAttribute(attributes$Q.transparent) === 'true';
        const firstSection = body.querySelector(selectors$1e.main).children[0];
        if (!firstSection)
            return;
        const preventTransparentHeader = firstSection.querySelector(`${selectors$1e.preventTransparentHeader}:first-of-type`);
        window.isHeaderTransparent = headerTransparent && firstSection.classList.contains(classes$11.supportsTransparentHeader) && !preventTransparentHeader;
        const supportsHasSelector = CSS.supports('(selector(:has(*)))');
        if (!supportsHasSelector) {
            body.classList.toggle(classes$11.isFirstSectionTransparent, window.isHeaderTransparent);
            header.classList.toggle(classes$11.siteHeaderTransparent, window.isHeaderTransparent)
        }
    }
    ;
    const selectors$1d = {
        footerParallax: '.section-footer--parallax',
        footerParallaxInner: '[data-section-type]',
        wave: ':scope > [data-wave]',
        sectionsWavy: '.wavy:not(.site-footer)',
        sectionsShadow: '.parallax-shadow:not(.site-footer)',
    };
    const classes$10 = {
        wavy: 'wavy',
        shadow: 'parallax-shadow',
        footerParallax: 'section-footer--parallax',
    };
    const attributes$P = {
        parallaxWavy: 'data-parallax-wavy',
    };
    const removeFooterWave = (section) => {
        const currentSection = section;
        const wavySections = document.querySelectorAll(selectors$1d.sectionsWavy);
        const shadowSections = document.querySelectorAll(selectors$1d.sectionsShadow);
        wavySections.forEach( (wavySection) => {
            wavySection.classList.remove(classes$10.wavy);
            const waves = wavySection.querySelectorAll(selectors$1d.wave);
            [...waves].map( (wave) => wave.remove())
        }
        );
        shadowSections.forEach( (shadowSection) => {
            shadowSection.classList.remove(classes$10.shadow);
            const waves = shadowSection.querySelectorAll(selectors$1d.wave);
            [...waves].map( (wave) => wave.remove())
        }
        );
        const footerParallax = document.querySelectorAll(selectors$1d.footerParallax);
        if (footerParallax.length > 0) {
            const footerParallaxInner = footerParallax[0].querySelector(selectors$1d.footerParallaxInner);
            if (footerParallaxInner.hasAttribute(attributes$P.parallaxWavy)) {
                footerParallaxInner.classList.add(classes$10.wavy)
            }
        }
        if (!currentSection.classList.contains(classes$10.footerParallax)) {
            document.dispatchEvent(new CustomEvent('theme:footer:unload'))
        }
    }
    ;
    let screenOrientation = getScreenOrientation();
    const selectors$1c = {
        body: 'body',
        main: '[data-main]',
        collectionFilters: '[data-collection-filters-sticky]',
        footer: '[data-section-type*="footer"]',
        header: '[data-header-height]',
        stickyHeader: '[data-site-header][data-position="fixed"]',
        announcementBar: '[data-announcement-bar]',
        collectionStickyBar: '[data-collection-sticky-bar]',
        logoTextLink: '[data-logo-text-link]',
    };
    const classes$$ = {
        templateCollection: 'template-collection',
        templateSearch: 'template-search',
        supportsTransparentHeader: 'supports-transparent-header',
    };
    function readHeights() {
        const h = {};
        h.windowHeight = Math.min(window.screen.height, window.innerHeight);
        h.footerHeight = getHeight(selectors$1c.footer);
        h.headerHeight = getHeight(selectors$1c.header);
        h.stickyHeaderHeight = isHeaderSticky() ? window.stickyHeaderHeight : 0;
        h.headerInitialHeight = parseInt(document.querySelector(selectors$1c.header)?.dataset.height || document.querySelector(selectors$1c.header)?.offsetHeight) || 0;
        h.announcementBarHeight = getHeight(selectors$1c.announcementBar);
        h.collectionStickyBarHeight = getHeight(selectors$1c.collectionStickyBar);
        return h
    }
    function setVarsOnResize() {
        document.addEventListener('theme:resize', resizeVars);
        setVars();
        document.dispatchEvent(new CustomEvent('theme:vars'), {
            bubbles: !1
        })
    }
    function setVars() {
        calcVars()
    }
    function resizeVars() {
        calcVars(!0)
    }
    function calcVars(checkOrientation=!1) {
        const body = document.querySelector(selectors$1c.body);
        const hasCollectionFilters = document.querySelector(selectors$1c.collectionFilters);
        const hasLogoTextLink = document.querySelector(selectors$1c.logoTextLink) !== null;
        let {windowHeight, headerHeight, headerInitialHeight, announcementBarHeight, footerHeight, collectionStickyBarHeight} = readHeights();
        if (hasLogoTextLink)
            headerHeight = recalcHeaderHeight();
        const contentFullHeight = window.isHeaderTransparent && checkFirstSectionTransparency() ? windowHeight - announcementBarHeight : windowHeight - headerInitialHeight - announcementBarHeight;
        let fullHeight = isHeaderSticky() ? windowHeight - window.stickyHeaderHeight : windowHeight;
        const isCollectionPage = body.classList.contains(classes$$.templateCollection);
        const isSearchPage = body.classList.contains(classes$$.templateSearch);
        const isPageWithFilters = (isCollectionPage && hasCollectionFilters) || (isSearchPage && hasCollectionFilters);
        document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
        document.documentElement.style.setProperty('--content-full', `${contentFullHeight}px`);
        document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);
        document.documentElement.style.setProperty('--collection-sticky-bar-height', `${collectionStickyBarHeight}px`);
        if (isPageWithFilters)
            fullHeight = windowHeight;
        if (!checkOrientation) {
            document.documentElement.style.setProperty('--full-height', `${fullHeight}px`);
            return
        }
        const currentScreenOrientation = getScreenOrientation();
        if (currentScreenOrientation !== screenOrientation) {
            document.documentElement.style.setProperty('--full-height', `${fullHeight}px`);
            screenOrientation = currentScreenOrientation
        }
    }
    function getHeight(selector) {
        const el = document.querySelector(selector);
        if (el) {
            return el.clientHeight
        } else {
            return 0
        }
    }
    function checkFirstSectionTransparency() {
        const firstSection = document.querySelector(selectors$1c.main).firstElementChild;
        return firstSection.classList.contains(classes$$.supportsTransparentHeader)
    }
    function isHeaderSticky() {
        return document.querySelector(selectors$1c.stickyHeader)
    }
    function getScreenOrientation() {
        if (window.matchMedia('(orientation: portrait)').matches) {
            return 'portrait'
        }
        if (window.matchMedia('(orientation: landscape)').matches) {
            return 'landscape'
        }
    }
    function recalcHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', 'auto');
        document.documentElement.style.setProperty('--header-sticky-height', 'auto');
        const header = document.querySelector(selectors$1c.header);
        const resetHeight = header.offsetHeight;
        requestAnimationFrame( () => {
            document.documentElement.style.setProperty('--header-height', `${resetHeight}px`);
            document.documentElement.style.setProperty('--header-sticky-height', `${resetHeight}px`)
        }
        );
        return resetHeight
    }
    const selectors$1b = {
        overflowBackground: '[data-overflow-background]',
        overflowFrame: '[data-overflow-frame]',
        overflowContent: '[data-overflow-content]',
        overflowContainer: '[data-overflow-container]',
        overflowWrapper: '[data-overflow-wrapper]',
    };
    function singles(frame, wrappers) {
        let tallest = 0;
        wrappers.forEach( (wrap) => {
            tallest = wrap.offsetHeight > tallest ? wrap.offsetHeight : tallest
        }
        );
        const images = frame.querySelectorAll(selectors$1b.overflowBackground);
        const frames = [frame, ...images];
        frames.forEach( (el) => {
            el.style.setProperty('min-height', `calc(${tallest}px + var(--header-height))`)
        }
        )
    }
    function doubles(section) {
        if (window.innerWidth < window.theme.sizes.small) {
            let singleFrames = section.querySelectorAll(selectors$1b.overflowFrame);
            singleFrames.forEach( (singleframe) => {
                const wrappers = singleframe.querySelectorAll(selectors$1b.overflowContent);
                singles(singleframe, wrappers)
            }
            );
            return
        }
        let tallest = 0;
        const frames = section.querySelectorAll(selectors$1b.overflowFrame);
        const contentWrappers = section.querySelectorAll(selectors$1b.overflowContent);
        contentWrappers.forEach( (content) => {
            if (content.offsetHeight > tallest) {
                tallest = content.offsetHeight
            }
        }
        );
        const images = section.querySelectorAll(selectors$1b.overflowBackground);
        let applySizes = [...frames, ...images];
        applySizes.forEach( (el) => {
            el.style.setProperty('min-height', `${tallest}px`)
        }
        );
        section.style.setProperty('min-height', `${tallest}px`)
    }
    function preventOverflow(container) {
        const singleFrames = container.querySelectorAll(selectors$1b.overflowContainer);
        if (singleFrames) {
            singleFrames.forEach( (frame) => {
                const wrappers = frame.querySelectorAll(selectors$1b.overflowContent);
                singles(frame, wrappers);
                document.addEventListener('theme:resize', () => {
                    singles(frame, wrappers)
                }
                )
            }
            )
        }
        const doubleSections = container.querySelectorAll(selectors$1b.overflowWrapper);
        if (doubleSections) {
            doubleSections.forEach( (section) => {
                doubles(section);
                document.addEventListener('theme:resize', () => {
                    doubles(section)
                }
                )
            }
            )
        }
    }
    window.lastWindowWidth = window.innerWidth;
    function dispatchResizeEvent() {
        document.dispatchEvent(new CustomEvent('theme:resize',{
            bubbles: !0,
        }));
        if (window.lastWindowWidth !== window.innerWidth) {
            document.dispatchEvent(new CustomEvent('theme:resize:width',{
                bubbles: !0,
            }));
            window.lastWindowWidth = window.innerWidth
        }
    }
    function resizeListener() {
        window.addEventListener('resize', debounce(dispatchResizeEvent, 50))
    }
    let prev = window.pageYOffset;
    let up = null;
    let down = null;
    let wasUp = null;
    let wasDown = null;
    let scrollLockTimer$1 = 0;
    const classes$_ = {
        quickViewVisible: 'js-quick-view-visible',
        cartDrawerOpen: 'js-drawer-open-cart',
    };
    function dispatchScrollEvent() {
        const position = window.pageYOffset;
        if (position > prev) {
            down = !0;
            up = !1
        } else if (position < prev) {
            down = !1;
            up = !0
        } else {
            up = null;
            down = null
        }
        prev = position;
        document.dispatchEvent(new CustomEvent('theme:scroll',{
            detail: {
                up,
                down,
                position,
            },
            bubbles: !1,
        }));
        if (up && !wasUp) {
            document.dispatchEvent(new CustomEvent('theme:scroll:up',{
                detail: {
                    position
                },
                bubbles: !1,
            }))
        }
        if (down && !wasDown) {
            document.dispatchEvent(new CustomEvent('theme:scroll:down',{
                detail: {
                    position
                },
                bubbles: !1,
            }))
        }
        wasDown = down;
        wasUp = up
    }
    function lock(e) {
        setTimeout( () => {
            if (scrollLockTimer$1) {
                clearTimeout(scrollLockTimer$1)
            }
            scrollLock.disablePageScroll(e.detail, {
                allowTouchMove: (el) => el.tagName === 'TEXTAREA',
            });
            document.documentElement.setAttribute('data-scroll-locked', '')
        }
        )
    }
    function unlock(e) {
        const timeout = e.detail;
        if (timeout) {
            scrollLockTimer$1 = setTimeout(removeScrollLock, timeout)
        } else {
            removeScrollLock()
        }
    }
    function removeScrollLock() {
        const isPopupVisible = document.body.classList.contains(classes$_.quickViewVisible) || document.body.classList.contains(classes$_.cartDrawerOpen);
        if (!isPopupVisible) {
            scrollLock.clearQueueScrollLocks();
            scrollLock.enablePageScroll();
            document.documentElement.removeAttribute('data-scroll-locked')
        }
    }
    function scrollListener() {
        let timeout;
        window.addEventListener('scroll', function() {
            if (timeout) {
                window.cancelAnimationFrame(timeout)
            }
            timeout = window.requestAnimationFrame(function() {
                dispatchScrollEvent()
            })
        }, {
            passive: !0
        });
        window.addEventListener('theme:scroll:lock', lock);
        window.addEventListener('theme:scroll:unlock', unlock)
    }
    const wrap = (toWrap, wrapperClass='', wrapperOption) => {
        const wrapper = wrapperOption || document.createElement('div');
        wrapper.classList.add(wrapperClass);
        wrapper.setAttribute('data-scroll-lock-scrollable', '');
        toWrap.parentNode.insertBefore(wrapper, toWrap);
        return wrapper.appendChild(toWrap)
    }
    ;
    function wrapElements(container) {
        const tableSelectors = 'table';
        const tables = container.querySelectorAll(tableSelectors);
        tables.forEach( (table) => {
            wrap(table, 'table-wrapper')
        }
        )
    }
    function isTouchDevice() {
        return 'ontouchstart'in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    }
    function isTouch() {
        if (isTouchDevice()) {
            document.documentElement.className = document.documentElement.className.replace('no-touch', 'supports-touch');
            window.theme.touch = !0
        } else {
            window.theme.touch = !1
        }
    }
    const classes$Z = {
        loading: 'is-loading',
        imgIn: 'img-in',
    };
    const selectors$1a = {
        img: 'img.is-loading',
        section: '[data-section-type]',
    };
    function loadedImagesEventHook() {
        document.addEventListener('load', (e) => {
            if (e.target.tagName.toLowerCase() == 'img' && e.target.classList.contains(classes$Z.loading)) {
                e.target.classList.remove(classes$Z.loading);
                e.target.parentNode.classList.remove(classes$Z.loading);
                const section = e.target.closest(selectors$1a.section);
                if (section)
                    section.classList.add(classes$Z.imgIn);
            }
        }
        , !0)
    }
    function removeLoadingClassFromLoadedImages(container) {
        container.querySelectorAll(selectors$1a.img).forEach( (img) => {
            if (img.complete) {
                img.classList.remove(classes$Z.loading);
                img.parentNode.classList.remove(classes$Z.loading);
                const section = img.closest(selectors$1a.section);
                if (section)
                    section.classList.add(classes$Z.imgIn);
            }
        }
        )
    }
    const selectors$19 = {
        img: 'img',
        template: 'template',
        shopifySection: '.shopify-section',
        deferredContent: '[data-deferred-content]',
        reloadSrcsetException: '[data-product-image]',
    };
    const attributes$O = {
        srcset: 'srcset',
        loaded: 'data-loaded',
        deferredContainer: 'data-deferred-container',
    };
    class DeferredLoading extends HTMLElement {
        constructor() {
            super();
            this.container = this;
            if (this.hasAttribute(attributes$O.deferredContainer)) {
                this.container = this.closest(this.getAttribute(attributes$O.deferredContainer)) || this.closest(selectors$19.shopifySection)
            }
            this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers)
        }
        connectedCallback() {
            if (this.deferredTriggers.length == 0) {
                this.container.addEventListener('mouseenter', () => {
                    if (this.hasAttribute(attributes$O.loaded))
                        return;
                    this.loadTemplate()
                }
                , {
                    once: !0
                });
                return
            }
            this.deferredTriggers.forEach( (trigger) => {
                trigger.addEventListener('mouseenter', () => {
                    if (this.hasAttribute(attributes$O.loaded))
                        return;
                    this.loadTemplate()
                }
                , {
                    once: !0
                })
            }
            )
        }
        loadTemplate() {
            const content = document.createElement('div');
            const template = this.querySelector(selectors$19.template);
            if (!template || !template?.content?.firstElementChild)
                return;
            content.appendChild(template.content.firstElementChild.cloneNode(!0));
            const deferredContent = content.querySelector(selectors$19.deferredContent);
            if (!deferredContent)
                return;
            this.append(deferredContent);
            this.setAttribute(attributes$O.loaded, !0);
            const containsImages = deferredContent.querySelectorAll(selectors$19.img).length > 0;
            if (containsImages) {
                this.reloadSrcset(this)
            }
        }
        reloadSrcset(container) {
            if (!container)
                return;
            container.querySelectorAll(selectors$19.img).forEach( (img) => {
                const reloadSrcsetException = img.parentNode.matches(selectors$19.reloadSrcsetException);
                if (!reloadSrcsetException) {
                    const srcset = img.getAttribute(attributes$O.srcset);
                    img.setAttribute(attributes$O.srcset, '');
                    img.setAttribute(attributes$O.srcset, srcset)
                }
            }
            )
        }
    }
    const selectors$18 = {
        inputSearch: 'input[type="search"]',
        inputType: 'input[name="type"]',
        form: 'form',
        allVisibleElements: '[role="option"]',
        ariaSelected: '[aria-selected="true"]',
        selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
        popularSearches: '[data-popular-searches]',
        popdownBody: '[data-popdown-body]',
        mainInputSearch: '[data-main-input-search]',
        predictiveSearchResults: '[data-predictive-search-results]',
        predictiveSearch: 'predictive-search',
        searchForm: 'search-form',
    };
    const classes$Y = {
        isSearched: 'is-searched',
        templateSearch: 'template-search',
    };
    class SearchForm extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector(selectors$18.inputSearch);
            this.form = this.querySelector(selectors$18.form);
            this.popdownBody = this.closest(selectors$18.popdownBody);
            this.popularSearches = this.popdownBody?.querySelector(selectors$18.popularSearches);
            this.predictiveSearchResults = this.querySelector(selectors$18.predictiveSearchResults);
            this.predictiveSearch = this.matches(selectors$18.predictiveSearch);
            this.searchForm = this.matches(selectors$18.searchForm);
            this.selectedElement = null;
            this.activeElement = null;
            this.searchTerm = '';
            this.currentSearchTerm = '';
            this.isSearchPage = document.body.classList.contains(classes$Y.templateSearch);
            this.input.addEventListener('input', debounce( (event) => {
                this.onChange(event)
            }
            , 300).bind(this));
            this.input.addEventListener('focus', this.onFocus.bind(this));
            this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
            this.addEventListener('keyup', this.onKeyup.bind(this));
            this.addEventListener('keydown', this.onKeydown.bind(this));
            if (this.isSearchPage) {
                this.mainInputType = document.querySelector(`${selectors$18.mainInputSearch} ${selectors$18.inputType}`);
                this.inputType = this.querySelector(selectors$18.inputType);
                this.inputType.value = this.mainInputType.value
            }
        }
        getQuery() {
            return this.input.value.trim()
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery()
        }
        onChange() {
            this.classList.toggle(classes$Y.isSearched, !this.isFormCleared());
            this.searchTerm = this.getQuery()
        }
        isFormCleared() {
            return this.input.value.length === 0
        }
        submit() {
            this.form.submit()
        }
        reset() {
            this.input.val = ''
        }
        onFormSubmit(event) {
            if (!this.getQuery().length || this.querySelector(selectors$18.selectedLink))
                event.preventDefault();
        }
        onKeydown(event) {
            if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
                event.preventDefault()
            }
        }
        onKeyup(event) {
            if (!this.getQuery().length && this.predictiveSearch) {
                this.close(!0)
            }
            event.preventDefault();
            switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break
            }
        }
        switchOption(direction) {
            const moveUp = direction === 'up';
            const predictiveSearchOpened = this.classList.contains(classes$Y.isSearched) && this.predictiveSearchResults;
            const visibleElementsContainer = predictiveSearchOpened ? this.predictiveSearchResults : this.popularSearches;
            if (!visibleElementsContainer)
                return;
            this.selectedElement = visibleElementsContainer.querySelector(selectors$18.ariaSelected);
            const allVisibleElements = Array.from(visibleElementsContainer.querySelectorAll(selectors$18.allVisibleElements)).filter( (element) => element.offsetParent !== null);
            let activeElementIndex = 0;
            if (moveUp && !this.selectedElement)
                return;
            let selectedElementIndex = -1;
            let i = 0;
            while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
                if (allVisibleElements[i] === this.selectedElement) {
                    selectedElementIndex = i
                }
                i++
            }
            if (!moveUp && this.selectedElement) {
                activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1
            } else if (moveUp) {
                activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1
            }
            if (activeElementIndex === selectedElementIndex)
                return;
            this.activeElement = allVisibleElements[activeElementIndex];
            this.handleFocusableDescendants()
        }
        selectOption() {
            const selectedOption = this.querySelector(selectors$18.selectedOption);
            if (selectedOption)
                selectedOption.click();
        }
        handleFocusableDescendants(reset=!1) {
            const selected = this.selectedElement ? this.selectedElement : this.querySelector(selectors$18.ariaSelected);
            if (selected)
                selected.setAttribute('aria-selected', !1);
            if (!this.activeElement || reset) {
                this.selectedElement = null;
                this.activeElement?.setAttribute('aria-selected', !1);
                this.input.setAttribute('aria-expanded', !1);
                this.input.setAttribute('aria-activedescendant', '');
                return
            }
            this.activeElement.setAttribute('aria-selected', !0);
            this.input.setAttribute('aria-activedescendant', this.activeElement.id)
        }
    }
    customElements.define('search-form', SearchForm);
    const selectors$17 = {
        predictiveSearch: 'predictive-search',
        sectionPredictiveSearch: '#shopify-section-api-predictive-search',
        predictiveSearchResults: '[data-predictive-search-results]',
        predictiveSearchStatus: '[data-predictive-search-status]',
        searchResultsLiveRegion: '[data-predictive-search-live-region-count-value]',
        searchResultsWrapper: '[data-search-results-wrapper]',
    };
    const classes$X = {
        reset: 'reset',
    };
    const attributes$N = {
        aosAnchor: 'data-aos-anchor',
        ariaHidden: 'aria-hidden',
        open: 'open',
        loading: 'loading',
        loadingText: 'data-loading-text',
        results: 'results',
    };
    class PredictiveSearch extends SearchForm {
        constructor() {
            super();
            this.abortController = new AbortController();
            this.allPredictiveSearchInstances = document.querySelectorAll(selectors$17.predictiveSearch);
            this.predictiveSearchResults = this.querySelector(selectors$17.predictiveSearchResults);
            this.cachedResults = {}
        }
        connectedCallback() {
            this.predictiveSearchResults.addEventListener('transitionend', (event) => {
                if (event.target === this.predictiveSearchResults && !this.getQuery().length) {
                    this.classList.remove(classes$X.reset);
                    requestAnimationFrame( () => this.clearResultsHTML())
                }
            }
            )
        }
        onChange() {
            super.onChange();
            this.classList.remove(classes$X.reset);
            if (!this.searchTerm.length) {
                this.classList.add(classes$X.reset);
                return
            }
            requestAnimationFrame( () => this.getSearchResults(this.searchTerm))
        }
        onFocus() {
            super.onFocus();
            if (!this.currentSearchTerm.length)
                return;
            if (this.searchTerm !== this.currentSearchTerm) {
                this.onChange()
            } else if (this.getAttribute(attributes$N.results) === 'true') {
                this.open()
            } else {
                this.getSearchResults(this.searchTerm)
            }
        }
        getSearchResults(searchTerm) {
            const queryKey = searchTerm.replace(' ', '-').toLowerCase();
            const suggestionsResultsLimit = parseInt(window.theme.settings.suggestionsResultsLimit);
            let resources = 'query';
            resources += window.theme.settings.suggestArticles ? ',article' : '';
            resources += window.theme.settings.suggestCollections ? ',collection' : '';
            resources += window.theme.settings.suggestProducts ? ',product' : '';
            resources += window.theme.settings.suggestPages ? ',page' : '';
            this.setLiveRegionLoadingState();
            if (this.cachedResults[queryKey]) {
                this.renderSearchResults(this.cachedResults[queryKey]);
                return
            }
            fetch(`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(searchTerm)}&resources[type]=${resources}&resources[limit]=${suggestionsResultsLimit}&section_id=api-predictive-search`, {
                signal: this.abortController.signal,
            }).then( (response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error
                }
                return response.text()
            }
            ).then( (text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors$17.sectionPredictiveSearch).innerHTML;
                this.allPredictiveSearchInstances.forEach( (predictiveSearchInstance) => {
                    predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup
                }
                );
                this.renderSearchResults(resultsMarkup)
            }
            ).catch( (error) => {
                if (error?.code === 20) {
                    return
                }
                this.close();
                throw error
            }
            )
        }
        switchOption(direction) {
            super.switchOption(direction);
            if (this.statusElement)
                this.statusElement.textContent = ''
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(selectors$17.predictiveSearchStatus);
            this.loadingText = this.loadingText || this.getAttribute(attributes$N.loadingText);
            this.setLiveRegionText(this.loadingText);
            this.setAttribute(attributes$N.loading, !0)
        }
        setLiveRegionText(statusText) {
            this.statusElement.setAttribute(attributes$N.ariaHidden, 'false');
            this.statusElement.textContent = statusText;
            setTimeout( () => {
                this.statusElement.setAttribute(attributes$N.ariaHidden, 'true')
            }
            , 1000)
        }
        renderSearchResults(resultsMarkup) {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            const parentId = this.predictiveSearchResults.parentElement.id;
            const el = this.predictiveSearchResults.querySelector(selectors$17.searchResultsWrapper);
            const tempId = el.id;
            el.id = `${tempId}--${parentId}`;
            el.setAttribute(attributes$N.aosAnchor, `#${el.id}`);
            this.setAttribute(attributes$N.results, !0);
            this.setLiveRegionResults();
            this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute(attributes$N.loading);
            this.setLiveRegionText(this.querySelector(selectors$17.searchResultsLiveRegion).textContent)
        }
        open() {
            this.setAttribute(attributes$N.open, !0)
        }
        close(clearSearchTerm=!1) {
            this.closeResults(clearSearchTerm)
        }
        closeResults(clearSearchTerm=!1) {
            if (clearSearchTerm) {
                this.reset();
                this.removeAttribute(attributes$N.results);
                this.classList.remove(classes$X.reset)
            }
            this.removeAttribute(attributes$N.loading);
            this.removeAttribute(attributes$N.open)
        }
        clearResultsHTML() {
            this.predictiveSearchResults.innerHTML = ''
        }
    }
    customElements.define('predictive-search', PredictiveSearch);
    class LoadingOverlay extends HTMLElement {
        constructor() {
            super();
            document.addEventListener('DOMContentLoaded', () => {
                document.documentElement.classList.remove('page-loading')
            }
            )
        }
    }
    const selectors$16 = {
        aos: '[data-aos]:not(.aos-animate)',
        aosAnchor: '[data-aos-anchor]',
        animatable: '[data-aos], [data-aos-anchor]',
        watchMutations: '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop',
        skeletonLoading: '.skeleton-loading',
    };
    const classes$W = {
        aosAnimate: 'aos-animate',
        isLoading: 'is-loading',
    };
    const attributes$M = {
        aos: 'data-aos',
        aosAnchor: 'data-aos-anchor',
        aosIntersection: 'data-aos-intersection',
        aosDebounce: 'data-aos-debounce',
        aosCustomInit: 'data-aos-custom-init',
        aosWatchAnchors: 'data-aos-watch-anchors',
        aosTrigger: 'data-aos-trigger',
    };
    const settings$a = {
        intersectionRatio: 0.1,
        debounceTime: 0,
    };
    let anchorObserversCollection = new Set();
    function anchorsIntersectionObserver() {
        const anchors = document.querySelectorAll(selectors$16.aosAnchor);
        initAnchorObservers(anchors)
    }
    function initAnchorObservers(anchors) {
        if (!anchors.length)
            return;
        anchors.forEach( (anchor) => {
            const containerId = anchor.dataset.aosAnchor;
            let container;
            if (containerId != '')
                container = document.querySelector(containerId);
            if (container && !anchorObserversCollection.has(anchor)) {
                anchorObserversCollection.add(container)
            }
        }
        );
        anchorObserversCollection.forEach( (container) => {
            aosAnchorObserver.observe(container)
        }
        )
    }
    const aosAnchorObserver = new IntersectionObserver( (entries, observer) => {
        entries.forEach( (entry) => {
            const target = entry.target;
            const intersectionRatio = entry.intersectionRatio;
            const isIntersecting = entry.isIntersecting;
            let intersectAt = settings$a.intersectionRatio;
            if (target.hasAttribute(attributes$M.aosIntersection)) {
                intersectAt = Number(target.getAttribute(attributes$M.aosIntersection))
            }
            let timeout;
            let debounceTime = settings$a.debounceTime;
            if (target.hasAttribute(attributes$M.aosDebounce)) {
                debounceTime = Number(target.getAttribute(attributes$M.aosDebounce))
            }
            if (isIntersecting && intersectionRatio > intersectAt) {
                if (debounceTime !== 0) {
                    if (timeout)
                        clearTimeout(timeout);
                    timeout = setTimeout( () => onIntersecting(target), debounceTime)
                } else {
                    onIntersecting(target)
                }
                observer.unobserve(target);
                anchorObserversCollection.delete(target)
            }
        }
        )
    }
    ,{
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1],
    });
    function onIntersecting(target) {
        if (!target)
            return;
        animate(target);
        const skeletonLoading = target.closest(selectors$16.skeletonLoading);
        if (skeletonLoading) {
            skeletonLoading.querySelectorAll('img').forEach( (image) => {
                if (image.classList.contains(classes$W.isLoading)) {
                    image.setAttribute('loading', 'eager')
                }
            }
            )
        }
        if (target.hasAttribute(attributes$M.aosTrigger)) {
            const triggerId = target.getAttribute(attributes$M.aosTrigger);
            const elementsToTrigger = document.querySelectorAll(`[${attributes$M.aosAnchor}="${triggerId}"]`);
            elementsToTrigger.forEach( (element) => animate(element))
        }
        let elementsToAnimate = target.querySelectorAll(selectors$16.aos);
        if (target.hasAttribute(attributes$M.aosWatchAnchors)) {
            const filteredElements = [...elementsToAnimate].filter( (element) => {
                const anchor = element.hasAttribute(attributes$M.aosAnchor) ? element.getAttribute(attributes$M.aosAnchor) : !1;
                if (anchor && `#${target.id}` === anchor)
                    return element
            }
            );
            elementsToAnimate = filteredElements
        }
        elementsToAnimate.forEach( (item) => {
            let customInit = item.hasAttribute(attributes$M.aosCustomInit);
            if (customInit) {
                target.dispatchEvent(new CustomEvent('theme:target:animate',{
                    bubbles: !0,
                    detail: item
                }));
                return
            }
            animate(item)
        }
        )
    }
    function animate(element) {
        requestAnimationFrame( () => element.classList.add(classes$W.aosAnimate))
    }
    function bodyMutationObserver() {
        const isNode = (element) => element instanceof HTMLElement;
        const bodyObserver = new MutationObserver( (mutationList) => {
            for (const mutation of mutationList) {
                if (!mutation.type === 'childList')
                    return;
                const target = mutation.target;
                const addedNodes = [...mutation.addedNodes];
                const removedNodes = [...mutation.removedNodes];
                const watchMutations = target.matches(selectors$16.watchMutations) || addedNodes.some( (item) => (isNode(item) ? item.matches(selectors$16.watchMutations) : !1)) || removedNodes.some( (item) => (isNode(item) ? item.matches(selectors$16.watchMutations) : !1));
                const isAnimatableElement = target.matches(selectors$16.animatable) || addedNodes.some( (item) => (isNode(item) ? item.matches(selectors$16.animatable) : !1));
                const hasElementToAnimate = target.querySelector(`[${attributes$M.aosAnchor}="#${target.id}"]`) !== null;
                if (isAnimatableElement || hasElementToAnimate || watchMutations) {
                    const anchors = target.querySelectorAll(selectors$16.aosAnchor);
                    initAnchorObservers(anchors)
                }
            }
        }
        );
        bodyObserver.observe(document.body, {
            attributes: !1,
            childList: !0,
            subtree: !0,
        })
    }
    function initAnimations() {
        anchorsIntersectionObserver();
        bodyMutationObserver()
    }
    window.requestIdleCallback = window.requestIdleCallback || function(cb) {
        var start = Date.now();
        return setTimeout(function() {
            cb({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - start))
                },
            })
        }, 1)
    }
    ;
    window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
        clearTimeout(id)
    }
    ;
    resizeListener();
    scrollListener();
    isTouch();
    loadedImagesEventHook();
    const headerFunctions = debounce( () => {
        initTransparentHeader()
    }
    , 300);
    window.addEventListener('DOMContentLoaded', () => {
        setVarsOnResize();
        preventOverflow(document);
        wrapElements(document);
        removeLoadingClassFromLoadedImages(document);
        if (window.theme.settings.animationsEnabled) {
            initAnimations()
        }
    }
    );
    document.addEventListener('shopify:section:load', (e) => {
        const container = e.target;
        window.dispatchEvent(new Event('resize'), {
            bubbles: !0
        });
        preventOverflow(container);
        wrapElements(container);
        setVarsOnResize();
        headerFunctions();
        removeFooterWave(container);
        if (window.theme.settings.animationsEnabled) {
            initAnimations()
        }
    }
    );
    document.addEventListener('shopify:section:reorder', (e) => {
        const container = e.target;
        headerFunctions();
        removeFooterWave(container)
    }
    );
    document.addEventListener('shopify:section:unload', (e) => {
        const container = e.target;
        headerFunctions();
        removeFooterWave(container)
    }
    );
    if (!customElements.get('deferred-loading')) {
        customElements.define('deferred-loading', DeferredLoading)
    }
    if (!customElements.get('loading-overlay')) {
        customElements.define('loading-overlay', LoadingOverlay)
    }
    (function() {
        function n(n) {
            var i = window.innerWidth || document.documentElement.clientWidth
              , r = window.innerHeight || document.documentElement.clientHeight
              , t = n.getBoundingClientRect();
            return t.top >= 0 && t.bottom <= r && t.left >= 0 && t.right <= i
        }
        function t(n) {
            var i = window.innerWidth || document.documentElement.clientWidth
              , r = window.innerHeight || document.documentElement.clientHeight
              , t = n.getBoundingClientRect()
              , u = (t.left >= 0 && t.left <= i) || (t.right >= 0 && t.right <= i)
              , f = (t.top >= 0 && t.top <= r) || (t.bottom >= 0 && t.bottom <= r);
            return u && f
        }
        function i(n, i) {
            function r() {
                var r = t(n);
                r != u && ((u = r),
                typeof i == 'function' && i(r, n))
            }
            var u = t(n);
            window.addEventListener('load', r);
            window.addEventListener('resize', r);
            window.addEventListener('scroll', r)
        }
        function r(t, i) {
            function r() {
                var r = n(t);
                r != u && ((u = r),
                typeof i == 'function' && i(r, t))
            }
            var u = n(t);
            window.addEventListener('load', r);
            window.addEventListener('resize', r);
            window.addEventListener('scroll', r)
        }
        window.visibilityHelper = {
            isElementTotallyVisible: n,
            isElementPartiallyVisible: t,
            inViewportPartially: i,
            inViewportTotally: r
        }
    }
    )();
    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};
    window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
    window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const registered = window.Shopify.theme.sections.registered;
    const instances = window.Shopify.theme.sections.instances;
    const attributes$L = {
        id: 'data-section-id',
        type: 'data-section-type',
    };
    class Registration {
        constructor(type=null, components=[]) {
            this.type = type;
            this.components = validateComponentsArray(components);
            this.callStack = {
                onLoad: [],
                onUnload: [],
                onSelect: [],
                onDeselect: [],
                onBlockSelect: [],
                onBlockDeselect: [],
                onReorder: [],
            };
            components.forEach( (comp) => {
                for (const [key,value] of Object.entries(comp)) {
                    const arr = this.callStack[key];
                    if (Array.isArray(arr) && typeof value === 'function') {
                        arr.push(value)
                    } else {
                        console.warn(`Unregisted function: '${key}' in component: '${this.type}'`);
                        console.warn(value)
                    }
                }
            }
            )
        }
        getStack() {
            return this.callStack
        }
    }
    class Section {
        constructor(container, registration) {
            this.container = validateContainerElement(container);
            this.id = container.getAttribute(attributes$L.id);
            this.type = registration.type;
            this.callStack = registration.getStack();
            try {
                this.onLoad()
            } catch (e) {
                console.warn(`Error in section: ${this.id}`);
                console.warn(this);
                console.warn(e)
            }
        }
        callFunctions(key, e=null) {
            this.callStack[key].forEach( (func) => {
                const props = {
                    id: this.id,
                    type: this.type,
                    container: this.container,
                };
                if (e) {
                    func.call(props, e)
                } else {
                    func.call(props)
                }
            }
            )
        }
        onLoad() {
            this.callFunctions('onLoad')
        }
        onUnload() {
            this.callFunctions('onUnload')
        }
        onSelect(e) {
            this.callFunctions('onSelect', e)
        }
        onDeselect(e) {
            this.callFunctions('onDeselect', e)
        }
        onBlockSelect(e) {
            this.callFunctions('onBlockSelect', e)
        }
        onBlockDeselect(e) {
            this.callFunctions('onBlockDeselect', e)
        }
        onReorder(e) {
            this.callFunctions('onReorder', e)
        }
    }
    function validateContainerElement(container) {
        if (!(container instanceof Element)) {
            throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.')
        }
        if (container.getAttribute(attributes$L.id) === null) {
            throw new Error('Theme Sections: The section container provided does not have an id assigned to the ' + attributes$L.id + ' attribute.')
        }
        return container
    }
    function validateComponentsArray(value) {
        if ((typeof value !== 'undefined' && typeof value !== 'object') || value === null) {
            throw new TypeError('Theme Sections: The components object provided is not a valid')
        }
        return value
    }
    function register(type, components) {
        if (typeof type !== 'string') {
            throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered')
        }
        if (typeof registered[type] !== 'undefined') {
            throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice')
        }
        if (!Array.isArray(components)) {
            components = [components]
        }
        const section = new Registration(type,components);
        registered[type] = section;
        return registered
    }
    function load(types, containers) {
        types = normalizeType(types);
        if (typeof containers === 'undefined') {
            containers = document.querySelectorAll('[' + attributes$L.type + ']')
        }
        containers = normalizeContainers(containers);
        types.forEach(function(type) {
            const registration = registered[type];
            if (typeof registration === 'undefined') {
                return
            }
            containers = containers.filter(function(container) {
                if (isInstance(container)) {
                    return !1
                }
                if (container.getAttribute(attributes$L.type) === null) {
                    return !1
                }
                if (container.getAttribute(attributes$L.type) !== type) {
                    return !0
                }
                instances.push(new Section(container,registration));
                return !1
            })
        })
    }
    function reorder(selector) {
        var instancesToReorder = getInstances(selector);
        instancesToReorder.forEach(function(instance) {
            instance.onReorder()
        })
    }
    function unload(selector) {
        var instancesToUnload = getInstances(selector);
        instancesToUnload.forEach(function(instance) {
            var index = instances.map(function(e) {
                return e.id
            }).indexOf(instance.id);
            instances.splice(index, 1);
            instance.onUnload()
        })
    }
    function getInstances(selector) {
        var filteredInstances = [];
        if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
            var firstElement = selector[0]
        }
        if (selector instanceof Element || firstElement instanceof Element) {
            var containers = normalizeContainers(selector);
            containers.forEach(function(container) {
                filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
                    return instance.container === container
                }))
            })
        } else if (typeof selector === 'string' || typeof firstElement === 'string') {
            var types = normalizeType(selector);
            types.forEach(function(type) {
                filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
                    return instance.type === type
                }))
            })
        }
        return filteredInstances
    }
    function getInstanceById(id) {
        var instance;
        for (var i = 0; i < instances.length; i++) {
            if (instances[i].id === id) {
                instance = instances[i];
                break
            }
        }
        return instance
    }
    function isInstance(selector) {
        return getInstances(selector).length > 0
    }
    function normalizeType(types) {
        if (types === '*') {
            types = Object.keys(registered)
        } else if (typeof types === 'string') {
            types = [types]
        } else if (types.constructor === Section) {
            types = [types.prototype.type]
        } else if (Array.isArray(types) && types[0].constructor === Section) {
            types = types.map(function(Section) {
                return Section.type
            })
        }
        types = types.map(function(type) {
            return type.toLowerCase()
        });
        return types
    }
    function normalizeContainers(containers) {
        if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
            containers = Array.prototype.slice.call(containers)
        } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
            containers = []
        } else if (containers === null) {
            containers = []
        } else if (!Array.isArray(containers) && containers instanceof Element) {
            containers = [containers]
        }
        return containers
    }
    if (window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
            var id = event.detail.sectionId;
            var container = event.target.querySelector('[' + attributes$L.id + '="' + id + '"]');
            if (window.Shopify.visualPreviewMode === !0) {
                if (container === null) {
                    container = event.target.querySelector(`[${attributes$L.id}]`)
                }
            }
            if (container !== null) {
                load(container.getAttribute(attributes$L.type), container)
            }
        });
        document.addEventListener('shopify:section:reorder', function(event) {
            var id = event.detail.sectionId;
            var container = event.target.querySelector('[' + attributes$L.id + '="' + id + '"]');
            var instance = getInstances(container)[0];
            if (typeof instance === 'object') {
                reorder(container)
            }
        });
        document.addEventListener('shopify:section:unload', function(event) {
            var id = event.detail.sectionId;
            var container = event.target.querySelector('[' + attributes$L.id + '="' + id + '"]');
            var instance = getInstances(container)[0];
            if (typeof instance === 'object') {
                unload(container)
            }
        });
        document.addEventListener('shopify:section:select', function(event) {
            var instance = getInstanceById(event.detail.sectionId);
            if (typeof instance === 'object') {
                instance.onSelect(event)
            }
        });
        document.addEventListener('shopify:section:deselect', function(event) {
            var instance = getInstanceById(event.detail.sectionId);
            if (typeof instance === 'object') {
                instance.onDeselect(event)
            }
        });
        document.addEventListener('shopify:block:select', function(event) {
            var instance = getInstanceById(event.detail.sectionId);
            if (typeof instance === 'object') {
                instance.onBlockSelect(event)
            }
        });
        document.addEventListener('shopify:block:deselect', function(event) {
            var instance = getInstanceById(event.detail.sectionId);
            if (typeof instance === 'object') {
                instance.onBlockDeselect(event)
            }
        })
    }
    const throttle = (fn, wait) => {
        let prev, next;
        return function invokeFn(...args) {
            const now = Date.now();
            next = clearTimeout(next);
            if (!prev || now - prev >= wait) {
                fn.apply(null, args);
                prev = now
            } else {
                next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev))
            }
        }
    }
    ;
    function FetchError(object) {
        this.status = object.status || null;
        this.headers = object.headers || null;
        this.json = object.json || null;
        this.body = object.body || null
    }
    FetchError.prototype = Error.prototype;
    const selectors$15 = {
        single: '[data-collapsible-single]',
        trigger: '[data-collapsible-trigger]',
        content: '[data-collapsible-content]',
    };
    const classes$V = {
        isExpanded: 'is-expanded',
    };
    const attributes$K = {
        expanded: 'aria-expanded',
        controls: 'aria-controls',
        triggerMobile: 'data-collapsible-trigger-mobile',
        transitionOverride: 'data-collapsible-transition-override',
    };
    const settings$9 = {
        animationDelay: 500,
    };
    const sections$G = {};
    class Collapsible {
        constructor(container) {
            this.container = container;
            this.single = this.container.querySelector(selectors$15.single);
            this.triggers = this.container.querySelectorAll(selectors$15.trigger);
            this.resetHeightTimer = 0;
            this.isTransitioning = !1;
            this.transitionOverride = this.container.hasAttribute(attributes$K.transitionOverride);
            this.collapsibleToggleEvent = (event) => throttle(this.collapsibleToggle(event), 1250);
            this.init()
        }
        init() {
            this.triggers.forEach( (trigger) => {
                trigger.addEventListener('click', this.collapsibleToggleEvent);
                trigger.addEventListener('keyup', this.collapsibleToggleEvent)
            }
            )
        }
        collapsibleToggle(e) {
            e.preventDefault();
            const trigger = e.target.matches(selectors$15.trigger) ? e.target : e.target.closest(selectors$15.trigger);
            const dropdownId = trigger.getAttribute(attributes$K.controls);
            const dropdown = document.getElementById(dropdownId);
            const triggerMobile = trigger.hasAttribute(attributes$K.triggerMobile);
            const isExpanded = trigger.classList.contains(classes$V.isExpanded);
            const isSpace = e.code === theme.keyboardKeys.SPACE;
            const isEscape = e.code === theme.keyboardKeys.ESCAPE;
            const isMobile = window.innerWidth < theme.sizes.small;
            if (this.isTransitioning && !this.transitionOverride) {
                return
            }
            if (e.code && !isSpace && !isEscape) {
                return
            }
            if ((!isExpanded && isEscape) || (triggerMobile && !isMobile)) {
                return
            }
            this.isTransitioning = !0;
            trigger.disabled = !0;
            if (this.single) {
                this.triggers.forEach( (otherTrigger) => {
                    const isExpanded = otherTrigger.classList.contains(classes$V.isExpanded);
                    if (trigger == otherTrigger || !isExpanded)
                        return;
                    const dropdownId = otherTrigger.getAttribute(attributes$K.controls);
                    const dropdown = document.getElementById(dropdownId);
                    requestAnimationFrame( () => {
                        this.closeItem(dropdown, otherTrigger)
                    }
                    )
                }
                )
            }
            if (isExpanded) {
                requestAnimationFrame( () => {
                    this.closeItem(dropdown, trigger)
                }
                )
            } else {
                requestAnimationFrame( () => {
                    this.openItem(dropdown, trigger)
                }
                )
            }
        }
        openItem(dropdown, trigger) {
            let dropdownHeight = dropdown.querySelector(selectors$15.content).offsetHeight;
            this.setDropdownHeight(dropdown, dropdownHeight, trigger, !0);
            trigger.classList.add(classes$V.isExpanded);
            trigger.setAttribute(attributes$K.expanded, !0);
            trigger.dispatchEvent(new CustomEvent('theme:form:sticky',{
                bubbles: !0,
                detail: {
                    element: 'accordion',
                },
            }))
        }
        closeItem(dropdown, trigger) {
            let dropdownHeight = dropdown.querySelector(selectors$15.content).offsetHeight;
            requestAnimationFrame( () => {
                dropdownHeight = 0;
                this.setDropdownHeight(dropdown, dropdownHeight, trigger, !1);
                trigger.classList.remove(classes$V.isExpanded)
            }
            );
            this.setDropdownHeight(dropdown, dropdownHeight, trigger, !1);
            trigger.classList.remove(classes$V.isExpanded);
            trigger.setAttribute(attributes$K.expanded, !1)
        }
        setDropdownHeight(dropdown, dropdownHeight, trigger, isExpanded) {
            dropdown.style.height = `${dropdownHeight}px`;
            dropdown.setAttribute(attributes$K.expanded, isExpanded);
            dropdown.classList.toggle(classes$V.isExpanded, isExpanded);
            if (this.resetHeightTimer) {
                clearTimeout(this.resetHeightTimer)
            }
            if (dropdownHeight == 0) {
                this.resetHeightTimer = setTimeout( () => {
                    dropdown.style.height = ''
                }
                , settings$9.animationDelay)
            }
            if (isExpanded) {
                this.resetHeightTimer = setTimeout( () => {
                    dropdown.style.height = 'auto';
                    this.isTransitioning = !1
                }
                , settings$9.animationDelay)
            } else {
                this.isTransitioning = !1
            }
            setTimeout( () => {
                trigger.disabled = !1
            }
            , settings$9.animationDelay)
        }
        onUnload() {
            this.triggers.forEach( (trigger) => {
                trigger.removeEventListener('click', this.collapsibleToggleEvent);
                trigger.removeEventListener('keyup', this.collapsibleToggleEvent)
            }
            )
        }
    }
    const collapsible = {
        onLoad() {
            sections$G[this.id] = new Collapsible(this.container)
        },
        onUnload() {
            sections$G[this.id].onUnload()
        },
    };
    const selectors$14 = {
        quantityHolder: '[data-quantity-holder]',
        quantityField: '[data-quantity-field]',
        quantityButton: '[data-quantity-button]',
        quantityMinusButton: '[data-quantity-minus]',
        quantityPlusButton: '[data-quantity-plus]',
    };
    const classes$U = {
        quantityReadOnly: 'read-only',
        isDisabled: 'is-disabled',
    };
    class QuantityCounter {
        constructor(holder, inCart=!1) {
            this.holder = holder;
            this.quantityUpdateCart = inCart
        }
        init() {
            this.quantity = this.holder.querySelector(selectors$14.quantityHolder);
            if (!this.quantity) {
                return
            }
            this.field = this.quantity.querySelector(selectors$14.quantityField);
            this.buttons = this.quantity.querySelectorAll(selectors$14.quantityButton);
            this.increaseButton = this.quantity.querySelector(selectors$14.quantityPlusButton);
            this.quantityValue = Number(this.field.value || 0);
            this.cartItemID = this.field.getAttribute('data-id');
            this.maxValue = Number(this.field.getAttribute('max')) > 0 ? Number(this.field.getAttribute('max')) : null;
            this.minValue = Number(this.field.getAttribute('min')) > 0 ? Number(this.field.getAttribute('min')) : 0;
            this.disableIncrease = this.disableIncrease.bind(this);
            this.emptyField = !1;
            this.updateQuantity = this.updateQuantity.bind(this);
            this.decrease = this.decrease.bind(this);
            this.increase = this.increase.bind(this);
            this.disableIncrease();
            if (!this.quantity.classList.contains(classes$U.quantityReadOnly)) {
                this.changeValueOnClick();
                this.changeValueOnInput()
            }
        }
        changeValueOnClick() {
            this.buttons.forEach( (element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.quantityValue = Number(this.field.value || 0);
                    const clickedElement = event.target;
                    const isDescrease = clickedElement.matches(selectors$14.quantityMinusButton) || clickedElement.closest(selectors$14.quantityMinusButton);
                    const isIncrease = clickedElement.matches(selectors$14.quantityPlusButton) || clickedElement.closest(selectors$14.quantityPlusButton);
                    if (isDescrease) {
                        this.decrease()
                    }
                    if (isIncrease) {
                        this.increase()
                    }
                    this.updateQuantity()
                }
                )
            }
            )
        }
        changeValueOnInput() {
            this.field.addEventListener('input', () => {
                this.quantityValue = this.field.value;
                this.updateQuantity()
            }
            )
        }
        updateQuantity() {
            if (this.maxValue < this.quantityValue && this.maxValue !== null) {
                this.quantityValue = this.maxValue
            }
            if (this.minValue > this.quantityValue) {
                this.quantityValue = this.minValue
            }
            this.field.value = this.quantityValue;
            this.disableIncrease();
            document.dispatchEvent(new CustomEvent('theme:cart:update'));
            if (this.quantityUpdateCart) {
                this.updateCart()
            }
        }
        decrease() {
            if (this.quantityValue > this.minValue) {
                this.quantityValue--;
                return
            }
            this.quantityValue = 0
        }
        increase() {
            this.quantityValue++
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(classes$U.isDisabled, this.quantityValue >= this.maxValue && this.maxValue !== null)
        }
        updateCart() {
            if (this.quantityValue === '')
                return;
            const event = new CustomEvent('theme:cart:update',{
                bubbles: !0,
                detail: {
                    id: this.cartItemID,
                    quantity: this.quantityValue,
                },
            });
            this.holder.dispatchEvent(event)
        }
    }
    const a11y = {
        state: {
            firstFocusable: null,
            lastFocusable: null,
            trigger: null,
        },
        trapFocus: function(options) {
            var focusableElements = Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function(element) {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue('display') !== 'none'
            });
            focusableElements = focusableElements.filter(function(element) {
                return !element.classList.contains('deferred-media__poster')
            });
            this.state.firstFocusable = focusableElements[0];
            this.state.lastFocusable = focusableElements[focusableElements.length - 1];
            if (!options.elementToFocus) {
                options.elementToFocus = this.state.firstFocusable || options.container
            }
            this._setupHandlers();
            document.addEventListener('focusin', this._onFocusInHandler);
            document.addEventListener('focusout', this._onFocusOutHandler);
            options.container.setAttribute('tabindex', '-1');
            options.elementToFocus.focus()
        },
        removeTrapFocus: function(options) {
            const focusVisible = !document.body.classList.contains('no-outline');
            if (options && options.container) {
                options.container.removeAttribute('tabindex')
            }
            document.removeEventListener('focusin', this._onFocusInHandler);
            if (this.state.trigger && focusVisible) {
                this.state.trigger.focus()
            }
        },
        _manageFocus: function(evt) {
            if (evt.code !== theme.keyboardKeys.TAB) {
                return
            }
            if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
                evt.preventDefault();
                this.state.firstFocusable.focus()
            }
            if (evt.target === this.state.firstFocusable && evt.shiftKey) {
                evt.preventDefault();
                this.state.lastFocusable.focus()
            }
        },
        _onFocusOut: function() {
            document.removeEventListener('keydown', this._manageFocusHandler)
        },
        _onFocusIn: function(evt) {
            if (evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable) {
                return
            }
            document.addEventListener('keydown', this._manageFocusHandler)
        },
        _setupHandlers: function() {
            if (!this._onFocusInHandler) {
                this._onFocusInHandler = this._onFocusIn.bind(this)
            }
            if (!this._onFocusOutHandler) {
                this._onFocusOutHandler = this._onFocusIn.bind(this)
            }
            if (!this._manageFocusHandler) {
                this._manageFocusHandler = this._manageFocus.bind(this)
            }
        },
    };
    function getScript(url, callback, callbackError) {
        let head = document.getElementsByTagName('head')[0];
        let done = !1;
        let script = document.createElement('script');
        script.src = url;
        script.onload = script.onreadystatechange = function() {
            if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
                done = !0;
                callback()
            } else {
                callbackError()
            }
        }
        ;
        head.appendChild(script)
    }
    const loaders = {};
    window.isYoutubeAPILoaded = !1;
    window.isVimeoAPILoaded = !1;
    function loadScript(options={}) {
        if (!options.type) {
            options.type = 'json'
        }
        if (options.url) {
            if (loaders[options.url]) {
                return loaders[options.url]
            } else {
                return getScriptWithPromise(options.url, options.type)
            }
        } else if (options.json) {
            if (loaders[options.json]) {
                return Promise.resolve(loaders[options.json])
            } else {
                return window.fetch(options.json).then( (response) => {
                    return response.json()
                }
                ).then( (response) => {
                    loaders[options.json] = response;
                    return response
                }
                )
            }
        } else if (options.name) {
            const key = ''.concat(options.name, options.version);
            if (loaders[key]) {
                return loaders[key]
            } else {
                return loadShopifyWithPromise(options)
            }
        } else {
            return Promise.reject()
        }
    }
    function getScriptWithPromise(url, type) {
        const loader = new Promise( (resolve, reject) => {
            if (type === 'text') {
                fetch(url).then( (response) => response.text()).then( (data) => {
                    resolve(data)
                }
                ).catch( (error) => {
                    reject(error)
                }
                )
            } else {
                getScript(url, function() {
                    resolve()
                }, function() {
                    reject()
                })
            }
        }
        );
        loaders[url] = loader;
        return loader
    }
    function loadShopifyWithPromise(options) {
        const key = ''.concat(options.name, options.version);
        const loader = new Promise( (resolve, reject) => {
            try {
                window.Shopify.loadFeatures([{
                    name: options.name,
                    version: options.version,
                    onLoad: (err) => {
                        onLoadFromShopify(resolve, reject, err)
                    }
                    ,
                }, ])
            } catch (err) {
                reject(err)
            }
        }
        );
        loaders[key] = loader;
        return loader
    }
    function onLoadFromShopify(resolve, reject, err) {
        if (err) {
            return reject(err)
        } else {
            return resolve()
        }
    }
    const selectors$13 = {
        videoIframe: '[data-video-id]',
    };
    const classes$T = {
        loaded: 'loaded',
    };
    const attributes$J = {
        dataEnableSound: 'data-enable-sound',
        dataEnableBackground: 'data-enable-background',
        dataEnableAutoplay: 'data-enable-autoplay',
        dataEnableLoop: 'data-enable-loop',
        dataVideoId: 'data-video-id',
        dataVideoType: 'data-video-type',
    };
    class LoadVideoVimeo {
        constructor(container) {
            this.container = container;
            this.player = this.container.querySelector(selectors$13.videoIframe);
            if (this.player) {
                this.videoID = this.player.getAttribute(attributes$J.dataVideoId);
                this.videoType = this.player.getAttribute(attributes$J.dataVideoType);
                this.enableBackground = this.player.getAttribute(attributes$J.dataEnableBackground) === 'true';
                this.disableSound = this.player.getAttribute(attributes$J.dataEnableSound) === 'false';
                this.enableAutoplay = this.player.getAttribute(attributes$J.dataEnableAutoplay) !== 'false';
                this.enableLoop = this.player.getAttribute(attributes$J.dataEnableLoop) !== 'false';
                if (this.videoType == 'vimeo') {
                    this.init()
                }
            }
        }
        init() {
            this.loadVimeoPlayer()
        }
        loadVimeoPlayer() {
            const oembedUrl = 'https://vimeo.com/api/oembed.json';
            const vimeoUrl = 'https://vimeo.com/' + this.videoID;
            let paramsString = '';
            const state = this.player;
            const params = {
                url: vimeoUrl,
                background: this.enableBackground,
                muted: this.disableSound,
                autoplay: this.enableAutoplay,
                loop: this.enableLoop,
            };
            for (let key in params) {
                paramsString += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
            }
            fetch(`${oembedUrl}?${paramsString}`).then( (response) => response.json()).then(function(data) {
                state.innerHTML = data.html;
                setTimeout(function() {
                    state.parentElement.classList.add(classes$T.loaded)
                }, 1000)
            }).catch(function() {
                console.log('error')
            })
        }
    }
    const selectors$12 = {
        videoIframe: '[data-video-id]',
        videoWrapper: '.video-wrapper',
        youtubeWrapper: '[data-youtube-wrapper]',
    };
    const attributes$I = {
        dataSectionId: 'data-section-id',
        dataEnableSound: 'data-enable-sound',
        dataHideOptions: 'data-hide-options',
        dataCheckPlayerVisibility: 'data-check-player-visibility',
        dataVideoId: 'data-video-id',
        dataVideoType: 'data-video-type',
    };
    const classes$S = {
        loaded: 'loaded',
    };
    const players = [];
    class LoadVideoYT {
        constructor(container) {
            this.container = container;
            this.player = this.container.querySelector(selectors$12.videoIframe);
            if (this.player) {
                this.videoOptionsVars = {};
                this.videoID = this.player.getAttribute(attributes$I.dataVideoId);
                this.videoType = this.player.getAttribute(attributes$I.dataVideoType);
                if (this.videoType == 'youtube') {
                    this.checkPlayerVisibilityFlag = this.player.getAttribute(attributes$I.dataCheckPlayerVisibility) === 'true';
                    this.playerID = this.player.querySelector(selectors$12.youtubeWrapper) ? this.player.querySelector(selectors$12.youtubeWrapper).id : this.player.id;
                    if (this.player.hasAttribute(selectors$12.dataHideOptions)) {
                        this.videoOptionsVars = {
                            cc_load_policy: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            autohide: 0,
                            controls: 0,
                            branding: 0,
                            showinfo: 0,
                            rel: 0,
                            fs: 0,
                            wmode: 'opaque',
                        }
                    }
                    this.init();
                    this.container.addEventListener('touchstart', function(e) {
                        if (e.target.matches(selectors$12.videoWrapper) || e.target.closest(selectors$12.videoWrapper)) {
                            const playerID = e.target.querySelector(selectors$12.videoIframe).id;
                            players[playerID].playVideo()
                        }
                    }, {
                        passive: !0
                    })
                }
            }
        }
        init() {
            if (window.isYoutubeAPILoaded) {
                this.loadYoutubePlayer()
            } else {
                loadScript({
                    url: 'https://www.youtube.com/iframe_api'
                }).then( () => this.loadYoutubePlayer())
            }
        }
        loadYoutubePlayer() {
            const defaultYoutubeOptions = {
                height: '720',
                width: '1280',
                playerVars: this.videoOptionsVars,
                events: {
                    onReady: (event) => {
                        const eventIframe = event.target.getIframe();
                        const id = eventIframe.id;
                        const enableSound = document.querySelector(`#${id}`).getAttribute(attributes$I.dataEnableSound) === 'true';
                        if (enableSound) {
                            event.target.unMute()
                        } else {
                            event.target.mute()
                        }
                        event.target.playVideo();
                        if (this.checkPlayerVisibilityFlag) {
                            this.checkPlayerVisibility(id);
                            window.addEventListener('scroll', throttle( () => {
                                this.checkPlayerVisibility(id)
                            }
                            , 150))
                        }
                    }
                    ,
                    onStateChange: (event) => {
                        if (event.data == 0) {
                            event.target.playVideo()
                        }
                        if (event.data == 1) {
                            event.target.getIframe().parentElement.classList.add(classes$S.loaded)
                        }
                    }
                    ,
                },
            };
            const currentYoutubeOptions = {
                ...defaultYoutubeOptions
            };
            currentYoutubeOptions.videoId = this.videoID;
            if (this.videoID.length) {
                YT.ready( () => {
                    players[this.playerID] = new YT.Player(this.playerID,currentYoutubeOptions)
                }
                )
            }
            window.isYoutubeAPILoaded = !0
        }
        checkPlayerVisibility(id) {
            let playerID;
            if (typeof id === 'string') {
                playerID = id
            } else if (id.data != undefined) {
                playerID = id.data.id
            } else {
                return
            }
            const playerElement = document.getElementById(playerID + '-container');
            if (!playerElement) {
                return
            }
            const player = players[playerID];
            const box = playerElement.getBoundingClientRect();
            let isVisible = visibilityHelper.isElementPartiallyVisible(playerElement) || visibilityHelper.isElementTotallyVisible(playerElement);
            if (box.top < 0 && playerElement.clientHeight + box.top >= 0) {
                isVisible = !0
            }
            if (isVisible && player && typeof player.playVideo === 'function') {
                player.playVideo()
            } else if (!isVisible && player && typeof player.pauseVideo === 'function') {
                player.pauseVideo()
            }
        }
        onUnload() {
            const playerID = 'youtube-' + this.container.getAttribute(attributes$I.dataSectionId);
            if (!players[playerID]) {
                return
            }
            players[playerID].destroy()
        }
    }
    const selectors$11 = {
        notificationForm: '[data-notification-form]',
        notification: '[data-notification]',
        popupClose: '[data-popup-close]',
    };
    const classes$R = {
        popupSuccess: 'pswp--success',
        notificationPopupVisible: 'notification-popup-visible',
    };
    class LoadNotification {
        constructor(popup, pswpElement) {
            this.popup = popup;
            this.pswpElement = pswpElement;
            this.notificationForm = null;
            this.notificationStopSubmit = !0;
            this.sessionStorage = window.sessionStorage;
            const notificationWrapper = this.pswpElement.querySelector(selectors$11.notification);
            this.outerCloseEvent = (e) => {
                if (!notificationWrapper.contains(e.target)) {
                    this.popup.close()
                }
            }
            ;
            this.init()
        }
        init() {
            this.popup.listen('preventDragEvent', (e, isDown, preventObj) => {
                preventObj.prevent = !1
            }
            );
            const notificationFormSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
            this.notificationForm = this.pswpElement.querySelector(selectors$11.notificationForm);
            const closeBtn = this.pswpElement.querySelector(selectors$11.popupClose);
            document.body.classList.add(classes$R.notificationPopupVisible);
            this.pswpElement.addEventListener('mousedown', () => {
                this.popup.framework.unbind(window, 'pointermove pointerup pointercancel', this.popup)
            }
            );
            if (notificationFormSuccess) {
                this.pswpElement.classList.add(classes$R.popupSuccess)
            }
            this.notificationForm.addEventListener('submit', (e) => this.notificationSubmitEvent(e));
            this.pswpElement.addEventListener('click', this.outerCloseEvent);
            closeBtn.addEventListener('click', () => {
                this.popup.close()
            }
            );
            this.popup.listen('destroy', () => {
                this.notificationRemoveStorage();
                this.pswpElement.removeEventListener('click', this.outerCloseEvent);
                document.body.classList.remove(classes$R.notificationPopupVisible)
            }
            )
        }
        notificationSubmitEvent(e) {
            if (this.notificationStopSubmit) {
                e.preventDefault();
                this.notificationRemoveStorage();
                this.notificationWriteStorage();
                this.notificationStopSubmit = !1;
                this.notificationForm.submit()
            }
        }
        notificationWriteStorage() {
            if (this.sessionStorage !== undefined) {
                this.sessionStorage.setItem('notification_form_id', this.notificationForm.id)
            }
        }
        notificationRemoveStorage() {
            this.sessionStorage.removeItem('notification_form_id')
        }
    }
    function flickitySmoothScrolling(slider) {
        const flkty = Flickity.data(slider);
        if (!flkty) {
            return
        }
        flkty.on('dragStart', (event, pointer) => {
            document.ontouchmove = function(e) {
                e.preventDefault()
            }
        }
        );
        flkty.on('dragEnd', (event, pointer) => {
            document.ontouchmove = function(e) {
                return !0
            }
        }
        )
    }
    const hosts = {
        html5: 'html5',
        youtube: 'youtube',
        vimeo: 'vimeo',
    };
    const selectors$10 = {
        deferredMedia: '[data-deferred-media]',
        deferredMediaButton: '[data-deferred-media-button]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        mediaContainer: '[data-video]',
        mediaHidden: '.media--hidden',
    };
    const classes$Q = {
        mediaHidden: 'media--hidden',
    };
    const attributes$H = {
        loaded: 'loaded',
        sectionId: 'data-section-id',
        dataAutoplayVideo: 'data-autoplay-video',
        mediaId: 'data-media-id',
    };
    class ProductVideo {
        constructor(container) {
            this.container = container;
            this.id = this.container.getAttribute(attributes$H.sectionId);
            this.autoplayVideo = this.container.getAttribute(attributes$H.dataAutoplayVideo) === 'true';
            this.players = {};
            this.pauseContainerMedia = (mediaId, container=this.container) => this.pauseOtherMedia(mediaId, container);
            this.init()
        }
        init() {
            const mediaContainers = this.container.querySelectorAll(selectors$10.mediaContainer);
            mediaContainers.forEach( (mediaContainer) => {
                const deferredMediaButton = mediaContainer.querySelector(selectors$10.deferredMediaButton);
                if (deferredMediaButton) {
                    deferredMediaButton.addEventListener('click', this.loadContent.bind(this, mediaContainer))
                }
                if (this.autoplayVideo) {
                    this.loadContent(mediaContainer)
                }
            }
            )
        }
        loadContent(mediaContainer) {
            if (mediaContainer.querySelector(selectors$10.deferredMedia).getAttribute(attributes$H.loaded)) {
                return
            }
            const content = document.createElement('div');
            content.appendChild(mediaContainer.querySelector('template').content.firstElementChild.cloneNode(!0));
            const mediaId = mediaContainer.dataset.mediaId;
            const element = content.querySelector('video, iframe');
            const host = this.hostFromVideoElement(element);
            const deferredMedia = mediaContainer.querySelector(selectors$10.deferredMedia);
            deferredMedia.appendChild(element);
            deferredMedia.setAttribute('loaded', !0);
            this.players[mediaId] = {
                mediaId: mediaId,
                sectionId: this.id,
                container: mediaContainer,
                element: element,
                host: host,
                ready: () => {
                    this.createPlayer(mediaId)
                }
                ,
            };
            const video = this.players[mediaId];
            switch (video.host) {
            case hosts.html5:
                this.loadVideo(video, hosts.html5);
                break;
            case hosts.vimeo:
                if (window.isVimeoAPILoaded) {
                    this.loadVideo(video, hosts.vimeo)
                } else {
                    loadScript({
                        url: 'https://player.vimeo.com/api/player.js'
                    }).then( () => this.loadVideo(video, hosts.vimeo))
                }
                break;
            case hosts.youtube:
                if (window.isYoutubeAPILoaded) {
                    this.loadVideo(video, hosts.youtube)
                } else {
                    loadScript({
                        url: 'https://www.youtube.com/iframe_api'
                    }).then( () => this.loadVideo(video, hosts.youtube))
                }
                break
            }
        }
        hostFromVideoElement(video) {
            if (video.tagName === 'VIDEO') {
                return hosts.html5
            }
            if (video.tagName === 'IFRAME') {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src)) {
                    return hosts.youtube
                } else if (video.src.includes('vimeo.com')) {
                    return hosts.vimeo
                }
            }
            return null
        }
        loadVideo(video, host) {
            if (video.host === host) {
                video.ready()
            }
        }
        createPlayer(mediaId) {
            const video = this.players[mediaId];
            switch (video.host) {
            case hosts.html5:
                video.element.addEventListener('play', () => {
                    video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                        bubbles: !0
                    })
                }
                );
                video.element.addEventListener('pause', () => {
                    video.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
                        bubbles: !0
                    })
                }
                );
                if (this.autoplayVideo) {
                    this.observeVideo(video, mediaId)
                }
                break;
            case hosts.vimeo:
                video.player = new Vimeo.Player(video.element);
                video.player.play();
                video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                    bubbles: !0
                });
                window.isVimeoAPILoaded = !0;
                video.player.on('play', () => {
                    video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                        bubbles: !0
                    })
                }
                );
                video.player.on('pause', () => {
                    video.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
                        bubbles: !0
                    })
                }
                );
                if (this.autoplayVideo) {
                    this.observeVideo(video, mediaId)
                }
                break;
            case hosts.youtube:
                if (video.host == hosts.youtube && video.player) {
                    return
                }
                YT.ready( () => {
                    const videoId = video.container.dataset.videoId;
                    video.player = new YT.Player(video.element,{
                        videoId: videoId,
                        events: {
                            onReady: (event) => {
                                event.target.playVideo();
                                video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                                    bubbles: !0
                                })
                            }
                            ,
                            onStateChange: (event) => {
                                if (event.data == 1) {
                                    video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                                        bubbles: !0
                                    })
                                }
                                if (event.data == 2) {
                                    video.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
                                        bubbles: !0
                                    })
                                }
                                if (event.data == 0) {
                                    video.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
                                        bubbles: !0
                                    })
                                }
                            }
                            ,
                        },
                    });
                    window.isYoutubeAPILoaded = !0;
                    if (this.autoplayVideo) {
                        this.observeVideo(video, mediaId)
                    }
                }
                );
                break
            }
            video.container.addEventListener('theme:media:visible', (event) => this.onVisible(event));
            video.container.addEventListener('theme:media:hidden', (event) => this.onHidden(event));
            video.container.addEventListener('xrLaunch', (event) => this.onHidden(event))
        }
        observeVideo(video) {
            let observer = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    const outsideViewport = entry.intersectionRatio == 0;
                    const isVisible = !video.element.closest(selectors$10.mediaHidden);
                    if (outsideViewport) {
                        this.pauseVideo(video)
                    } else if (isVisible) {
                        this.playVideo(video)
                    }
                }
                )
            }
            ,{
                rootMargin: '200px',
                threshold: [0, 0.25, 0.75, 1],
            });
            observer.observe(video.element)
        }
        playVideo(video) {
            if (video.player && video.player.playVideo) {
                video.player.playVideo()
            } else if (video.element && video.element.play) {
                video.element.play()
            } else if (video.player && video.player.play) {
                video.player.play()
            }
            video.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                bubbles: !0
            })
        }
        pauseVideo(video) {
            if (video.player && video.player.pauseVideo) {
                if (video.player.playerInfo.playerState == '1') {
                    video.player.pauseVideo()
                }
            } else if (video.player && video.player.pause) {
                video.player.pause()
            } else if (video.element && !video.element.paused) {
                if (typeof video.element.pause === 'function') {
                    video.element?.pause()
                }
            }
        }
        onHidden(event) {
            if (typeof event.target.dataset.mediaId !== 'undefined') {
                const mediaId = event.target.dataset.mediaId;
                const video = this.players[mediaId];
                this.pauseVideo(video)
            }
        }
        onVisible(event) {
            if (typeof event.target.dataset.mediaId !== 'undefined') {
                const mediaId = event.target.dataset.mediaId;
                const video = this.players[mediaId];
                setTimeout( () => {
                    this.playVideo(video)
                }
                , 50);
                this.pauseContainerMedia(mediaId)
            }
        }
        pauseOtherMedia(mediaId, container) {
            const currentMedia = `[${attributes$H.mediaId}="${mediaId}"]`;
            const otherMedia = container.querySelectorAll(`${selectors$10.productMediaWrapper}:not(${currentMedia})`);
            if (otherMedia.length) {
                otherMedia.forEach( (media) => {
                    media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                        bubbles: !0
                    });
                    media.classList.add(classes$Q.mediaHidden)
                }
                )
            }
        }
    }
    function getSearchParams(searchForm, filtersForm, deleteParams=[], type=!1) {
        const searchFormData = new FormData(searchForm);
        const searchFormParams = new URLSearchParams(searchFormData);
        if (!filtersForm)
            return searchFormParams.toString();
        const filtersFormData = new FormData(filtersForm);
        const filtersFormParams = new URLSearchParams(filtersFormData);
        const emptyParams = [];
        for (const pair of searchFormData.entries()) {
            if (pair[1] === '')
                emptyParams.push(pair[0]);
        }
        for (const pair of filtersFormData.entries()) {
            if (pair[1] === '')
                emptyParams.push(pair[0]);
        }
        for (let index = 0; index < emptyParams.length; index++) {
            const param = emptyParams[index];
            if (searchFormParams.has(param))
                searchFormParams.delete(param);
            if (filtersFormParams.has(param))
                filtersFormParams.delete(param);
        }
        for (const key of searchFormParams.keys()) {
            if (filtersFormParams.has(key))
                filtersFormParams.delete(key);
        }
        if (deleteParams.length > 0) {
            for (let index = 0; index < deleteParams.length; index++) {
                const param = deleteParams[index];
                if (searchFormParams.has(param))
                    searchFormParams.delete(param);
                if (filtersFormParams.has(param))
                    filtersFormParams.delete(param);
            }
        }
        if (type) {
            if (filtersFormParams.has('type'))
                filtersFormParams.delete('type');
            searchFormParams.set('type', type)
        }
        return `${searchFormParams.toString()}&${filtersFormParams.toString()}`
    }
    const selectors$$ = {
        scrollbar: '[data-custom-scrollbar]',
        scrollbarItems: '[data-custom-scrollbar-items]',
        scrollbarThumb: '[data-custom-scrollbar-thumb]',
        current: '.current',
    };
    class CustomScrollbar {
        constructor(container) {
            this.container = container;
            this.scrollbarItems = container.querySelector(selectors$$.scrollbarItems);
            this.scrollbar = container.querySelector(selectors$$.scrollbar);
            this.scrollbarThumb = container.querySelector(selectors$$.scrollbarThumb);
            this.trackWidth = 0;
            this.calcScrollbarEvent = () => this.calculateScrollbar();
            this.onScrollbarChangeEvent = (e) => this.onScrollbarChange(e);
            if (this.scrollbar && this.scrollbarItems) {
                this.events();
                this.calculateScrollbar();
                if (this.scrollbarItems.children.length) {
                    this.calculateTrack(this.scrollbarItems.querySelector(selectors$$.current))
                }
            }
        }
        calculateTrack(element) {
            if (!element) {
                this.scrollbar.style.setProperty('--thumb-scale', 0);
                this.scrollbar.style.setProperty('--thumb-position', '0px');
                return
            }
            const thumbScale = element.clientWidth / this.scrollbarThumb.parentElement.clientWidth;
            const thumbPosition = element.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            this.scrollbar.style.setProperty('--thumb-scale', thumbScale);
            this.scrollbar.style.setProperty('--thumb-position', `${this.trackWidth * thumbPosition}px`)
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const childrenArr = [...this.scrollbarItems.children];
                this.trackWidth = 0;
                childrenArr.forEach( (element) => {
                    this.trackWidth += element.getBoundingClientRect().width + parseInt(window.getComputedStyle(element).marginRight)
                }
                );
                this.scrollbar.style.setProperty('--track-width', `${this.trackWidth}px`)
            }
        }
        onScrollbarChange(e) {
            if (e && e.detail && e.detail.element && this.container.contains(e.detail.element)) {
                this.calculateTrack(e.detail.element)
            }
        }
        events() {
            document.addEventListener('theme:resize:width', this.calcScrollbarEvent);
            document.addEventListener('theme:custom-scrollbar:change', this.onScrollbarChangeEvent)
        }
        unload() {
            document.removeEventListener('theme:resize:width', this.calcScrollbarEvent);
            document.removeEventListener('theme:custom-scrollbar:change', this.onScrollbarChangeEvent)
        }
    }
    const selectors$_ = {
        tooltip: '[data-tooltip]',
        tooltipContainer: '[data-tooltip-container]',
        tooltipArrow: '[data-tooltip-arrow]',
        aos: '[data-aos]',
    };
    const classes$P = {
        root: 'tooltip-default',
        isAnimating: 'is-animating',
        visible: 'is-visible',
        hiding: 'is-hiding',
    };
    const attributes$G = {
        aos: 'data-aos',
        tooltip: 'data-tooltip',
        tooltipContainer: 'data-tooltip-container',
        tooltipStopMouseEnter: 'data-tooltip-stop-mouseenter',
    };
    const sections$F = {};
    class Tooltip {
        constructor(el) {
            this.tooltip = el;
            if (!this.tooltip.hasAttribute(attributes$G.tooltip)) {
                return
            }
            this.rootClass = classes$P.root;
            this.isAnimatingClass = classes$P.isAnimating;
            this.label = this.tooltip.getAttribute(attributes$G.tooltip);
            this.transitionSpeed = 200;
            this.hideTransitionTimeout = 0;
            this.animatedContainer = this.tooltip.closest(selectors$_.aos);
            this.addPinEvent = () => this.addPin();
            this.addPinMouseEvent = () => this.addPin(!0);
            this.removePinEvent = (event) => throttle(this.removePin(event), 50);
            this.removePinMouseEvent = (event) => this.removePin(event, !0, !0);
            this.init()
        }
        init() {
            if (!document.querySelector(selectors$_.tooltipContainer)) {
                const tooltipTemplate = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`;
                const tooltipElement = document.createElement('div');
                tooltipElement.className = `${this.rootClass} ${this.isAnimatingClass}`;
                tooltipElement.setAttribute(attributes$G.tooltipContainer, '');
                tooltipElement.innerHTML = tooltipTemplate;
                document.body.appendChild(tooltipElement)
            }
            this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent);
            this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent);
            this.tooltip.addEventListener('theme:tooltip:init', this.addPinEvent);
            document.addEventListener('theme:tooltip:close', this.removePinEvent);
            const tooltipTarget = document.querySelector(selectors$_.tooltipContainer);
            if (theme.settings.animationsEnabled && this.animatedContainer) {
                if (this.animatedContainer.getAttribute(attributes$G.aos) === 'hero') {
                    this.animatedContainer.addEventListener('animationend', () => {
                        tooltipTarget.classList.remove(classes$P.isAnimating)
                    }
                    )
                } else {
                    this.animatedContainer.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'transform') {
                            tooltipTarget.classList.remove(classes$P.isAnimating)
                        }
                    }
                    )
                }
            }
        }
        addPin(stopMouseEnter=!1) {
            const tooltipTarget = document.querySelector(selectors$_.tooltipContainer);
            const tooltipTargetArrow = tooltipTarget.querySelector(selectors$_.tooltipArrow);
            if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(attributes$G.tooltipStopMouseEnter)) || !stopMouseEnter)) {
                const tooltipTargetInner = tooltipTarget.querySelector(`.${this.rootClass}__inner`);
                const tooltipTargetText = tooltipTarget.querySelector(`.${this.rootClass}__text`);
                tooltipTargetText.textContent = this.label;
                const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
                const tooltipRect = this.tooltip.getBoundingClientRect();
                const tooltipTop = tooltipRect.top;
                const tooltipWidth = tooltipRect.width;
                const tooltipHeight = tooltipRect.height;
                const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
                let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
                let tooltipArrowPositionLeft = '50%';
                const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
                const tooltipTargetWindowDifference = tooltipLeftWithWidth - window.innerWidth;
                if (tooltipTargetWindowDifference > 0) {
                    tooltipTargetPositionLeft -= tooltipTargetWindowDifference
                }
                if (tooltipTargetPositionLeft < 0) {
                    tooltipArrowPositionLeft = `calc(50% + ${tooltipTargetPositionLeft}px)`;
                    tooltipTargetPositionLeft = 0
                }
                tooltipTargetArrow.style.left = tooltipArrowPositionLeft;
                tooltipTarget.style.transform = `translate(${tooltipTargetPositionLeft}px, ${tooltipTargetPositionTop}px)`;
                tooltipTarget.classList.remove(classes$P.hiding);
                const onTooltipHiding = (event) => {
                    if (event.target !== tooltipTargetInner)
                        return;
                    if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
                        requestAnimationFrame( () => (tooltipTarget.style.transform = 'translate(0, -100%)'))
                    }
                    tooltipTarget.removeEventListener('transitionend', onTooltipHiding)
                }
                ;
                tooltipTarget.addEventListener('transitionend', onTooltipHiding);
                tooltipTarget.classList.add(classes$P.visible);
                document.addEventListener('theme:scroll', this.removePinEvent)
            }
        }
        removePin(event, stopMouseEnter=!1, hideTransition=!1) {
            const tooltipTarget = document.querySelector(selectors$_.tooltipContainer);
            const tooltipVisible = tooltipTarget.classList.contains(classes$P.visible);
            if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(attributes$G.tooltipStopMouseEnter)) || !stopMouseEnter)) {
                if (tooltipVisible && (hideTransition || event.detail.hideTransition)) {
                    tooltipTarget.classList.add(classes$P.hiding);
                    if (this.hideTransitionTimeout) {
                        clearTimeout(this.hideTransitionTimeout)
                    }
                    this.hideTransitionTimeout = setTimeout( () => {
                        tooltipTarget.classList.remove(classes$P.hiding)
                    }
                    , this.transitionSpeed)
                }
                tooltipTarget.classList.remove(classes$P.visible);
                document.removeEventListener('theme:scroll', this.removePinEvent)
            }
        }
        unload() {
            this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent);
            this.tooltip.removeEventListener('mouseleave', this.removePinMouseEvent);
            this.tooltip.removeEventListener('theme:tooltip:init', this.addPinEvent);
            document.removeEventListener('theme:tooltip:close', this.removePinEvent);
            document.removeEventListener('theme:scroll', this.removePinEvent)
        }
    }
    const tooltip = {
        onLoad() {
            sections$F[this.id] = [];
            const tooltips = this.container.querySelectorAll(selectors$_.tooltip);
            tooltips.forEach( (tooltip) => {
                sections$F[this.id].push(new Tooltip(tooltip))
            }
            )
        },
        onUnload() {
            sections$F[this.id].forEach( (tooltip) => {
                if (typeof tooltip.unload === 'function') {
                    tooltip.unload()
                }
            }
            )
        },
    };
    const selectors$Z = {
        rangeSlider: '[data-range-slider]',
        rangeDotLeft: '[data-range-left]',
        rangeDotRight: '[data-range-right]',
        rangeLine: '[data-range-line]',
        rangeHolder: '[data-range-holder]',
        dataMin: 'data-se-min',
        dataMax: 'data-se-max',
        dataMinValue: 'data-se-min-value',
        dataMaxValue: 'data-se-max-value',
        dataStep: 'data-se-step',
        dataFilterUpdate: 'data-range-filter-update',
        priceMin: '[data-field-price-min]',
        priceMax: '[data-field-price-max]',
    };
    const classes$O = {
        isInitialized: 'is-initialized',
    };
    class RangeSlider {
        constructor(container) {
            this.container = container;
            this.init();
            this.initListener = () => this.init();
            document.addEventListener('theme:filters:init', this.initListener)
        }
        init() {
            this.slider = this.container.querySelector(selectors$Z.rangeSlider);
            if (!this.slider) {
                return
            }
            this.resizeFilters = debounce(this.reset.bind(this), 50);
            this.onMoveEvent = (event) => this.onMove(event);
            this.onStopEvent = (event) => this.onStop(event);
            this.onStartEvent = (event) => this.onStart(event);
            this.startX = 0;
            this.x = 0;
            this.touchLeft = this.slider.querySelector(selectors$Z.rangeDotLeft);
            this.touchRight = this.slider.querySelector(selectors$Z.rangeDotRight);
            this.lineSpan = this.slider.querySelector(selectors$Z.rangeLine);
            this.min = parseFloat(this.slider.getAttribute(selectors$Z.dataMin));
            this.max = parseFloat(this.slider.getAttribute(selectors$Z.dataMax));
            this.step = 0.0;
            this.normalizeFact = 20;
            let defaultMinValue = this.min;
            if (this.slider.hasAttribute(selectors$Z.dataMinValue)) {
                defaultMinValue = parseFloat(this.slider.getAttribute(selectors$Z.dataMinValue))
            }
            let defaultMaxValue = this.max;
            if (this.slider.hasAttribute(selectors$Z.dataMaxValue)) {
                defaultMaxValue = parseFloat(this.slider.getAttribute(selectors$Z.dataMaxValue))
            }
            if (defaultMinValue < this.min) {
                defaultMinValue = this.min
            }
            if (defaultMaxValue > this.max) {
                defaultMaxValue = this.max
            }
            if (defaultMinValue > defaultMaxValue) {
                defaultMinValue = defaultMaxValue
            }
            if (this.slider.getAttribute(selectors$Z.dataStep)) {
                this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors$Z.dataStep)))
            }
            this.reset();
            window.addEventListener('theme:resize', this.resizeFilters);
            this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth;
            this.selectedTouch = null;
            this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact;
            this.setMinValue(defaultMinValue);
            this.setMaxValue(defaultMaxValue);
            this.touchLeft.addEventListener('mousedown', this.onStartEvent);
            this.touchRight.addEventListener('mousedown', this.onStartEvent);
            this.touchLeft.addEventListener('touchstart', this.onStartEvent, {
                passive: !0
            });
            this.touchRight.addEventListener('touchstart', this.onStartEvent, {
                passive: !0
            });
            this.slider.classList.add(classes$O.isInitialized)
        }
        reset() {
            this.touchLeft.style.left = '0px';
            this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
            this.lineSpan.style.marginLeft = '0px';
            this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
            this.startX = 0;
            this.x = 0;
            this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth;
            this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact
        }
        setMinValue(minValue) {
            const ratio = (minValue - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + 'px';
            this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
            this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
            this.slider.setAttribute(selectors$Z.dataMinValue, minValue)
        }
        setMaxValue(maxValue) {
            const ratio = (maxValue - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + 'px';
            this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
            this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
            this.slider.setAttribute(selectors$Z.dataMaxValue, maxValue)
        }
        onStart(event) {
            event.preventDefault();
            let eventTouch = event;
            if (event.touches) {
                eventTouch = event.touches[0]
            }
            if (event.currentTarget === this.touchLeft) {
                this.x = this.touchLeft.offsetLeft
            } else if (event.currentTarget === this.touchRight) {
                this.x = this.touchRight.offsetLeft
            }
            this.startX = eventTouch.pageX - this.x;
            this.selectedTouch = event.currentTarget;
            document.addEventListener('mousemove', this.onMoveEvent);
            document.addEventListener('mouseup', this.onStopEvent);
            document.addEventListener('touchmove', this.onMoveEvent, {
                passive: !0
            });
            document.addEventListener('touchend', this.onStopEvent, {
                passive: !0
            })
        }
        onMove(event) {
            let eventTouch = event;
            if (event.touches) {
                eventTouch = event.touches[0]
            }
            this.x = eventTouch.pageX - this.startX;
            if (this.selectedTouch === this.touchLeft) {
                if (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) {
                    this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                } else if (this.x < 0) {
                    this.x = 0
                }
                this.selectedTouch.style.left = this.x + 'px'
            } else if (this.selectedTouch === this.touchRight) {
                if (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) {
                    this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                } else if (this.x > this.maxX) {
                    this.x = this.maxX
                }
                this.selectedTouch.style.left = this.x + 'px'
            }
            this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
            this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
            this.calculateValue();
            if (this.slider.getAttribute('on-change')) {
                const fn = new Function('min, max',this.slider.getAttribute('on-change'));
                fn(this.slider.getAttribute(selectors$Z.dataMinValue), this.slider.getAttribute(selectors$Z.dataMaxValue))
            }
            this.onChange(this.slider.getAttribute(selectors$Z.dataMinValue), this.slider.getAttribute(selectors$Z.dataMaxValue))
        }
        onStop(event) {
            document.removeEventListener('mousemove', this.onMoveEvent);
            document.removeEventListener('mouseup', this.onStopEvent);
            document.removeEventListener('touchmove', this.onMoveEvent, {
                passive: !0
            });
            document.removeEventListener('touchend', this.onStopEvent, {
                passive: !0
            });
            this.selectedTouch = null;
            this.calculateValue();
            this.onChanged(this.slider.getAttribute(selectors$Z.dataMinValue), this.slider.getAttribute(selectors$Z.dataMaxValue))
        }
        onChange(min, max) {
            const rangeHolder = this.slider.closest(selectors$Z.rangeHolder);
            if (rangeHolder) {
                const priceMin = rangeHolder.querySelector(selectors$Z.priceMin);
                const priceMax = rangeHolder.querySelector(selectors$Z.priceMax);
                if (priceMin && priceMax) {
                    priceMin.value = parseInt(min);
                    priceMax.value = parseInt(max)
                }
            }
        }
        onChanged(min, max) {
            if (this.slider.hasAttribute(selectors$Z.dataFilterUpdate)) {
                this.slider.dispatchEvent(new CustomEvent('theme:filter:range-update',{
                    bubbles: !0
                }))
            }
        }
        calculateValue() {
            const newValue = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let minValue = this.lineSpan.offsetLeft / this.initialValue;
            let maxValue = minValue + newValue;
            minValue = minValue * (this.max - this.min) + this.min;
            maxValue = maxValue * (this.max - this.min) + this.min;
            if (this.step !== 0.0) {
                let multi = Math.floor(minValue / this.step);
                minValue = this.step * multi;
                multi = Math.floor(maxValue / this.step);
                maxValue = this.step * multi
            }
            if (this.selectedTouch === this.touchLeft) {
                this.slider.setAttribute(selectors$Z.dataMinValue, minValue)
            }
            if (this.selectedTouch === this.touchRight) {
                this.slider.setAttribute(selectors$Z.dataMaxValue, maxValue)
            }
        }
        unload() {
            document.removeEventListener('theme:filters:init', this.initListener);
            window.removeEventListener('theme:resize', this.resizeFilters)
        }
    }
    function Listeners() {
        this.entries = []
    }
    Listeners.prototype.add = function(element, event, fn) {
        this.entries.push({
            element: element,
            event: event,
            fn: fn
        });
        element.addEventListener(event, fn)
    }
    ;
    Listeners.prototype.removeAll = function() {
        this.entries = this.entries.filter(function(listener) {
            listener.element.removeEventListener(listener.event, listener.fn);
            return !1
        })
    }
    ;
    function getVariantFromSerializedArray(product, collection) {
        _validateProductStructure(product);
        var optionArray = _createOptionArrayFromOptionCollection(product, collection);
        return getVariantFromOptionArray(product, optionArray)
    }
    function getVariantFromOptionArray(product, options) {
        _validateProductStructure(product);
        _validateOptionsArray(options);
        var result = product.variants.filter(function(variant) {
            return options.every(function(option, index) {
                return variant.options[index] === option
            })
        });
        var stickySizeOption = document.querySelector("[data-sticky-option-position]");
        if (stickySizeOption) {
            var optionPosition = stickySizeOption.getAttribute("data-sticky-option-position");
            if (result.length) {
                stickySizeOption.innerHTML = result[0].options[optionPosition]
            }
        }
        return result[0] || null
    }
    function _createOptionArrayFromOptionCollection(product, collection) {
        _validateProductStructure(product);
        _validateSerializedArray(collection);
        var optionArray = [];
        collection.forEach(function(option) {
            for (var i = 0; i < product.options.length; i++) {
                var name = product.options[i].name || product.options[i];
                if (name.toLowerCase() === option.name.toLowerCase()) {
                    optionArray[i] = option.value;
                    break
                }
            }
        });
        return optionArray
    }
    function _validateProductStructure(product) {
        if (typeof product !== 'object') {
            throw new TypeError(product + ' is not an object.')
        }
        if (Object.keys(product).length === 0 && product.constructor === Object) {
            throw new Error(product + ' is empty.')
        }
    }
    function _validateSerializedArray(collection) {
        if (!Array.isArray(collection)) {
            throw new TypeError(collection + ' is not an array.')
        }
        if (collection.length === 0) {
            throw new Error(collection + ' is empty.')
        }
        if (collection[0].hasOwnProperty('name')) {
            if (typeof collection[0].name !== 'string') {
                throw new TypeError('Invalid value type passed for name of option ' + collection[0].name + '. Value should be string.')
            }
        } else {
            throw new Error(collection[0] + 'does not contain name key.')
        }
    }
    function _validateOptionsArray(options) {
        if (Array.isArray(options) && typeof options[0] === 'object') {
            throw new Error(options + 'is not a valid array of options.')
        }
    }
    var selectors$Y = {
        idInput: '[name="id"]',
        planInput: '[name="selling_plan"]',
        optionInput: '[name^="options"]',
        quantityInput: '[name="quantity"]',
        propertyInput: '[name^="properties"]',
    };
    function getUrlWithVariant(url, id) {
        if (/variant=/.test(url)) {
            return url.replace(/(variant=)[^&]+/, '$1' + id)
        } else if (/\?/.test(url)) {
            return url.concat('&variant=').concat(id)
        }
        return url.concat('?variant=').concat(id)
    }
    class ProductForm {
        constructor(element, product, options) {
            this.element = element;
            this.form = this.element.tagName == 'FORM' ? this.element : this.element.querySelector('form');
            this.product = this._validateProductObject(product);
            this.variantElement = this.element.querySelector(selectors$Y.idInput);
            options = options || {};
            this._listeners = new Listeners();
            this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, options));
            this.optionInputs = this._initInputs(selectors$Y.optionInput, options.onOptionChange);
            this.planInputs = this._initInputs(selectors$Y.planInput, options.onPlanChange);
            this.quantityInputs = this._initInputs(selectors$Y.quantityInput, options.onQuantityChange);
            this.propertyInputs = this._initInputs(selectors$Y.propertyInput, options.onPropertyChange)
        }
        destroy() {
            this._listeners.removeAll()
        }
        options() {
            return this._serializeInputValues(this.optionInputs, function(item) {
                var regex = /(?:^(options\[))(.*?)(?:\])/;
                item.name = regex.exec(item.name)[2];
                return item
            })
        }
        variant() {
            const opts = this.options();
            if (opts.length) {
                if (document.querySelectorAll(".shop-availability-container").length) {
                    var variantObj = getVariantFromSerializedArray(this.product, opts);
                    if (variantObj) {
                        document.querySelectorAll(".shop-availability-container").forEach(function(availabilityContainer) {
                            if (availabilityContainer.getAttribute("data-variant-id") == variantObj.id) {
                                availabilityContainer.removeAttribute("hidden")
                            } else {
                                availabilityContainer.setAttribute("hidden", "")
                            }
                        })
                    }
                }
                return getVariantFromSerializedArray(this.product, opts)
            } else {
                return this.product.variants[0]
            }
        }
        plan(variant) {
            let plan = {
                allocation: null,
                group: null,
                detail: null,
            };
            const formData = new FormData(this.form);
            const id = formData.get('selling_plan');
            if (id && variant) {
                plan.allocation = variant.selling_plan_allocations.find(function(item) {
                    return item.selling_plan_id.toString() === id.toString()
                })
            }
            if (plan.allocation) {
                plan.group = this.product.selling_plan_groups.find(function(item) {
                    return item.id.toString() === plan.allocation.selling_plan_group_id.toString()
                })
            }
            if (plan.group) {
                plan.detail = plan.group.selling_plans.find(function(item) {
                    return item.id.toString() === id.toString()
                })
            }
            if (plan && plan.allocation && plan.detail && plan.allocation) {
                return plan
            } else
                return null
        }
        properties() {
            return this._serializeInputValues(this.propertyInputs, function(item) {
                var regex = /(?:^(properties\[))(.*?)(?:\])/;
                item.name = regex.exec(item.name)[2];
                return item
            })
        }
        quantity() {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
        }
        getFormState() {
            const variant = this.variant();
            return {
                options: this.options(),
                variant: variant,
                properties: this.properties(),
                quantity: this.quantity(),
                plan: this.plan(variant),
            }
        }
        _setIdInputValue(variant) {
            if (variant && variant.id) {
                this.variantElement.value = variant.id.toString()
            } else {
                this.variantElement.value = ''
            }
            this.variantElement.dispatchEvent(new Event('change'))
        }
        _onSubmit(options, event) {
            event.dataset = this.getFormState();
            if (options.onFormSubmit) {
                options.onFormSubmit(event)
            }
        }
        _onOptionChange(event) {
            this._setIdInputValue(event.dataset.variant)
        }
        _onFormEvent(cb) {
            if (typeof cb === 'undefined') {
                return Function.prototype.bind()
            }
            return function(event) {
                event.dataset = this.getFormState();
                this._setIdInputValue(event.dataset.variant);
                cb(event)
            }
            .bind(this)
        }
        _initInputs(selector, cb) {
            var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
            return elements.map(function(element) {
                this._listeners.add(element, 'change', this._onFormEvent(cb));
                return element
            }
            .bind(this))
        }
        _serializeInputValues(inputs, transform) {
            return inputs.reduce(function(options, input) {
                if (input.checked || (input.type !== 'radio' && input.type !== 'checkbox')) {
                    if (input.checked) {
                        var originalID = input.getAttribute("id");
                        if (document.querySelector("#" + originalID + "-desktop")) {
                            document.querySelector("#" + originalID + "-desktop").checked = !0
                        }
                        if (document.querySelector("#" + originalID + "-mobile")) {
                            document.querySelector("#" + originalID + "-mobile").checked = !0
                        }
                    }
                    options.push(transform({
                        name: input.name,
                        value: input.value
                    }))
                }
                return options
            }, [])
        }
        _validateProductObject(product) {
            if (typeof product !== 'object') {
                throw new TypeError(product + ' is not an object.')
            }
            if (typeof product.variants[0].options === 'undefined') {
                throw new TypeError('Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route')
            }
            return product
        }
    }
    function fetchProduct(handle) {
        const requestRoute = `${theme.routes.root}products/${handle}.js`;
        return window.fetch(requestRoute).then( (response) => {
            return response.json()
        }
        ).catch( (e) => {
            console.error(e)
        }
        )
    }
    const defaults$1 = {
        color: 'ash',
    };
    const selectors$X = {
        swatch: '[data-swatch]',
        swatchColor: '[data-swatch-color]',
        productBlock: '[data-product-block]',
        productImage: '[data-product-image]',
        productImageSecondary: '[data-product-image-secondary]',
        productImageHover: '[data-product-image-hover]',
        quickView: '[data-button-quick-view]',
        gridImage: '[data-grid-image]',
        link: '[data-grid-link]',
        swatchesMore: '[data-swatches-more]',
        sectionType: '[data-section-type]',
        swatchesContainer: '[data-swatches-container]',
        swatchesLabel: '[data-swatches-label]',
        swatchesButton: '[data-swatches-button]',
        selectorWrapper: '[data-option-position]',
        slider: '[data-slider]',
    };
    const classes$N = {
        mediaVisible: 'product__media--featured-visible',
        mediaHoverVisible: 'product__media__hover-img--visible',
        noImage: 'swatch__link--no-image',
        noOutline: 'no-outline',
        isVisible: 'is-visible',
        selectorLarge: 'selector-wrapper--large',
    };
    const attributes$F = {
        swatch: 'data-swatch',
        handle: 'data-swatch-handle',
        label: 'data-swatch-label',
        image: 'data-swatch-image',
        imageId: 'data-swatch-image-id',
        variant: 'data-swatch-variant',
        variantId: 'data-variant-id',
        variantSecondaryId: 'data-variant-secondary-id',
        loaded: 'data-loaded',
        href: 'href',
    };
    let swatches = {};
    const sections$E = {};
    class ColorMatch {
        constructor(options={}) {
            this.settings = {
                ...defaults$1,
                ...options,
            };
            this.match = this.init()
        }
        getColor() {
            return this.match
        }
        init() {
            const getColors = loadScript({
                json: theme.assets.swatches
            });
            return getColors.then( (colors) => {
                return this.matchColors(colors, this.settings.color)
            }
            ).catch( (e) => {
                console.log('failed to load swatch colors script');
                console.log(e)
            }
            )
        }
        matchColors(colors, name) {
            let bg = '#E5E5E5';
            let img = null;
            const path = theme.assets.base || '/';
            const comparisonName = name.toLowerCase().replace(/\s/g, '');
            const array = colors.colors;
            if (array) {
                let indexArray = null;
                const hexColorArr = array.filter( (colorObj, index) => {
                    const neatName = Object.keys(colorObj).toString().toLowerCase().replace(/\s/g, '');
                    if (neatName === comparisonName) {
                        indexArray = index;
                        return colorObj
                    }
                }
                );
                if (hexColorArr.length && indexArray !== null) {
                    const value = Object.values(array[indexArray])[0];
                    bg = value;
                    if (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png') || value.includes('.svg')) {
                        img = `${path}${value}`;
                        bg = '#888888'
                    }
                }
            }
            return {
                color: this.settings.color,
                path: img,
                hex: bg,
            }
        }
    }
    class Swatch {
        constructor(element) {
            this.element = element;
            this.swatchLink = this.element.nextElementSibling;
            this.colorString = element.getAttribute(attributes$F.swatch);
            this.image = this.element.getAttribute(attributes$F.image);
            this.imageId = this.element.getAttribute(attributes$F.imageId);
            this.variant = this.element.getAttribute(attributes$F.variant);
            this.outer = this.element.closest(selectors$X.productBlock);
            this.hoverImages = [];
            const matcher = new ColorMatch({
                color: this.colorString
            });
            matcher.getColor().then( (result) => {
                this.colorMatch = result;
                this.init()
            }
            )
        }
        init() {
            this.setStyles();
            if (this.variant && this.outer) {
                this.handleClicks()
            }
            if (!this.image && this.swatchLink) {
                this.swatchLink.classList.add(classes$N.noImage)
            }
        }
        setStyles() {
            if (this.colorMatch && this.colorMatch.hex) {
                this.element.style.setProperty('--swatch', `${this.colorMatch.hex}`)
            }
            if (this.colorMatch && this.colorMatch.path) {
                this.element.style.setProperty('background-image', `url(${this.colorMatch.path})`)
            }
        }
        handleClicks() {
            this.swatchLink.addEventListener('click', (event) => {
                const isFocusEnabled = !document.body.classList.contains(classes$N.noOutline);
                const variantId = this.swatchLink.getAttribute(attributes$F.variant);
                if (!isFocusEnabled) {
                    event.preventDefault();
                    this.updateImagesAndLinksOnEvent(variantId)
                }
            }
            );
            this.swatchLink.addEventListener('keyup', (event) => {
                const isFocusEnabled = !document.body.classList.contains(classes$N.noOutline);
                const variantId = this.swatchLink.getAttribute(attributes$F.variant);
                if (event.code !== theme.keyboardKeys.ENTER && event.code !== theme.keyboardKeys.NUMPADENTER) {
                    return
                }
                if (!isFocusEnabled) {
                    event.preventDefault();
                    this.swatchLink.dispatchEvent(new Event('mouseenter',{
                        bubbles: !0
                    }));
                    this.updateImagesAndLinksOnEvent(variantId)
                }
            }
            )
        }
        updateImagesAndLinksOnEvent(variantId) {
            this.updateLinks();
            this.replaceImages(variantId)
        }
        updateLinks() {
            this.linkElements = this.outer.querySelectorAll(selectors$X.link);
            this.quickView = this.outer.querySelector(selectors$X.quickView);
            if (this.linkElements.length) {
                this.linkElements.forEach( (element) => {
                    const destination = getUrlWithVariant(element.getAttribute('href'), this.variant);
                    element.setAttribute('href', destination)
                }
                )
            }
            if (this.quickView && theme.settings.quickBuy === 'quick_buy') {
                this.quickView.setAttribute(attributes$F.variantId, this.variant)
            }
        }
        replaceImages(id) {
            const imageSecondary = this.outer.querySelector(`[${attributes$F.variantSecondaryId}="${id}"]`);
            const gridImage = this.outer.querySelector(`[${attributes$F.variantId}="${id}"]`);
            const gridImages = this.outer.querySelectorAll(selectors$X.gridImage);
            const currentGridImage = [...gridImages].find( (image) => image.classList.contains(classes$N.mediaVisible));
            if (gridImage && this.imageId) {
                if (!imageSecondary || !currentGridImage)
                    return;
                const onAnimationEnd = () => {
                    requestAnimationFrame( () => {
                        currentGridImage.classList.remove(classes$N.mediaVisible);
                        gridImage.classList.add(classes$N.mediaVisible);
                        requestAnimationFrame( () => {
                            imageSecondary.classList.remove(classes$N.mediaVisible)
                        }
                        )
                    }
                    );
                    imageSecondary.removeEventListener('animationend', onAnimationEnd)
                }
                ;
                requestAnimationFrame( () => {
                    imageSecondary.classList.add(classes$N.mediaVisible)
                }
                );
                imageSecondary.addEventListener('animationend', onAnimationEnd)
            }
            if (theme.settings.productGridHover === 'image') {
                this.hoverImages = this.outer.querySelectorAll(selectors$X.productImageHover)
            }
            if (this.hoverImages.length > 1) {
                this.hoverImages.forEach( (hoverImage) => {
                    hoverImage.classList.remove(classes$N.mediaHoverVisible);
                    if (hoverImage.getAttribute(attributes$F.variantId) === this.variant) {
                        hoverImage.classList.add(classes$N.mediaHoverVisible)
                    } else {
                        this.hoverImages[0].classList.add(classes$N.mediaHoverVisible)
                    }
                }
                )
            }
        }
    }
    class GridSwatch extends HTMLElement {
        constructor() {
            super();
            this.handle = this.getAttribute(attributes$F.handle);
            this.label = this.getAttribute(attributes$F.label).trim().toLowerCase();
            fetchProduct(this.handle).then( (product) => {
                this.product = product;
                this.colorOption = product.options.find( (element) => {
                    return element.name.toLowerCase() === this.label || null
                }
                );
                if (this.colorOption) {
                    this.swatches = this.colorOption.values;
                    this.init()
                }
            }
            )
        }
        init() {
            this.swatchElements = this.querySelectorAll(selectors$X.swatch);
            this.swatchElements.forEach( (el) => {
                new Swatch(el)
            }
            );
            this.handleShowMore()
        }
        handleShowMore() {
            this.initialHeight = this.offsetHeight;
            this.expandedHeight = this.initialHeight;
            const section = this.closest(selectors$X.sectionType);
            const moreLink = this.querySelector(selectors$X.swatchesMore);
            if (!moreLink)
                return;
            moreLink?.addEventListener('click', () => {
                this.classList.add(classes$N.isVisible)
            }
            );
            section?.addEventListener('touchstart', (e) => {
                if (!this.contains(e.target)) {
                    this.classList.remove(classes$N.isVisible);
                    this.dispatchEvent(new Event('mouseleave',{
                        bubbles: !0
                    }))
                }
            }
            );
            this.addEventListener('mouseenter', () => {
                const onAnimationStart = (event) => {
                    this.expandedHeight = this.offsetHeight;
                    const slider = event.target.closest(selectors$X.slider);
                    const heightDiffers = this.expandedHeight > this.initialHeight;
                    if (heightDiffers && slider) {
                        requestAnimationFrame( () => slider.dispatchEvent(new CustomEvent('theme:slider:resize',{
                            bubbles: !1
                        })))
                    }
                    this.removeEventListener('animationstart', onAnimationStart)
                }
                ;
                this.addEventListener('animationstart', onAnimationStart)
            }
            );
            this.addEventListener('mouseleave', () => {
                const onAnimationStart = (event) => {
                    const slider = event.target.closest(selectors$X.slider);
                    const heightDiffers = this.expandedHeight > this.initialHeight;
                    if (heightDiffers && slider) {
                        requestAnimationFrame( () => slider.dispatchEvent(new CustomEvent('theme:slider:resize',{
                            bubbles: !1
                        })))
                    }
                    this.removeEventListener('animationstart', onAnimationStart)
                }
                ;
                this.addEventListener('animationstart', onAnimationStart)
            }
            )
        }
    }
    class SwatchesContainer {
        constructor(container) {
            this.container = container;
            this.swatchesContainers = this.container.querySelectorAll(selectors$X.swatchesContainer);
            this.swatchesContainers.forEach( (swatchesContainer) => {
                this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(swatchesContainer);
                this.checkSwatchesHeight(swatchesContainer);
                document.addEventListener('theme:resize:width', this.checkSwatchesHeightOnResize)
            }
            )
        }
        checkSwatchesHeight(swatchesContainer) {
            const label = swatchesContainer.querySelector(selectors$X.swatchesLabel);
            const swatch = swatchesContainer.querySelector(selectors$X.swatchesButton);
            const containerPaddingTop = parseInt(window.getComputedStyle(swatchesContainer).getPropertyValue('padding-top'));
            if (label) {
                var labelOffsetHeight = label.offsetHeight;
                var labelMargin = parseInt(window.getComputedStyle(label).getPropertyValue('margin-bottom'))
            } else {
                var labelMargin = 0;
                var labelOffsetHeight = 0
            }
            const swatchMargin = parseInt(window.getComputedStyle(swatch).getPropertyValue('margin-bottom'));
            const selectorWrapper = swatchesContainer.closest(selectors$X.selectorWrapper);
            selectorWrapper.classList.remove(classes$N.selectorLarge);
            if (swatchesContainer.offsetHeight - containerPaddingTop > labelOffsetHeight + labelMargin + swatch.offsetHeight * 2 + swatchMargin * 2) {
                swatchesContainer.style.setProperty('--swatches-max-height', `${swatchesContainer.offsetHeight}px`);
                selectorWrapper.classList.add(classes$N.selectorLarge)
            }
        }
        onUnload() {
            this.swatchesContainers.forEach( (swatchesContainer) => {
                document.removeEventListener('theme:resize:width', this.checkSwatchesHeightOnResize)
            }
            )
        }
    }
    const makeSwatches = (container) => {
        swatches = [];
        const els = container.querySelectorAll(selectors$X.swatch);
        els.forEach( (el) => {
            swatches.push(new Swatch(el))
        }
        )
    }
    ;
    const swatchSection = {
        onLoad() {
            makeSwatches(this.container)
        },
    };
    const swatchesContainer = {
        onLoad() {
            sections$E[this.id] = new SwatchesContainer(this.container)
        },
        onUnload() {
            sections$E[this.id].onUnload()
        },
    };
    const selectors$W = {
        slider: '[data-slider]',
        productMediaContainer: '[data-product-media-container]',
        productMediaSlider: '[data-product-media-slideshow]',
        productMediaSlide: '[data-product-media-slideshow-slide]',
        progressBar: '[data-product-slideshow-progress]',
        flickityButton: '.flickity-button',
        popupProduct: '[data-product]',
        popupClose: '[data-popup-close]',
    };
    const classes$M = {
        fill: 'fill',
        quickViewVisible: 'js-quick-view-visible',
    };
    const sections$D = {};
    class ProductGrid {
        constructor(container) {
            this.container = container;
            this.body = document.body;
            this.sliders = this.container.querySelectorAll(selectors$W.slider);
            if (theme.settings.productGridHover === 'slideshow' && !window.theme.touch) {
                this.productGridSlideshow()
            }
            new QuickViewPopup(this.container)
        }
        productGridSlideshow() {
            const productMediaSlider = this.container.querySelectorAll(selectors$W.productMediaSlider);
            const linkedImages = this.container.querySelectorAll(selectors$W.productMediaContainer);
            if (productMediaSlider.length) {
                productMediaSlider.forEach( (slider) => {
                    const mediaContainer = slider.closest(selectors$W.productMediaContainer);
                    const progressBar = mediaContainer.querySelector(selectors$W.progressBar);
                    const countImages = slider.querySelectorAll(selectors$W.productMediaSlide).length;
                    const autoplaySpeed = 2200;
                    const draggable = !this.sliders.length;
                    let flkty = new Flickity.data(slider);
                    let timer = 0;
                    let cellSelector = selectors$W.productMediaSlide;
                    if (!flkty.isActive && countImages > 1) {
                        flkty = new Flickity(slider,{
                            draggable: draggable,
                            cellSelector: cellSelector,
                            contain: !0,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pauseAutoPlayOnHover: !1,
                            selectedAttraction: 0.2,
                            friction: 1,
                            on: {
                                ready: () => {
                                    this.container.style.setProperty('--autoplay-speed', `${autoplaySpeed}ms`)
                                }
                                ,
                                change: () => {
                                    if (timer) {
                                        clearTimeout(timer)
                                    }
                                    progressBar.classList.remove(classes$M.fill);
                                    progressBar.offsetWidth;
                                    requestAnimationFrame( () => {
                                        progressBar.classList.add(classes$M.fill)
                                    }
                                    );
                                    timer = setTimeout( () => {
                                        progressBar.classList.remove(classes$M.fill)
                                    }
                                    , autoplaySpeed)
                                }
                                ,
                                dragEnd: () => {
                                    flkty.playPlayer()
                                }
                                ,
                            },
                        });
                        if (!window.theme.touch) {
                            mediaContainer.addEventListener('mouseenter', () => {
                                progressBar.classList.add(classes$M.fill);
                                if (timer) {
                                    clearTimeout(timer)
                                }
                                timer = setTimeout( () => {
                                    progressBar.classList.remove(classes$M.fill)
                                }
                                , autoplaySpeed);
                                flkty.options.autoPlay = autoplaySpeed;
                                flkty.playPlayer()
                            }
                            );
                            mediaContainer.addEventListener('mouseleave', () => {
                                flkty.stopPlayer();
                                if (timer) {
                                    clearTimeout(timer)
                                }
                                progressBar.classList.remove(classes$M.fill)
                            }
                            )
                        }
                    }
                }
                )
            }
            if (linkedImages.length) {
                linkedImages.forEach( (item) => {
                    item.addEventListener('click', (e) => {
                        if (e.target.matches(selectors$W.flickityButton)) {
                            e.preventDefault()
                        }
                    }
                    )
                }
                )
            }
        }
        popupClose() {
            const popupProduct = document.querySelector(selectors$W.popupProduct);
            if (popupProduct) {
                const popupClose = popupProduct.querySelector(selectors$W.popupClose);
                popupClose.dispatchEvent(new Event('click'))
            }
        }
        onBlockSelect() {
            if (this.body.classList.contains(classes$M.quickViewVisible)) {
                this.popupClose()
            }
        }
        onDeselect() {
            if (this.body.classList.contains(classes$M.quickViewVisible)) {
                this.popupClose()
            }
        }
        onUnload() {
            if (this.body.classList.contains(classes$M.quickViewVisible)) {
                this.popupClose()
            }
        }
    }
    const productGrid = {
        onLoad() {
            sections$D[this.id] = new ProductGrid(this.container)
        },
        onBlockSelect() {
            sections$D[this.id].onBlockSelect()
        },
        onDeselect() {
            sections$D[this.id].onDeselect()
        },
        onUnload() {
            sections$D[this.id].onUnload()
        },
    };
    const selectors$V = {
        ajaxinateContainer: '#AjaxinateLoop',
        ajaxinatePagination: '#AjaxinatePagination',
    };
    const attributes$E = {
        ajaxinateId: 'data-ajaxinate-id',
    };
    const classes$L = {
        isLoaded: 'is-loaded',
    };
    let sections$C = {};
    class Ajaxify {
        constructor(container) {
            this.container = container;
            this.endlessScroll = [];
            if (theme.settings.enableInfinityScroll) {
                this.init()
            }
        }
        init() {
            this.loadMoreFix();
            this.ajaxinateContainer = this.container.querySelectorAll(selectors$V.ajaxinateContainer);
            this.ajaxinateContainer.forEach( (element) => {
                const ajaxinateContainer = `${selectors$V.ajaxinateContainer}[${attributes$E.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
                const ajaxinatePagination = `${selectors$V.ajaxinatePagination}[${attributes$E.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
                const hasChildren = element.children.length > 0;
                if (hasChildren) {
                    const endlessScroll = new Ajaxinate({
                        container: ajaxinateContainer,
                        pagination: ajaxinatePagination,
                        method: 'scroll',
                    });
                    element.classList.add(classes$L.isLoaded);
                    this.endlessScroll.push(endlessScroll)
                }
            }
            )
        }
        update(id) {
            this.ajaxinateContainer = this.container.querySelectorAll(selectors$V.ajaxinateContainer);
            const instanceIDMatch = (instance) => instance.settings.container === id;
            const elementIDMatch = (element) => `${selectors$V.ajaxinateContainer}[${attributes$E.ajaxinateId}="${element.dataset.ajaxinateId}"]` === id;
            const instanceExists = this.endlessScroll.find(instanceIDMatch);
            if (instanceExists) {
                const index = this.endlessScroll.findIndex(instanceIDMatch);
                this.endlessScroll.splice(index, 1);
                instanceExists.settings.method = 'scroll';
                instanceExists.destroy()
            }
            const element = [...this.ajaxinateContainer].find(elementIDMatch);
            if (!element)
                return;
            const ajaxinateContainer = `${selectors$V.ajaxinateContainer}[${attributes$E.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
            const ajaxinatePagination = `${selectors$V.ajaxinatePagination}[${attributes$E.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
            const hasChildren = element.children.length > 0;
            if (!hasChildren)
                return;
            const endlessScroll = new Ajaxinate({
                container: ajaxinateContainer,
                pagination: ajaxinatePagination,
                method: 'scroll',
            });
            element.classList.add(classes$L.isLoaded);
            this.endlessScroll.push(endlessScroll)
        }
        loadMoreFix() {
            Ajaxinate.prototype.loadMore = function loadMore() {
                this.request = new XMLHttpRequest();
                this.request.onreadystatechange = function success() {
                    if (!this.request.responseXML) {
                        return
                    }
                    if (!this.request.readyState === 4 || !this.request.status === 200) {
                        return
                    }
                    const newContainer = this.request.responseXML.querySelector(this.settings.container);
                    const newPagination = this.request.responseXML.querySelector(this.settings.pagination);
                    this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
                    if (typeof newPagination === 'undefined' || newPagination === null) {
                        this.removePaginationElement()
                    } else {
                        this.paginationElement.innerHTML = newPagination.innerHTML;
                        if (this.settings.callback && typeof this.settings.callback === 'function') {
                            this.settings.callback(this.request.responseXML)
                        }
                        this.initialize()
                    }
                }
                .bind(this);
                this.request.open('GET', this.nextPageUrl, !0);
                this.request.responseType = 'document';
                this.request.send()
            }
        }
        unload() {
            if (this.endlessScroll.length > 0) {
                this.endlessScroll.forEach( (instance) => {
                    instance.settings.method = 'scroll';
                    instance.destroy()
                }
                );
                this.ajaxinateContainer.forEach( (element) => element.classList.remove(classes$L.isLoaded))
            }
        }
    }
    const ajaxify = {
        onLoad() {
            sections$C = new Ajaxify(this.container)
        },
        onUnload: function() {
            if (typeof sections$C.unload === 'function') {
                sections$C.unload()
            }
        },
    };
    const settings$8 = {
        loadingTimeout: 300,
    };
    const selectors$U = {
        buttons: 'button',
        toggleFilters: '[data-toggle-filters]',
        closeFilters: '[data-close-filters]',
        openFilters: '[data-open-filters]',
        collectionWrapper: '[data-collection-wrapper]',
        collapsibleTrigger: '[data-collapsible-trigger]',
        sortToggle: '[data-sort-toggle]',
        collectionSortOptions: '[data-collection-sort-options]',
        inputs: 'input, select, label, textarea',
        inputSort: '[data-input-sort]',
        filters: '[data-collection-filters]',
        filtersWrapper: '[data-collection-filters-wrapper]',
        filtersList: '[data-collection-filters-list]',
        filtersStickyBar: '[data-collection-sticky-bar]',
        filter: '[data-collection-filter]',
        filterTag: '[data-collection-filter-tag]',
        filterTagButton: '[data-collection-filter-tag-button]',
        filtersForm: '[data-collection-filters-form]',
        filterResetButton: '[data-filter-reset-button]',
        filterTagClearButton: '[data-filter-tag-reset-button]',
        popupsSection: '[data-section-type="popups"]',
        productGrid: '[data-collection-products]',
        productsCount: '[data-products-count]',
        priceMin: '[data-field-price-min]',
        priceMax: '[data-field-price-max]',
        rangeMin: '[data-se-min-value]',
        rangeMax: '[data-se-max-value]',
        rangeMinValue: 'data-se-min-value',
        rangeMaxValue: 'data-se-max-value',
        rangeMinDefault: 'data-se-min',
        rangeMaxDefault: 'data-se-max',
        tooltip: '[data-tooltip]',
        tooltipContainer: '[data-tooltip-container]',
        showMore: '[data-show-more]',
        showMoreActions: '[data-show-more-actions]',
        showMoreContainer: '[data-show-more-container]',
        showMoreTrigger: '[data-show-more-trigger]',
        searchPerformed: '[data-search-performed]',
        searchForm: '[data-search-form]',
        scrollable: '[data-custom-scrollbar]',
    };
    const classes$K = {
        isActive: 'is-active',
        isExpanded: 'is-expanded',
        isVisible: 'is-visible',
        isLoading: 'is-loading',
        popupVisible: 'popup--visible',
        collectionFiltersVisible: 'collection__filters--visible',
        collectionSortOptionWrapperVisible: 'collection__sort__option-wrapper--visible',
        hidden: 'is-hidden',
    };
    const attributes$D = {
        filterActive: 'data-filter-active',
        preventScrollLock: 'data-prevent-scroll-lock',
        filtersDefaultState: 'data-filters-default-state',
        tabIndex: 'tabindex',
        ariaExpanded: 'aria-expanded',
        currentType: 'data-current-type',
    };
    const sections$B = {};
    class Filters {
        constructor(container) {
            this.container = container;
            this.sectionId = container.dataset.sectionId;
            this.enableFilters = container.dataset.enableFilters === 'true';
            this.enableSorting = container.dataset.enableSorting === 'true';
            this.filterMode = container.dataset.filterMode;
            this.collectionHandle = this.container.dataset.collection;
            this.isSearchPage = container.closest(selectors$U.searchPerformed) != null;
            this.productGrid = this.container.querySelector(selectors$U.productGrid);
            this.productsCount = this.container.querySelector(selectors$U.productsCount);
            this.groupTagFilters = this.container.querySelectorAll(selectors$U.filter);
            this.filters = this.container.querySelector(selectors$U.filters);
            this.filterTriggers = this.container.querySelectorAll(selectors$U.collapsibleTrigger);
            this.filtersStickyBar = this.container.querySelector(selectors$U.filtersStickyBar);
            this.filtersForm = this.container.querySelector(selectors$U.filtersForm);
            this.inputSort = this.container.querySelectorAll(selectors$U.inputSort);
            this.sortToggle = this.container.querySelector(selectors$U.sortToggle);
            this.collectionSortOptions = this.container.querySelector(selectors$U.collectionSortOptions);
            this.a11y = a11y;
            this.filterData = [];
            this.rangeSlider = null;
            this.sortDropdownEvent = () => this.sortDropdownToggle();
            this.onTabHandlerEvent = (event) => this.onTabHandler(event);
            this.updateCollectionFormSortEvent = (event) => this.updateCollectionFormSort(event);
            this.bodyClickEvent = (event) => this.bodyClick(event);
            this.onFilterResetClick = this.onFilterResetClick.bind(this);
            this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this);
            this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this);
            this.onFilterToggleClick = this.onFilterToggleClick.bind(this);
            this.onKeyUpHandler = this.onKeyUpHandler.bind(this);
            this.updateRangeEvent = this.updateRange.bind(this);
            this.debouncedSubmitEvent = debounce( (event) => {
                this.onSubmitHandler(event)
            }
            , 500);
            this.debouncedSortEvent = debounce( (event) => {
                this.onSortChange(event)
            }
            , 500);
            this.productGridEvents = {};
            if (this.filters) {
                this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this);
                this.showFiltersDrawer = this.showFiltersDrawer.bind(this);
                this.resizeEvent = debounce( () => {
                    this.filtersResizeEvents()
                }
                , 500);
                this.filtersResizeEvents();
                document.addEventListener('theme:resize:width', this.resizeEvent)
            }
            this.initTagFilters();
            this.initFacetedFilters();
            this.bindToggleButtonsEvents();
            this.bindFilterButtonsEvents();
            this.initProductGridEvents(theme.settings.enableInfinityScroll);
            makeSwatches(this.container);
            this.collapsible = new Collapsible(this.container);
            setVars();
            window.addEventListener('popstate', this.onHistoryChange.bind(this));
            this.sortToggle?.addEventListener('click', this.sortDropdownEvent);
            document.addEventListener('click', this.bodyClickEvent);
            this.filterShowMore()
        }
        initFacetedFilters() {
            if (this.filterMode == 'tag' || this.filterMode == 'group' || !this.enableFilters) {
                return
            }
            this.rangeSlider = new RangeSlider(this.container)
        }
        initTooltips() {
            this.tooltips = this.container.querySelectorAll(selectors$U.tooltip);
            if (window.innerWidth < theme.sizes.small) {
                this.tooltips = this.productGrid?.querySelectorAll(selectors$U.tooltip)
            }
            this.tooltips?.forEach( (tooltip) => {
                new Tooltip(tooltip)
            }
            );
            this.handleVisibleTooltips()
        }
        handleVisibleTooltips() {
            if (this.tooltips.length > 0) {
                const tooltipTarget = document.querySelector(selectors$U.tooltipContainer);
                if (tooltipTarget.classList.contains(classes$K.isVisible)) {
                    tooltipTarget.classList.remove(classes$K.isVisible)
                }
            }
        }
        updateRange() {
            const rangeMin = this.filtersForm.querySelector(selectors$U.rangeMin);
            const rangeMax = this.filtersForm.querySelector(selectors$U.rangeMax);
            const priceMin = this.filtersForm.querySelector(selectors$U.priceMin);
            const priceMax = this.filtersForm.querySelector(selectors$U.priceMax);
            if (rangeMin.hasAttribute(selectors$U.rangeMinValue) && rangeMax.hasAttribute(selectors$U.rangeMaxValue)) {
                const priceMinValue = parseFloat(priceMin.placeholder, 10);
                const priceMaxValue = parseFloat(priceMax.placeholder, 10);
                const rangeMinValue = parseFloat(rangeMin.getAttribute(selectors$U.rangeMinValue), 10);
                const rangeMaxValue = parseFloat(rangeMax.getAttribute(selectors$U.rangeMaxValue), 10);
                if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
                    priceMin.value = parseInt(rangeMinValue);
                    priceMax.value = parseInt(rangeMaxValue);
                    this.filtersForm.dispatchEvent(new Event('input',{
                        bubbles: !0
                    }))
                }
            }
        }
        onSubmitHandler(event) {
            event.preventDefault();
            const formData = new FormData(this.filtersForm);
            const searchParams = new URLSearchParams(formData);
            const deleteParams = [];
            let searchParamsString = '';
            if (this.isSearchPage) {
                this.searchForm = this.container.querySelector(selectors$U.searchForm);
                this.currentType = this.container.getAttribute(attributes$D.currentType)
            }
            const rangeMin = this.filtersForm.querySelector(selectors$U.rangeMin);
            const rangeMax = this.filtersForm.querySelector(selectors$U.rangeMax);
            const priceMin = this.filtersForm.querySelector(selectors$U.priceMin);
            const priceMax = this.filtersForm.querySelector(selectors$U.priceMax);
            const checkElements = rangeMin && rangeMax && priceMin && priceMax;
            if (checkElements && rangeMin.hasAttribute(selectors$U.rangeMinDefault) && rangeMax.hasAttribute(selectors$U.rangeMaxDefault)) {
                const rangeMinDefault = parseFloat(rangeMin.getAttribute(selectors$U.rangeMinDefault), 10);
                const rangeMaxDefault = parseFloat(rangeMax.getAttribute(selectors$U.rangeMaxDefault), 10);
                const priceMinValue = !priceMin.value ? rangeMinDefault : parseFloat(priceMin.value, 10);
                const priceMaxValue = !priceMax.value ? rangeMaxDefault : parseFloat(priceMax.value, 10);
                if (priceMinValue <= rangeMinDefault && priceMaxValue >= rangeMaxDefault) {
                    deleteParams.push('filter.v.price.gte');
                    deleteParams.push('filter.v.price.lte');
                    searchParams.delete('filter.v.price.gte');
                    searchParams.delete('filter.v.price.lte')
                }
            }
            searchParamsString = searchParams.toString();
            if (this.isSearchPage) {
                searchParamsString = getSearchParams(this.searchForm, this.filtersForm, deleteParams);
                let typeString = '';
                if (this.currentType === 'all')
                    typeString = '&type=product';
                if (searchParamsString.indexOf('&type=product') > -1)
                    typeString = '';
                searchParamsString += typeString
            }
            this.renderSection(searchParamsString, event)
        }
        onHistoryChange(event) {
            if (!this.filters)
                return;
            let searchParams = event.state?.searchParams || '';
            if (this.isSearchPage) {
                if (!event.state)
                    searchParams = window.location.search;
                const shouldRenderSearchResults = searchParams.indexOf('type=product') > -1;
                if (!shouldRenderSearchResults)
                    return
            }
            this.renderSection(searchParams, null, !1)
        }
        renderSection(searchParams, event, updateURLHash=!0) {
            this.startLoading();
            const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;
            this.filterData.some(filterDataUrl) ? this.renderSectionFromCache(filterDataUrl, event) : this.renderSectionFromFetch(url, event);
            if (updateURLHash) {
                this.updateURLHash(searchParams)
            }
        }
        renderSectionFromFetch(url) {
            fetch(url).then( (response) => response.text()).then( (responseText) => {
                const html = responseText;
                this.filterData = [...this.filterData, {
                    html,
                    url
                }];
                this.inputSort = this.container.querySelectorAll(selectors$U.inputSort);
                this.renderFilters(html);
                this.bindFilterButtonsEvents();
                this.hideFiltersOnMobile();
                this.renderProductGrid(html);
                this.updateProductsCount(html);
                this.finishLoading();
                this.mobileFiltersScrollLock();
                this.handleSearchPageActiveTab()
            }
            )
        }
        renderSectionFromCache(filterDataUrl, event) {
            const html = this.filterData.find(filterDataUrl).html;
            this.renderFilters(html, event);
            this.hideFiltersOnMobile();
            this.renderProductGrid(html);
            this.updateProductsCount(html);
            this.finishLoading();
            this.mobileFiltersScrollLock();
            this.handleSearchPageActiveTab()
        }
        handleSearchPageActiveTab() {
            if (!this.isSearchPage)
                return;
            this.scrollable = this.container.querySelector(selectors$U.scrollable);
            if (!this.scrollable || this.customScrollbar)
                return;
            this.customScrollbar = new CustomScrollbar(this.container)
        }
        renderProductGrid(html) {
            const newProductGrid = new DOMParser().parseFromString(html, 'text/html').querySelector(selectors$U.productGrid);
            if (!newProductGrid) {
                return
            }
            this.productGrid.innerHTML = newProductGrid.innerHTML;
            this.initProductGridEvents(theme.settings.enableInfinityScroll);
            this.filterShowMore()
        }
        updateProductsCount(html) {
            const newProductsCount = new DOMParser().parseFromString(html, 'text/html').querySelector(selectors$U.productsCount);
            if (!newProductsCount) {
                return
            }
            this.productsCount.innerHTML = newProductsCount.innerHTML
        }
        renderFilters(html) {
            const newFilters = new DOMParser().parseFromString(html, 'text/html').querySelector(selectors$U.filters);
            if (!newFilters) {
                return
            }
            this.filters.innerHTML = newFilters.innerHTML;
            this.filtersForm = document.querySelector(selectors$U.filtersForm);
            this.bindFilterButtonsEvents();
            this.bindToggleButtonsEvents();
            makeSwatches(this.container);
            this.collapsible = new Collapsible(this.container);
            document.dispatchEvent(new CustomEvent('theme:filters:init',{
                bubbles: !0
            }))
        }
        updateURLHash(searchParams) {
            history.pushState({
                searchParams
            }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
        }
        bindFilterButtonsEvents() {
            if (this.inputSort.length > 0) {
                this.inputSort.forEach( (input) => {
                    input.addEventListener('change', this.updateCollectionFormSortEvent)
                }
                )
            }
            if (this.filtersForm) {
                this.filtersForm.addEventListener('input', this.debouncedSubmitEvent.bind(this));
                this.filtersForm.addEventListener('theme:filter:range-update', this.updateRangeEvent)
            }
            if (this.collectionSortOptions) {
                this.collectionSortOptions.addEventListener('keyup', this.onTabHandlerEvent)
            }
            if (this.filterMode == 'tag' || this.filterMode == 'group' || !this.enableFilters) {
                return
            }
            this.container.querySelectorAll(selectors$U.filterResetButton).forEach( (button) => {
                button.addEventListener('click', this.onFilterResetClick, {
                    once: !0
                })
            }
            )
        }
        onFilterResetClick(event) {
            event.preventDefault();
            this.renderSection(new URL(event.currentTarget.href).searchParams.toString())
        }
        bindToggleButtonsEvents() {
            this.container.querySelectorAll(selectors$U.toggleFilters).forEach( (button) => {
                button.addEventListener('click', this.onFilterToggleClick)
            }
            );
            this.container.querySelectorAll(selectors$U.closeFilters).forEach( (button) => {
                button.addEventListener('click', this.hideFiltersDrawer)
            }
            );
            this.container.querySelectorAll(selectors$U.openFilters).forEach( (button) => {
                button.addEventListener('click', this.showFiltersDrawer)
            }
            );
            if (document.querySelector(".drawer__overlay")) {
                document.querySelector(".drawer__overlay").addEventListener('click', () => {
                    this.hideFiltersDrawer()
                }
                )
            }
            this.container.querySelector(selectors$U.collectionWrapper)?.addEventListener('keyup', this.onKeyUpHandler)
        }
        onTabHandler(event) {
            if (event.code === theme.keyboardKeys.SPACE || event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER) {
                const newSortValue = event.target.previousElementSibling.value;
                this.filtersForm.querySelectorAll(selectors$U.inputSort).forEach( (input) => {
                    if (input.checked) {
                        input.checked = !1
                    }
                    if (input.value === newSortValue) {
                        input.checked = !0
                    }
                }
                );
                this.filtersForm.dispatchEvent(new Event('input',{
                    bubbles: !0
                }));
                event.target.dispatchEvent(new Event('click',{
                    bubbles: !0
                }))
            }
        }
        onKeyUpHandler(event) {
            if (event.code === theme.keyboardKeys.ESCAPE) {
                this.hideFiltersDrawer()
            }
        }
        onFilterToggleClick(event) {
            event.preventDefault();
            setVars();
            const filtersVisible = this.filters.classList.contains(classes$K.collectionFiltersVisible);
            filtersVisible ? this.hideFiltersDrawer() : this.showFiltersDrawer()
        }
        sortDropdownToggle() {
            if (!this.collectionSortOptions)
                return;
            this.collectionSortOptions.classList.toggle(classes$K.collectionSortOptionWrapperVisible)
        }
        bodyClick(event) {
            if (!this.collectionSortOptions)
                return;
            const isSortBar = this.sortToggle.contains(event.target);
            const isVisible = this.collectionSortOptions.classList.contains(classes$K.collectionSortOptionWrapperVisible);
            if (isVisible && !isSortBar) {
                this.sortDropdownToggle()
            }
        }
        updateCollectionFormSort(event) {
            const target = event.target;
            const newSortValue = target.value;
            const secondarySortBy = target.closest(selectors$U.collectionSortOptions);
            this.container.querySelectorAll(selectors$U.inputSort).forEach( (input) => {
                if (input.value === newSortValue) {
                    input.checked = !0
                }
            }
            );
            if (secondarySortBy !== null) {
                this.filtersForm.dispatchEvent(new Event('input',{
                    bubbles: !0
                }))
            }
        }
        showFiltersDrawer() {
            const instance = this;
            this.a11y.state.trigger = document.querySelector(selectors$U.toggleFilters);
            this.a11y.trapFocus({
                container: instance.filters,
            });
            this.mobileFiltersScrollLock()
        }
        mobileFiltersScrollLock() {
            const scrollableElement = document.querySelector(selectors$U.filtersList);
            if (!this.filters.classList.contains(classes$K.collectionFiltersVisible)) {
                this.filters.classList.add(classes$K.collectionFiltersVisible)
            }
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: scrollableElement
            }))
        }
        hideFiltersOnMobile() {
            const filterTriggers = this.container.querySelectorAll(`${selectors$U.collapsibleTrigger}:not(${selectors$U.showMoreTrigger})`);
            if (window.innerWidth < theme.sizes.small) {
                requestAnimationFrame( () => {
                    filterTriggers.forEach( (element) => {
                        const isFilterActive = element.getAttribute(attributes$D.filterActive) === 'true';
                        if (element.classList.contains(classes$K.isExpanded) && !isFilterActive) {
                            element.dispatchEvent(new Event('click'))
                        }
                    }
                    )
                }
                )
            }
        }
        showFiltersOnDesktop() {
            const filterTriggers = this.container.querySelectorAll(`${selectors$U.collapsibleTrigger}:not(${selectors$U.showMoreTrigger})`);
            const filtersDefaultState = this.container.getAttribute(attributes$D.filtersDefaultState);
            const openFirstFilterOnly = filtersDefaultState === 'first-open';
            const openAllFilters = filtersDefaultState === 'open';
            const closeAllFilters = filtersDefaultState === 'closed';
            const firstTriggerIndex = this.enableSorting ? 1 : 0;
            filterTriggers.forEach( (element, index) => {
                const isCurrentFilterExpanded = element.classList.contains(classes$K.isExpanded);
                const isCurrentFilterActive = element.getAttribute(attributes$D.filterActive) === 'true';
                const isFirstClosed = !isCurrentFilterExpanded && index === firstTriggerIndex;
                const allElseExpanded = isCurrentFilterExpanded && index !== firstTriggerIndex;
                const shouldOpenFirst = openFirstFilterOnly && isFirstClosed;
                const shouldCloseAllExceptFirst = openFirstFilterOnly && allElseExpanded;
                const shouldOpenAllClosedOnes = openAllFilters && !isCurrentFilterExpanded;
                const shouldOpenActiveOnes = isCurrentFilterActive && !isCurrentFilterExpanded && openAllFilters;
                const shouldCloseExpandedOnes = closeAllFilters && isCurrentFilterExpanded;
                if (isCurrentFilterActive && !shouldOpenActiveOnes)
                    return;
                if (shouldCloseExpandedOnes || shouldOpenFirst || shouldCloseAllExceptFirst || shouldOpenAllClosedOnes || shouldOpenActiveOnes) {
                    element.dispatchEvent(new Event('click'))
                }
            }
            )
        }
        hideFiltersDrawer() {
            let filtersVisible = this.filters.classList.contains(classes$K.collectionFiltersVisible);
            let loading = this.container.classList.contains(classes$K.isLoading);
            if (filtersVisible) {
                this.filters.classList.remove(classes$K.collectionFiltersVisible);
                this.a11y.removeTrapFocus()
            }
            if (!loading) {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                    bubbles: !0,
                    detail: settings$8.loadingTimeout
                }))
            }
        }
        filtersResizeEvents() {
            if (window.innerWidth >= theme.sizes.small) {
                this.showFiltersOnDesktop();
                this.hideFiltersDrawer()
            } else {
                this.hideFiltersOnMobile()
            }
        }
        filterShowMore() {
            this.showMore = this.container.querySelectorAll(selectors$U.showMore);
            if (this.showMore.length === 0)
                return;
            this.showMore.forEach( (element) => {
                const filterCollapsibleTrigger = element.querySelector(selectors$U.collapsibleTrigger);
                const showMoreActions = element.querySelector(selectors$U.showMoreActions);
                if (!showMoreActions)
                    return;
                const showMoreTrigger = showMoreActions.querySelector(selectors$U.showMoreTrigger);
                const showMoreContainer = showMoreActions.querySelector(selectors$U.showMoreContainer);
                const focusable = showMoreContainer.querySelectorAll(window.theme.focusable);
                const isShowMoreContainerExpanded = showMoreContainer.getAttribute(attributes$D.ariaExpanded) === 'true';
                if (!isShowMoreContainerExpanded) {
                    focusable.forEach( (item) => {
                        item.setAttribute(attributes$D.tabIndex, '-1')
                    }
                    )
                }
                showMoreTrigger.addEventListener('keyup', (event) => {
                    if (event.code === theme.keyboardKeys.SPACE || event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER) {
                        this.updateShowMoreFocusableElements(event, focusable)
                    }
                }
                );
                showMoreTrigger.addEventListener('click', (event) => {
                    this.updateShowMoreFocusableElements(event, focusable)
                }
                );
                filterCollapsibleTrigger.addEventListener('keyup', (event) => {
                    if (event.code === theme.keyboardKeys.SPACE || event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER) {
                        this.updateCollapsedContainerFocusableElements(filterCollapsibleTrigger, showMoreTrigger, focusable)
                    }
                }
                );
                filterCollapsibleTrigger.addEventListener('click', () => {
                    this.updateCollapsedContainerFocusableElements(filterCollapsibleTrigger, showMoreTrigger, focusable)
                }
                )
            }
            )
        }
        updateCollapsedContainerFocusableElements(filterCollapsibleTrigger, showMoreTrigger, focusable) {
            requestAnimationFrame( () => {
                const isFilterExpanded = filterCollapsibleTrigger.getAttribute(attributes$D.ariaExpanded) === 'true';
                const isShowMoreExpanded = showMoreTrigger.getAttribute(attributes$D.ariaExpanded) === 'true';
                focusable.forEach( (item) => {
                    if (!isFilterExpanded && isShowMoreExpanded) {
                        item.setAttribute(attributes$D.tabIndex, '-1')
                    }
                    if (isFilterExpanded && isShowMoreExpanded) {
                        item.removeAttribute(attributes$D.tabIndex)
                    }
                }
                )
            }
            )
        }
        updateShowMoreFocusableElements(event, focusable) {
            requestAnimationFrame( () => {
                requestAnimationFrame( () => {
                    const isExpanded = event.target.getAttribute(attributes$D.ariaExpanded) === 'true';
                    focusable.forEach( (item, index) => {
                        if (isExpanded) {
                            item.removeAttribute(attributes$D.tabIndex);
                            if (index === 0)
                                item.focus();
                            return
                        }
                        item.setAttribute(attributes$D.tabIndex, '-1')
                    }
                    )
                }
                )
            }
            )
        }
        initTagFilters() {
            if ((this.filterMode != 'tag' && this.filterMode != 'group') || !this.enableFilters) {
                return
            }
            this.tags = this.container.dataset.tags.split('+').filter( (item) => item);
            this.bindFilterTagButtonsEvents();
            this.bindSortChangeEvent()
        }
        renderTagFiltersProducts(url) {
            this.startLoading();
            if (typeof this.endlessCollection === 'object') {
                this.endlessCollection.unload()
            }
            fetch(url).then( (response) => response.text()).then( (responseText) => {
                const html = responseText;
                const parsedData = new DOMParser().parseFromString(html, 'text/html');
                const productsHTML = parsedData.querySelector(selectors$U.productGrid).innerHTML;
                const filtersHTML = parsedData.querySelector(selectors$U.filters).innerHTML;
                this.productGrid.innerHTML = productsHTML;
                this.filters.innerHTML = filtersHTML;
                this.inputSort = this.container.querySelectorAll(selectors$U.inputSort);
                this.filtersForm = document.querySelector(selectors$U.filtersForm);
                this.filterData = [...this.filterData, {
                    html,
                    url
                }];
                this.alreadyClicked = !1;
                this.bindFilterTagButtonsEvents();
                this.bindFilterButtonsEvents();
                this.bindSortChangeEvent();
                this.bindToggleButtonsEvents();
                this.initProductGridEvents(theme.settings.enableInfinityScroll);
                this.updateProductsCount(html);
                this.mobileFiltersScrollLock();
                this.hideFiltersOnMobile();
                makeSwatches(this.container);
                this.collapsible = new Collapsible(this.container);
                this.filterShowMore();
                if (history.replaceState) {
                    window.history.pushState({
                        path: url
                    }, '', url)
                }
            }
            ).catch( (error) => {
                this.finishLoading();
                console.log(`Error: ${error}`)
            }
            )
        }
        bindFilterTagButtonsEvents() {
            this.container.querySelectorAll(selectors$U.filterTagButton).forEach( (button) => {
                button.addEventListener('click', this.onFilterTagButtonClick.bind(this))
            }
            );
            this.container.querySelectorAll(selectors$U.filterTagClearButton).forEach( (button) => {
                button.addEventListener('click', this.onFilterTagClearClick)
            }
            );
            this.container.querySelectorAll(selectors$U.filterResetButton).forEach( (button) => {
                button.addEventListener('click', this.onFilterTagResetClick)
            }
            )
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(selectors$U.inputSort).forEach( (input) => {
                input.addEventListener('input', this.debouncedSortEvent.bind(this))
            }
            )
        }
        onFilterTagButtonClick(event) {
            event.preventDefault();
            if (this.alreadyClicked) {
                return
            }
            this.alreadyClicked = !0;
            const button = event.currentTarget;
            const selectedTag = button.dataset.tag;
            let isTagSelected = button.parentNode.classList.contains(classes$K.isActive);
            if (isTagSelected) {
                let tagIndex = this.tags.indexOf(selectedTag);
                button.parentNode.classList.remove(classes$K.isActive);
                if (tagIndex > -1) {
                    this.tags.splice(tagIndex, 1)
                }
            } else {
                button.parentNode.classList.add(classes$K.isActive);
                this.tags.push(selectedTag)
            }
            let url = this.collectionHandle + '/' + this.tags.join('+') + '?sort_by=' + this.getSortValue();
            this.container.querySelector(selectors$U.filter).classList.remove(classes$K.isExpanded);
            this.container.querySelector(selectors$U.filter).setAttribute(attributes$D.ariaExpanded, !1);
            this.container.setAttribute('data-tags', '[' + this.tags + ']');
            this.renderTagFiltersProducts(url)
        }
        onFilterTagClearClick(event) {
            event.preventDefault();
            if (this.alreadyClicked) {
                return
            }
            this.alreadyClicked = !0;
            const button = event.currentTarget;
            const selectedTag = button.dataset.tag;
            const tagIndex = this.tags.indexOf(selectedTag);
            if (tagIndex > -1) {
                this.tags.splice(tagIndex, 1)
            }
            const url = this.collectionHandle + '/' + this.tags.join('+') + '?sort_by=' + this.getSortValue();
            this.container.setAttribute('data-tags', '[' + this.tags + ']');
            this.renderTagFiltersProducts(url)
        }
        onSortChange() {
            let url = this.collectionHandle + '/' + this.tags.join('+') + '?sort_by=' + this.getSortValue();
            this.renderTagFiltersProducts(url)
        }
        getSortValue() {
            let sortValue = '';
            this.inputSort.forEach( (input) => {
                if (input.checked) {
                    sortValue = input.value
                }
            }
            );
            return sortValue
        }
        onFilterTagResetClick(event) {
            event?.preventDefault();
            if (this.alreadyClicked) {
                return
            }
            this.alreadyClicked = !0;
            this.container.querySelectorAll(selectors$U.filterTag).forEach( (element) => {
                element.classList.remove(classes$K.isActive)
            }
            );
            this.container.querySelectorAll(selectors$U.filter).forEach( (element) => {
                element.classList.remove(classes$K.isExpanded);
                element.setAttribute(attributes$D.ariaExpanded, !1)
            }
            );
            this.tags = [];
            this.container.setAttribute('data-tags', '');
            let url = this.collectionHandle + '/?sort_by=' + this.getSortValue();
            this.renderTagFiltersProducts(url)
        }
        getProductsOffsetTop() {
            return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight
        }
        getStickyBarOffsetTop() {
            return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top
        }
        initProductGridEvents(infinityScroll) {
            if (infinityScroll) {
                this.initInfinityScroll();
                this.initProductGridEvents(!1);
                return
            }
            this.productGridEvents = new ProductGrid(this.container);
            this.initTooltips();
            setTimeout( () => {
                this.finishLoading()
            }
            , settings$8.loadingTimeout * 1.5)
        }
        initInfinityScroll() {
            const callback = () => this.initProductGridEvents(!1);
            if (this.isSearchPage) {
                if (!this.enableFilters)
                    return;
                document.dispatchEvent(new CustomEvent('theme:tab:ajaxinate',{
                    bubbles: !0,
                    detail: 'product',
                }));
                return
            }
            if (typeof this.endlessCollection === 'object') {
                this.endlessCollection.unload()
            }
            this.endlessCollection = new Ajaxify(this.container);
            if (this.endlessCollection.endlessScroll.length === 0)
                return;
            this.endlessCollection.endlessScroll[0].settings.callback = callback
        }
        startLoading() {
            this.container.classList.add(classes$K.isLoading);
            if (window.innerWidth >= theme.sizes.small) {
                document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                    bubbles: !0
                }))
            }
            let productsTop = this.getProductsOffsetTop();
            window.scrollTo({
                top: productsTop,
                left: 0,
                behavior: 'smooth',
            })
        }
        finishLoading() {
            const popups = document.querySelectorAll(`${selectors$U.popupsSection} .${classes$K.popupVisible}`);
            const isPopupActive = popups.length > 0;
            this.container.classList.remove(classes$K.isLoading);
            if (isPopupActive) {
                let preventScrollPopupsCount = 0;
                [...popups].forEach( (popup) => {
                    if (popup.hasAttribute(attributes$D.preventScrollLock)) {
                        preventScrollPopupsCount += 1
                    }
                }
                );
                if (preventScrollPopupsCount === popups.length) {
                    document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                        bubbles: !0,
                        detail: settings$8.loadingTimeout
                    }))
                }
            } else if (window.innerWidth >= theme.sizes.small) {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                    bubbles: !0,
                    detail: settings$8.loadingTimeout
                }))
            }
        }
        onDeselect() {
            if (this.productGridEvents) {
                this.productGridEvents.onDeselect()
            }
        }
        onUnload() {
            if (typeof this.endlessCollection === 'object') {
                this.endlessCollection.unload()
            }
            if (this.productGridEvents) {
                this.productGridEvents.onUnload()
            }
            if (this.collapsible) {
                this.collapsible.onUnload()
            }
            if (this.rangeSlider) {
                this.rangeSlider.unload()
            }
            if (this.filters) {
                document.removeEventListener('theme:resize:width', this.resizeEvent)
            }
            document.removeEventListener('click', this.bodyClickEvent);
            if (this.groupTagFilters.length > 0) {
                this.onFilterTagResetClick()
            }
            this.finishLoading()
        }
    }
    const filters = {
        onLoad() {
            sections$B[this.id] = new Filters(this.container)
        },
        onDeselect() {
            sections$B[this.id].onDeselect()
        },
        onUnload() {
            sections$B[this.id].onUnload()
        },
    };
    const selectors$T = {
        aosItem: '[data-aos]',
        tabsLink: '[data-tabs-link]',
        tab: '[data-tab]',
        tabRef: '[data-tab-ref]',
        scrollable: '[data-custom-scrollbar]',
        scrollableHolder: '[data-custom-scrollbar-holder]',
        slider: '[data-slider]',
        tabsContents: '[data-tabs-contents]',
        searchForm: '[data-search-form]',
        allTypesContainer: '[data-all-types-container]',
        filtersForm: '[data-collection-filters-form]',
        currentPage: '[data-current-page]',
        tooltip: '[data-tooltip]',
        productGrid: '[data-collection-products]',
        ajaxinateContainer: '#AjaxinateLoop',
        ajaxinatePagination: '#AjaxinatePagination',
    };
    const classes$J = {
        current: 'current',
        hide: 'hide',
        alt: 'alt',
        aosAnimate: 'aos-animate',
        isLoaded: 'is-loaded',
    };
    const attributes$C = {
        tabsLink: 'data-tabs-link',
        tab: 'data-tab',
        tabRef: 'data-tab-ref',
        tabStartIndex: 'data-start-index',
        searchPerformed: 'data-search-performed',
        type: 'data-type',
        currentType: 'data-current-type',
        allTypes: 'data-all-types',
        currentPage: 'data-current-page',
        ajaxinateId: 'data-ajaxinate-id',
    };
    const sections$A = {};
    class Tabs {
        constructor(container) {
            this.container = container;
            this.tabsContents = container.querySelector(selectors$T.tabsContents);
            this.animateElementsTimer = null;
            this.isSearchPage = container.closest(`[${attributes$C.searchPerformed}="true"]`) != null;
            if (this.container) {
                this.scrollable = this.container.querySelector(selectors$T.scrollable);
                this.tabRef = this.container.querySelectorAll(selectors$T.tabRef);
                this.tabsLink = this.container.querySelectorAll(selectors$T.tabsLink);
                this.tab = this.container.querySelectorAll(selectors$T.tab);
                this.assignSearchPageArguments();
                this.init();
                this.initCustomScrollbar();
                if (!this.isSearchPage) {
                    this.initTooltips()
                }
                this.inactiveTabsAnimationsCallback = debounce( () => this.handleInactiveTabsAnimations(), 200);
                document.addEventListener('theme:scroll', this.inactiveTabsAnimationsCallback);
                this.container.addEventListener('mouseenter', () => {
                    this.handleInactiveTabsAnimations()
                }
                )
            }
        }
        assignSearchPageArguments() {
            if (!this.isSearchPage)
                return;
            this.searchForm = this.container.querySelector(selectors$T.searchForm);
            this.searchFormData = new FormData(this.searchForm);
            this.searchTerm = encodeURIComponent(this.searchFormData.get('q'));
            this.currentType = this.container.getAttribute(attributes$C.currentType);
            this.sectionId = this.container.dataset.sectionId;
            this.searchForAllTypes = this.container.getAttribute(attributes$C.allTypes) === 'true';
            this.fetchURL = '';
            this.searchParams = '';
            this.cachedResults = {};
            this.handleTabsHistory();
            this.infiniteScrollListener();
            this.initInfinityScroll(this.currentType)
        }
        init() {
            const tabsNavList = this.container.querySelectorAll(selectors$T.tabsLink);
            const firstTabsLink = this.container.querySelector(`[${attributes$C.tabsLink}="${this.container.hasAttribute(attributes$C.tabStartIndex) ? this.container.getAttribute(attributes$C.tabStartIndex) : 0}"]`);
            const firstTab = this.container.querySelector(`[${attributes$C.tab}="${this.container.hasAttribute(attributes$C.tabStartIndex) ? this.container.getAttribute(attributes$C.tabStartIndex) : 0}"]`);
            firstTab?.classList.add(classes$J.current);
            firstTabsLink?.classList.add(classes$J.current);
            this.checkVisibleTabsLinks();
            tabsNavList.forEach( (element) => {
                this.handleTabsNavListeners(element)
            }
            )
        }
        handleTabsHistory() {
            window.addEventListener('popstate', this.onHistoryChange.bind(this));
            this.openTabFromHistoryEvent = (event) => this.openTabFromHistory(event);
            this.tabsLink.forEach( (element) => {
                element.addEventListener('theme:tab:open-from-history', this.openTabFromHistoryEvent)
            }
            )
        }
        handleTabsNavListeners(element) {
            const tabId = element.getAttribute(attributes$C.tabsLink);
            const tab = this.container.querySelector(`[${attributes$C.tab}="${tabId}"]`);
            if (!tab)
                return;
            element.addEventListener('click', (event) => {
                if (this.isSearchPage)
                    this.handleURLSearchParams(event, !0);
                this.tabChange(element, tab)
            }
            );
            element.addEventListener('keyup', (event) => {
                if (event.code === theme.keyboardKeys.SPACE || event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER) {
                    if (this.isSearchPage)
                        this.handleURLSearchParams(event, !0);
                    this.tabChange(element, tab)
                }
            }
            )
        }
        openTabFromHistory(event) {
            const target = event.target;
            const element = this.container.querySelector(event.detail.element);
            const tabId = element.getAttribute(attributes$C.tabsLink);
            const tab = this.container.querySelector(`[${attributes$C.tab}="${tabId}"]`);
            if (!tab)
                return;
            this.handleURLSearchParams(event, !1);
            this.tabChange(target, tab)
        }
        handleURLSearchParams(event, updateHistory=!0) {
            const target = event.target.matches(selectors$T.tabsLink) ? event.target : event.target.closest(selectors$T.tabsLink);
            const type = target.getAttribute(attributes$C.type);
            const tabId = target.getAttribute(attributes$C.tabsLink);
            const tab = this.container.querySelector(`[${attributes$C.tab}="${tabId}"]`);
            const currentPage = tab.querySelector(selectors$T.currentPage);
            const filtersForm = document.querySelector(selectors$T.filtersForm);
            let currentPageStr = currentPage ? `&page=${currentPage.getAttribute(attributes$C.currentPage)}` : '';
            this.searchParams = getSearchParams(this.searchForm, filtersForm, [], type);
            if (type === 'product') {
                const sanitized = this.searchParams.replace('&type=product', '');
                this.searchParams = `${sanitized}&type=product`
            } else {
                this.searchParams = `q=${this.searchTerm}&type=${type}`
            }
            if (!theme.settings.enableInfinityScroll && currentPageStr !== '') {
                this.searchParams += currentPageStr
            }
            this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`;
            if (updateHistory) {
                history.pushState({
                    searchParams: this.searchParams
                }, '', `${window.location.pathname}${this.searchParams && '?'.concat(this.searchParams)}`)
            }
        }
        tabChangeFetchContent(element, tab) {
            const type = element.getAttribute(attributes$C.type);
            const tabId = element.getAttribute(attributes$C.tabsLink);
            const tabContainer = this.container.querySelector(`[${attributes$C.tab}="${tabId}"]`);
            const typeRendered = this.currentType === type;
            if (this.cachedResults[tabId] || typeRendered) {
                if (type === 'product' && !this.searchFilters) {
                    this.searchFilters = new Filters(this.container)
                }
                requestAnimationFrame( () => {
                    this.handleActiveTabClasses(element, tab);
                    this.scrollToCurrentTabLink(element);
                    this.triggerTabAnimations(tab);
                    this.checkVisibleTabsLinks();
                    this.updateAjaxify(tab, type)
                }
                );
                return
            }
            fetch(this.fetchURL).then( (response) => {
                if (!response.ok) {
                    const error = new Error(response.status);
                    throw error
                }
                return response.text()
            }
            ).then( (text) => {
                const parsed = new DOMParser().parseFromString(text, 'text/html');
                const resultsMarkup = parsed.querySelector(`[${attributes$C.tab}="${tabId}"]`).innerHTML;
                if (this.searchForAllTypes) {
                    this.container.querySelector(selectors$T.allTypesContainer)?.remove()
                }
                this.cachedResults[tabId] = resultsMarkup;
                tabContainer.innerHTML = resultsMarkup;
                if (type === 'product' && !this.searchFilters) {
                    this.searchFilters = new Filters(this.container)
                }
                requestAnimationFrame( () => {
                    this.handleActiveTabClasses(element, tab);
                    this.scrollToCurrentTabLink(element);
                    this.triggerTabAnimations(tab);
                    this.checkVisibleTabsLinks();
                    this.initInfinityScroll(type)
                }
                )
            }
            ).catch( (error) => {
                throw error
            }
            )
        }
        onHistoryChange(event) {
            const searchParams = event.state?.searchParams || window.location.search;
            const productResults = searchParams.indexOf('type=product') > -1;
            const articleResults = searchParams.indexOf('type=article') > -1;
            const pageResults = searchParams.indexOf('type=page') > -1;
            const shouldOpenTab = productResults || articleResults || pageResults;
            const typeProduct = this.container.querySelector(`${selectors$T.tabsLink}[${attributes$C.type}="product"]`);
            const typeArticle = this.container.querySelector(`${selectors$T.tabsLink}[${attributes$C.type}="article"]`);
            const typePage = this.container.querySelector(`${selectors$T.tabsLink}[${attributes$C.type}="page"]`);
            if (!shouldOpenTab) {
                window.location = searchParams;
                return
            }
            if (productResults) {
                typeProduct?.dispatchEvent(new CustomEvent('theme:tab:open-from-history',{
                    bubbles: !0,
                    detail: {
                        element: `[${attributes$C.type}="product"]`,
                    },
                }))
            }
            if (articleResults) {
                typeArticle?.dispatchEvent(new CustomEvent('theme:tab:open-from-history',{
                    bubbles: !0,
                    detail: {
                        element: `[${attributes$C.type}="article"]`,
                    },
                }))
            }
            if (pageResults) {
                typePage?.dispatchEvent(new CustomEvent('theme:tab:open-from-history',{
                    bubbles: !0,
                    detail: {
                        element: `[${attributes$C.type}="page"]`,
                    },
                }))
            }
        }
        initCustomScrollbar() {
            if (!this.scrollable || this.customScrollbar)
                return;
            this.customScrollbar = new CustomScrollbar(this.container)
        }
        infiniteScrollListener() {
            if (!theme.settings.enableInfinityScroll)
                return;
            this.ajaxifyFromFiltersEvent = (event) => this.ajaxifyFromFilters(event);
            document.addEventListener('theme:tab:ajaxinate', this.ajaxifyFromFiltersEvent)
        }
        ajaxifyFromFilters(event) {
            this.initInfinityScroll(event.detail)
        }
        initInfinityScroll(type) {
            if (!theme.settings.enableInfinityScroll)
                return;
            const ajaxinateContainer = this.container.querySelectorAll(selectors$T.ajaxinateContainer);
            if (ajaxinateContainer.length === 0)
                return;
            const activeTab = this.container.querySelector(`${selectors$T.tab}.${classes$J.current}`);
            const tabAjaxinateContainer = activeTab?.querySelector(selectors$T.ajaxinateContainer);
            const isLoaded = tabAjaxinateContainer?.classList.contains(classes$J.isLoaded);
            if (!activeTab) {
                this.initAjaxyfy(type);
                return
            }
            if (!tabAjaxinateContainer && this.endlessCollection) {
                this.updateAjaxinateInstancesSettings(type)
            }
            if (!tabAjaxinateContainer || isLoaded)
                return;
            this.initAjaxyfy(type)
        }
        updateAjaxinateInstancesSettings(type) {
            setTimeout( () => {
                if (this.endlessCollection.endlessScroll.length === 0)
                    return;
                [...this.endlessCollection.endlessScroll].forEach( (instance) => {
                    const containerElement = instance.containerElement;
                    const activeTabPresent = [...this.tab].find( (tab) => tab.classList.contains(classes$J.current));
                    const isInActiveTab = containerElement.closest(`${selectors$T.tab}.${classes$J.current}`) !== null;
                    if (!isInActiveTab && activeTabPresent)
                        instance.settings.method = 'click'
                }
                );
                const callback = () => this.initProductGridEvents();
                if (type === 'product' || type === 'all') {
                    const instanceIDCheck = (instance) => {
                        return instance.settings.container.indexOf('resultsProducts') > -1 || instance.settings.container.indexOf('allTypes') > -1
                    }
                    ;
                    const productAjaxinateInstance = [...this.endlessCollection.endlessScroll].find(instanceIDCheck);
                    if (!productAjaxinateInstance)
                        return;
                    productAjaxinateInstance.settings.callback = callback
                }
            }
            )
        }
        initAjaxyfy(type) {
            if (typeof this.endlessCollection !== 'object') {
                this.endlessCollection = new Ajaxify(this.container);
                this.updateAjaxinateInstancesSettings(type);
                return
            }
            if (this.endlessCollection.endlessScroll.length > 0) {
                this.endlessCollection.unload();
                this.endlessCollection = new Ajaxify(this.container);
                this.updateAjaxinateInstancesSettings(type)
            }
        }
        updateAjaxify(tab, type) {
            if (this.endlessCollection?.endlessScroll.length === 0)
                return;
            const ajaxinateContainer = tab.querySelector(selectors$T.ajaxinateContainer);
            const id = `${selectors$T.ajaxinateContainer}[${attributes$C.ajaxinateId}="${ajaxinateContainer?.dataset.ajaxinateId}"]`;
            if (!ajaxinateContainer)
                return;
            this.endlessCollection.update(id);
            this.updateAjaxinateInstancesSettings(type)
        }
        initProductGridEvents() {
            this.productGridEvents = new ProductGrid(this.container);
            this.initTooltips()
        }
        initTooltips() {
            this.tooltips = this.container.querySelectorAll(selectors$T.tooltip);
            this.productGrid = this.container.querySelector(selectors$T.productGrid);
            if (window.innerWidth < theme.sizes.small) {
                this.tooltips = this.productGrid?.querySelectorAll(selectors$T.tooltip)
            }
            this.tooltips?.forEach( (tooltip) => {
                new Tooltip(tooltip)
            }
            )
        }
        tabChange(element, tab) {
            if (element.classList.contains(classes$J.current))
                return;
            if (this.isSearchPage) {
                this.tabChangeFetchContent(element, tab);
                return
            }
            this.handleActiveTabClasses(element, tab);
            this.scrollToCurrentTabLink(element);
            this.triggerTabAnimations(tab);
            this.handleTabSliders(tab);
            this.checkVisibleTabsLinks()
        }
        handleActiveTabClasses(element, tab) {
            const lastActiveTab = this.container.querySelector(`${selectors$T.tab}.${classes$J.current}`);
            const lastActiveTabsLink = this.container.querySelector(`${selectors$T.tabsLink}.${classes$J.current}`);
            lastActiveTab?.classList.remove(classes$J.current);
            lastActiveTabsLink?.classList.remove(classes$J.current);
            element.classList.add(classes$J.current);
            tab.classList.add(classes$J.current);
            if (element.classList.contains(classes$J.hide)) {
                tab.classList.add(classes$J.hide)
            }
            this.tabRef?.forEach( (refElement) => {
                const isActive = refElement.classList.contains(classes$J.current);
                const shouldBeActive = refElement.getAttribute(attributes$C.tabRef) === tab.getAttribute(attributes$C.tab);
                refElement.classList.toggle(classes$J.current, !isActive && shouldBeActive)
            }
            )
        }
        scrollToCurrentTabLink(element) {
            const parent = element.closest(selectors$T.scrollableHolder) ? element.closest(selectors$T.scrollableHolder) : element.parentElement;
            const parentPadding = parseInt(window.getComputedStyle(parent).getPropertyValue('padding-left'));
            parent.scrollTo({
                top: 0,
                left: element.offsetLeft - parent.offsetWidth / 2 + element.offsetWidth / 2 + parentPadding,
                behavior: 'smooth',
            });
            element.dispatchEvent(new CustomEvent('theme:custom-scrollbar:change',{
                bubbles: !0,
                detail: {
                    element: element,
                },
            }))
        }
        triggerTabAnimations(tab) {
            if (theme.settings.animationsEnabled == 'false')
                return;
            this.tabsContents.querySelectorAll(selectors$T.aosItem).forEach( (element) => {
                element.classList.remove(classes$J.aosAnimate)
            }
            );
            if (this.animateElementsTimer) {
                clearTimeout(this.animateElementsTimer)
            }
            this.animateElementsTimer = setTimeout( () => {
                tab.querySelectorAll(selectors$T.aosItem).forEach( (element) => {
                    element.classList.add(classes$J.aosAnimate)
                }
                )
            }
            , 150)
        }
        handleInactiveTabsAnimations() {
            this.tab.forEach( (tab) => {
                if (!tab.classList.contains(classes$J.current)) {
                    tab.querySelectorAll(selectors$T.aosItem).forEach( (element) => {
                        requestAnimationFrame( () => element.classList.remove(classes$J.aosAnimate))
                    }
                    )
                }
            }
            )
        }
        handleTabSliders(tab) {
            const slider = tab.querySelector(selectors$T.slider);
            if (slider)
                slider.dispatchEvent(new CustomEvent('theme:tab:change',{
                    bubbles: !1
                }))
        }
        checkVisibleTabsLinks() {
            const tabsNavList = this.container.querySelectorAll(selectors$T.tabsLink);
            const tabsNavListHidden = this.container.querySelectorAll(`${selectors$T.tabsLink}.${classes$J.hide}`);
            const difference = tabsNavList.length - tabsNavListHidden.length;
            if (difference < 2) {
                this.container.classList.add(classes$J.alt)
            } else {
                this.container.classList.remove(classes$J.alt)
            }
        }
        onBlockSelect(event) {
            const element = event.target;
            if (element) {
                element.dispatchEvent(new Event('click'));
                element.parentNode.scrollTo({
                    top: 0,
                    left: element.offsetLeft - element.clientWidth,
                    behavior: 'smooth',
                })
            }
        }
        onUnload() {
            if (this.customScrollbar) {
                this.customScrollbar.unload()
            }
            if (this.isSearchPage && theme.settings.enableInfinityScroll) {
                document.removeEventListener('theme:tab:ajaxinate', this.ajaxifyFromFiltersEvent)
            }
            document.removeEventListener('theme:scroll', this.inactiveTabsAnimationsCallback)
        }
    }
    const tabs = {
        onLoad() {
            sections$A[this.id] = new Tabs(this.container)
        },
        onBlockSelect(e) {
            sections$A[this.id].onBlockSelect(e)
        },
        onUnload() {
            sections$A[this.id].onUnload()
        },
    };
    const selectors$S = {
        drawer: '[data-drawer]',
        drawerToggle: '[data-drawer-toggle]',
        scroller: '[data-scroll]',
        quickviewItem: '[data-quick-view-item]',
        tabsLink: '[data-tabs-link]',
    };
    const classes$I = {
        open: 'is-open',
        drawerOpen: 'js-drawer-open',
        drawerOpenSize: 'js-drawer-open--size',
        contentVisibilityHidden: 'cv-h',
        header: 'site-header',
        productSingle: 'product-single',
    };
    const attributes$B = {
        ariaExpanded: 'aria-expanded',
        ariaControls: 'aria-controls',
    };
    let sections$z = {};
    class Drawer {
        constructor(container) {
            this.container = container;
            this.body = document.body;
            this.drawers = this.container.querySelectorAll(selectors$S.drawer);
            this.drawerToggleButtons = this.container.querySelectorAll(selectors$S.drawerToggle);
            this.a11y = a11y;
            this.drawerToggleEvent = throttle( (event) => {
                this.toggle(event)
            }
            , 150);
            this.keyPressCloseEvent = throttle( (event) => {
                if (event.code === theme.keyboardKeys.ESCAPE) {
                    this.close(event)
                }
            }
            , 150);
            this.drawerCloseEvent = (event) => {
                const activeDrawer = document.querySelector(`${selectors$S.drawer}.${classes$I.open}`);
                let isDrawerToggle = !1;
                if (!activeDrawer) {
                    return
                }
                if (event.type === 'click') {
                    isDrawerToggle = event.target.matches(selectors$S.drawerToggle)
                }
                const isDrawerChild = activeDrawer ? activeDrawer.contains(event.target) : !1;
                const quickviewItem = activeDrawer.closest(selectors$S.quickviewItem);
                const isQuickviewChild = quickviewItem ? quickviewItem.contains(event.target) : !1;
                if (!isDrawerToggle && !isDrawerChild && !isQuickviewChild) {
                    this.close()
                }
            }
            ;
            this.initListeners()
        }
        initListeners() {
            this.drawerToggleButtons.forEach( (button) => {
                button.addEventListener('click', this.drawerToggleEvent)
            }
            );
            this.drawers.forEach( (drawer) => {
                drawer.addEventListener('keyup', this.keyPressCloseEvent);
                this.collapsible = new Collapsible(drawer);
                this.tabs = new Tabs(drawer)
            }
            );
            document.addEventListener('click', this.drawerCloseEvent);
            document.addEventListener('theme:drawer:closing', this.drawerCloseEvent)
        }
        toggle(e) {
            e.preventDefault();
            const drawer = document.querySelector(`#${e.target.getAttribute(attributes$B.ariaControls)}`);
            if (!drawer) {
                return
            }
            const isDrawerOpen = drawer.classList.contains(classes$I.open);
            if (isDrawerOpen) {
                this.close()
            } else {
                this.open(e)
            }
        }
        open(e) {
            const drawerOpenButton = e.target;
            const drawer = document.querySelector(`#${e.target.getAttribute(attributes$B.ariaControls)}`);
            if (!drawer) {
                return
            }
            const drawerScroller = drawer.querySelector(selectors$S.scroller) || drawer;
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: drawerScroller
            }));
            document.dispatchEvent(new CustomEvent('theme:drawer:open'), {
                bubbles: !0
            });
            this.body.classList.add(classes$I.drawerOpen);
            if (this.container.classList.contains(classes$I.productSingle)) {
                this.body.classList.add(classes$I.drawerOpenSize)
            }
            drawer.classList.add(classes$I.open);
            drawer.classList.remove(classes$I.contentVisibilityHidden);
            drawerOpenButton.setAttribute(attributes$B.ariaExpanded, !0);
            setTimeout( () => {
                this.a11y.state.trigger = drawerOpenButton;
                this.a11y.trapFocus({
                    container: drawer,
                })
            }
            )
        }
        close() {
            if (!this.body.classList.contains(classes$I.drawerOpen)) {
                return
            }
            const drawer = document.querySelector(`${selectors$S.drawer}.${classes$I.open}`);
            this.drawerToggleButtons.forEach( (button) => {
                button.setAttribute(attributes$B.ariaExpanded, !1)
            }
            );
            this.a11y.removeTrapFocus({
                container: drawer,
            });
            drawer.classList.remove(classes$I.open);
            const onDrawerTransitionEnd = (event) => {
                if (event.target !== drawer)
                    return;
                requestAnimationFrame( () => {
                    drawer.classList.add(classes$I.contentVisibilityHidden);
                    document.dispatchEvent(new CustomEvent('theme:drawer:close'), {
                        bubbles: !0
                    });
                    document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                        bubbles: !0
                    }))
                }
                );
                drawer.removeEventListener('transitionend', onDrawerTransitionEnd)
            }
            ;
            drawer.addEventListener('transitionend', onDrawerTransitionEnd);
            this.body.classList.remove(classes$I.drawerOpen);
            this.body.classList.remove(classes$I.drawerOpenSize)
        }
        onUnload() {
            this.close();
            this.drawerToggleButtons.forEach( (button) => {
                button.removeEventListener('click', this.drawerToggleEvent)
            }
            );
            this.drawers.forEach( (drawer) => {
                drawer.removeEventListener('keyup', this.keyPressCloseEvent)
            }
            );
            document.removeEventListener('click', this.drawerCloseEvent);
            document.removeEventListener('theme:drawer:closing', this.drawerCloseEvent);
            if (this.collapsible) {
                this.collapsible.onUnload()
            }
            if (this.tabs) {
                this.tabs.onUnload()
            }
        }
    }
    const drawer = {
        onLoad() {
            if (this.container.classList.contains(classes$I.header)) {
                this.container = this.container.parentNode
            }
            sections$z[this.id] = new Drawer(this.container)
        },
        onUnload() {
            sections$z[this.id].onUnload()
        },
    };
    const showElement = (elem, removeProp=!1, prop='block') => {
        if (elem) {
            if (removeProp) {
                elem.style.removeProperty('display')
            } else {
                elem.style.display = prop
            }
        }
    }
    ;
    const hideElement = (elem) => {
        if (elem) {
            elem.style.display = 'none'
        }
    }
    ;
    const scrollTo = (elementTop) => {
        const {stickyHeaderHeight} = readHeights();
        window.scrollTo({
            top: elementTop + Math.round(window.scrollY) - stickyHeaderHeight,
            left: 0,
            behavior: 'smooth',
        })
    }
    ;
    const selectors$R = {
        list: '[data-store-availability-list]',
    };
    const defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-store-availability-modal',
        openClass: 'modal--is-active',
        openBodyClass: 'modal--is-visible',
        closeModalOnClick: !1,
        scrollIntoView: !1,
    };
    class Modals {
        constructor(id, options) {
            this.modal = document.getElementById(id);
            if (!this.modal)
                return !1;
            this.nodes = {
                parents: [document.querySelector('html'), document.body],
            };
            this.config = Object.assign(defaults, options);
            this.modalIsOpen = !1;
            this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal;
            this.openElement = document.querySelector(this.config.open);
            this.a11y = a11y;
            this.init()
        }
        init() {
            this.openElement.addEventListener('click', this.open.bind(this));
            this.modal.querySelector(this.config.close).addEventListener('click', this.closeModal.bind(this))
        }
        open(evt) {
            let externalCall = !1;
            if (evt) {
                evt.preventDefault()
            } else {
                externalCall = !0
            }
            if (this.modalIsOpen && !externalCall) {
                this.closeModal();
                return
            }
            this.modal.classList.add(this.config.openClass);
            this.nodes.parents.forEach( (node) => {
                node.classList.add(this.config.openBodyClass)
            }
            );
            this.modalIsOpen = !0;
            const scrollableElement = document.querySelector(selectors$R.list);
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: scrollableElement
            }));
            if (this.config.scrollIntoView) {
                this.scrollIntoView()
            }
            this.bindEvents();
            this.a11y.trapFocus({
                container: this.modal,
            })
        }
        closeModal() {
            if (!this.modalIsOpen)
                return;
            document.activeElement.blur();
            this.modal.classList.remove(this.config.openClass);
            var self = this;
            this.nodes.parents.forEach(function(node) {
                node.classList.remove(self.config.openBodyClass)
            });
            this.modalIsOpen = !1;
            this.openElement.focus();
            this.unbindEvents();
            this.a11y.removeTrapFocus({
                container: this.modal,
            });
            const timeout = 400;
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                bubbles: !0,
                detail: timeout
            }))
        }
        bindEvents() {
            this.keyupHandler = this.keyupHandler.bind(this);
            this.clickHandler = this.clickHandler.bind(this);
            document.body.addEventListener('keyup', this.keyupHandler);
            document.body.addEventListener('click', this.clickHandler)
        }
        unbindEvents() {
            document.body.removeEventListener('keyup', this.keyupHandler);
            document.body.removeEventListener('click', this.clickHandler)
        }
        keyupHandler(event) {
            if (event.code === theme.keyboardKeys.ESCAPE) {
                this.closeModal()
            }
        }
        clickHandler(event) {
            if (this.config.closeModalOnClick && !this.modal.contains(event.target) && !event.target.matches(this.config.open)) {
                this.closeModal()
            }
        }
        scrollIntoView() {
            this.focusOnOpen.scrollIntoView({
                behavior: 'smooth',
            })
        }
    }
    const selectors$Q = {
        body: 'body',
        storeAvailabilityModal: '[data-store-availability-modal]',
        storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
        storeAvailabilityModalClose: '[data-store-availability-modal-close]',
        storeAvailabilityModalProductTitle: '[data-store-availability-modal-product__title]',
    };
    const classes$H = {
        openClass: 'store-availabilities-modal--active',
    };
    class StoreAvailability {
        constructor(container) {
            this.container = container
        }
        updateContent(variantId, productTitle) {
            this._fetchStoreAvailabilities(variantId, productTitle)
        }
        clearContent() {
            this.container.innerHTML = ''
        }
        _initModal() {
            return new Modals('StoreAvailabilityModal',{
                close: selectors$Q.storeAvailabilityModalClose,
                open: selectors$Q.storeAvailabilityModalOpen,
                closeModalOnClick: !0,
                openClass: classes$H.openClass,
                scrollIntoView: !1,
            })
        }
        _fetchStoreAvailabilities(variantId, productTitle) {
            const variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';
            this.clearContent();
            const self = this;
            fetch(variantSectionUrl).then(function(response) {
                return response.text()
            }).then(function(storeAvailabilityHTML) {
                const body = document.querySelector(selectors$Q.body);
                let storeAvailabilityModal = body.querySelector(selectors$Q.storeAvailabilityModal);
                if (storeAvailabilityModal) {
                    storeAvailabilityModal.remove()
                }
                self.container.innerHTML = storeAvailabilityHTML;
                self.container.innerHTML = self.container.firstElementChild.innerHTML;
                if (self.container.firstElementChild.innerHTML.trim() === '') {
                    self.clearContent();
                    return
                }
                const storeAvailabilityModalOpen = self.container.querySelector(selectors$Q.storeAvailabilityModalOpen);
                if (!storeAvailabilityModalOpen) {
                    return
                }
                self.modal = self._initModal();
                self._updateProductTitle(productTitle);
                storeAvailabilityModal = self.container.querySelector(selectors$Q.storeAvailabilityModal);
                if (storeAvailabilityModal) {
                    body.appendChild(storeAvailabilityModal)
                }
            })
        }
        _updateProductTitle(productTitle) {
            const storeAvailabilityModalProductTitle = this.container.querySelector(selectors$Q.storeAvailabilityModalProductTitle);
            storeAvailabilityModalProductTitle.textContent = productTitle
        }
    }
    const selectors$P = {
        form: '[data-product-form]',
        optionPosition: '[data-option-position]',
        optionInput: '[name^="options"], [data-popout-option]',
    };
    const classes$G = {
        soldOut: 'sold-out',
        unavailable: 'unavailable',
    };
    const attributes$A = {
        optionPosition: 'data-option-position',
        selectOptionValue: 'data-value',
    };
    class SelloutVariants {
        constructor(container, productJSON) {
            this.container = container;
            this.productJSON = productJSON;
            this.form = this.container.querySelector(selectors$P.form);
            this.formData = new FormData(this.form);
            this.optionElements = this.container.querySelectorAll(selectors$P.optionInput);
            if (this.productJSON && this.form) {
                this.init()
            }
        }
        init() {
            this.update()
        }
        update() {
            this.getCurrentState();
            this.optionElements.forEach( (el) => {
                const val = el.value || el.getAttribute(attributes$A.selectOptionValue);
                const optionSelector = el.closest(selectors$P.optionPosition);
                if (!optionSelector) {
                    return
                }
                const positionString = optionSelector.getAttribute(attributes$A.optionPosition);
                const position = parseInt(positionString, 10) - 1;
                let newVals = [...this.selections];
                newVals[position] = val;
                const found = this.productJSON.variants.find( (element) => {
                    let perfectMatch = !0;
                    for (let index = 0; index < newVals.length; index++) {
                        if (element.options[index] !== newVals[index]) {
                            perfectMatch = !1
                        }
                    }
                    return perfectMatch
                }
                );
                el.parentElement.classList.remove(classes$G.soldOut, classes$G.unavailable);
                if (typeof found === 'undefined') {
                    el.parentElement.classList.add(classes$G.unavailable)
                } else if (found?.available === !1) {
                    el.parentElement.classList.add(classes$G.soldOut)
                }
            }
            )
        }
        getCurrentState() {
            this.formData = new FormData(this.form);
            this.selections = [];
            for (var value of this.formData.entries()) {
                if (value[0].includes('options[')) {
                    this.selections.push(value[1])
                }
            }
        }
    }
    const settings$7 = {
        templateIndex: 1,
    };
    const classes$F = {
        popupNotification: 'pswp--notification pswp--not-close-btn',
    };
    const attributes$z = {
        notificationPopup: 'data-notification-popup',
    };
    const options$1 = {
        history: !1,
        focus: !1,
        mainClass: classes$F.popupNotification,
        closeOnVerticalDrag: !1,
    };
    class NotificationPopup {
        constructor(button) {
            this.button = button;
            this.a11y = a11y;
            this.notificationPopupHtml = this.button.getAttribute(attributes$z.notificationPopup);
            if (this.notificationPopupHtml.trim() !== '') {
                this.init()
            }
        }
        init() {
            const items = [{
                html: this.notificationPopupHtml,
            }, ];
            this.a11y.state.trigger = this.button;
            new LoadPhotoswipe(items,options$1,settings$7.templateIndex)
        }
    }
    const selectors$O = {
        product: '[data-product]',
        productForm: '[data-product-form]',
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        buyItNow: '[data-buy-it-now]',
        comparePrice: '[data-compare-price]',
        formWrapper: '[data-form-wrapper]',
        header: '[data-site-header]',
        originalSelectorId: '[data-product-select]',
        preOrderTag: '_preorder',
        priceWrapper: '[data-price-wrapper]',
        priceOffWrap: '[data-price-off]',
        priceOffType: '[data-price-off-type]',
        priceOffAmount: '[data-price-off-amount]',
        productSlide: '[data-product-slide]',
        productImage: '[data-product-image]',
        productMediaSlider: '[data-product-single-media-slider]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        unitPrice: '[data-product-unit-price]',
        unitBase: '[data-product-base]',
        unitWrapper: '[data-product-unit]',
        subPrices: '[data-subscription-watch-price]',
        subSelectors: '[data-subscription-selectors]',
        subsToggle: '[data-toggles-group]',
        subsChild: 'data-group-toggle',
        subDescription: '[data-plan-description]',
        remainingCount: '[data-remaining-count]',
        remainingWrapper: '[data-remaining-wrapper]',
        remainingJSON: '[data-product-remaining-json]',
        idInput: '[name="id"]',
        storeAvailabilityContainer: '[data-store-availability-container]',
        upsellButton: '[data-upsell-btn]',
        sectionNode: '.shopify-section',
        quickViewItem: '[data-quick-view-item]',
        notificationButtonText: '[data-notification-button-text]',
        swatchesContainer: '[data-swatches-container]',
        swatchesMore: '[data-swatches-more]',
        selectorWrapper: '[data-option-position]',
        shopifyPaymentButton: '.shopify-payment-button__button',
        paymentButton: '[role="button"], [type="submit"], form',
        disabled: '[disabled]',
    };
    const classes$E = {
        hidden: 'hidden',
        variantSoldOut: 'variant--soldout',
        variantUnavailable: 'variant--unavailabe',
        productPriceSale: 'product__price--sale',
        priceWrapperHidden: 'product__price--hidden',
        remainingLow: 'count-is-low',
        remainingIn: 'count-is-in',
        remainingOut: 'count-is-out',
        remainingUnavailable: 'count-is-unavailable',
        selectorVisible: 'selector-wrapper--visible',
    };
    const attributes$y = {
        productImageId: 'data-image-id',
        tallLayout: 'data-tall-layout',
        dataEnableHistoryState: 'data-enable-history-state',
        notificationPopup: 'data-notification-popup',
        swatchVariant: 'data-swatch-variant',
        disabled: 'disabled',
    };
    let sections$y = {};
    class ProductAddForm {
        constructor(container) {
            this.container = container;
            this.product = this.container.querySelector(selectors$O.product);
            this.productForm = this.container.querySelector(selectors$O.productForm);
            this.tallLayout = this.container.getAttribute(attributes$y.tallLayout) === 'true';
            this.addToCartButton = this.container.querySelector(selectors$O.addToCart);
            this.buyItNow = this.container.querySelector(selectors$O.buyItNow);
            this.hasPaymentButton = this.buyItNow !== null;
            if (!this.product || !this.productForm) {
                const counter = new QuantityCounter(this.container);
                counter.init();
                return
            }
            this.storeAvailabilityContainer = this.container.querySelector(selectors$O.storeAvailabilityContainer);
            this.enableHistoryState = this.container.getAttribute(attributes$y.dataEnableHistoryState) === 'true';
            this.hasUnitPricing = this.container.querySelector(selectors$O.unitWrapper);
            this.subSelectors = this.container.querySelector(selectors$O.subSelectors);
            this.subPrices = this.container.querySelector(selectors$O.subPrices);
            this.priceOffWrap = this.container.querySelector(selectors$O.priceOffWrap);
            this.priceOffAmount = this.container.querySelector(selectors$O.priceOffAmount);
            this.priceOffType = this.container.querySelector(selectors$O.priceOffType);
            this.planDecription = this.container.querySelector(selectors$O.subDescription);
            this.swatchesContainer = this.container.querySelector(selectors$O.swatchesContainer);
            this.latestVariantId = '';
            this.latestVariantTitle = '';
            this.sellout = null;
            this.sessionStorage = window.sessionStorage;
            this.remainingWrapper = this.container.querySelector(selectors$O.remainingWrapper);
            if (this.remainingWrapper) {
                this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10);
                this.remainingCount = this.container.querySelector(selectors$O.remainingCount);
                this.remainingJSONWrapper = this.container.querySelector(selectors$O.remainingJSON);
                this.remainingJSON = null;
                if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== '') {
                    this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)
                }
            }
            if (this.storeAvailabilityContainer) {
                this.storeAvailability = new StoreAvailability(this.storeAvailabilityContainer)
            }
            const counter = new QuantityCounter(this.container);
            counter.init();
            this.init();
            if (this.hasPaymentButton) {
                this.mutationObserver = null;
                this.onResizeCallback = () => this.updateButtonsHeight();
                this.observeContainer();
                window.addEventListener('theme:resize:width', this.onResizeCallback)
            }
          //debugger;
            if(this.container.closest(".popup-quick-view") && window.innerWidth < 768){
              var swatches = this.container.querySelectorAll(".popup-quick-view__meta .selector-wrapper.selector-wrapper--boxes.selector-wrapper--grid input")
              if(swatches.length){
                swatches.forEach((swatch) => {
                  swatch.checked = false;
                })
              }
            }
        }
        init() {
            let productJSON = null;
            const productElemJSON = this.container.querySelector(selectors$O.productJson);
            if (productElemJSON) {
                productJSON = productElemJSON.innerHTML
            }
            if (productJSON) {
                this.productJSON = JSON.parse(productJSON);
                this.linkForm();
                this.sellout = new SelloutVariants(this.container,this.productJSON)
            } else {
                console.error('Missing product JSON')
            }
        }
        observeContainer() {
            this.mutationObserver = new MutationObserver( (mutationList) => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'childList' && mutation.target.closest(selectors$O.buyItNow)) {
                        this.updateButtonsHeight();
                        if (!mutation.target.querySelector(selectors$O.disabled)) {
                            this.mutationObserver?.disconnect();
                            this.mutationObserver = null
                        }
                    }
                }
            }
            );
            this.mutationObserver.observe(this.container, {
                childList: !0,
                subtree: !0
            })
        }
        updateButtonsHeight() {
            this.shopifyPaymentButton = this.container.querySelector(selectors$O.shopifyPaymentButton);
            this.paymentButton = this.buyItNow.querySelectorAll(`${selectors$O.paymentButton}`);
            if (!this.shopifyPaymentButton)
                return;
            if (this.shopifyPaymentButton.hasAttribute(attributes$y.disabled))
                return;
            this.shopifyPaymentButton.setAttribute('style', 'min-height: auto !important;');
            this.addToCartButton.setAttribute('style', 'min-height: auto;');
            this.paymentButton.forEach( (element) => element.setAttribute('style', 'min-height: auto !important;'));
            requestAnimationFrame( () => {
                this.compareHeights = [];
                this.paymentButton.forEach( (element) => this.compareHeights.push(element.offsetHeight));
                this.compareHeights.push(this.shopifyPaymentButton.offsetHeight);
                this.compareHeights.push(this.addToCartButton.offsetHeight);
                debounce(this.setButtonsStyles(), 400)
            }
            )
        }
        setButtonsStyles() {
            if (this.compareHeights.length === 0)
                return;
            this.maxHeight = Math.max(...this.compareHeights);
            requestAnimationFrame( () => {
                this.addToCartButton.setAttribute('style', `min-height: ${this.maxHeight}px;`);
                this.shopifyPaymentButton.setAttribute('style', `min-height: ${this.maxHeight}px !important; height: auto !important;`);
                this.paymentButton.forEach( (element) => element.setAttribute('style', `min-height: ${this.maxHeight}px !important; height: auto !important;`))
            }
            )
        }
        linkForm() {
            this.productForm = new ProductForm(this.productForm,this.productJSON,{
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this),
            });
            const formState = this.productForm.getFormState();
            this.pushState(formState, !0);
            this.subsToggleListeners();
            if (this.swatchesContainer) {
                this.observeSwatch(formState);
                const selectorWrapper = this.swatchesContainer.closest(selectors$O.selectorWrapper);
                const moreLink = selectorWrapper.querySelector(selectors$O.swatchesMore);
                moreLink?.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (selectorWrapper.classList.contains(classes$E.selectorVisible)) {
                        selectorWrapper.classList.remove(classes$E.selectorVisible)
                    } else {
                        selectorWrapper.classList.add(classes$E.selectorVisible)
                    }
                }
                )
            }
        }
        onOptionChange(evt) {
            this.pushState(evt.dataset);
            this.updateProductImage(evt);

            if(evt.target.closest(".popup-quick-view") && window.innerWidth < 768){
            var variant = evt.dataset.variant;
             if (!variant){
                return;
             }           
            
            if (variant.available) {
               const addToCart = evt.target.closest(".popup-quick-view").querySelector(selectors$O.addToCart);
               if(addToCart){
                 addToCart.dispatchEvent(new Event("click", {bubbles: true}));
               }
            }
            }
        }
        onPlanChange(evt) {
            if (this.subPrices) {
                this.pushState(evt.dataset)
            }
        }
        pushState(formState, init=!1) {
            this.productState = this.setProductState(formState);
            this.updateAddToCartState(formState);
            this.updateProductPrices(formState);
            this.updateSaleText(formState);
            this.updateSubscriptionText(formState);
            this.fireHookEvent(formState);
            this.updateRemaining(formState);
            this.sellout?.update(formState);
            if (this.enableHistoryState && !init) {
                this.updateHistoryState(formState)
            }
            if (this.storeAvailability) {
                if (formState.variant) {
                    this.storeAvailability.updateContent(formState.variant.id, this.productForm.product.title)
                } else {
                    this.storeAvailability.clearContent()
                }
            }
        }
        updateAddToCartState(formState) {
            const variant = formState.variant;
            const priceWrapper = this.container.querySelectorAll(selectors$O.priceWrapper);
            const addToCart = this.container.querySelectorAll(selectors$O.addToCart);
            const addToCartText = this.container.querySelectorAll(selectors$O.addToCartText);
            const formWrapper = this.container.querySelectorAll(selectors$O.formWrapper);
            const buyItNow = this.container.querySelector(selectors$O.buyItNow);
            let addText = theme.strings.add_to_cart;
            if (this.productJSON.tags.includes(selectors$O.preOrderTag)) {
                addText = theme.strings.preorder
            }
            priceWrapper?.forEach( (element) => {
                element.classList.toggle(classes$E.priceWrapperHidden, !variant)
            }
            );
            addToCart?.forEach( (element) => {
                if (element.matches(selectors$O.upsellButton))
                    return;
                element.disabled = !0;
                buyItNow?.classList.add(classes$E.hidden);
                if (!variant)
                    return;
                element.disabled = !1;
                if (variant.available) {
                    buyItNow?.classList.remove(classes$E.hidden)
                }
                if (!element.hasAttribute(attributes$y.notificationPopup))
                    return;
                const notificationFormId = element.id.replace('AddToCart', 'NotificationForm');
                const formID = this.sessionStorage.getItem('notification_form_id');
                let notificationFormSubmitted = !1;
                let variantId = variant.id;
                let variantTitle = variant.title;
                if (formID) {
                    const sessionId = formID.substring(0, formID.lastIndexOf('--'));
                    const sessionVariantId = formID.split('--').slice(-1)[0];
                    notificationFormSubmitted = notificationFormId === sessionId;
                    if (notificationFormSubmitted) {
                        this.latestVariantId = variantId;
                        this.latestVariantTitle = variantTitle;
                        variantId = Number(sessionVariantId);
                        this.productJSON.variants.forEach( (variant) => {
                            if (variant.id === variantId) {
                                variantTitle = variant.title
                            }
                        }
                        )
                    }
                }
                let notificationPopupHtml = element.getAttribute(attributes$y.notificationPopup);
                const notificationButtonText = new DOMParser().parseFromString(notificationPopupHtml, 'text/html').querySelector(selectors$O.notificationButtonText)?.innerHTML;
                if (this.latestVariantId != '' && this.latestVariantTitle != '') {
                    notificationPopupHtml = notificationPopupHtml.replaceAll(this.latestVariantId, variantId);
                    notificationPopupHtml = notificationPopupHtml.replaceAll(`<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`, `<p class='product__notification__subtitle'>${variantTitle}</p>`);
                    const updatedNotificationButtonText = new DOMParser().parseFromString(notificationPopupHtml, 'text/html').querySelector(selectors$O.notificationButtonText)?.innerHTML;
                    notificationPopupHtml = notificationPopupHtml.replace(updatedNotificationButtonText, notificationButtonText)
                }
                element.setAttribute(attributes$y.notificationPopup, notificationPopupHtml);
                if (notificationFormSubmitted) {
                    this.scrollToForm(this.product.closest(selectors$O.sectionNode));
                    new NotificationPopup(element)
                }
                this.latestVariantId = variantId;
                this.latestVariantTitle = variantTitle
            }
            );
            addToCartText?.forEach( (element) => {
                if (!variant) {
                    element.innerHTML = theme.strings.unavailable;
                    return
                }
                if (!variant.available) {
                    element.innerHTML = theme.strings.sold_out;
                    if (element.parentNode.hasAttribute(attributes$y.notificationPopup)) {
                        if (element.closest(selectors$O.quickViewItem))
                            return;
                        element.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`
                    }
                    return
                }
                element.innerHTML = addText
            }
            );
            formWrapper?.forEach( (element) => {
                if (!variant) {
                    element.classList.add(classes$E.variantUnavailable);
                    element.classList.remove(classes$E.variantSoldOut);
                    return
                }
                const formSelect = element.querySelector(selectors$O.originalSelectorId);
                if (formSelect) {
                    formSelect.value = variant.id
                }
                if (!variant.available) {
                    element.classList.add(classes$E.variantSoldOut);
                    element.classList.remove(classes$E.variantUnavailable);
                    return
                }
                element.classList.remove(classes$E.variantSoldOut, classes$E.variantUnavailable)
            }
            )
        }
        updateHistoryState(formState) {
            const variant = formState.variant;
            const plan = formState.plan;
            const location = window.location.href;
            if (variant && location.includes('/product')) {
                const url = new window.URL(location);
                const params = url.searchParams;
                params.set('variant', variant.id);
                if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
                    params.set('selling_plan', plan.detail.id)
                } else {
                    params.delete('selling_plan')
                }
                url.search = params.toString();
                const urlString = url.toString();
                window.history.replaceState({
                    path: urlString
                }, '', urlString)
            }
        }
        updateRemaining(formState) {
            const variant = formState.variant;
            const remainingClasses = [classes$E.remainingIn, classes$E.remainingOut, classes$E.remainingUnavailable, classes$E.remainingLow];
            if (variant && this.remainingWrapper && this.remainingJSON) {
                const remaining = this.remainingJSON[variant.id];
                if (remaining === 'out' || remaining < 1) {
                    this.remainingWrapper.classList.remove(...remainingClasses);
                    this.remainingWrapper.classList.add(classes$E.remainingOut)
                }
                if (remaining === 'in' || remaining >= this.remainingMaxInt) {
                    this.remainingWrapper.classList.remove(...remainingClasses);
                    this.remainingWrapper.classList.add(classes$E.remainingIn)
                }
                if (remaining === 'low' || (remaining > 0 && remaining < this.remainingMaxInt)) {
                    this.remainingWrapper.classList.remove(...remainingClasses);
                    this.remainingWrapper.classList.add(classes$E.remainingLow);
                    if (this.remainingCount) {
                        this.remainingCount.innerHTML = remaining
                    }
                }
            } else if (!variant && this.remainingWrapper) {
                this.remainingWrapper.classList.remove(...remainingClasses);
                this.remainingWrapper.classList.add(classes$E.remainingUnavailable)
            }
        }
        getBaseUnit(variant) {
            return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            const toggles = this.container.querySelectorAll(selectors$O.subsToggle);
            toggles.forEach( (toggle) => {
                toggle.addEventListener('change', function(e) {
                    const val = e.target.value.toString();
                    const selected = this.container.querySelector(`[${selectors$O.subsChild}="${val}"]`);
                    const groups = this.container.querySelectorAll(`[${selectors$O.subsChild}]`);
                    if (selected) {
                        selected.classList.remove(classes$E.hidden);
                        const first = selected.querySelector('[name="selling_plan"]');
                        first.checked = !0;
                        first.dispatchEvent(new Event('change'))
                    }
                    groups.forEach( (group) => {
                        if (group !== selected) {
                            group.classList.add(classes$E.hidden);
                            const plans = group.querySelectorAll('[name="selling_plan"]');
                            plans.forEach( (plan) => {
                                plan.checked = !1;
                                plan.dispatchEvent(new Event('change'))
                            }
                            )
                        }
                    }
                    )
                }
                .bind(this))
            }
            )
        }
        updateSaleText(formState) {
            if (this.productState.planSale) {
                this.updateSaleTextSubscription(formState)
            } else if (this.productState.onSale) {
                this.updateSaleTextStandard(formState)
            } else if (this.priceOffWrap) {
                this.priceOffWrap.classList.add(classes$E.hidden)
            }
        }
        updateSaleTextStandard(formState) {
            if (!this.priceOffType) {
                return
            }
            this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || 'sale';
            const variant = formState.variant;
            if (window.theme.settings.savingBadgeType && window.theme.settings.savingBadgeType === 'percentage') {
                const discountFloat = (variant.compare_at_price - variant.price) / variant.compare_at_price;
                const discountInt = Math.floor(discountFloat * 100);
                const discountIntRounded = Math.round(discountInt / 5) * 5;
                this.priceOffAmount.innerHTML = `${discountIntRounded}%`
            } else {
                const discount = variant.compare_at_price - variant.price;
                this.priceOffAmount.innerHTML = themeCurrency.formatMoney(discount, theme.moneyFormat)
            }
            this.priceOffWrap.classList.remove(classes$E.hidden)
        }
        updateSaleTextSubscription(formState) {
            const variant = formState.variant;
            const variantFirstPlan = this.productForm.product.selling_plan_groups.find( (plan) => plan.id === variant.selling_plan_allocations[0].selling_plan_group_id);
            const adjustment = formState.plan ? formState.plan.detail.price_adjustments[0] : variantFirstPlan.selling_plans[0].price_adjustments[0];
            const discount = adjustment.value || 0;
            const saleText = adjustment.value_type === 'percentage' ? `${discount}%` : themeCurrency.formatMoney(variant.price - discount, theme.moneyFormat);
            this.priceOffType.innerHTML = window.theme.strings.subscription || 'subscripton';
            this.priceOffAmount.innerHTML = saleText;
            this.priceOffWrap.classList.remove(classes$E.hidden)
        }
        updateSubscriptionText(formState) {
            if (formState.plan && this.planDecription && formState.plan.detail.description !== null) {
                this.planDecription.innerHTML = formState.plan.detail.description;
                this.planDecription.classList.remove(classes$E.hidden)
            } else if (this.planDecription) {
                this.planDecription.classList.add(classes$E.hidden)
            }
        }
        updateProductPrices(formState) {
            const variant = formState.variant;
            const plan = formState.plan;
            const priceWrappers = this.container.querySelectorAll(selectors$O.priceWrapper);
            priceWrappers.forEach( (wrap) => {
                const comparePriceEl = wrap.querySelector(selectors$O.comparePrice);
                const productPriceEl = wrap.querySelector(selectors$O.productPrice);
                let comparePrice = '';
                let price = '';
                if (this.productState.available) {
                    comparePrice = variant.compare_at_price;
                    price = variant.price
                }
                if (this.productState.hasPlan) {
                    const allocationPrice = plan ? plan.allocation.price : variant.selling_plan_allocations[0].per_delivery_price;
                    price = allocationPrice
                }
                if (this.productState.planSale) {
                    const allocationPrice = plan ? plan.allocation.price : variant.selling_plan_allocations[0].per_delivery_price;
                    const allocationPriceCompare = plan ? plan.allocation.compare_at_price : variant.selling_plan_allocations[0].compare_at_price;
                    comparePrice = allocationPriceCompare;
                    price = allocationPrice
                }
                if (comparePriceEl) {
                    if (this.productState.onSale || this.productState.planSale) {
                        comparePriceEl.classList.remove(classes$E.hidden);
                        productPriceEl.classList.add(classes$E.productPriceSale)
                    } else {
                        comparePriceEl.classList.add(classes$E.hidden);
                        productPriceEl.classList.remove(classes$E.productPriceSale)
                    }
                    comparePriceEl.innerHTML = theme.settings.currency_code_enable ? themeCurrency.formatMoney(comparePrice, theme.moneyWithCurrencyFormat) : themeCurrency.formatMoney(comparePrice, theme.moneyFormat)
                }
                if (price === 0) {
                    productPriceEl.innerHTML = window.theme.strings.free
                } else {
                    productPriceEl.innerHTML = theme.settings.currency_code_enable ? themeCurrency.formatMoney(price, theme.moneyWithCurrencyFormat) : themeCurrency.formatMoney(price, theme.moneyFormat)
                }
            }
            );
            if (this.hasUnitPricing) {
                this.updateProductUnits(formState)
            }
        }
        updateProductUnits(formState) {
            const variant = formState.variant;
            const plan = formState.plan;
            let unitPrice = null;
            if (variant && variant.unit_price) {
                unitPrice = variant.unit_price
            }
            if (plan && plan?.allocation && plan?.allocation.unit_price) {
                unitPrice = plan.allocation.unit_price
            }
            if (!plan && variant.selling_plan_allocations) {
                if (variant.selling_plan_allocations.length > 0) {
                    const allocationUnitPrice = variant.selling_plan_allocations[0].unit_price;
                    unitPrice = allocationUnitPrice
                }
            }
            if (unitPrice) {
                const base = this.getBaseUnit(variant);
                const formattedPrice = unitPrice === 0 ? window.theme.strings.free : themeCurrency.formatMoney(unitPrice, theme.moneyFormat);
                this.container.querySelector(selectors$O.unitPrice).innerHTML = formattedPrice;
                this.container.querySelector(selectors$O.unitBase).innerHTML = base;
                showElement(this.container.querySelector(selectors$O.unitWrapper))
            } else {
                hideElement(this.container.querySelector(selectors$O.unitWrapper))
            }
        }
        fireHookEvent(formState) {
            const variant = formState.variant;
            this.container.dispatchEvent(new CustomEvent('theme:variant:change',{
                detail: {
                    variant: variant,
                },
                bubbles: !0,
            }))
        }
        setProductState(dataset) {
            const variant = dataset.variant;
            const plan = dataset.plan;
            const productState = {
                available: !0,
                soldOut: !1,
                onSale: !1,
                showUnitPrice: !1,
                requiresPlan: !1,
                hasPlan: !1,
                planPerDelivery: !1,
                planSale: !1,
            };
            if (!variant) {
                productState.available = !1
            } else {
                const requiresPlan = variant.requires_selling_plan || !1;
                if (!variant.available) {
                    productState.soldOut = !0
                }
                if (variant.compare_at_price > variant.price) {
                    productState.onSale = !0
                }
                if (variant.unit_price) {
                    productState.showUnitPrice = !0
                }
                if (this.product && this.product.requires_selling_plan) {
                    productState.requiresPlan = !0
                }
                if (plan && this.subPrices) {
                    productState.hasPlan = !0;
                    if (plan.allocation.per_delivery_price !== plan.allocation.price) {
                        productState.planPerDelivery = !0
                    }
                    if (variant.price > plan.allocation.price) {
                        productState.planSale = !0
                    }
                }
                if (!plan && requiresPlan) {
                    productState.hasPlan = !0;
                    if (variant.selling_plan_allocations[0].per_delivery_price !== variant.selling_plan_allocations[0].price) {
                        productState.planPerDelivery = !0
                    }
                    if (variant.price > variant.selling_plan_allocations[0].price) {
                        productState.planSale = !0
                    }
                }
            }
            return productState
        }
        updateProductImage(evt) {
            const variant = evt.dataset.variant;
            if (!variant || !variant?.featured_media) {
                return
            }
            const newImg = this.container.querySelector(`${selectors$O.productImage}[${attributes$y.productImageId}="${variant.featured_media.id}"]`);
            const newImageParent = newImg?.closest(selectors$O.productSlide);
            if (newImageParent) {
                const newImagePos = parseInt([...newImageParent.parentElement.children].indexOf(newImageParent));
                const imgSlider = this.container.querySelector(selectors$O.productMediaSlider);
                const flkty = Flickity.data(imgSlider);
                if (flkty && flkty.isActive) {
                    const variantSlide = imgSlider.querySelector(`[data-id="${variant.featured_media.id}"]`);
                    if (variantSlide) {
                        const slideIndex = parseInt([...variantSlide.parentNode.children].indexOf(variantSlide));
                        flkty.select(slideIndex)
                    }
                    return
                }
                if (this.tallLayout) {
                    const newImgTop = newImg.getBoundingClientRect().top;
                    if (newImagePos === 0 && newImgTop + window.scrollY > window.pageYOffset)
                        return;
                    document.dispatchEvent(new CustomEvent('theme:tooltip:close',{
                        bubbles: !1,
                        detail: {
                            hideTransition: !1,
                        },
                    }));
                    scrollTo(newImgTop)
                }
            }
        }
        observeSwatch(formState) {
            const swatch = this.swatchesContainer.querySelector(`[${attributes$y.swatchVariant}*="${formState.variant.id}"]`);
            this.swatchesContainer.closest(selectors$O.selectorWrapper).classList.remove(classes$E.selectorVisible);
            let observer = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    const notVisible = entry.intersectionRatio == 0;
                    if (notVisible) {
                        this.swatchesContainer.closest(selectors$O.selectorWrapper).classList.add(classes$E.selectorVisible)
                    }
                }
                )
            }
            ,{
                root: this.container,
                threshold: [0.95, 1],
            });
            observer.observe(swatch)
        }
        scrollToForm(section) {
            const headerHeight = document.querySelector(selectors$O.header)?.dataset.height;
            const isVisible = visibilityHelper.isElementPartiallyVisible(section) || visibilityHelper.isElementTotallyVisible(section);
            if (!isVisible) {
                setTimeout( () => {
                    const rect = section.getBoundingClientRect();
                    const sectionTop = rect.top - headerHeight;
                    window.scrollTo({
                        top: sectionTop,
                        left: 0,
                        behavior: 'smooth',
                    })
                }
                , 400)
            }
        }
        onUnload() {
            if (this.productForm)
                this.productForm.destroy();
            if (this.hasPaymentButton)
                window.removeEventListener('theme:resize:width', this.onResizeCallback);
        }
    }
    const productFormSection = {
        onLoad() {
            sections$y[this.id] = new ProductAddForm(this.container)
        },
        onUnload() {
            sections$y[this.id].onUnload()
        },
    };
    const selectors$N = {
        form: 'form',
        popoutWrapper: '[data-popout]',
        popoutList: '[data-popout-list]',
        popoutToggle: '[data-popout-toggle]',
        popoutInput: '[data-popout-input]',
        popoutOptions: '[data-popout-option]',
        popoutText: '[data-popout-text]',
        ariaCurrent: '[aria-current]',
        productGridImage: '[data-product-image]',
        productGrid: '[data-product-grid-item]',
    };
    const classes$D = {
        listVisible: 'select-popout__list--visible',
        popoutAlternative: 'select-popout--alt',
        currentSuffix: '--current',
        visible: 'is-visible',
    };
    const attributes$x = {
        ariaCurrent: 'aria-current',
        ariaExpanded: 'aria-expanded',
        dataValue: 'data-value',
        popoutPrevent: 'data-popout-prevent',
        popoutQuantity: 'data-quantity-field',
        quickViewItem: 'data-quick-view-item',
    };
    let sections$x = {};
    class Popout {
        constructor(popout) {
            this.popout = popout;
            this.popoutList = this.popout.querySelector(selectors$N.popoutList);
            this.popoutToggle = this.popout.querySelector(selectors$N.popoutToggle);
            this.popoutText = this.popout.querySelector(selectors$N.popoutText);
            this.popoutInput = this.popout.querySelector(selectors$N.popoutInput);
            this.popoutOptions = this.popout.querySelectorAll(selectors$N.popoutOptions);
            this.popoutPrevent = this.popout.getAttribute(attributes$x.popoutPrevent) === 'true';
            this.popupToggleFocusoutEvent = (evt) => this.popupToggleFocusout(evt);
            this.popupListFocusoutEvent = (evt) => this.popupListFocusout(evt);
            this.popupToggleClickEvent = (evt) => this.popupToggleClick(evt);
            this.popoutKeyupEvent = (evt) => this.popoutKeyup(evt);
            this.popupOptionsClickEvent = (evt) => this.popupOptionsClick(evt);
            this._connectOptionsDispatchEvent = (evt) => this._connectOptionsDispatch(evt);
            this.bodyClick = this.bodyClick.bind(this);
            this.updatePopout = this.updatePopout.bind(this);
            this._connectOptions();
            this._connectToggle();
            this._onFocusOut();
            if (this.popoutInput && this.popoutInput.hasAttribute(attributes$x.popoutQuantity)) {
                document.addEventListener('theme:cart:update', this.updatePopout)
            }
        }
        unload() {
            if (this.popoutOptions.length) {
                this.popoutOptions.forEach( (element) => {
                    element.removeEventListener('theme:popout:click', this.popupOptionsClickEvent);
                    element.removeEventListener('click', this._connectOptionsDispatchEvent)
                }
                )
            }
            this.popoutToggle.removeEventListener('click', this.popupToggleClickEvent);
            this.popoutToggle.removeEventListener('focusout', this.popupToggleFocusoutEvent);
            this.popoutList.removeEventListener('focusout', this.popupListFocusoutEvent);
            this.popout.removeEventListener('keyup', this.popoutKeyupEvent);
            document.removeEventListener('theme:cart:update', this.updatePopout);
            document.body.removeEventListener('click', this.bodyClick)
        }
        popupToggleClick(evt) {
            const ariaExpanded = evt.currentTarget.getAttribute(attributes$x.ariaExpanded) === 'true';
            if (this.popoutList.closest(selectors$N.productGrid)) {
                const productGridItemImage = this.popoutList.closest(selectors$N.productGrid).querySelector(selectors$N.productGridImage);
                if (productGridItemImage) {
                    productGridItemImage.classList.toggle(classes$D.visible, !ariaExpanded)
                }
            }
            evt.currentTarget.setAttribute(attributes$x.ariaExpanded, !ariaExpanded);
            this.popoutList.classList.toggle(classes$D.listVisible)
        }
        popupToggleFocusout(evt) {
            if (!evt.relatedTarget) {
                return
            }
            const popoutLostFocus = this.popout.contains(evt.relatedTarget);
            const popoutFromQuickView = evt.relatedTarget.hasAttribute(attributes$x.quickViewItem);
            if (!popoutLostFocus && !popoutFromQuickView) {
                this._hideList()
            }
        }
        popupListFocusout(evt) {
            const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
            const isVisible = this.popoutList.classList.contains(classes$D.listVisible);
            if (isVisible && !childInFocus) {
                this._hideList()
            }
        }
        popupOptionsClick(evt) {
            const link = evt.target.closest(selectors$N.popoutOptions);
            if (link.attributes.href.value === '#') {
                evt.preventDefault();
                let attrValue = '';
                if (evt.currentTarget.getAttribute(attributes$x.dataValue)) {
                    attrValue = evt.currentTarget.getAttribute(attributes$x.dataValue)
                }
                this.popoutInput.value = attrValue;
                if (this.popoutPrevent) {
                    this.popoutInput.dispatchEvent(new Event('change'));
                    if (!evt.detail.preventTrigger && this.popoutInput.hasAttribute(attributes$x.popoutQuantity)) {
                        this.popoutInput.dispatchEvent(new Event('input'))
                    }
                    const currentElement = this.popoutList.querySelector(`[class*="${classes$D.currentSuffix}"]`);
                    let targetClass = classes$D.currentSuffix;
                    if (currentElement && currentElement.classList.length) {
                        for (const currentElementClass of currentElement.classList) {
                            if (currentElementClass.includes(classes$D.currentSuffix)) {
                                targetClass = currentElementClass;
                                break
                            }
                        }
                    }
                    const listTargetElement = this.popoutList.querySelector(`.${targetClass}`);
                    if (listTargetElement) {
                        listTargetElement.classList.remove(`${targetClass}`);
                        evt.currentTarget.parentElement.classList.add(`${targetClass}`)
                    }
                    const targetAttribute = this.popoutList.querySelector(selectors$N.ariaCurrent);
                    if (targetAttribute) {
                        targetAttribute.removeAttribute(attributes$x.ariaCurrent);
                        evt.currentTarget.setAttribute(attributes$x.ariaCurrent, 'true')
                    }
                    if (attrValue !== '') {
                        this.popoutText.textContent = attrValue
                    }
                    this.popupToggleFocusout(evt);
                    this.popupListFocusout(evt)
                } else {
                    this._submitForm(attrValue)
                }
            }
        }
        updatePopout() {
            const targetElement = this.popoutList.querySelector(`[${attributes$x.dataValue}="${this.popoutInput.value}"]`);
            if (targetElement) {
                targetElement.dispatchEvent(new CustomEvent('theme:popout:click',{
                    cancelable: !0,
                    bubbles: !0,
                    detail: {
                        preventTrigger: !0,
                    },
                }));
                if (!targetElement.parentElement.nextSibling) {
                    this.popout.classList.add(classes$D.popoutAlternative)
                }
            } else {
                this.popout.classList.add(classes$D.popoutAlternative)
            }
        }
        popoutKeyup(event) {
            if (event.code !== theme.keyboardKeys.ESCAPE) {
                return
            }
            this._hideList();
            this.popoutToggle.focus()
        }
        bodyClick(event) {
            const isOption = this.popout.contains(event.target);
            const isVisible = this.popoutList.classList.contains(classes$D.listVisible);
            if (isVisible && !isOption) {
                this._hideList()
            }
        }
        _connectToggle() {
            this.popoutToggle.addEventListener('click', this.popupToggleClickEvent)
        }
        _connectOptions() {
            if (this.popoutOptions.length) {
                this.popoutOptions.forEach( (element) => {
                    element.addEventListener('theme:popout:click', this.popupOptionsClickEvent);
                    element.addEventListener('click', this._connectOptionsDispatchEvent)
                }
                )
            }
        }
        _connectOptionsDispatch(evt) {
            const event = new CustomEvent('theme:popout:click',{
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !1,
                },
            });
            if (!evt.target.dispatchEvent(event)) {
                evt.preventDefault()
            }
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener('focusout', this.popupToggleFocusoutEvent);
            this.popoutList.addEventListener('focusout', this.popupListFocusoutEvent);
            this.popout.addEventListener('keyup', this.popoutKeyupEvent);
            document.body.addEventListener('click', this.bodyClick)
        }
        _submitForm() {
            const form = this.popout.closest(selectors$N.form);
            if (form) {
                form.submit()
            }
        }
        _hideList() {
            this.popoutList.classList.remove(classes$D.listVisible);
            this.popoutToggle.setAttribute(attributes$x.ariaExpanded, !1)
        }
    }
    const popoutSection = {
        onLoad() {
            sections$x[this.id] = [];
            const wrappers = this.container.querySelectorAll(selectors$N.popoutWrapper);
            wrappers.forEach( (wrapper) => {
                sections$x[this.id].push(new Popout(wrapper))
            }
            )
        },
        onUnload() {
            sections$x[this.id].forEach( (popout) => {
                if (typeof popout.unload === 'function') {
                    popout.unload()
                }
            }
            )
        },
    };
    const selectors$M = {
        addToCart: '[data-add-to-cart]',
        deferredMedia: '[data-deferred-media]',
        deferredMediaButton: '[data-deferred-media-button]',
        popupClose: '[data-popup-close]',
        popout: '[data-popout]',
        quickViewInner: '[data-quick-view-inner]',
        quickViewItemHolder: '[data-quick-view-item-holder]',
        product: '[data-product]',
        productForm: '[data-product-form]',
        productMediaSlider: '[data-product-single-media-slider]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productModel: '[data-model]',
        productJSON: '[data-product-json]',
        quickViewFootInner: '[data-quick-view-foot-inner]',
        shopTheLookThumb: '[data-shop-the-look-thumb]',
        tooltip: '[data-tooltip]',
        drawerToggle: '[data-drawer-toggle]',
    };
    const classes$C = {
        hasMediaActive: 'has-media-active',
        isActive: 'is-active',
        isLoading: 'is-loading',
        mediaHidden: 'media--hidden',
        noOutline: 'no-outline',
        notificationPopupVisible: 'notification-popup-visible',
        popupQuickViewAnimateIn: 'popup-quick-view--animate-in',
        popupQuickViewAnimateOut: 'popup-quick-view--animate-out',
        popupQuickViewAnimated: 'popup-quick-view--animated',
        popupQuickView: 'popup-quick-view',
        jsQuickViewVisible: 'js-quick-view-visible',
        jsQuickViewFromCart: 'js-quick-view-from-cart',
        drawerOpen: 'js-drawer-open',
    };
    const attributes$w = {
        id: 'id',
        mediaId: 'data-media-id',
        sectionId: 'data-section-id',
        handle: 'data-handle',
        loaded: 'loaded',
        tabindex: 'tabindex',
        quickViewOnboarding: 'data-quick-view-onboarding',
        hotspot: 'data-hotspot',
        hotspotRef: 'data-hotspot-ref',
    };
    const ids = {
        addToCartFormId: 'AddToCartForm--',
        addToCartId: 'AddToCart--',
    };
    class LoadQuickview {
        constructor(popup, pswpElement) {
            this.popup = popup;
            this.pswpElement = pswpElement;
            this.quickViewFoot = this.pswpElement.querySelector(selectors$M.quickViewFootInner);
            this.quickViewInner = this.pswpElement.querySelector(selectors$M.quickViewInner);
            this.product = this.pswpElement.querySelectorAll(selectors$M.product);
            this.flkty = [];
            this.videos = [];
            this.productForms = [];
            this.deferredMedias = this.pswpElement.querySelectorAll(selectors$M.deferredMedia);
            this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(selectors$M.shopTheLookThumb);
            this.quickViewItemHolders = this.pswpElement.querySelectorAll(selectors$M.quickViewItemHolder);
            this.popupCloseButtons = this.quickViewInner.querySelectorAll(selectors$M.popupClose);
            this.a11y = a11y;
            this.prevent3dModelSubmitEvent = (event) => this.prevent3dModelSubmit(event);
            this.closeOnAnimationEndEvent = (event) => this.closeOnAnimationEnd(event);
            this.closeOnEscapeEvent = (event) => this.closeOnEscape(event);
            this.outerCloseEvent = (event) => {
                if (!this.quickViewInner.contains(event.target)) {
                    const drawer = this.quickViewInner.nextElementSibling;
                    if (drawer && drawer.contains(event.target))
                        return;
                    this.closePopup(event)
                }
            }
            ;
            this.product.forEach( (item, index) => {
                const isQuickViewOnboarding = item.hasAttribute(attributes$w.quickViewOnboarding);
                if (!isQuickViewOnboarding) {
                    this.initItems(item, index)
                }
            }
            );
            this.init();
            this.initTooltips();
            this.initPopouts();
            this.swatchesContainer = new SwatchesContainer(this.pswpElement)
        }
        initTooltips() {
            this.tooltips = this.pswpElement.querySelectorAll(selectors$M.tooltip);
            this.tooltips.forEach( (tooltip) => {
                new Tooltip(tooltip)
            }
            )
        }
        initPopouts() {
            this.popoutElements = this.pswpElement.querySelectorAll(selectors$M.popout);
            this.popouts = {};
            this.popoutElements?.forEach( (popout, index) => {
                this.popouts[index] = new Popout(popout)
            }
            )
        }
        handleDraggable(slider, draggableStatus) {
            if (!slider)
                return;
            slider.options.draggable = Boolean(draggableStatus);
            slider.updateDraggable()
        }
        initItems(item, index) {
            this.addFormSuffix(item);
            this.initProductSlider(item, index);
            this.initProductVideo(item);
            this.initProductModel(item);
            this.initShopifyXrLaunch(item);
            makeSwatches(item);
            const drawerToggles = this.pswpElement.querySelectorAll(selectors$M.drawerToggle);
            if (drawerToggles.length) {
                new Drawer(item)
            }
            wrapElements(item);
            const productForm = new ProductAddForm(item.parentNode);
            this.productForms.push(productForm);
            if (Shopify.PaymentButton) {
                Shopify.PaymentButton.init()
            }
            item.classList.remove(classes$C.isLoading)
        }
        init() {
            document.addEventListener('submit', this.prevent3dModelSubmitEvent);
            this.popupCloseButtons.forEach( (popupClose) => {
                popupClose.addEventListener('keyup', (event) => {
                    if (event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER || event.code === theme.keyboardKeys.SPACE) {
                        this.closePopup(event)
                    }
                }
                );
                popupClose.addEventListener('click', (event) => {
                    this.closePopup(event)
                }
                )
            }
            );
            this.pswpElement.addEventListener('click', this.outerCloseEvent);
            //debugger;
             if(this.pswpElement.classList.contains("popup-quick-view")){
               
             }else{
               document.dispatchEvent(new CustomEvent('theme:popup:open',{
                bubbles: !0
              }));
             }
            
            this.popup.listen('preventDragEvent', (e, isDown, preventObj) => {
                preventObj.prevent = !1
            }
            );
            this.pswpElement.addEventListener('mousedown', () => {
                this.popup.framework.unbind(window, 'pointermove pointerup pointercancel', this.popup)
            }
            );
            this.popup.listen('initialZoomInEnd', () => {
                document.body.classList.add(classes$C.jsQuickViewVisible);
                this.a11y.trapFocus({
                    container: this.quickViewInner,
                })
            }
            );
            this.pswpElement.addEventListener('animationend', this.closeOnAnimationEndEvent);
            this.popup.listen('destroy', () => {
                if (this.flkty.length > 0) {
                    requestAnimationFrame( () => {
                        this.flkty.forEach( (slider) => slider.pausePlayer())
                    }
                    )
                }
                document.body.classList.remove(classes$C.jsQuickViewVisible);
                document.removeEventListener('keyup', this.closeOnEscapeEvent);
                document.addEventListener('keyup', this.closeOnEscapeEvent);
                this.pswpElement.removeEventListener('click', this.outerCloseEvent);
                this.pswpElement.removeEventListener('animationend', this.closeOnAnimationEndEvent);
                document.removeEventListener('submit', this.prevent3dModelSubmitEvent);
                this.deferredMedias.forEach( (deferredMedia) => {
                    deferredMedia.removeAttribute(attributes$w.loaded);
                    const media = deferredMedia.closest(selectors$M.productMediaWrapper);
                    media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                        bubbles: !0
                    });
                    media.classList.add(classes$C.mediaHidden)
                }
                )
            }
            );
            document.addEventListener('keyup', this.closeOnEscapeEvent);
            document.addEventListener('theme:cart:added', () => {
                if (this.pswpElement.classList.contains(classes$C.popupQuickView)) {
                    this.pswpElement.classList.add(classes$C.popupQuickViewAnimateOut)
                }
            }
            );
          
            this.animateInQuickview();
            this.initShopTheLookListeners()
        }
        initShopTheLookListeners() {
            this.buttonsShopTheLookThumb?.forEach( (button) => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    const thumb = event.target.matches(selectors$M.shopTheLookThumb) ? event.target : event.target.closest(selectors$M.shopTheLookThumb);
                    const holder = this.pswpElement.querySelector(`[${attributes$w.hotspot}="${thumb.getAttribute(attributes$w.hotspotRef)}"]`);
                    if (thumb.classList.contains(classes$C.isActive) || !holder)
                        return;
                    if (this.flkty.length > 0) {
                        requestAnimationFrame( () => {
                            this.flkty.forEach( (slider) => {
                                slider.resize();
                                const allMediaItems = this.quickViewInner.querySelectorAll(selectors$M.productMediaWrapper);
                                if (allMediaItems.length) {
                                    allMediaItems.forEach( (media) => {
                                        media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                                            bubbles: !0
                                        });
                                        media.classList.add(classes$C.mediaHidden)
                                    }
                                    )
                                }
                            }
                            )
                        }
                        )
                    }
                    holder.classList.add(classes$C.isActive);
                    this.quickViewItemHolders.forEach( (element) => {
                        if (element !== holder) {
                            element.classList.remove(classes$C.isActive)
                        }
                    }
                    )
                }
                )
            }
            )
        }
        prevent3dModelSubmit(event) {
            if (event.submitter.closest(selectors$M.deferredMedia) && event.submitter.closest(selectors$M.productForm)) {
                event.preventDefault()
            }
        }
        closeQuickviewOnMobile() {
            if (window.innerWidth < window.theme.sizes.large && document.body.classList.contains(classes$C.jsQuickViewVisible)) {
                this.popup.close()
            }
        }
        animateInQuickview() {
            this.pswpElement.classList.add(classes$C.popupQuickViewAnimateIn);
            this.quickViewFoot.addEventListener('animationend', (event) => {
                this.handleAnimatedState(event)
            }
            );
            this.pswpElement.addEventListener('animationend', (event) => {
                this.handleAnimatedState(event, !0)
            }
            )
        }
        handleAnimatedState(event, isMobileAnimation=!1) {
            if (event.animationName == 'quickViewAnimateInUp') {
                if (isMobileAnimation && window.innerWidth >= window.theme.sizes.small) {
                    return
                }
                this.pswpElement.classList.add(classes$C.popupQuickViewAnimated);
                this.pswpElement.classList.remove(classes$C.popupQuickViewAnimateIn);
                document.body.classList.remove(classes$C.jsQuickViewFromCart);
                removeLoadingClassFromLoadedImages(this.pswpElement)
            }
        }
        closePopup(event) {
            event?.preventDefault();
            const isNavDrawerOpen = document.body.classList.contains(classes$C.drawerOpen);
            if (isNavDrawerOpen) {
                document.dispatchEvent(new CustomEvent('theme:drawer:closing',{
                    bubbles: !0
                }))
            }
            this.pswpElement.classList.add(classes$C.popupQuickViewAnimateOut);
            this.swatchesContainer.onUnload()
        }
        closeOnAnimationEnd(event) {
            if (event.animationName == 'quickViewAnimateOutRight' || event.animationName == 'quickViewAnimateOutDown') {
                this.popup.template.classList.remove(classes$C.popupQuickViewAnimateOut, classes$C.popupQuickViewAnimated);
                this.popup.close();
                if (this.productForms.length > 0) {
                    this.productForms.forEach( (form) => form.onUnload())
                }
            }
        }
        closeOnEscape(event) {
            const isQuickViewVisible = document.body.classList.contains(classes$C.jsQuickViewVisible);
            const isNotificationVisible = document.body.classList.contains(classes$C.notificationPopupVisible);
            if (event.code === theme.keyboardKeys.ESCAPE && isQuickViewVisible && !isNotificationVisible) {
                this.closePopup(event)
            }
        }
        initProductSlider(item, index) {
            const slider = item.querySelector(selectors$M.productMediaSlider);
            const mediaItems = item.querySelectorAll(selectors$M.productMediaWrapper);
            if (mediaItems.length > 1) {
                const itemSlider = new Flickity(slider,{
                    wrapAround: !0,
                    cellAlign: 'left',
                    pageDots: !1,
                    prevNextButtons: !0,
                    adaptiveHeight: !1,
                    pauseAutoPlayOnHover: !1,
                    selectedAttraction: 0.2,
                    friction: 1,
                    autoPlay: !1,
                    on: {
                        ready: () => {
                            slider.setAttribute(attributes$w.tabindex, '-1');
                            requestAnimationFrame( () => {
                                itemSlider.resize()
                            }
                            )
                        }
                        ,
                        settle: () => {
                            const currentSlide = itemSlider.selectedElement;
                            const mediaId = currentSlide.getAttribute(attributes$w.mediaId);
                            currentSlide.setAttribute(attributes$w.tabindex, '0');
                            itemSlider.cells.forEach( (slide) => {
                                if (slide.element === currentSlide) {
                                    return
                                }
                                slide.element.setAttribute(attributes$w.tabindex, '-1')
                            }
                            );
                            this.switchMedia(item, mediaId)
                        }
                        ,
                    },
                });
                this.flkty.push(itemSlider);
                if (mediaItems.length) {
                    mediaItems.forEach( (element) => {
                        element.addEventListener('theme:media:play', () => {
                            this.handleDraggable(this.flkty[index], !1);
                            element.closest(selectors$M.productMediaSlider).classList.add(classes$C.hasMediaActive)
                        }
                        );
                        element.addEventListener('theme:media:pause', () => {
                            this.handleDraggable(this.flkty[index], !0);
                            element.closest(selectors$M.productMediaSlider).classList.remove(classes$C.hasMediaActive)
                        }
                        )
                    }
                    )
                }
                flickitySmoothScrolling(slider)
            }
        }
        switchMedia(item, mediaId) {
            const allMediaItems = this.quickViewInner.querySelectorAll(selectors$M.productMediaWrapper);
            const selectedMedia = item.querySelector(`${selectors$M.productMediaWrapper}[${attributes$w.mediaId}="${mediaId}"]`);
            const isFocusEnabled = !document.body.classList.contains(classes$C.noOutline);
            if (allMediaItems.length) {
                allMediaItems.forEach( (media) => {
                    media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                        bubbles: !0
                    });
                    media.classList.add(classes$C.mediaHidden)
                }
                )
            }
            if (isFocusEnabled) {
                selectedMedia.focus()
            }
            selectedMedia.closest(selectors$M.productMediaSlider).classList.remove(classes$C.hasMediaActive);
            selectedMedia.classList.remove(classes$C.mediaHidden);
            selectedMedia.dispatchEvent(new CustomEvent('theme:media:visible'), {
                bubbles: !0
            });
            const deferredMedia = selectedMedia.querySelector(selectors$M.deferredMedia);
            if (deferredMedia && deferredMedia.getAttribute(attributes$w.loaded) !== 'true') {
                selectedMedia.querySelector(selectors$M.deferredMediaButton).dispatchEvent(new Event('click'))
            }
        }
        initProductVideo(item) {
            const videos = new ProductVideo(item);
            this.videos.push(videos)
        }
        initProductModel(item) {
            const sectionId = item.getAttribute(attributes$w.sectionId);
            const modelItems = item.querySelectorAll(selectors$M.productModel);
            if (modelItems.length) {
                modelItems.forEach( (element) => {
                    theme.ProductModel.init(element, sectionId)
                }
                )
            }
        }
        initShopifyXrLaunch(item) {
            document.addEventListener('shopify_xr_launch', () => {
                const currentMedia = item.querySelector(`${selectors$M.productModel}:not(.${classes$C.mediaHidden})`);
                currentMedia.dispatchEvent(new CustomEvent('xrLaunch'))
            }
            )
        }
        addFormSuffix(item) {
            const sectionId = item.getAttribute(attributes$w.sectionId);
            const productObject = JSON.parse(item.querySelector(selectors$M.productJSON).innerHTML);
            const formSuffix = `${sectionId}-${productObject.handle}`;
            const productForm = item.querySelector(selectors$M.productForm);
            const addToCart = item.querySelector(selectors$M.addToCart);
            productForm.setAttribute(attributes$w.id, ids.addToCartFormId + formSuffix);
            addToCart.setAttribute(attributes$w.id, ids.addToCartId + formSuffix)
        }
    }
    const settings$6 = {
        unlockScrollDelay: 400,
    };
    const selectors$L = {
        popupContainer: '.pswp',
        popupCloseBtn: '.pswp__custom-close',
        popupIframe: 'iframe, video',
        popupCustomIframe: '.pswp__custom-iframe',
        popupThumbs: '.pswp__thumbs',
        popupButtons: '.pswp__button, .pswp__caption-close',
        product: '[data-product]',
        productJSON: '[data-product-json]',
    };
    const classes$B = {
        current: 'is-current',
        customLoader: 'pswp--custom-loader',
        customOpen: 'pswp--custom-opening',
        loader: 'pswp__loader',
        opened: 'pswp--open',
        popupCloseButton: 'pswp__button--close',
        notificationPopup: 'pswp--notification',
        quickviewPopup: 'popup-quick-view',
        isCartDrawerOpen: 'js-drawer-open-cart',
        quickViewAnimateOut: 'popup-quick-view--animate-out',
    };
    const attributes$v = {
        dataOptionClasses: 'data-pswp-option-classes',
        dataVideoType: 'data-video-type',
    };
    const loaderHTML = `<div class="${classes$B.loader}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    class LoadPhotoswipe {
        constructor(items, options='', templateIndex=0, triggerButton=null) {
            this.items = items;
            this.triggerBtn = triggerButton;
            this.pswpElements = document.querySelectorAll(selectors$L.popupContainer);
            this.pswpElement = this.pswpElements[templateIndex];
            this.popup = null;
            this.popupThumbs = null;
            this.popupThumbsContainer = this.pswpElement.querySelector(selectors$L.popupThumbs);
            this.closeBtn = this.pswpElement.querySelector(selectors$L.popupCloseBtn);
            const defaultOptions = {
                history: !1,
                focus: !1,
                mainClass: '',
            };
            this.options = options !== '' ? options : defaultOptions;
            this.onCloseCallback = () => this.onClose();
            this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent();
            this.setCurrentThumbCallback = () => this.setCurrentThumb();
            this.loadingStateCallback = (event) => this.loadingState(event);
            this.a11y = a11y;
            this.init()
        }
        init() {
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0
            }));
            this.pswpElement.classList.add(classes$B.customOpen);
            this.initLoader();
            loadScript({
                url: window.theme.assets.photoswipe
            }).then( () => this.loadPopup()).catch( (e) => console.error(e))
        }
        initLoader() {
            if (this.pswpElement.classList.contains(classes$B.customLoader) && this.options !== '' && this.options.mainClass) {
                this.pswpElement.setAttribute(attributes$v.dataOptionClasses, this.options.mainClass);
                let loaderElem = document.createElement('div');
                loaderElem.innerHTML = loaderHTML;
                loaderElem = loaderElem.firstChild;
                this.pswpElement.appendChild(loaderElem)
            } else {
                this.pswpElement.setAttribute(attributes$v.dataOptionClasses, '')
            }
        }
        loadPopup() {
            const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
            const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.remove(classes$B.customOpen);
            this.popup = new PhotoSwipe(this.pswpElement,PhotoSwipeUI,this.items,this.options);
            this.popup.listen('afterInit', this.dispatchPopupInitEventCallback);
            this.popup.listen('imageLoadComplete', this.setCurrentThumbCallback);
            this.popup.listen('imageLoadComplete', this.loadingStateCallback);
            this.popup.listen('beforeChange', this.setCurrentThumbCallback);
            this.popup.listen('close', this.onCloseCallback);
            if (typeof this.options.openAtZoomLevel === 'number' && this.options.openAtZoomLevel > 0) {
                this.popup.listen('initialZoomInEnd', () => {
                    const v = this.popup.viewportSize;
                    if (v) {
                        this.popup.zoomTo(this.options.openAtZoomLevel, {
                            x: v.x / 2,
                            y: v.y / 2
                        }, 300);
                    }
                });
            }
            this.popup.init();
            this.initPopupCallback()
        }
        loadingState(event) {
            if (event === this.options.index && this.pswpElement.classList.contains(classes$B.customLoader)) {
                this.pswpElement.classList.remove(classes$B.customLoader)
            }
        }
        initPopupCallback() {
            if (this.isVideo) {
                this.hideUnusedButtons()
            }
            this.initVideo();
            this.thumbsActions();
            this.a11y.trapFocus({
                container: this.pswpElement,
            });
            if (this.pswpElement.classList.contains(classes$B.quickviewPopup)) {
                new LoadQuickview(this.popup,this.pswpElement)
            }
            if (this.pswpElement.classList.contains(classes$B.notificationPopup)) {
                new LoadNotification(this.popup,this.pswpElement)
            }
            this.closePopup = () => {
                if (this.pswpElement.classList.contains(classes$B.quickviewPopup)) {
                    this.pswpElement.classList.add(classes$B.quickViewAnimateOut)
                } else {
                    this.popup.close()
                }
            }
            ;
            if (this.closeBtn) {
                this.closeBtn.addEventListener('click', this.closePopup)
            }
            document.addEventListener('theme:cart:added', this.closePopup)
        }
        dispatchPopupInitEvent() {
            if (this.triggerBtn) {
                this.triggerBtn.dispatchEvent(new CustomEvent('theme:popup:init',{
                    bubbles: !0
                }))
            }
        }
        initVideo() {
            const videoContainer = this.pswpElement.querySelector(selectors$L.popupCustomIframe);
            if (videoContainer) {
                const videoType = videoContainer.getAttribute(attributes$v.dataVideoType);
                this.isVideo = !0;
                if (videoType == 'youtube') {
                    new LoadVideoYT(videoContainer.parentElement)
                } else if (videoType == 'vimeo') {
                    new LoadVideoVimeo(videoContainer.parentElement)
                }
            }
        }
        thumbsActions() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
                this.popupThumbsContainer.addEventListener('wheel', (e) => this.stopDisabledScroll(e));
                this.popupThumbsContainer.addEventListener('mousewheel', (e) => this.stopDisabledScroll(e));
                this.popupThumbsContainer.addEventListener('DOMMouseScroll', (e) => this.stopDisabledScroll(e));
                this.popupThumbs = this.pswpElement.querySelectorAll(`${selectors$L.popupThumbs} > *`);
                this.popupThumbs.forEach( (element, i) => {
                    element.addEventListener('click', (e) => {
                        e.preventDefault();
                        element.parentElement.querySelector(`.${classes$B.current}`).classList.remove(classes$B.current);
                        element.classList.add(classes$B.current);
                        this.popup.goTo(i)
                    }
                    )
                }
                )
            }
        }
        hideUnusedButtons() {
            const buttons = this.pswpElement.querySelectorAll(selectors$L.popupButtons);
            buttons.forEach( (element) => {
                if (!element.classList.contains(classes$B.popupCloseButton)) {
                    element.style.display = 'none'
                }
            }
            )
        }
        stopDisabledScroll(e) {
            e.stopPropagation()
        }
        onClose() {
            const popupIframe = this.pswpElement.querySelector(selectors$L.popupIframe);
            if (popupIframe) {
                popupIframe.parentNode.removeChild(popupIframe)
            }
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
                while (this.popupThumbsContainer.firstChild) {
                    this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild)
                }
            }
            this.pswpElement.setAttribute(attributes$v.dataOptionClasses, '');
            const loaderElem = this.pswpElement.querySelector(`.${classes$B.loader}`);
            if (loaderElem) {
                this.pswpElement.removeChild(loaderElem)
            }
            if (!document.body.classList.contains(classes$B.isCartDrawerOpen)) {
                this.a11y.removeTrapFocus()
            }
            document.removeEventListener('theme:cart:added', this.closePopup);
            setTimeout( () => {
                const recentlyOpenedPopups = this.recentlyOpenedPopupsCount();
                const isCartDrawerOpen = document.body.classList.contains(classes$B.isCartDrawerOpen);
                if (recentlyOpenedPopups === 0 && !isCartDrawerOpen) {
                    document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                        bubbles: !0
                    }))
                }
            }
            , settings$6.unlockScrollDelay)
        }
        recentlyOpenedPopupsCount() {
            let count = 0;
            this.pswpElements.forEach( (popup) => {
                const isOpened = popup.classList.contains(classes$B.opened);
                if (isOpened) {
                    count += 1
                }
            }
            );
            return count
        }
        setCurrentThumb() {
            const hasThumbnails = this.popupThumbsContainer && this.popupThumbsContainer.firstChild;
            if (hasThumbnails)
                return;
            const lastCurrentThumb = this.pswpElement.querySelector(`${selectors$L.popupThumbs} > .${classes$B.current}`);
            if (lastCurrentThumb) {
                lastCurrentThumb.classList.remove(classes$B.current)
            }
            if (!this.popupThumbs) {
                return
            }
            const currentThumb = this.popupThumbs[this.popup.getCurrentIndex()];
            currentThumb.classList.add(classes$B.current);
            this.scrollThumbs(currentThumb)
        }
        scrollThumbs(currentThumb) {
            const thumbsContainerLeft = this.popupThumbsContainer.scrollLeft;
            const thumbsContainerWidth = this.popupThumbsContainer.offsetWidth;
            const thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth;
            const currentThumbLeft = currentThumb.offsetLeft;
            const currentThumbWidth = currentThumb.offsetWidth;
            const currentThumbPos = currentThumbLeft + currentThumbWidth;
            if (thumbsContainerPos <= currentThumbPos || thumbsContainerPos > currentThumbLeft) {
                const currentThumbMarginLeft = parseInt(window.getComputedStyle(currentThumb).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: currentThumbLeft - currentThumbMarginLeft,
                    behavior: 'smooth',
                })
            }
        }
    }
    const settings$5 = {
        templateIndex: 0,
    };
    const selectors$K = {
        buttonQuickView: '[data-button-quick-view]',
        quickViewItemsTemplate: '[data-quick-view-items-template]',
        cartDrawer: '[data-cart-drawer]',
        shopTheLookQuickViewButton: '[data-shop-the-look-quick-view-button]',
        shopTheLookThumb: '[data-shop-the-look-thumb]',
        quickViewItemHolder: '[data-quick-view-item-holder]',
    };
    const classes$A = {
        loading: 'is-loading',
        isActive: 'is-active',
        quickViewFromCart: 'js-quick-view-from-cart',
        mainClass: 'popup-quick-view pswp--not-close-btn',
        shopTheLookPopupClass: 'popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn',
    };
    const attributes$u = {
        loaded: 'data-loaded',
        handle: 'data-handle',
        variantId: 'data-variant-id',
        shopTheLookQuickView: 'data-shop-the-look-quick-view',
        hotspot: 'data-hotspot',
        quickButtonInit: 'data-initialized',
    };
    const options = {
        history: !1,
        focus: !1,
        mainClass: classes$A.mainClass,
        showHideOpacity: !1,
        closeOnVerticalDrag: !1,
        closeOnScroll: !1,
        modal: !1,
        escKey: !1,
    };
    class QuickViewPopup {
        constructor(container) {
            this.container = container;
            this.a11y = a11y;
            this.buttonsQuickView = this.container.querySelectorAll(selectors$K.buttonQuickView);
            this.buttonsShopTheLookQuickView = this.container.querySelectorAll(selectors$K.shopTheLookQuickViewButton);
            this.popupInitCallback = (trigger) => this.popupInit(trigger);
            this.buttonsQuickView?.forEach( (button) => {
                if (!button.hasAttribute(attributes$u.quickButtonInit)) {
                    button.addEventListener('click', (event) => this.initPhotoswipe(event));
                    button.addEventListener('theme:popup:init', () => {
                        button.classList.remove(classes$A.loading);
                        if (button.hasAttribute(attributes$u.shopTheLookQuickView)) {
                            this.popupInitCallback(button)
                        }
                    }
                    );
                    button.setAttribute(attributes$u.quickButtonInit, '')
                }
            }
            );
            this.buttonsShopTheLookQuickView?.forEach( (button) => {
                button.addEventListener('click', () => {
                    this.buttonsQuickView[0]?.dispatchEvent(new Event('click'))
                }
                )
            }
            )
        }
        popupInit(trigger) {
            const holder = this.loadPhotoswipe.pswpElement.querySelector(`[${attributes$u.hotspot}="${trigger.getAttribute(attributes$u.hotspot)}"]`);
            const quickViewItemHolders = this.loadPhotoswipe.pswpElement.querySelectorAll(selectors$K.quickViewItemHolder);
            holder.classList.add(classes$A.isActive);
            quickViewItemHolders.forEach( (element) => {
                if (element !== holder) {
                    element.classList.remove(classes$A.isActive)
                }
            }
            );
            this.toggleQuickViewButtonsLoadingClasses(!0);
            this.toggleQuickViewThumbsLoadingClasses(!0);
            const onAnimationInEnd = (event) => {
                if (event.animationName === 'quickViewAnimateInUp') {
                    requestAnimationFrame( () => {
                        this.toggleQuickViewThumbsLoadingClasses(!1)
                    }
                    )
                }
                if (event.animationName === 'quickViewAnimateOutDown') {
                    this.loadPhotoswipe.pswpElement.removeEventListener('animationend', onAnimationInEnd)
                }
            }
            ;
            this.loadPhotoswipe.pswpElement.addEventListener('animationend', onAnimationInEnd);
            this.loadPhotoswipe?.popup?.listen('destroy', () => {
                this.toggleQuickViewButtonsLoadingClasses(!1);
                this.toggleQuickViewThumbsLoadingClasses(!1)
            }
            )
        }
        toggleQuickViewButtonsLoadingClasses(isLoading=!0) {
            if (isLoading) {
                this.buttonsQuickView?.forEach( (element) => {
                    element.classList.add(classes$A.loading)
                }
                );
                return
            }
            this.buttonsQuickView?.forEach( (element) => {
                element.classList.remove(classes$A.loading)
            }
            )
        }
        toggleQuickViewThumbsLoadingClasses(isLoading=!0) {
            this.buttonsShopTheLookThumb = this.loadPhotoswipe?.pswpElement.querySelectorAll(selectors$K.shopTheLookThumb);
            if (isLoading) {
                this.buttonsShopTheLookThumb?.forEach( (element) => {
                    element.classList.add(classes$A.loading)
                }
                );
                return
            }
            this.buttonsShopTheLookThumb?.forEach( (element) => {
                element.classList.remove(classes$A.loading)
            }
            )
        }
        initPhotoswipe(event) {
            event.preventDefault();
            const button = event.target.matches(selectors$K.buttonQuickView) ? event.target : event.target.closest(selectors$K.buttonQuickView);
            const isMobile = window.innerWidth < theme.sizes.small;
            let quickViewVariant = '';
            let isShopTheLookPopupTrigger = !1;
            if (button.hasAttribute(attributes$u.shopTheLookQuickView)) {
                if (!isMobile)
                    return;
                isShopTheLookPopupTrigger = !0
            }
            options.mainClass = classes$A.mainClass;
            button.classList.add(classes$A.loading);
            if (button.closest(selectors$K.cartDrawer)) {
                document.body.classList.add(classes$A.quickViewFromCart)
            }
            this.a11y.state.trigger = button;
            if (button.hasAttribute(attributes$u.variantId)) {
                quickViewVariant = `&variant=${button.getAttribute(attributes$u.variantId)}`
            }
            const productUrl = `${theme.routes.root}products/${button.getAttribute(attributes$u.handle)}?section_id=api-quickview${quickViewVariant}`;
            if (isShopTheLookPopupTrigger) {
                options.mainClass = classes$A.shopTheLookPopupClass;
                this.buttonsQuickView.forEach( (element) => {
                    element.classList.add(classes$A.loading)
                }
                );
                const XMLS = new XMLSerializer();
                const quickViewItemsTemplate = this.container.querySelector(selectors$K.quickViewItemsTemplate).content.firstElementChild.cloneNode(!0);
                const itemsData = XMLS.serializeToString(quickViewItemsTemplate);
                this.loadPhotoswipeWithTemplate(itemsData, button)
            } else {
                this.loadPhotoswipeFromFetch(productUrl, button)
            }
        }
        loadPhotoswipeWithTemplate(data, button) {
            const items = [{
                html: data,
            }, ];
            this.loadPhotoswipe = new LoadPhotoswipe(items,options,settings$5.templateIndex,button)
        }
        loadPhotoswipeFromFetch(url, button) {
            fetch(url).then( (response) => {
                return response.text()
            }
            ).then( (data) => {
                const items = [{
                    html: data,
                }, ];
                this.loadPhotoswipe = new LoadPhotoswipe(items,options,settings$5.templateIndex,button)
            }
            ).catch( (error) => console.log('error: ', error))
        }
    }
    const settings$4 = {
        cartDrawerEnabled: window.theme.settings.cartType === 'drawer',
        timers: {
            addProductTimeout: 1000,
        },
        animations: {
            data: 'data-aos',
            method: 'fade-up',
        },
    };
    const selectors$J = {
        outerSection: '[data-section-id]',
        aos: '[data-aos]',
        additionalCheckoutButtons: '[data-additional-checkout-button]',
        apiContent: '[data-api-content]',
        apiLineItems: '[data-api-line-items]',
        apiUpsellItems: '[data-api-upsell-items]',
        apiCartPrice: '[data-api-cart-price]',
        apiCartFooter: '[data-api-cart-footer]',
        buttonAddToCart: '[data-add-to-cart]',
        upsellButtonByHandle: '[data-handle]',
        cartCloseError: '[data-cart-error-close]',
        cartDrawer: '[data-cart-drawer]',
        cartDrawerTemplate: '[data-cart-drawer-template]',
        cartDrawerToggle: '[data-cart-drawer-toggle]',
        cartDrawerBody: '[data-cart-drawer-body]',
        cartErrors: '[data-cart-errors]',
        cartForm: '[data-cart-form]',
        cartTermsCheckbox: '[data-cart-acceptance-checkbox]',
        cartCheckoutButtonWrapper: '[data-cart-checkout-buttons]',
        cartCheckoutButton: '[data-cart-checkout-button]',
        cartItemRemove: '[data-item-remove]',
        cartItemsQty: '[data-cart-items-qty]',
        cartTotal: '[data-cart-total]',
        cartTotalPrice: '[data-cart-total-price]',
        cartMessage: '[data-cart-message]',
        cartMessageDefault: '[data-message-default]',
        cartPage: '[data-cart-page]',
        cartProgress: '[data-cart-message-progress]',
        emptyMessage: '[data-empty-message]',
        buttonHolder: '[data-foot-holder]',
        item: '[data-cart-item]',
        itemsHolder: '[data-items-holder]',
        cartDrawerSubhead: '[data-cart-drawer-subhead]',
        itemsWrapper: '[data-items-wrapper]',
        formCloseError: '[data-close-error]',
        formErrorsContainer: '[data-cart-errors-container]',
        upsellHolder: '[data-upsell-holder]',
        errorMessage: '[data-error-message]',
        termsErrorMessage: '[data-terms-error-message]',
        pairProductsHolder: '[data-pair-products-holder]',
        pairProducts: '[data-pair-products]',
        priceHolder: '[data-cart-price-holder]',
        leftToSpend: '[data-left-to-spend]',
        quickBuyForm: '[data-quickbuy-form]',
        qtyInput: '[data-quantity-field]',
        productMediaContainer: '[data-product-media-container]',
        formWrapper: '[data-form-wrapper]',
        productForm: '[data-product-form]',
        popupQuickView: '.popup-quick-view',
        popupClose: '[data-popup-close]',
        error: '[data-error]',
        quickViewOnboarding: '[data-quick-view-onboarding]',
        flickityEnabled: '.flickity-enabled',
    };
    const classes$z = {
        hidden: 'hidden',
        added: 'is-added',
        isHidden: 'is-hidden',
        cartDrawerOpen: 'js-drawer-open-cart',
        open: 'is-open',
        visible: 'is-visible',
        expanded: 'is-expanded',
        loading: 'is-loading',
        disabled: 'is-disabled',
        success: 'is-success',
        error: 'has-error',
        cartItems: 'cart__toggle--has-items',
        variantSoldOut: 'variant--soldout',
        removed: 'is-removed',
        aosAnimate: 'aos-animate',
        updated: 'is-updated',
        noOutline: 'no-outline',
        productGridImageError: 'product-grid-item__image--error',
        contentVisibilityHidden: 'cv-h',
    };
    const attributes$t = {
        shippingMessageLimit: 'data-limit',
        cartMessageValue: 'data-cart-message',
        cartTotal: 'data-cart-total',
        ariaExpanded: 'aria-expanded',
        disabled: 'disabled',
        value: 'value',
        dataId: 'data-id',
        item: 'data-item',
        itemIndex: 'data-item-index',
        itemTitle: 'data-item-title',
        atcTrigger: 'data-atc-trigger',
        upsellButton: 'data-upsell-btn',
        notificationPopup: 'data-notification-popup',
        sectionId: 'data-section-id',
        recipientError: 'data-recipient-errors',
    };
    let sections$w = {};
    class CartDrawer {
        constructor() {
            if (window.location.pathname === '/password') {
                return
            }
            this.init()
        }
        init() {
            this.cartToggleButtons = document.querySelectorAll(selectors$J.cartDrawerToggle);
            this.cartPage = document.querySelector(selectors$J.cartPage);
            this.cartDrawer = document.querySelector(selectors$J.cartDrawer);
            this.cart = this.cartDrawer || this.cartPage;
            this.cartCount = this.getCartItemCount();
            this.assignArguments();
            this.recipientErrors = this.form?.getAttribute(attributes$t.recipientError) === 'true';
            this.flktyUpsell = null;
            this.form = null;
            this.collapsible = null;
            this.a11y = a11y;
            this.build = this.build.bind(this);
            this.addToCart = this.addToCart.bind(this);
            this.updateCart = this.updateCart.bind(this);
            this.openCartDrawer = this.openCartDrawer.bind(this);
            this.closeCartDrawer = this.closeCartDrawer.bind(this);
            this.toggleCartDrawer = this.toggleCartDrawer.bind(this);
            this.formSubmitHandler = throttle(this.formSubmitHandler.bind(this), 50);
            this.closeCartError = () => {
                this.cartErrorHolder.classList.remove(classes$z.expanded)
            }
            ;
            this.cartDrawerCloseEvent = null;
            this.hasItemsInCart = this.hasItemsInCart.bind(this);
            this.isCartPage = Boolean(this.cart && this.cartDrawer === null);
            this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this);
            this.totalItems = 0;
            this.isCartDrawerOpen = !1;
            this.isCartDrawerLoaded = !1;
            this.cartDiscounts = 0;
            this.cartDrawerEnabled = settings$4.cartDrawerEnabled;
            this.cartUpdateFailed = !1;
            this.cartEvents();
            this.cartAddEvent();
            this.cartDrawerToggleEvents();
            this.initQuantity();
            if (this.buttonHolder) {
                this.collapsible = new Collapsible(this.buttonHolder)
            }
            if (this.isCartPage) {
                this.renderPairProducts()
            }
            document.addEventListener('theme:popup:open', this.closeCartDrawer)
        }
        assignArguments() {
            this.outerSection = this.cart.closest(selectors$J.outerSection);
            this.cartDrawerBody = document.querySelector(selectors$J.cartDrawerBody);
            this.emptyMessage = document.querySelector(selectors$J.emptyMessage);
            this.buttonHolder = document.querySelector(selectors$J.buttonHolder);
            this.itemsHolder = document.querySelector(selectors$J.itemsHolder);
            this.cartDrawerSubhead = document.querySelector(selectors$J.cartDrawerSubhead);
            this.cartItemsQty = document.querySelector(selectors$J.cartItemsQty);
            this.itemsWrapper = document.querySelector(selectors$J.itemsWrapper);
            this.items = document.querySelectorAll(selectors$J.item);
            this.cartTotal = document.querySelector(selectors$J.cartTotal);
            this.cartTotalPrice = document.querySelector(selectors$J.cartTotalPrice);
            this.cartMessage = document.querySelectorAll(selectors$J.cartMessage);
            this.cartOriginalTotal = document.querySelector(selectors$J.cartOriginalTotal);
            this.cartErrorHolder = document.querySelector(selectors$J.cartErrors);
            this.cartCloseErrorMessage = document.querySelector(selectors$J.cartCloseError);
            this.pairProductsHolder = document.querySelector(selectors$J.pairProductsHolder);
            this.pairProducts = document.querySelector(selectors$J.pairProducts);
            this.priceHolder = document.querySelector(selectors$J.priceHolder);
            this.upsellHolders = document.querySelectorAll(selectors$J.upsellHolder);
            this.cartTermsCheckbox = document.querySelector(selectors$J.cartTermsCheckbox);
            this.cartCheckoutButtonWrapper = document.querySelector(selectors$J.cartCheckoutButtonWrapper);
            this.cartCheckoutButton = document.querySelector(selectors$J.cartCheckoutButton);
            this.cartForm = document.querySelector(selectors$J.cartForm);
            this.cartItemCount = 0;
            this.subtotal = window.theme.subtotal;
            this.button = null;
            const {headerInitialHeight, announcementBarHeight} = readHeights();
            this.headerInitialHeight = headerInitialHeight;
            this.announcementBarHeight = announcementBarHeight;
            if (this.cartMessage.length > 0) {
                this.cartFreeLimitShipping = Number(this.cartMessage[0].getAttribute(attributes$t.shippingMessageLimit)) * 100
            }
            this.updateProgress()
        }
        initQuantity() {
            this.items = document.querySelectorAll(selectors$J.item);
            this.items?.forEach( (item) => {
                const quantity = new QuantityCounter(item,!0);
                quantity.init();
                this.cartUpdateEvent(item)
            }
            )
        }
        cartUpdateEvent(item) {
            item.addEventListener('theme:cart:update', (event) => {
                this.updateCart({
                    id: event.detail.id,
                    quantity: event.detail.quantity,
                }, item)
            }
            )
        }
        cartEvents() {
            const cartItemRemove = document.querySelectorAll(selectors$J.cartItemRemove);
            this.totalItems = cartItemRemove.length;
            cartItemRemove?.forEach( (button) => {
                const item = button.closest(selectors$J.item);
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (button.classList.contains(classes$z.disabled))
                        return;
                    this.updateCart({
                        id: item.getAttribute(attributes$t.dataId),
                        quantity: 0,
                    }, item)
                }
                )
            }
            );
            if (this.cartCloseErrorMessage) {
                this.cartCloseErrorMessage.removeEventListener('click', this.closeCartError);
                this.cartCloseErrorMessage.addEventListener('click', this.closeCartError)
            }
            if (this.cartTermsCheckbox) {
                this.cartTermsCheckbox.removeEventListener('change', this.formSubmitHandler);
                this.cartCheckoutButtonWrapper.removeEventListener('click', this.formSubmitHandler);
                this.cartForm.removeEventListener('submit', this.formSubmitHandler);
                this.cartTermsCheckbox.addEventListener('change', this.formSubmitHandler);
                this.cartCheckoutButtonWrapper.addEventListener('click', this.formSubmitHandler);
                this.cartForm.addEventListener('submit', this.formSubmitHandler)
            }
        }
        cartAddEvent() {
            document.addEventListener('click', (event) => {
                if (event.target.closest(".product-sticky-form-button") || event.target.closest(".shop_availability_popup_content_button")) {
                    var neededForm = document.querySelector("#" + event.target.getAttribute("data-form-id"));
                    var clickedElement = neededForm.querySelector(selectors$J.buttonAddToCart);
                    document.querySelector('[aria-controls="shop_availability_popup"]').dispatchEvent(new Event('click',{
                        'bubbles': !0
                    }))
                } else {
                    var clickedElement = event.target
                }
                const isButtonATC = clickedElement?.matches(selectors$J.buttonAddToCart);
                const getButtonATC = clickedElement?.closest(selectors$J.buttonAddToCart);
                if (isButtonATC || getButtonATC) {
                    event.preventDefault();
                    this.button = isButtonATC ? clickedElement : getButtonATC;
                    this.form = clickedElement.closest('form');
                    this.recipientErrors = this.form?.getAttribute(attributes$t.recipientError) === 'true';
                    this.formWrapper = this.button.closest(selectors$J.formWrapper);
                    const isVariantSoldOut = this.formWrapper?.classList.contains(classes$z.variantSoldOut);
                    const isButtonDisabled = this.button.hasAttribute(attributes$t.disabled);
                    const isQuickViewOnboarding = this.button.closest(selectors$J.quickViewOnboarding);
                    const hasDataAtcTrigger = this.button.hasAttribute(attributes$t.atcTrigger);
                    const hasNotificationPopup = this.button.hasAttribute(attributes$t.notificationPopup);
                    const hasFileInput = this.form?.querySelector('[type="file"]');
                    if (isButtonDisabled || hasFileInput || isQuickViewOnboarding)
                        return;
                    if (isVariantSoldOut && hasNotificationPopup) {
                        new NotificationPopup(this.button);
                        return
                    }
                    if (hasDataAtcTrigger) {
                        this.a11y.state.trigger = this.button
                    }
                    const formData = new FormData(this.form);
                    this.addToCart(formData);
                    document.dispatchEvent(new CustomEvent('theme:cart:add',{
                        bubbles: !0,
                        detail: {
                            selector: clickedElement,
                        },
                    }))
                }
            }
            )
        }
        getCart() {
            if (this.cartDrawer && !this.isCartDrawerLoaded) {
                const alwaysOpen = !1;
                this.renderCartDrawer(alwaysOpen)
            }
            fetch(theme.routes.cart_url + '?section_id=api-cart-items').then(this.handleErrors).then( (response) => response.text()).then( (response) => {
                const element = document.createElement('div');
                element.innerHTML = response;
                const cleanResponse = element.querySelector(selectors$J.apiContent);
                this.build(cleanResponse)
            }
            ).catch( (error) => console.log(error))
        }
        addToCart(data) {
            if (this.cartDrawerEnabled && this.button) {
                this.button.classList.add(classes$z.loading);
                this.button.setAttribute(attributes$t.disabled, !0)
            }
            fetch(theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Accept: 'application/javascript',
                },
                body: data,
            }).then( (response) => response.json()).then( (response) => {
                this.button.disabled = !0;
                this.addLoadingClass();
                if (response.status) {
                    this.addToCartError(response);
                    this.removeLoadingClass();
                    this.scrollToCartTop();
                    return
                }
                this.hideAddToCartErrorMessage();
                if (this.cartDrawerEnabled) {
                    this.getCart()
                } else {
                    window.location = theme.routes.cart_url
                }
            }
            ).catch( (error) => console.log(error))
        }
        updateCart(updateData={}, currentItem=null) {
            let updatedQuantity = updateData.quantity;
            if (currentItem !== null) {
                if (updatedQuantity) {
                    currentItem.classList.add(classes$z.loading)
                } else {
                    currentItem.classList.add(classes$z.removed)
                }
            }
            this.disableCartButtons();
            this.addLoadingClass();
            const newItem = this.cart.querySelector(`[${attributes$t.item}="${updateData.id}"]`) || currentItem;
            const lineIndex = newItem?.hasAttribute(attributes$t.itemIndex) ? parseInt(newItem.getAttribute(attributes$t.itemIndex)) : 0;
            const itemTitle = newItem?.hasAttribute(attributes$t.itemTitle) ? newItem.getAttribute(attributes$t.itemTitle) : null;
            if (lineIndex === 0)
                return;
            const data = {
                line: lineIndex,
                quantity: updatedQuantity,
            };
            fetch(theme.routes.cart_change_url, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(data),
            }).then( (response) => {
                if (response.status === 400) {
                    const error = new Error(response.status);
                    this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url);
                    throw error
                }
                return response.text()
            }
            ).then( (state) => {
                const parsedState = JSON.parse(state);
                if (parsedState.errors) {
                    this.cartUpdateFailed = !0;
                    this.updateErrorText(itemTitle);
                    this.toggleErrorMessage();
                    this.resetLineItem(currentItem);
                    this.enableCartButtons();
                    this.removeLoadingClass();
                    this.scrollToCartTop();
                    return
                }
                this.getCart()
            }
            ).catch( (error) => {
                console.log(error);
                this.enableCartButtons();
                this.removeLoadingClass()
            }
            )
        }
        resetLineItem(item) {
            const qtyInput = item.querySelector(selectors$J.qtyInput);
            const qty = qtyInput.getAttribute('value');
            qtyInput.value = qty;
            item.classList.remove(classes$z.loading)
        }
        disableCartButtons() {
            const inputs = this.cart.querySelectorAll('input');
            const buttons = this.cart.querySelectorAll(`button, ${selectors$J.cartItemRemove}`);
            if (inputs.length) {
                inputs.forEach( (item) => {
                    item.classList.add(classes$z.disabled);
                    item.blur();
                    item.disabled = !0
                }
                )
            }
            if (buttons.length) {
                buttons.forEach( (item) => {
                    item.setAttribute(attributes$t.disabled, !0)
                }
                )
            }
        }
        enableCartButtons() {
            const inputs = this.cart.querySelectorAll('input');
            const buttons = this.cart.querySelectorAll(`button, ${selectors$J.cartItemRemove}`);
            if (inputs.length) {
                inputs.forEach( (item) => {
                    item.classList.remove(classes$z.disabled);
                    item.disabled = !1
                }
                )
            }
            if (buttons.length) {
                buttons.forEach( (item) => {
                    item.removeAttribute(attributes$t.disabled)
                }
                )
            }
        }
        updateErrorText(itemTitle) {
            this.cartErrorHolder.querySelector(selectors$J.errorMessage).innerText = itemTitle
        }
        toggleErrorMessage() {
            if (!this.cartErrorHolder)
                return;
            this.cartErrorHolder.classList.toggle(classes$z.expanded, this.cartUpdateFailed);
            if (this.cartUpdateFailed) {
                const cartCloseError = this.cartErrorHolder.querySelector(selectors$J.cartCloseError);
                this.focusOnErrorMessage(this.cartErrorHolder, cartCloseError)
            }
            this.cartUpdateFailed = !1
        }
        handleErrors(response) {
            if (!response.ok) {
                return response.json().then(function(json) {
                    const e = new FetchError({
                        status: response.statusText,
                        headers: response.headers,
                        json: json,
                    });
                    throw e
                })
            }
            return response
        }
        addToCartError(data) {
            const buttonQuickBuyForm = this.button.closest(selectors$J.quickBuyForm);
            const buttonUpsellHolder = this.button.closest(selectors$J.upsellHolder);
            const isFocusEnabled = !document.body.classList.contains(classes$z.noOutline);
            let holder = this.button.closest(selectors$J.productForm) ? this.button.closest(selectors$J.productForm) : this.button.closest(selectors$J.upsellHolder);
            let errorContainer = holder.querySelector(selectors$J.formErrorsContainer);
            if (buttonUpsellHolder) {
                errorContainer = buttonUpsellHolder.querySelector(selectors$J.formErrorsContainer)
            }
            if (this.cartDrawerEnabled && this.button && this.button.closest(selectors$J.cartDrawer) !== null && !this.button.closest(selectors$J.cartDrawer)) {
                this.closeCartDrawer()
            }
            this.button.classList.remove(classes$z.loading);
            this.button.removeAttribute(attributes$t.disabled);
            const closeErrorButton = buttonQuickBuyForm ? '' : `
      <button type="button" class="errors__button-close" data-close-error>
        ${theme.icons.close}
      </button>
    `;
            let errorMessages = `${data.message}: ${data.description}`;
            if (data.message === data.description)
                errorMessages = data.message;
            if (this.recipientErrors && data.description && typeof data.description === 'object') {
                errorMessages = Object.entries(data.description).map( ([key,value]) => `${value}`).join('<br>')
            }
            errorContainer.innerHTML = `
      <div class="errors" data-error autofocus>
        ${errorMessages}
        ${closeErrorButton}
      </div>
    `;
            if (buttonQuickBuyForm) {
                const productMediaContainer = errorContainer.closest(selectors$J.productMediaContainer);
                productMediaContainer.classList.add(classes$z.productGridImageError);
                errorContainer.querySelector(selectors$J.error).addEventListener('animationend', () => {
                    productMediaContainer.classList.remove(classes$z.productGridImageError);
                    errorContainer.innerHTML = '';
                    if (!isFocusEnabled) {
                        document.activeElement.blur()
                    }
                }
                )
            } else {
                errorContainer.classList.add(classes$z.visible);
                errorContainer.addEventListener('transitionend', () => {
                    this.resizeSliders(errorContainer)
                }
                );
                this.handleCloseErrorMessages(errorContainer)
            }
        }
        handleCloseErrorMessages(container) {
            const formErrorClose = container.querySelector(selectors$J.formCloseError);
            formErrorClose?.addEventListener('click', (event) => {
                const clickedElement = event.target;
                const isFormCloseError = clickedElement.matches(selectors$J.formCloseError) || clickedElement.closest(selectors$J.formCloseError);
                if (!isFormCloseError)
                    return;
                event.preventDefault();
                container.classList.remove(classes$z.visible);
                container.querySelector(selectors$J.error).addEventListener('transitionend', () => {
                    container.innerHTML = '';
                    this.resizeSliders(clickedElement)
                }
                )
            }
            );
            this.focusOnErrorMessage(container, formErrorClose)
        }
        focusOnErrorMessage(container, button) {
            const isFocusEnabled = !document.body.classList.contains(classes$z.noOutline);
            if (!isFocusEnabled)
                return;
            container.addEventListener('transitionend', () => {
                requestAnimationFrame( () => button?.focus({
                    focusVisible: !0
                }))
            }
            )
        }
        hideAddToCartErrorMessage() {
            const holder = this.button.closest(selectors$J.upsellHolder) ? this.button.closest(selectors$J.upsellHolder) : this.button.closest(selectors$J.productForm);
            const errorContainer = holder?.querySelector(selectors$J.formErrorsContainer);
            errorContainer?.classList.remove(classes$z.visible)
        }
        resizeSliders(element) {
            const slider = element.closest(selectors$J.flickityEnabled);
            if (!slider)
                return;
            const flkty = Flickity.data(slider);
            requestAnimationFrame( () => flkty.resize())
        }
        renderCartDrawer(alwaysOpen=!0) {
            const cartDrawerTemplate = document.querySelector(selectors$J.cartDrawerTemplate);
            if (!cartDrawerTemplate) {
                return
            }
            this.cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
            this.assignArguments();
            this.initQuantity();
            this.cartEvents();
            if (this.buttonHolder) {
                this.collapsible = new Collapsible(this.buttonHolder)
            }
            this.cartDrawerToggle = this.cartDrawer.querySelector(selectors$J.cartDrawerToggle);
            this.cartDrawerToggle.addEventListener('click', this.cartDrawerToggleClickEvent);
            this.isCartDrawerLoaded = !0;
            this.renderPairProducts();
            document.dispatchEvent(new CustomEvent('theme:cart:loaded',{
                bubbles: !0
            }));
            if (alwaysOpen) {
                this.openCartDrawer()
            }
        }
        openCartDrawer() {
            if (this.isCartDrawerOpen) {
                return
            }
            if (!this.isCartDrawerLoaded) {
                this.renderCartDrawer();
                return
            }
            document.dispatchEvent(new CustomEvent('theme:cart:open',{
                bubbles: !0
            }));
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: this.cartDrawer
            }));
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: this.cartDrawerBody
            }));
            this.scrollToCartTop();
            document.body.classList.add(classes$z.cartDrawerOpen);
            this.cartDrawer.classList.add(classes$z.open);
            this.cartDrawer.classList.remove(classes$z.contentVisibilityHidden);
            requestAnimationFrame( () => this.animateCartItems('in'));
            this.cartToggleButtons.forEach( (button) => {
                button.setAttribute(attributes$t.ariaExpanded, !0)
            }
            );
            this.a11y.trapFocus({
                container: this.cartDrawer,
            });
            this.observeAdditionalCheckoutButtons();
            this.isCartDrawerOpen = !0
        }
        animateCartItems(state='in') {
            const items = this.cart.querySelectorAll(selectors$J.aos);
            if (state === 'in') {
                items.forEach( (item) => requestAnimationFrame( () => item.classList.add(classes$z.aosAnimate)))
            }
            if (state === 'out') {
                items.forEach( (item) => item.classList.remove(classes$z.aosAnimate))
            }
        }
        closeCartDrawer() {
            if (!this.isCartDrawerOpen) {
                return
            }
            document.dispatchEvent(new CustomEvent('theme:cart:close',{
                bubbles: !0
            }));
            this.cartErrorHolder.classList.remove(classes$z.expanded);
            this.a11y.removeTrapFocus();
            this.cartToggleButtons.forEach( (button) => {
                button.setAttribute(attributes$t.ariaExpanded, !1)
            }
            );
            document.body.classList.remove(classes$z.cartDrawerOpen);
            this.cartDrawer.classList.remove(classes$z.open);
            this.itemsHolder.classList.remove(classes$z.updated);
            const onCartDrawerTransitionEnd = (event) => {
                if (event.target !== this.cartDrawer)
                    return;
                this.animateCartItems('out');
                this.cartDrawer.removeEventListener('transitionend', onCartDrawerTransitionEnd)
            }
            ;
            this.cartDrawer.addEventListener('transitionend', onCartDrawerTransitionEnd);
            const isFocusEnabled = !document.body.classList.contains(classes$z.noOutline);
            if (!isFocusEnabled) {
                requestAnimationFrame( () => {
                    document.activeElement.blur()
                }
                )
            }
            const timeout = 400;
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                bubbles: !0,
                detail: timeout
            }));
            this.isCartDrawerOpen = !1
        }
        toggleCartDrawer() {
            if (this.isCartDrawerOpen) {
                this.closeCartDrawer()
            } else {
                this.openCartDrawer()
            }
        }
        cartDrawerToggleEvents() {
            if (!this.cartDrawer)
                return;
            this.cartDrawer.addEventListener('keyup', (event) => {
                if (event.code === theme.keyboardKeys.ESCAPE) {
                    this.closeCartDrawer()
                }
            }
            );
            this.cartDrawerToggleClickEvent = (event) => {
                event.preventDefault();
                const button = event.target;
                if (button.getAttribute(attributes$t.ariaExpanded) === 'false') {
                    this.a11y.state.trigger = button
                }
                this.toggleCartDrawer()
            }
            ;
            this.cartDrawerCloseEvent = (event) => {
                const isCartDrawerToggle = event.target.matches(selectors$J.cartDrawerToggle);
                const isCartDrawerChild = document.querySelector(selectors$J.cartDrawer).contains(event.target);
                const isPopupQuickView = event.target.closest(selectors$J.popupQuickView);
                if (!isCartDrawerToggle && !isCartDrawerChild && !isPopupQuickView) {
                    this.closeCartDrawer()
                }
            }
            ;
            this.cartToggleButtons.forEach( (button) => {
                button.addEventListener('click', this.cartDrawerToggleClickEvent)
            }
            );
            document.addEventListener('mousedown', this.cartDrawerCloseEvent)
        }
        toggleClassesOnContainers() {
            const that = this;
            this.emptyMessage.classList.toggle(classes$z.hidden, that.hasItemsInCart());
            this.buttonHolder.classList.toggle(classes$z.hidden, !that.hasItemsInCart());
            this.itemsHolder.classList.toggle(classes$z.hidden, !that.hasItemsInCart());
            this.cartDrawerSubhead.classList.toggle(classes$z.hidden, !that.hasItemsInCart());
            this.cartItemsQty.classList.toggle(classes$z.hidden, !that.hasItemsInCart())
        }
        build(data) {
            const cartItemsData = data.querySelector(selectors$J.apiLineItems);
            const upsellItemsData = data.querySelector(selectors$J.apiUpsellItems);
            const cartEmptyData = Boolean(cartItemsData === null && upsellItemsData === null);
            const priceData = data.querySelector(selectors$J.apiCartPrice);
            const cartTotal = data.querySelector(selectors$J.cartTotal);
            const footerData = data.querySelector(selectors$J.apiCartFooter);
            if (this.priceHolder && priceData) {
                this.priceHolder.innerHTML = priceData.innerHTML
            }
            if (this.buttonHolder && footerData) {
                this.buttonHolder.innerHTML = footerData.innerHTML;
                if (this.buttonHolder) {
                    this.collapsible = new Collapsible(this.buttonHolder)
                }
            }
            this.animateCartItems('out');
            if (cartEmptyData) {
                this.itemsHolder.innerHTML = '';
                if (this.pairProductsHolder) {
                    this.pairProductsHolder.innerHTML = ''
                }
            } else {
                this.itemsHolder.innerHTML = cartItemsData.innerHTML;
                if (this.pairProductsHolder) {
                    this.pairProductsHolder.innerHTML = upsellItemsData.innerHTML
                }
                this.renderPairProducts()
            }
            this.newTotalItems = cartItemsData && cartItemsData.querySelectorAll(selectors$J.item).length ? cartItemsData.querySelectorAll(selectors$J.item).length : 0;
            this.subtotal = cartTotal && cartTotal.hasAttribute(attributes$t.cartTotal) ? parseInt(cartTotal.getAttribute(attributes$t.cartTotal)) : 0;
            this.cartCount = this.getCartItemCount();
            if (this.cartMessage.length > 0) {
                this.updateProgress()
            }
            this.cartToggleButtons.forEach( (button) => {
                button.classList.remove(classes$z.cartItems);
                if (this.newTotalItems > 0) {
                    button.classList.add(classes$z.cartItems)
                }
            }
            );
            this.toggleErrorMessage();
            this.updateItemsQuantity(this.cartCount);
            this.cartTotalPrice.innerHTML = this.subtotal === 0 ? window.theme.strings.free : themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
            if (this.totalItems !== this.newTotalItems) {
                this.totalItems = this.newTotalItems;
                this.toggleClassesOnContainers()
            }
            if (this.isCartDrawerOpen || this.isCartPage) {
                this.itemsHolder.classList.add(classes$z.updated)
            }
            this.cartEvents();
            this.initQuantity();
            this.enableCartButtons();
            this.resetButtonClasses();
            this.removeLoadingClass();
            document.dispatchEvent(new CustomEvent('theme:cart:added',{
                bubbles: !0
            }));
            if (this.cartDrawer) {
                this.openCartDrawer()
            }
            requestAnimationFrame( () => this.animateCartItems('in'))
        }
        getCartItemCount() {
            if (!this.cart)
                return 0;
            return Array.from(this.cart.querySelectorAll(selectors$J.qtyInput)).reduce( (total, quantityInput) => total + parseInt(quantityInput.value), 0)
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        freeShippingMessageHandle(total) {
            if (this.cartMessage.length > 0) {
                document.querySelectorAll(selectors$J.cartMessage).forEach( (message) => {
                    const hasFreeShipping = message.hasAttribute(attributes$t.cartMessageValue) && message.getAttribute(attributes$t.cartMessageValue) === 'true' && total !== 0;
                    const cartMessageDefault = message.querySelector(selectors$J.cartMessageDefault);
                    message.classList.toggle(classes$z.success, total >= this.cartFreeLimitShipping && hasFreeShipping);
                    message.classList.toggle(classes$z.isHidden, total === 0);
                    cartMessageDefault.classList.toggle(classes$z.isHidden, total >= this.cartFreeLimitShipping)
                }
                )
            }
        }
        updateProgress() {
            const newPercentValue = (this.subtotal / this.cartFreeLimitShipping) * 100;
            //debugger;
            const leftToSpend = theme.settings.currency_code_enable ? themeCurrency.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyWithCurrencyFormat) : themeCurrency.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
            if (this.cartMessage.length > 0) {
                document.querySelectorAll(selectors$J.cartMessage).forEach( (message) => {
                    const cartMessageProgressItems = message.querySelectorAll(selectors$J.cartProgress);
                    const leftToSpendMessage = message.querySelector(selectors$J.leftToSpend);
                    if (leftToSpendMessage) {
                        if(leftToSpend.indexOf(".000") == -1 && leftToSpend.indexOf(",000") == -1 ){
                        leftToSpendMessage.innerHTML = leftToSpend.replace('.00', '').replace(',00', '');
                        }
                    }
                    if (cartMessageProgressItems.length) {
                        cartMessageProgressItems.forEach( (cartMessageProgress, index) => {
                            cartMessageProgress.classList.toggle(classes$z.isHidden, this.subtotal / this.cartFreeLimitShipping >= 1);
                            cartMessageProgress.style.setProperty('--progress-width', `${newPercentValue}%`);
                            if (index === 0) {
                                cartMessageProgress.setAttribute(attributes$t.value, newPercentValue)
                            }
                        }
                        )
                    }
                    this.freeShippingMessageHandle(this.subtotal)
                }
                )
            }
        }
        renderPairProducts() {
            this.flktyUpsell = null;
            this.pairProductsHolder = document.querySelector(selectors$J.pairProductsHolder);
            this.pairProducts = document.querySelector(selectors$J.pairProducts);
            this.upsellHolders = document.querySelectorAll(selectors$J.upsellHolder);
            if (this.pairProductsHolder === null || this.pairProductsHolder === undefined) {
                return
            }
            const that = this;
            if (this.upsellHolders.length > 1) {
                this.flktyUpsell = new Flickity(this.pairProducts,{
                    wrapAround: !0,
                    pageDots: !0,
                    adaptiveHeight: !0,
                    prevNextButtons: !1,
                    on: {
                        ready: function() {
                            new QuickViewPopup(that.cart);
                            this.reloadCells();
                            requestAnimationFrame( () => this.resize())
                        },
                    },
                });
                return
            }
            new QuickViewPopup(this.cart)
        }
        updateItemsQuantity(itemsQty) {
            let oneItemText = theme.strings.cart_items_one;
            let manyItemsText = theme.strings.cart_items_many;
            oneItemText = oneItemText.split('}}')[1];
            manyItemsText = manyItemsText.split('}}')[1];
            if (this.cartItemsQty) {
                this.cartItemsQty.textContent = itemsQty === 1 ? `${itemsQty}` : `${itemsQty}`
            }
        }
        observeAdditionalCheckoutButtons() {
            const additionalCheckoutButtons = this.cart.querySelector(selectors$J.additionalCheckoutButtons);
            if (additionalCheckoutButtons) {
                const observer = new MutationObserver( () => {
                    this.a11y.removeTrapFocus();
                    this.a11y.trapFocus({
                        container: this.cart,
                    });
                    observer.disconnect()
                }
                );
                observer.observe(additionalCheckoutButtons, {
                    subtree: !0,
                    childList: !0
                })
            }
        }
        formSubmitHandler() {
            const termsAccepted = document.querySelector(selectors$J.cartTermsCheckbox).checked;
            const termsError = document.querySelector(selectors$J.termsErrorMessage);
            if (!termsAccepted) {
                if (document.querySelector(selectors$J.termsErrorMessage).length > 0) {
                    return
                }
                termsError.innerText = theme.strings.cart_acceptance_error;
                this.cartCheckoutButton.setAttribute(attributes$t.disabled, !0);
                termsError.classList.add(classes$z.expanded)
            } else {
                termsError.classList.remove(classes$z.expanded);
                this.cartCheckoutButton.removeAttribute(attributes$t.disabled)
            }
        }
        resetButtonClasses() {
            const buttons = document.querySelectorAll(selectors$J.buttonAddToCart);
            if (buttons) {
                buttons.forEach( (button) => {
                    if (button.classList.contains(classes$z.loading)) {
                        button.classList.remove(classes$z.loading);
                        button.classList.add(classes$z.success);
                        setTimeout( () => {
                            button.removeAttribute(attributes$t.disabled);
                            button.classList.remove(classes$z.success)
                        }
                        , settings$4.timers.addProductTimeout)
                    }
                }
                )
            }
        }
        addLoadingClass() {
            if (this.cartDrawer) {
                this.cartDrawer.classList.add(classes$z.loading)
            } else if (this.itemsWrapper) {
                this.itemsWrapper.classList.add(classes$z.loading)
            }
        }
        removeLoadingClass() {
            if (this.cartDrawer) {
                this.cartDrawer.classList.remove(classes$z.loading)
            } else if (this.itemsWrapper) {
                this.itemsWrapper.classList.remove(classes$z.loading)
            }
        }
        scrollToCartTop() {
            if (this.cartDrawer) {
                this.cartDrawerBody.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant',
                });
                return
            }
            window.scrollTo({
                top: this.outerSection.offsetTop - this.headerInitialHeight - this.announcementBarHeight,
                left: 0,
                behavior: 'smooth',
            })
        }
        unload() {
            if (this.cartDrawerToggle) {
                this.cartDrawerToggle.removeEventListener('click', this.cartDrawerToggleClickEvent)
            }
            this.cartToggleButtons.forEach( (button) => {
                button.removeEventListener('click', this.cartDrawerToggleClickEvent)
            }
            );
            document.removeEventListener('mousedown', this.cartDrawerCloseEvent);
            if (this.collapsible !== null) {
                this.collapsible.onUnload()
            }
        }
    }
    const cartDrawer = {
        onLoad() {
            sections$w[this.id] = new CartDrawer()
        },
        onUnload() {
            if (typeof sections$w[this.id].unload === 'function') {
                sections$w[this.id].unload()
            }
        },
    };
    register('cart-template', cartDrawer);
    const selectors$I = {
        scrollToTop: '[data-scroll-top-button]',
    };
    const classes$y = {
        isVisible: 'is-visible',
    };
    const scrollTopButton = document.querySelector(selectors$I.scrollToTop);
    if (scrollTopButton) {
        scrollTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            })
        }
        );
        document.addEventListener('scroll', throttle( () => {
            scrollTopButton.classList.toggle(classes$y.isVisible, window.pageYOffset > window.innerHeight)
        }
        , 150))
    }
    const selectors$H = {
        details: 'details',
        popdownBody: '[data-popdown-body]',
        popdownClose: '[data-popdown-close]',
        popdownToggle: '[data-popdown-toggle]',
        searchFormInner: '[data-search-form-inner]',
        input: 'input:not([type="hidden"])',
        popularSearchesLink: '[data-popular-searches-link]',
        header: '[data-site-header]',
        nav: '[data-nav]',
        navItemsCompress: '[data-nav-items-compress]',
        navIcons: '[data-nav-icons]',
        mobileMenu: '[data-mobile-menu]',
        predictiveSearch: 'predictive-search',
        searchForm: 'search-form',
    };
    const attributes$s = {
        popdownInHeader: 'data-popdown-in-header',
        popdownInPage: 'data-popdown-in-page',
        searchPerformed: 'data-search-performed',
        ariaActivedescendant: 'aria-activedescendant',
        ariaExpanded: 'aria-expanded',
        open: 'open',
        role: 'role',
    };
    const classes$x = {
        searchOpened: 'search-opened',
        headerMenuOpened: 'site-header--menu-opened',
        headerCompress: 'site-header--compress',
        open: 'is-open',
    };
    class SearchPopdown extends HTMLElement {
        constructor() {
            super();
            this.isPopdownInHeader = this.hasAttribute(attributes$s.popdownInHeader);
            this.isPopdownInPage = this.hasAttribute(attributes$s.popdownInPage);
            this.popdownBody = this.querySelector(selectors$H.popdownBody);
            this.popdownClose = this.querySelector(selectors$H.popdownClose);
            this.searchFormInner = this.querySelector(selectors$H.searchFormInner);
            this.popularSearchesLink = this.querySelectorAll(selectors$H.popularSearchesLink);
            this.searchFormWrapper = this.querySelector(selectors$H.searchForm) ? this.querySelector(selectors$H.searchForm) : this.querySelector(selectors$H.predictiveSearch);
            this.predictiveSearch = this.searchFormWrapper.matches(selectors$H.predictiveSearch);
            this.header = document.querySelector(selectors$H.header);
            this.headerSection = this.header?.parentNode;
            this.nav = this.header?.querySelector(selectors$H.nav);
            this.mobileMenu = this.headerSection?.querySelector(selectors$H.mobileMenu);
            this.a11y = a11y;
            this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize();
            this.popdownTransitionCallbackEvent = (event) => this.popdownTransitionCallback(event);
            this.detailsToggleCallbackEvent = (event) => this.detailsToggleCallback(event);
            if (this.isPopdownInHeader) {
                this.details = this.querySelector(selectors$H.details);
                this.popdownToggle = this.querySelector(selectors$H.popdownToggle)
            }
        }
        connectedCallback() {
            if (this.isPopdownInHeader) {
                this.searchFormInner.addEventListener('transitionend', this.popdownTransitionCallbackEvent);
                this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
                this.details.addEventListener('toggle', this.detailsToggleCallbackEvent);
                this.popdownClose.addEventListener('click', (event) => this.close(event));
                this.popdownToggle.addEventListener('click', (event) => this.onPopdownToggleClick(event));
                this.popdownToggle.setAttribute(attributes$s.role, 'button')
            }
            if (this.isPopdownInPage) {
                this.popdownClose.addEventListener('click', () => this.triggerPopdownClose());
                this.searchFormWrapper.addEventListener('focusout', () => this.onFocusOut());
                this.searchFormWrapper.input.addEventListener('click', (event) => this.triggerPopdownOpen(event))
            }
            this.popularSearchesLink.forEach( (element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    const popularSearchText = event.target.textContent;
                    this.searchFormWrapper.input.value = popularSearchText;
                    this.searchFormWrapper.submit()
                }
                )
            }
            )
        }
        onPopdownToggleClick(event) {
            const isChrome = navigator.userAgent.includes('Chrome');
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isChrome && !isIOS) {
                event.target.closest(selectors$H.details).setAttribute(attributes$s.open, '')
            }
            if (event.target.closest(selectors$H.details).hasAttribute(attributes$s.open)) {
                event.preventDefault();
                this.close()
            }
        }
        detailsToggleCallback(event) {
            if (event.target.hasAttribute(attributes$s.open)) {
                this.open()
            }
        }
        popdownTransitionCallback(event) {
            if (event.target !== this.searchFormInner)
                return;
            if (!this.details.classList.contains(classes$x.open)) {
                this.onClose()
            } else if (event.propertyName === 'transform') {
                this.a11y.trapFocus({
                    container: this.searchFormInner,
                })
            }
        }
        onBodyClick(event) {
            const isTargetInPopdown = this.contains(event.target);
            const isHeaderMenuOpened = this.header?.classList.contains(classes$x.headerMenuOpened);
            if (isHeaderMenuOpened || isTargetInPopdown)
                return;
            if (!isTargetInPopdown)
                this.close();
        }
        onFocusOut() {
            if (!this.predictiveSearch)
                return;
            requestAnimationFrame( () => {
                if (!this.searchFormWrapper.contains(document.activeElement)) {
                    this.searchFormWrapper.close()
                }
            }
            )
        }
        triggerPopdownOpen(event) {
            const isSearchPageWithoutTerms = this.closest(`[${attributes$s.searchPerformed}="false"]`);
            let isTouch = matchMedia('(pointer:coarse)').matches;
            const viewportMobile = window.innerWidth < theme.sizes.small;
            const shouldOpenPopdownOnTouchDevice = isTouch || viewportMobile;
            const shouldOpenPopdownOnNoTerms = isSearchPageWithoutTerms != null;
            if (viewportMobile && window.Shopify.designMode) {
                isTouch = !0
            }
            if (!this.nav || !this.mobileMenu)
                return;
            if (shouldOpenPopdownOnTouchDevice || shouldOpenPopdownOnNoTerms) {
                event.preventDefault();
                const isHeaderCompressed = this.header.classList.contains(classes$x.headerCompress);
                let popdownToggle = this.mobileMenu.querySelector(selectors$H.popdownToggle);
                if (!isTouch) {
                    popdownToggle = isHeaderCompressed ? this.nav.querySelector(`${selectors$H.navItemsCompress} ${selectors$H.popdownToggle}`) : this.nav.querySelector(`${selectors$H.navIcons} ${selectors$H.popdownToggle}`)
                }
                setTimeout( () => {
                    popdownToggle?.dispatchEvent(new Event('click',{
                        bubbles: !0
                    }))
                }
                , 300)
            }
        }
        open() {
            this.onBodyClickEvent = (event) => this.onBodyClick(event);
            this.searchFormWrapper.input.setAttribute(attributes$s.ariaExpanded, !0);
            document.body.classList.add(classes$x.searchOpened);
            document.body.addEventListener('click', this.onBodyClickEvent);
            document.addEventListener('theme:resize', this.ensureClosingOnResizeEvent);
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0
            }));
            requestAnimationFrame( () => {
                this.details.classList.add(classes$x.open)
            }
            )
        }
        close(event) {
            if (event && event.target === this.popdownClose) {
                if (this.searchFormWrapper.input.getAttribute(attributes$s.ariaActivedescendant) !== '')
                    return
            }
            this.a11y.removeTrapFocus();
            this.details.classList.remove(classes$x.open);
            if (this.predictiveSearch)
                this.searchFormWrapper.close();
            this.searchFormWrapper.handleFocusableDescendants(!0)
        }
        triggerPopdownClose() {
            if (this.predictiveSearch)
                this.searchFormWrapper.close();
            if (this.searchFormWrapper.popularSearches) {
                requestAnimationFrame( () => document.activeElement.blur())
            }
        }
        onClose() {
            this.details.removeAttribute(attributes$s.open);
            document.dispatchEvent(new CustomEvent('theme:search:close',{
                bubbles: !0
            }));
            document.body.classList.remove(classes$x.searchOpened);
            document.body.removeEventListener('click', this.onBodyClickEvent);
            document.removeEventListener('theme:resize', this.ensureClosingOnResizeEvent);
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                bubbles: !0
            }))
        }
        ensureClosingOnResize() {
            const isElementHiddenFromView = this.offsetParent === null;
            if (!isElementHiddenFromView)
                return;
            this.onClose()
        }
    }
    customElements.define('search-popdown', SearchPopdown);
    Shopify.Products = (function() {
        const config = {
            howManyToShow: 4,
            howManyToStoreInMemory: 10,
            wrapperId: 'recently-viewed-products',
            section: null,
            onComplete: null,
            apiSectionId: 'api-product-grid-item'
        };
        let productHandleQueue = [];
        let wrapper = null;
        let howManyToShowItems = null;
        const today = new Date();
        const expiresDate = new Date();
        const daysToExpire = 90;
        expiresDate.setTime(today.getTime() + 3600000 * 24 * daysToExpire);
        const cookie = {
            configuration: {
                expires: expiresDate.toGMTString(),
                path: '/',
                domain: window.location.hostname,
                sameSite: 'none',
                secure: !0,
            },
            name: 'shopify_recently_viewed',
            write: function(recentlyViewed) {
                const recentlyViewedString = recentlyViewed.join(' ');
                document.cookie = `${this.name}=${recentlyViewedString}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
            },
            read: function() {
                let recentlyViewed = [];
                let cookieValue = null;
                if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find( (row) => row.startsWith(this.name))) {
                    cookieValue = document.cookie.split('; ').find( (row) => row.startsWith(this.name)).split('=')[1]
                }
                if (cookieValue !== null) {
                    recentlyViewed = cookieValue.split(' ')
                }
                return recentlyViewed
            },
            destroy: function() {
                const cookieVal = null;
                document.cookie = `${this.name}=${cookieVal}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
            },
            remove: function(productHandle) {
                const recentlyViewed = this.read();
                const position = recentlyViewed.indexOf(productHandle);
                if (position !== -1) {
                    recentlyViewed.splice(position, 1);
                    this.write(recentlyViewed)
                }
            },
        };
        const finalize = (wrapper, section) => {
            showElement(wrapper, !0);
            const cookieItemsLength = cookie.read().length;
            if (Shopify.recentlyViewed && howManyToShowItems && cookieItemsLength && cookieItemsLength < howManyToShowItems && wrapper.children.length) {
                let allClassesArr = [];
                let addClassesArr = [];
                let objCounter = 0;
                for (const property in Shopify.recentlyViewed) {
                    objCounter += 1;
                    const objString = Shopify.recentlyViewed[property];
                    const objArr = objString.split(' ');
                    const propertyIdx = parseInt(property.split('_')[1]);
                    allClassesArr = [...allClassesArr, ...objArr];
                    if (cookie.read().length === propertyIdx || (objCounter === Object.keys(Shopify.recentlyViewed).length && !addClassesArr.length)) {
                        addClassesArr = [...addClassesArr, ...objArr]
                    }
                }
                for (let i = 0; i < wrapper.children.length; i++) {
                    const element = wrapper.children[i];
                    if (allClassesArr.length) {
                        element.classList.remove(...allClassesArr)
                    }
                    if (addClassesArr.length) {
                        element.classList.add(...addClassesArr)
                    }
                }
            }
            if (config.onComplete) {
                try {
                    config.onComplete(wrapper, section)
                } catch (error) {
                    console.log(error)
                }
            }
        }
        ;
        const moveAlong = (shown, productHandleQueue, wrapper, section) => {
            if (productHandleQueue.length && shown < config.howManyToShow) {
                fetch(`${window.theme.routes.root}products/${productHandleQueue[0]}?section_id=${config.apiSectionId}`).then( (response) => response.text()).then( (product) => {
                    const aosDelay = shown * 150;
                    const aosAnchor = wrapper.id ? `#${wrapper.id}` : '';
                    const fresh = document.createElement('div');
                    let productReplaced = product;
                    if (productReplaced.includes('data-unpublished')) {
                        cookie.remove(productHandleQueue[0]);
                        productHandleQueue.shift();
                        moveAlong(shown, productHandleQueue, wrapper, section);
                        return
                    }
                    productReplaced = productReplaced.includes('||itemAosDelay||') ? productReplaced.replaceAll('||itemAosDelay||', aosDelay) : productReplaced;
                    productReplaced = productReplaced.includes('||itemAosAnchor||') ? productReplaced.replaceAll('||itemAosAnchor||', aosAnchor) : productReplaced;
                    fresh.innerHTML = productReplaced;
                    wrapper.innerHTML += fresh.querySelector('[data-api-content]').innerHTML;
                    productHandleQueue.shift();
                    shown++;
                    moveAlong(shown, productHandleQueue, wrapper, section)
                }
                ).catch( () => {
                    cookie.remove(productHandleQueue[0]);
                    productHandleQueue.shift();
                    moveAlong(shown, productHandleQueue, wrapper, section)
                }
                )
            } else {
                finalize(wrapper, section)
            }
        }
        ;
        return {
            showRecentlyViewed: function(params) {
                const paramsNew = params || {};
                const shown = 0;
                Object.assign(config, paramsNew);
                productHandleQueue = cookie.read();
                wrapper = document.querySelector(`#${config.wrapperId}`);

                if (wrapper) {
                const isPackshotFirst = wrapper.dataset.isPackshotFirst === 'true';
                config.apiSectionId = isPackshotFirst
                    ? 'api-product-grid-item-packshot'
                    : 'api-product-grid-item';
                }

                howManyToShowItems = config.howManyToShow;
                config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
                if (config.howManyToShow && wrapper) {
                    moveAlong(shown, productHandleQueue, wrapper, config.section)
                }
            },
            getConfig: function() {
                return config
            },
            clearList: function() {
                cookie.destroy()
            },
            recordRecentlyViewed: function(params) {
                const paramsNew = params || {};
                Object.assign(config, paramsNew);
                let recentlyViewed = cookie.read();
                if (window.location.pathname.indexOf('/products/') !== -1) {
                    let productHandle = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split('/products/')[1];
                    if (config.handle) {
                        productHandle = config.handle
                    }
                    const position = recentlyViewed.indexOf(productHandle);
                    if (position === -1) {
                        recentlyViewed.unshift(productHandle);
                        recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory)
                    } else {
                        recentlyViewed.splice(position, 1);
                        recentlyViewed.unshift(productHandle)
                    }
                    cookie.write(recentlyViewed)
                }
            },
            hasProducts: cookie.read().length > 0,
        }
    }
    )();
    theme.ProductModel = (function() {
        let modelJsonSections = {};
        let models = {};
        let xrButtons = {};
        const selectors = {
            productMediaWrapper: '[data-product-single-media-wrapper]',
            mediaGroup: '[data-product-single-media-group]',
            productXr: '[data-shopify-xr]',
            mediaId: 'data-media-id',
            model3d: 'data-shopify-model3d-id',
            modelViewer: 'model-viewer',
            modelJson: '#ModelJson-',
            deferredMedia: '[data-deferred-media]',
            deferredMediaButton: '[data-deferred-media-button]',
        };
        const classes = {
            isLoading: 'is-loading',
            mediaHidden: 'media--hidden',
        };
        function init(mediaContainer, sectionId) {
            modelJsonSections[sectionId] = {
                loaded: !1,
            };
            const deferredMediaButton = mediaContainer.querySelector(selectors.deferredMediaButton);
            if (deferredMediaButton) {
                deferredMediaButton.addEventListener('click', loadContent.bind(this, mediaContainer, sectionId))
            }
        }
        function loadContent(mediaContainer, sectionId) {
            if (mediaContainer.querySelector(selectors.deferredMedia).getAttribute('loaded')) {
                return
            }
            mediaContainer.classList.add(classes.isLoading);
            const content = document.createElement('div');
            content.appendChild(mediaContainer.querySelector('template').content.firstElementChild.cloneNode(!0));
            const modelViewerElement = content.querySelector('model-viewer');
            const deferredMedia = mediaContainer.querySelector(selectors.deferredMedia);
            deferredMedia.appendChild(modelViewerElement);
            deferredMedia.setAttribute('loaded', !0);
            const mediaId = mediaContainer.dataset.mediaId;
            const modelId = modelViewerElement.dataset.modelId;
            const xrButton = mediaContainer.closest(selectors.mediaGroup).parentElement.querySelector(selectors.productXr);
            xrButtons[sectionId] = {
                element: xrButton,
                defaultId: modelId,
            };
            models[mediaId] = {
                modelId: modelId,
                mediaId: mediaId,
                sectionId: sectionId,
                container: mediaContainer,
                element: modelViewerElement,
            };
            if (!window.ShopifyXR) {
                window.Shopify.loadFeatures([{
                    name: 'shopify-xr',
                    version: '1.0',
                    onLoad: setupShopifyXr,
                }, {
                    name: 'model-viewer-ui',
                    version: '1.0',
                    onLoad: setupModelViewerUi,
                }, ])
            } else {
                setupModelViewerUi()
            }
        }
        function setupShopifyXr(errors) {
            if (errors) {
                console.warn(errors);
                return
            }
            if (!window.ShopifyXR) {
                document.addEventListener('shopify_xr_initialized', function() {
                    setupShopifyXr()
                });
                return
            }
            for (const sectionId in modelJsonSections) {
                if (modelJsonSections.hasOwnProperty(sectionId)) {
                    const modelSection = modelJsonSections[sectionId];
                    if (modelSection.loaded) {
                        continue
                    }
                    const modelJson = document.querySelector(`${selectors.modelJson}${sectionId}`);
                    if (modelJson) {
                        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
                        modelSection.loaded = !0
                    }
                }
            }
            window.ShopifyXR.setupXRElements()
        }
        function setupModelViewerUi(errors) {
            if (errors) {
                console.warn(errors);
                return
            }
            for (const key in models) {
                if (models.hasOwnProperty(key)) {
                    const model = models[key];
                    if (!model.modelViewerUi) {
                        model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
                        setupModelViewerListeners(model)
                    }
                }
            }
        }
        function setupModelViewerListeners(model) {
            const xrButton = xrButtons[model.sectionId];
            model.container.addEventListener('theme:media:visible', function() {
                xrButton.element.setAttribute(selectors.model3d, model.modelId);
                if (window.theme.touch) {
                    return
                }
                model.modelViewerUi.play();
                model.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                    bubbles: !0
                })
            });
            model.container.addEventListener('theme:media:hidden', function() {
                model.modelViewerUi.pause()
            });
            model.container.addEventListener('xrLaunch', function() {
                model.modelViewerUi.pause()
            });
            model.element.addEventListener('load', () => {
                xrButton.element.setAttribute(selectors.model3d, model.modelId);
                model.container.classList.remove(classes.isLoading);
                model.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                    bubbles: !0
                })
            }
            );
            model.element.addEventListener('shopify_model_viewer_ui_toggle_play', function() {
                pauseOtherMedia(model.mediaId);
                setTimeout( () => {
                    model.container.dispatchEvent(new CustomEvent('theme:media:play'), {
                        bubbles: !0
                    })
                }
                , 50)
            });
            model.element.addEventListener('shopify_model_viewer_ui_toggle_pause', function() {
                model.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
                    bubbles: !0
                })
            });
            pauseOtherMedia(model.mediaId)
        }
        function pauseOtherMedia(mediaId) {
            const currentMedia = `[${selectors.mediaId}="${mediaId}"]`;
            const otherMedia = document.querySelectorAll(`${selectors.productMediaWrapper}:not(${currentMedia})`);
            if (otherMedia.length) {
                otherMedia.forEach( (media) => {
                    media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                        bubbles: !0
                    });
                    media.classList.add(classes.mediaHidden)
                }
                )
            }
        }
        function removeSectionModels(sectionId) {
            for (const key in models) {
                if (models.hasOwnProperty(key)) {
                    const model = models[key];
                    if (model.sectionId === sectionId) {
                        delete models[key]
                    }
                }
            }
            delete modelJsonSections[sectionId];
            delete theme.mediaInstances[sectionId]
        }
        return {
            init: init,
            loadContent: loadContent,
            removeSectionModels: removeSectionModels,
        }
    }
    )();
    register('collection-template', filters);
    const selectors$G = {
        templateAddresses: '.template-customers-addresses',
        accountForm: '[data-form]',
        addressNewForm: '[data-form-new]',
        btnNew: '[data-button-new]',
        btnEdit: '[data-button-edit]',
        btnDelete: '[data-button-delete]',
        btnCancel: '[data-button-cancel]',
        editAddress: 'data-form-edit',
        addressCountryNew: 'AddressCountryNew',
        addressProvinceNew: 'AddressProvinceNew',
        addressProvinceContainerNew: 'AddressProvinceContainerNew',
        addressCountryOption: '[data-country-option]',
        addressCountry: 'AddressCountry',
        addressProvince: 'AddressProvince',
        addressProvinceContainer: 'AddressProvinceContainer',
        requiredInputs: 'input[type="text"]:not(.optional)',
    };
    const attributes$r = {
        dataFormId: 'data-form-id',
    };
    const classes$w = {
        hidden: 'is-hidden',
        validation: 'validation--showup',
    };
    class Addresses {
        constructor(section) {
            this.section = section;
            this.addressNewForm = this.section.querySelector(selectors$G.addressNewForm);
            this.accountForms = this.section.querySelectorAll(selectors$G.accountForm);
            this.init();
            this.validate()
        }
        init() {
            if (this.addressNewForm) {
                const section = this.section;
                const newAddressForm = this.addressNewForm;
                this.customerAddresses();
                const newButtons = section.querySelectorAll(selectors$G.btnNew);
                if (newButtons.length) {
                    newButtons.forEach( (button) => {
                        button.addEventListener('click', function(e) {
                            e.preventDefault();
                            button.classList.add(classes$w.hidden);
                            newAddressForm.classList.remove(classes$w.hidden)
                        })
                    }
                    )
                }
                const editButtons = section.querySelectorAll(selectors$G.btnEdit);
                if (editButtons.length) {
                    editButtons.forEach( (button) => {
                        button.addEventListener('click', function(e) {
                            e.preventDefault();
                            const formId = this.getAttribute(attributes$r.dataFormId);
                            section.querySelector(`[${selectors$G.editAddress}="${formId}"]`).classList.toggle(classes$w.hidden)
                        })
                    }
                    )
                }
                const deleteButtons = section.querySelectorAll(selectors$G.btnDelete);
                if (deleteButtons.length) {
                    deleteButtons.forEach( (button) => {
                        button.addEventListener('click', function(e) {
                            e.preventDefault();
                            const formId = this.getAttribute(attributes$r.dataFormId);
                            if (confirm(theme.strings.delete_confirm)) {
                                Shopify.postLink('/account/addresses/' + formId, {
                                    parameters: {
                                        _method: 'delete'
                                    }
                                })
                            }
                        })
                    }
                    )
                }
                const cancelButtons = section.querySelectorAll(selectors$G.btnCancel);
                if (cancelButtons.length) {
                    cancelButtons.forEach( (button) => {
                        button.addEventListener('click', function(e) {
                            e.preventDefault();
                            this.closest(selectors$G.accountForm).classList.add(classes$w.hidden);
                            document.querySelector(selectors$G.btnNew).classList.remove(classes$w.hidden)
                        })
                    }
                    )
                }
            }
        }
        customerAddresses() {
            if (Shopify.CountryProvinceSelector) {
                new Shopify.CountryProvinceSelector(selectors$G.addressCountryNew,selectors$G.addressProvinceNew,{
                    hideElement: selectors$G.addressProvinceContainerNew,
                })
            }
            const countryOptions = this.section.querySelectorAll(selectors$G.addressCountryOption);
            countryOptions.forEach( (element) => {
                const formId = element.getAttribute(attributes$r.dataFormId);
                const countrySelector = `${selectors$G.addressCountry}_${formId}`;
                const provinceSelector = `${selectors$G.addressProvince}_${formId}`;
                const containerSelector = `${selectors$G.addressProvinceContainer}_${formId}`;
                new Shopify.CountryProvinceSelector(countrySelector,provinceSelector,{
                    hideElement: containerSelector,
                })
            }
            )
        }
        validate() {
            this.accountForms.forEach( (accountForm) => {
                const form = accountForm.querySelector('form');
                const inputs = form.querySelectorAll(selectors$G.requiredInputs);
                form.addEventListener('submit', (event) => {
                    let isEmpty = !1;
                    inputs.forEach( (input) => {
                        if (!input.value) {
                            input.nextElementSibling.classList.add(classes$w.validation);
                            isEmpty = !0
                        } else {
                            input.nextElementSibling.classList.remove(classes$w.validation)
                        }
                    }
                    );
                    if (isEmpty) {
                        event.preventDefault()
                    }
                }
                )
            }
            )
        }
    }
    const template = document.querySelector(selectors$G.templateAddresses);
    if (template) {
        new Addresses(template)
    }
    const selectors$F = {
        form: '[data-account-form]',
        showReset: '[data-show-reset]',
        hideReset: '[data-hide-reset]',
        recover: '[data-recover-password]',
        login: '[data-login-form]',
        recoverSuccess: '[data-recover-success]',
        recoverSuccessText: '[data-recover-success-text]',
        recoverHash: '#recover',
    };
    const classes$v = {
        hidden: 'is-hidden',
    };
    class Login {
        constructor(form) {
            this.form = form;
            this.showButton = form.querySelector(selectors$F.showReset);
            this.hideButton = form.querySelector(selectors$F.hideReset);
            this.recover = form.querySelector(selectors$F.recover);
            this.login = form.querySelector(selectors$F.login);
            this.success = form.querySelector(selectors$F.recoverSuccess);
            this.successText = form.querySelector(selectors$F.recoverSuccessText);
            this.init()
        }
        init() {
            if (window.location.hash == selectors$F.recoverHash) {
                this.showRecoverPasswordForm()
            } else {
                this.hideRecoverPasswordForm()
            }
            if (this.success) {
                this.successText.classList.remove(classes$v.hidden)
            }
            this.showButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.showRecoverPasswordForm()
            }
            , !1);
            this.hideButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.hideRecoverPasswordForm()
            }
            , !1)
        }
        showRecoverPasswordForm() {
            this.recover.classList.remove(classes$v.hidden);
            this.login.classList.add(classes$v.hidden);
            window.location.hash = selectors$F.recoverHash;
            return !1
        }
        hideRecoverPasswordForm() {
            this.login.classList.remove(classes$v.hidden);
            this.recover.classList.add(classes$v.hidden);
            window.location.hash = '';
            return !1
        }
    }
    const loginForm = document.querySelector(selectors$F.form);
    if (loginForm) {
        new Login(loginForm)
    }
    register('search-template', [filters, tabs]);
    const selectors$E = {
        frame: '[data-ticker-frame]',
        scale: '[data-ticker-scale]',
        text: '[data-ticker-text]',
        clone: 'data-clone',
    };
    const attributes$q = {
        speed: 'data-marquee-speed',
    };
    const classes$u = {
        animationClass: 'ticker--animated',
        unloadedClass: 'ticker--unloaded',
        comparitorClass: 'ticker__comparitor',
    };
    const settings$3 = {
        moveTime: 1.63,
        space: 100,
    };
    class Ticker {
        constructor(el, stopClone=!1) {
            this.frame = el;
            this.stopClone = stopClone;
            this.scale = this.frame.querySelector(selectors$E.scale);
            this.text = this.frame.querySelector(selectors$E.text);
            this.comparitor = this.text.cloneNode(!0);
            this.comparitor.classList.add(classes$u.comparitorClass);
            this.frame.appendChild(this.comparitor);
            this.scale.classList.remove(classes$u.unloadedClass);
            this.resizeEvent = debounce( () => this.checkWidth(), 100);
            this.listen()
        }
        listen() {
            document.addEventListener('theme:resize:width', this.resizeEvent);
            this.checkWidth()
        }
        checkWidth() {
            const padding = window.getComputedStyle(this.frame).paddingLeft.replace('px', '') * 2;
            if (this.frame.clientWidth - padding < this.comparitor.clientWidth || this.stopClone) {
                if (this.scale.childElementCount === 1) {
                    this.text.classList.add(classes$u.animationClass);
                    this.clone = this.text.cloneNode(!0);
                    this.clone.setAttribute(selectors$E.clone, '');
                    this.scale.appendChild(this.clone);
                    if (this.stopClone) {
                        for (let index = 0; index < 10; index++) {
                            const cloneSecond = this.text.cloneNode(!0);
                            cloneSecond.setAttribute(selectors$E.clone, '');
                            this.scale.appendChild(cloneSecond)
                        }
                    }
                    let frameSpeed = this.frame.getAttribute(attributes$q.speed);
                    if (frameSpeed === null) {
                        frameSpeed = 100
                    }
                    const speed = settings$3.moveTime * (100 / parseInt(frameSpeed, 10));
                    const animationTimeFrame = (this.text.clientWidth / settings$3.space) * speed;
                    this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`)
                }
            } else {
                this.text.classList.add(classes$u.animationClass);
                let clone = this.scale.querySelector(`[${selectors$E.clone}]`);
                if (clone) {
                    this.scale.removeChild(clone)
                }
                this.text.classList.remove(classes$u.animationClass)
            }
        }
        unload() {
            document.removeEventListener('theme:resize:width', this.resizeEvent)
        }
    }
    function getWindowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }
    function isDesktop() {
        return getWindowWidth() >= window.theme.sizes.small
    }
    function isMobile() {
        return getWindowWidth() < window.theme.sizes.small
    }
    const selectors$D = {
        parallaxElement: '[data-parallax]',
    };
    const classes$t = {
        isDisabled: 'is-disabled',
        mainContent: 'main-content',
        shopifySection: 'shopify-section',
    };
    const attributes$p = {
        parallaxAnimation: 'data-parallax',
        parallaxIntensity: 'data-parallax-intensity',
        parallaxStatic: 'data-parallax-static',
        singleElement: 'data-parallax-single',
        disableOnMobile: 'data-parallax-disable-on-mobile',
    };
    const sections$v = {};
    class ParallaxElement {
        constructor(el) {
            this.container = el;
            this.percentage = 0;
            this.percentageFull = 0;
            this.animation = this.container.getAttribute(attributes$p.parallaxAnimation);
            this.disableOnMobile = this.container.hasAttribute(attributes$p.disableOnMobile);
            this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            this.orientation = getScreenOrientation();
            this.scrollEvent = () => this.updateParallax();
            this.resizeEvent = () => this.updateHeight();
            requestAnimationFrame( () => {
                this.containerHeight = this.container.offsetHeight;
                this.footerOffset = 0.15 * this.containerHeight;
                this.cachedPosition = this.footerOffset;
                this.cachedPercentage = 0;
                this.init()
            }
            )
        }
        init() {
            this.updateParallax();
            document.addEventListener('theme:scroll', this.scrollEvent);
            document.addEventListener('theme:resize', this.resizeEvent)
        }
        updateParallax() {
            if (this.container.classList.contains(classes$t.isDisabled))
                return;
            if (this.disableOnMobile && isMobile())
                return;
            const scrollTop = Math.round(window.scrollY);
            const scrollBottom = scrollTop + this.viewportHeight;
            let elementOffsetTopPoint = Math.round(this.container.getBoundingClientRect().top + scrollTop);
            if (this.animation === 'footer') {
                let prevSection = this.container.parentNode.previousElementSibling;
                if (prevSection && !prevSection.classList.contains(classes$t.shopifySection) && !prevSection.classList.contains(classes$t.mainContent)) {
                    prevSection = prevSection.previousElementSibling
                }
                elementOffsetTopPoint = Math.round(prevSection?.getBoundingClientRect().bottom + scrollTop)
            }
            const elementHeight = this.container.offsetHeight;
            const elementOffsetBottomPoint = elementOffsetTopPoint + elementHeight;
            const isBottomOfElementPassed = elementOffsetBottomPoint < scrollTop;
            const isTopOfElementReached = elementOffsetTopPoint < scrollBottom;
            const isInView = isTopOfElementReached && !isBottomOfElementPassed;
            if (isInView) {
                const scrollProgress = scrollBottom - elementOffsetTopPoint;
                this.percentage = ((scrollProgress - elementHeight / 2) * 100) / this.viewportHeight;
                this.percentageFull = Number(scrollProgress / elementHeight).toFixed(2);
                this.percentageVisible = Number((scrollProgress * 100) / (this.viewportHeight + elementHeight)).toFixed(2);
                if (this.animation === 'circle') {
                    this.animateCircleText()
                } else if (this.animation === 'horizontal' || this.animation === 'vertical' || this.animation === 'diagonal') {
                    this.animateOverlappingImages()
                } else if (this.animation === 'offset-ltr' || this.animation === 'offset-rtl') {
                    this.offsetX()
                } else if (this.animation === 'footer') {
                    this.animateFooter()
                }
            }
        }
        offsetX() {
            const isStatic = this.container.hasAttribute(attributes$p.parallaxStatic);
            const intensity = this.container.getAttribute(attributes$p.parallaxIntensity) || 100;
            let adjustment = this.animation === 'offset-ltr' ? intensity : 0;
            if (isStatic)
                adjustment = intensity / 2;
            const direction = this.animation === 'offset-ltr' ? 1 : -1;
            const offset = (intensity * this.percentageVisible) / 100 - adjustment;
            const offsetX = Number(offset * direction).toFixed(2);
            this.container.style.setProperty('--offsetX', `${offsetX}%`)
        }
        updateHeight() {
            const isDesktop = matchMedia('(min-width: 1024px)').matches;
            if (this.orientation !== getScreenOrientation() || isDesktop) {
                this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
                this.containerHeight = this.container.offsetHeight;
                this.orientation = getScreenOrientation()
            }
        }
        animateCircleText() {
            const rotateDegree = 70;
            const angle = ((rotateDegree * this.percentage) / 100) * -1;
            const adjustRotateDegree = rotateDegree / 2;
            if (this.percentage > 0) {
                this.container.style.setProperty(`--rotate`, `${adjustRotateDegree + angle}deg`)
            }
        }
        animateOverlappingImages() {
            const intensity = this.container.getAttribute(attributes$p.parallaxIntensity);
            const offsetRange = 0.25 * intensity;
            const offsetRangeHalf = offsetRange / 2;
            const singleElement = this.container.hasAttribute(attributes$p.singleElement);
            const offset = (offsetRange * this.percentage) / 100;
            let offsetXPrimary = 0;
            let offsetYPrimary = 0;
            let offsetXSecondary = 0;
            let offsetYSecondary = 0;
            if (this.animation === 'horizontal' || this.animation === 'diagonal') {
                offsetXPrimary = -1 * offsetRangeHalf + offset;
                offsetXSecondary = offsetRangeHalf - offset
            }
            if (this.animation === 'vertical' || this.animation === 'diagonal') {
                offsetYPrimary = offsetRangeHalf - offset;
                offsetYSecondary = -1 * offsetRangeHalf + offset
            }
            this.container.style.setProperty('--transformX-primary', `${offsetXPrimary}%`);
            this.container.style.setProperty('--transformY-primary', `${offsetYPrimary}%`);
            if (!singleElement) {
                this.container.style.setProperty('--transformX-secondary', `${offsetXSecondary}%`);
                this.container.style.setProperty('--transformY-secondary', `${offsetYSecondary}%`)
            }
        }
        animateFooter() {
            const offsetMove = this.footerOffset * this.percentageFull;
            const percentageOfFullOffset = Number((offsetMove / this.footerOffset) * 100).toFixed(2);
            const currentTransform = new WebKitCSSMatrix(window.getComputedStyle(this.container).transform);
            const currentOffset = Number(currentTransform.m42).toFixed(2);
            let newOffset = Number(this.footerOffset - offsetMove).toFixed(2);
            if (this.percentageFull >= 1) {
                newOffset = 0
            }
            if (currentOffset !== newOffset && this.cachedPercentage !== percentageOfFullOffset) {
                this.container.style.setProperty('--transformY', `${newOffset}`);
                this.cachedPercentage = percentageOfFullOffset;
                this.cachedPosition = newOffset
            }
        }
        unload() {
            document.removeEventListener('theme:scroll', this.scrollEvent);
            document.removeEventListener('theme:resize', this.resizeEvent)
        }
    }
    const parallaxSection = {
        onLoad() {
            sections$v[this.id] = [];
            const elements = this.container.querySelectorAll(selectors$D.parallaxElement);
            elements.forEach( (element) => {
                sections$v[this.id].push(new ParallaxElement(element))
            }
            )
        },
        onUnload() {
            sections$v[this.id].forEach( (element) => {
                if (typeof element.unload === 'function') {
                    element.unload()
                }
            }
            )
        },
    };
    const selectors$C = {
        announcement: '[data-announcement]',
        announcementSlide: '[data-announcement-slide]',
        frame: '[data-ticker-frame]',
        slide: '[data-slide]',
        slider: '[data-slider]',
        static: '[data-static]',
        tickerScale: '[data-ticker-scale]',
        tickerText: '[data-ticker-text]',
        parallax: '[data-parallax]',
    };
    const attributes$o = {
        slide: 'data-slide',
        speed: 'data-slider-speed',
        arrows: 'data-slider-arrows',
        stop: 'data-stop',
        style: 'style',
        targetReferrer: 'data-target-referrer',
        clipPath: 'clip-path',
    };
    const classes$s = {
        desktop: 'desktop',
        mobile: 'mobile',
        tickerAnimated: 'ticker--animated',
        isDisabled: 'is-disabled',
    };
    const tags = {
        clipPath: 'clipPath',
    };
    const sections$u = {};
    class AnnouncementBar {
        constructor(container) {
            this.barHolder = container;
            this.locationPath = location.href;
            this.slides = this.barHolder.querySelectorAll(selectors$C.slide);
            this.slider = this.barHolder.querySelector(selectors$C.slider);
            this.static = this.barHolder.querySelector(selectors$C.static);
            this.parallax = this.barHolder.querySelector(selectors$C.parallax);
            this.tickers = [];
            this.flkty = null;
            this.init()
        }
        init() {
            this.removeAnnouncement();
            if (this.slider) {
                this.initSlider();
                document.addEventListener('theme:resize:width', this.initSlider.bind(this))
            }
            if (this.static) {
                this.initTickers();
                this.tickerAnimationPause()
            }
            if (!this.slider && !this.static) {
                this.initTickers(!0);
                this.tickerAnimationPause()
            }
            this.updateSVGClipPathIDs()
        }
        removeAnnouncement() {
            for (let i = 0; i < this.slides.length; i++) {
                const element = this.slides[i];
                if (!element.hasAttribute(attributes$o.targetReferrer)) {
                    continue
                }
                if (this.locationPath.indexOf(element.getAttribute(attributes$o.targetReferrer)) === -1 && !window.Shopify.designMode) {
                    element.parentNode.removeChild(element)
                }
            }
        }
        initSlider() {
            const slides = this.slider.querySelectorAll(selectors$C.slide);
            const sliderArrows = this.slider.hasAttribute(attributes$o.arrows);
            if (slides) {
                let slideSelector = `${selectors$C.slide}`;
                if (window.innerWidth < theme.sizes.small) {
                    slideSelector = `${selectors$C.slide}:not(.${classes$s.desktop})`
                } else {
                    slideSelector = `${selectors$C.slide}:not(.${classes$s.mobile})`
                }
                if (this.flkty != null) {
                    this.flkty.destroy()
                }
                this.flkty = new Flickity(this.slider,{
                    cellSelector: slideSelector,
                    pageDots: !1,
                    prevNextButtons: sliderArrows,
                    wrapAround: !0,
                    autoPlay: parseInt(this.slider.getAttribute(attributes$o.speed), 10),
                    on: {
                        ready: () => {
                            setTimeout( () => {
                                this.slider.dispatchEvent(new CustomEvent('slider-is-loaded',{
                                    bubbles: !0,
                                    detail: {
                                        slider: this,
                                    },
                                }))
                            }
                            , 10)
                        }
                        ,
                    },
                });
                this.flkty.reposition()
            }
            this.slider.addEventListener('slider-is-loaded', () => {
                this.initTickers();
                this.updateSVGClipPathIDs()
            }
            )
        }
        initTickers(stopClone=!1) {
            const frames = this.barHolder.querySelectorAll(selectors$C.frame);
            frames.forEach( (element) => {
                const ticker = new Ticker(element,stopClone);
                this.tickers.push(ticker);
                const slides = element.querySelectorAll(selectors$C.slide);
                if (slides.length !== 0) {
                    const slidesMobile = element.querySelectorAll(`${selectors$C.slide}.${classes$s.mobile}`);
                    const slidesDesktop = element.querySelectorAll(`${selectors$C.slide}.${classes$s.desktop}`);
                    if (slides.length === slidesMobile.length) {
                        element.parentNode.classList.add(classes$s.mobile)
                    } else if (slides.length === slidesDesktop.length) {
                        element.parentNode.classList.add(classes$s.desktop)
                    }
                }
            }
            )
        }
        toggleTicker(e, isStopped) {
            const tickerScale = e.target.closest(selectors$C.tickerScale);
            const element = document.querySelector(`[${attributes$o.slide}="${e.detail.blockId}"]`);
            if (isStopped && element) {
                tickerScale.setAttribute(attributes$o.stop, '');
                tickerScale.querySelectorAll(selectors$C.tickerText).forEach( (textHolder) => {
                    textHolder.classList.remove(classes$s.tickerAnimated);
                    textHolder.style.transform = `translate3d(${-(element.offsetLeft - parseInt(getComputedStyle(element).marginLeft, 10))}px, 0, 0)`
                }
                )
            }
            if (!isStopped && element) {
                tickerScale.querySelectorAll(selectors$C.tickerText).forEach( (textHolder) => {
                    textHolder.classList.add(classes$s.tickerAnimated);
                    textHolder.removeAttribute(attributes$o.style)
                }
                );
                tickerScale.removeAttribute(attributes$o.stop);
                if (this.static) {
                    document.dispatchEvent(new CustomEvent('theme:resize:width',{
                        bubbles: !0
                    }))
                }
            }
        }
        tickerAnimationPause() {
            let hoverTimer = 0;
            let isHovered = !1;
            const tickerContainer = this.barHolder.querySelector(selectors$C.announcementSlide);
            tickerContainer.addEventListener('mouseenter', () => {
                isHovered = !0;
                hoverTimer = setTimeout( () => {
                    if (isHovered) {
                        tickerContainer.querySelectorAll(selectors$C.tickerText).forEach( (element) => {
                            element.style.animationPlayState = 'paused'
                        }
                        )
                    }
                    clearTimeout(hoverTimer)
                }
                , 500)
            }
            );
            tickerContainer.addEventListener('mouseleave', () => {
                isHovered = !1;
                tickerContainer.querySelectorAll(selectors$C.tickerText).forEach( (element) => {
                    element.style.animationPlayState = 'running'
                }
                )
            }
            )
        }
        updateSVGClipPathIDs() {
            this.barHolder.querySelectorAll(selectors$C.slide).forEach( (svg, index) => {
                const clipPath = svg.querySelector(tags.clipPath);
                if (clipPath) {
                    const newclipPathId = `${clipPath.id}_${index}`;
                    clipPath.id = newclipPathId;
                    const gTag = svg.querySelector(`g[${attributes$o.clipPath}]`);
                    if (gTag) {
                        gTag.setAttribute(attributes$o.clipPath, `url(#${newclipPathId})`)
                    }
                }
            }
            )
        }
        onBlockSelect(evt) {
            const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
            if (this.slider && this.flkty !== null) {
                this.flkty.select(index);
                this.flkty.pausePlayer()
            }
            if (!this.slider) {
                this.toggleTicker(evt, !0)
            }
            if (this.parallax) {
                this.parallax.style.setProperty('--offsetX', '0%');
                this.parallax.classList.add(classes$s.isDisabled)
            }
        }
        onBlockDeselect(evt) {
            if (this.slider && this.flkty !== null) {
                this.flkty.unpausePlayer()
            }
            if (!this.slider) {
                this.toggleTicker(evt, !1)
            }
            if (this.parallax) {
                this.parallax.classList.remove(classes$s.isDisabled);
                document.dispatchEvent(new CustomEvent('theme:scroll'))
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.initSlider.bind(this));
            if (this.tickers.length > 0) {
                this.tickers.forEach( (ticker) => {
                    ticker.unload()
                }
                )
            }
        }
    }
    const announcement = {
        onLoad() {
            sections$u[this.id] = [];
            const element = this.container.querySelector(selectors$C.announcement);
            if (element) {
                sections$u[this.id].push(new AnnouncementBar(element))
            }
        },
        onBlockSelect(e) {
            if (sections$u[this.id].length) {
                sections$u[this.id].forEach( (el) => {
                    if (typeof el.onBlockSelect === 'function') {
                        el.onBlockSelect(e)
                    }
                }
                )
            }
        },
        onBlockDeselect(e) {
            if (sections$u[this.id].length) {
                sections$u[this.id].forEach( (el) => {
                    if (typeof el.onBlockSelect === 'function') {
                        el.onBlockDeselect(e)
                    }
                }
                )
            }
        },
        onUnload() {
            sections$u[this.id].forEach( (el) => {
                if (typeof el.onUnload === 'function') {
                    el.onUnload()
                }
            }
            )
        },
    };
    register('announcement-bar', announcement);
    register('marquee', [announcement, parallaxSection]);
    const selectors$B = {
        disclosureWrappper: '[data-hover-disclosure]',
        header: '[data-site-header]',
        link: '[data-top-link]',
        headerBackground: '[data-header-background]',
        navItem: '[data-nav-item]',
    };
    const classes$r = {
        isVisible: 'is-visible',
        grandparent: 'grandparent',
        headerMenuOpened: 'site-header--menu-opened',
        hasScrolled: 'has-scrolled',
        headerHovered: 'site-header--hovered',
        searchOpened: 'search-opened',
        megamenuOpened: 'megamenu-opened',
    };
    const attributes$n = {
        disclosureToggle: 'data-hover-disclosure-toggle',
        ariaHasPopup: 'aria-haspopup',
        ariaExpanded: 'aria-expanded',
        ariaControls: 'aria-controls',
    };
    let sections$t = {};
    class HoverDisclosure {
        constructor(el) {
            this.disclosure = el;
            this.body = document.body;
            this.header = el.closest(selectors$B.header);
            this.key = this.disclosure.id;
            this.trigger = document.querySelector(`[${attributes$n.disclosureToggle}='${this.key}']`);
            this.link = this.trigger.querySelector(selectors$B.link);
            this.grandparent = this.trigger.classList.contains(classes$r.grandparent);
            this.background = document.querySelector(selectors$B.headerBackground);
            this.trigger.setAttribute(attributes$n.ariaHasPopup, !0);
            this.trigger.setAttribute(attributes$n.ariaExpanded, !1);
            this.trigger.setAttribute(attributes$n.ariaControls, this.key);
            this.dropdown = this.trigger.querySelector(selectors$B.disclosureWrappper);
            this.setBackgroundHeightEvent = () => this.setBackgroundHeight();
            this.connectHoverToggle();
            this.handleTablets()
        }
        setBackgroundHeight() {
            this.hasScrolled = this.body.classList.contains(classes$r.hasScrolled);
            this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight;
            if (this.grandparent) {
                this.dropdown.style.height = 'auto';
                this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight
            } else {
                this.dropdownHeight = this.headerHeight
            }
            this.background.style.setProperty('--header-background-height', `${this.dropdownHeight - 1}px`);
            if (window.innerWidth < theme.sizes.small) {
                this.hideDisclosure()
            }
        }
        showDisclosure() {
            this.setBackgroundHeight();
            document.addEventListener('theme:resize', this.setBackgroundHeightEvent);
            this.trigger.setAttribute(attributes$n.ariaExpanded, !0);
            this.trigger.classList.add(classes$r.isVisible);
            this.header.classList.add(classes$r.headerMenuOpened);
            if (this.trigger.classList.contains(classes$r.grandparent)) {
                this.body.classList.add(classes$r.megamenuOpened);
                document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                    bubbles: !0,
                    detail: this.header
                }))
            }
            this.updateHeaderHover()
        }
        hideDisclosure() {
            this.background.style.removeProperty('--header-background-height');
            document.removeEventListener('theme:resize', this.setBackgroundHeightEvent);
            this.trigger.classList.remove(classes$r.isVisible);
            this.trigger.setAttribute(attributes$n.ariaExpanded, !1);
            this.header.classList.remove(classes$r.headerMenuOpened);
            this.body.classList.remove(classes$r.megamenuOpened);
            if (!this.body.classList.contains(classes$r.searchOpened)) {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                    bubbles: !0
                }))
            }
        }
        updateHeaderHover() {
            requestAnimationFrame( () => {
                const isHovered = this.header.matches(':hover');
                const hasHoveredClass = this.header.classList.contains(classes$r.headerHovered);
                if (isHovered && !hasHoveredClass)
                    this.header.classList.add(classes$r.headerHovered);
            }
            )
        }
        handleTablets() {
            this.trigger.addEventListener('touchstart', (e) => {
                const isOpen = this.trigger.classList.contains(classes$r.isVisible);
                if (!isOpen) {
                    e.preventDefault();
                    const activeNavItems = this.header.querySelectorAll(`.${classes$r.isVisible}${selectors$B.navItem}`);
                    if (activeNavItems.length > 0) {
                        activeNavItems.forEach( (item) => {
                            if (item !== this.trigger) {
                                item.dispatchEvent(new Event('mouseleave',{
                                    bubbles: !0
                                }));
                                const onTransitionEnd = () => {
                                    requestAnimationFrame( () => {
                                        this.showDisclosure()
                                    }
                                    );
                                    item.removeEventListener('transitionend', onTransitionEnd)
                                }
                                ;
                                item.addEventListener('transitionend', onTransitionEnd)
                            }
                        }
                        );
                        return
                    }
                    this.showDisclosure()
                }
            }
            )
        }
        connectHoverToggle() {
            this.trigger.addEventListener('mouseenter', () => this.showDisclosure());
            this.link.addEventListener('focus', () => this.showDisclosure());
            this.trigger.addEventListener('mouseleave', () => this.hideDisclosure());
            this.trigger.addEventListener('focusout', (event) => {
                const inMenu = this.trigger.contains(event.relatedTarget);
                if (!inMenu) {
                    this.hideDisclosure()
                }
            }
            );
            this.disclosure.addEventListener('keyup', (event) => {
                if (event.code !== theme.keyboardKeys.ESCAPE) {
                    return
                }
                this.hideDisclosure()
            }
            )
        }
        onBlockSelect(event) {
            if (this.disclosure.contains(event.target)) {
                this.showDisclosure(event)
            }
        }
        onBlockDeselect(event) {
            if (this.disclosure.contains(event.target)) {
                this.hideDisclosure()
            }
        }
    }
    const hoverDisclosure = {
        onLoad() {
            sections$t[this.id] = [];
            const disclosures = this.container.querySelectorAll(selectors$B.disclosureWrappper);
            disclosures.forEach( (el) => {
                sections$t[this.id].push(new HoverDisclosure(el))
            }
            )
        },
        onBlockSelect(evt) {
            sections$t[this.id].forEach( (el) => {
                if (typeof el.onBlockSelect === 'function') {
                    el.onBlockSelect(evt)
                }
            }
            )
        },
        onBlockDeselect(evt) {
            sections$t[this.id].forEach( (el) => {
                if (typeof el.onBlockDeselect === 'function') {
                    el.onBlockDeselect(evt)
                }
            }
            )
        },
    };
    const selectors$A = {
        header: '[data-site-header]',
        announcementBar: '[data-announcement-wrapper]',
        collectionFilters: '[data-collection-filters-sticky]',
        logoTextLink: '[data-logo-text-link]',
        mobileNavDropdownTrigger: '[data-collapsible-trigger]',
        navDrawer: '#nav-drawer',
        drawer: '[data-drawer]',
        drawerToggle: '[data-drawer-toggle]',
        popdownToggle: '[data-popdown-toggle]',
        mobileMenu: '[data-mobile-menu]',
        nav: '[data-nav]',
        navIcons: '[data-nav-icons]',
        navItem: '[data-nav-item]',
        navLinkMobile: '[data-nav-link-mobile]',
        navSearchOpen: '[data-nav-search-open]',
        wrapper: '[data-wrapper]',
        headerBackground: '[data-header-background]',
        cartPage: '[data-cart-page]',
        widthContent: '[data-takes-space]',
    };
    const classes$q = {
        jsDrawerOpenAll: ['js-drawer-open', 'js-drawer-open-cart', 'js-quick-view-visible', 'js-quick-view-from-cart'],
        headerTransparent: 'site-header--transparent',
        headerHovered: 'site-header--hovered',
        headerMenuOpened: 'site-header--menu-opened',
        hasScrolled: 'has-scrolled',
        hasStickyHeader: 'has-sticky-header',
        hideHeader: 'hide-header',
        headerCompress: 'site-header--compress',
        isVisible: 'is-visible',
        isOpen: 'is-open',
        searchOpened: 'search-opened',
        noOutline: 'no-outline',
        cloneClass: 'js__header__clone',
    };
    const attributes$m = {
        navAlignment: 'data-nav-alignment',
        headerSticky: 'data-header-sticky',
    };
    const sections$s = {};
    class Header {
        constructor(container) {
            this.container = container;
            this.background = document.querySelector(selectors$A.headerBackground);
            this.header = container;
            this.headerSection = container.parentNode;
            this.headerWrapper = container.querySelector(selectors$A.wrapper);
            this.logoTextLink = container.querySelector(selectors$A.logoTextLink);
            this.nav = container.querySelector(selectors$A.nav);
            this.navIcons = container.querySelector(selectors$A.navIcons);
            this.headerStateEvent = (event) => this.headerState(event);
            this.handleTouchstartEvent = (event) => this.handleTouchstart(event);
            this.updateBackgroundHeightEvent = (event) => this.updateBackgroundHeight(event);
            initTransparentHeader();
            this.minWidth = this.getMinWidth();
            this.checkWidthEvent = () => this.checkWidth();
            this.listenWidth();
            this.initMobileNav();
            this.handleTextLinkLogos();
            this.initStickyHeader();
            this.handleBackgroundEvents();
            if (!document.querySelector(selectors$A.cartPage)) {
                window.cart = new CartDrawer()
            }
            document.body.addEventListener('touchstart', this.handleTouchstartEvent, {
                passive: !0
            });
            this.updateHeaderHover()
        }
        updateHeaderHover() {
            requestAnimationFrame( () => {
                const isHovered = this.header.matches(':hover');
                const hasHoveredClass = this.header.classList.contains(classes$q.headerHovered);
                if (isHovered && !hasHoveredClass)
                    this.header.classList.add(classes$q.headerHovered);
            }
            )
        }
        handleTouchstart(event) {
            const isInHeader = this.header.contains(event.target);
            const activeNavItem = this.header.querySelector(`.${classes$q.isVisible}${selectors$A.navItem}`);
            if (!isInHeader && activeNavItem) {
                activeNavItem.dispatchEvent(new Event('mouseleave',{
                    bubbles: !0
                }))
            }
        }
        handleTextLinkLogos() {
            if (this.logoTextLink === null)
                return;
            const headerHeight = this.header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
            document.documentElement.style.setProperty('--header-sticky-height', `${headerHeight}px`)
        }
        initStickyHeader() {
            this.headerSticky = this.header.hasAttribute(attributes$m.headerSticky);
            if (!CSS.supports('(selector(:has(*)))')) {
                document.body.classList.toggle(classes$q.hasStickyHeader, this.headerSticky)
            }
            this.hasScrolled = !1;
            this.hasCollectionFilters = document.querySelector(selectors$A.collectionFilters);
            this.position = this.header.dataset.position;
            const shouldShowCompactHeader = this.position === 'fixed' && !this.hasCollectionFilters;
            if (shouldShowCompactHeader) {
                this.headerState();
                document.addEventListener('theme:scroll', this.headerStateEvent);
                return
            }
            document.body.classList.remove(classes$q.hasScrolled);
            if (window.isHeaderTransparent) {
                this.header.classList.add(classes$q.headerTransparent)
            }
        }
        headerState(event) {
            const headerHeight = parseInt(this.header.dataset.height || this.header.offsetHeight);
            const announcementBar = document.querySelector(selectors$A.announcementBar);
            const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
            const pageOffset = headerHeight + announcementHeight;
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollUp = event && event.detail && event.detail.up;
            this.hasScrolled = currentScrollTop > pageOffset;
            document.body.classList.toggle(classes$q.hasScrolled, this.hasScrolled);
            const hideHeaderThreshold = pageOffset + window.stickyHeaderHeight;
            const bellowThreshold = currentScrollTop < hideHeaderThreshold;
            const shouldHideHeader = bellowThreshold && scrollUp;
            document.body.classList.toggle(classes$q.hideHeader, shouldHideHeader);
            if (window.isHeaderTransparent) {
                const shouldShowTransparentHeader = !this.hasScrolled || shouldHideHeader;
                this.header.classList.toggle(classes$q.headerTransparent, shouldShowTransparentHeader)
            }
            if (this.header.classList.contains(classes$q.headerHovered)) {
                const currentHeight = this.hasScrolled ? window.stickyHeaderHeight : headerHeight;
                this.background.style.setProperty('--header-background-height', `${currentHeight - 1}px`);
                const activeNavItem = this.header.querySelector(`.${classes$q.isVisible}${selectors$A.navItem}`);
                if (activeNavItem) {
                    activeNavItem.dispatchEvent(new Event('mouseenter',{
                        bubbles: !0
                    }))
                }
            }
        }
        handleBackgroundEvents() {
            this.headerWrapper.addEventListener('mouseenter', this.updateBackgroundHeightEvent);
            this.headerWrapper.addEventListener('mouseleave', this.updateBackgroundHeightEvent);
            this.header.addEventListener('focusout', this.updateBackgroundHeightEvent);
            document.addEventListener('theme:cart:close', this.updateBackgroundHeightEvent);
            document.addEventListener('theme:search:close', this.updateBackgroundHeightEvent)
        }
        updateBackgroundHeight(event) {
            const isDesktop = matchMedia('(pointer:fine)').matches;
            const isFocusEnabled = !document.body.classList.contains(classes$q.noOutline);
            const isNotTabbingOnDesktop = isDesktop && !isFocusEnabled;
            if (!event)
                return;
            let drawersVisible = classes$q.jsDrawerOpenAll.some( (popupClass) => document.body.classList.contains(popupClass));
            if (event.type === 'mouseenter' || drawersVisible) {
                this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight;
                this.header.classList.add(classes$q.headerHovered);
                if (!this.header.classList.contains(classes$q.headerMenuOpened)) {
                    this.background.style.setProperty('--header-background-height', `${this.headerHeight - 1}px`)
                }
            }
            if (event.type === 'mouseenter')
                return;
            requestAnimationFrame( () => {
                drawersVisible = classes$q.jsDrawerOpenAll.some( (popupClass) => document.body.classList.contains(popupClass));
                if (drawersVisible)
                    return;
                if (event.type === 'focusout' && !isDesktop)
                    return;
                if (event.type === 'theme:search:close' && !isNotTabbingOnDesktop)
                    return;
                if (this.hasScrolled)
                    return;
                const focusOutOfHeader = document.activeElement.closest(selectors$A.header) === null;
                const isSearchOpened = document.body.classList.contains(classes$q.searchOpened);
                const headerMenuOpened = this.header.classList.contains(classes$q.headerMenuOpened);
                if (isSearchOpened || headerMenuOpened)
                    return;
                if (event.type === 'focusout') {
                    if (!focusOutOfHeader)
                        return
                }
                this.header.classList.remove(classes$q.headerHovered);
                this.background.style.setProperty('--header-background-height', '0px');
                if (!isFocusEnabled) {
                    document.activeElement.blur()
                }
            }
            )
        }
        listenWidth() {
            document.addEventListener('theme:resize', this.checkWidthEvent);
            this.checkWidth()
        }
        checkWidth() {
            if (window.innerWidth < this.minWidth) {
                this.header.classList.add(classes$q.headerCompress)
            } else {
                this.header.classList.remove(classes$q.headerCompress)
            }
        }
        getMinWidth() {
            const headerWrapperStyles = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper);
            const headerPaddings = parseInt(headerWrapperStyles.paddingLeft) * 2;
            const comparitor = this.header.cloneNode(!0);
            comparitor.classList.add(classes$q.cloneClass);
            document.body.appendChild(comparitor);
            const wideElements = comparitor.querySelectorAll(selectors$A.widthContent);
            const navAlignment = this.header.getAttribute(attributes$m.navAlignment);
            const minWidth = _sumSplitWidths(wideElements, navAlignment);
            document.body.removeChild(comparitor);
            return minWidth + wideElements.length * 20 + headerPaddings
        }
        initMobileNav() {
            this.mobileMenu = this.headerSection.querySelector(selectors$A.mobileMenu);
            this.navDrawer = this.headerSection.querySelector(selectors$A.navDrawer);
            this.drawerToggle = this.navDrawer.querySelector(selectors$A.drawerToggle);
            this.navSearchOpen = this.navDrawer.querySelectorAll(selectors$A.navSearchOpen);
            this.navSearchOpen?.forEach( (element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    const drawer = this.drawerToggle.closest(`${selectors$A.drawer}.${classes$q.isOpen}`);
                    const isMobile = matchMedia('(pointer:coarse)').matches;
                    const popdownToggle = isMobile ? this.mobileMenu.querySelector(selectors$A.popdownToggle) : this.nav.querySelector(selectors$A.popdownToggle);
                    this.drawerToggle.dispatchEvent(new Event('click',{
                        bubbles: !0
                    }));
                    const onDrawerTransitionEnd = (e) => {
                        if (e.target !== drawer)
                            return;
                        requestAnimationFrame( () => popdownToggle.dispatchEvent(new Event('click',{
                            bubbles: !0
                        })));
                        drawer.removeEventListener('transitionend', onDrawerTransitionEnd)
                    }
                    ;
                    drawer.addEventListener('transitionend', onDrawerTransitionEnd)
                }
                )
            }
            );
            if (theme.settings.mobileMenuBehaviour === 'link') {
                return
            }
            const navMobileLinks = this.headerSection.querySelectorAll(selectors$A.navLinkMobile);
            if (navMobileLinks.length) {
                navMobileLinks.forEach( (link) => {
                    link.addEventListener('click', (e) => {
                        const hasDropdown = link.parentNode.querySelectorAll(selectors$A.mobileNavDropdownTrigger).length;
                        const dropdownTrigger = link.nextElementSibling;
                        if (hasDropdown) {
                            e.preventDefault();
                            dropdownTrigger.dispatchEvent(new Event('click'), {
                                bubbles: !0
                            })
                        }
                    }
                    )
                }
                )
            }
        }
        onUnload() {
            document.documentElement.style.removeProperty('--header-height');
            document.documentElement.style.removeProperty('--header-sticky-height');
            this.initStickyHeader();
            document.body.classList.remove(...classes$q.jsDrawerOpenAll);
            document.removeEventListener('theme:scroll', this.headerStateEvent);
            document.removeEventListener('theme:resize', this.checkWidthEvent);
            document.removeEventListener('theme:cart:close', this.updateBackgroundHeightEvent);
            document.removeEventListener('theme:search:close', this.updateBackgroundHeightEvent);
            document.body.removeEventListener('touchstart', this.handleTouchstartEvent);
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                bubbles: !0
            }));
            if (typeof window.cart.unload === 'function') {
                window.cart.unload()
            }
        }
    }
    function _sumSplitWidths(nodes, alignment) {
        let arr = [];
        nodes.forEach( (el) => {
            arr.push(el.clientWidth)
        }
        );
        let[logoWidth,navWidth,iconsWidth] = arr;
        if (alignment === 'left') {
            const tempWidth = logoWidth;
            logoWidth = navWidth;
            navWidth = tempWidth
        }
        if (alignment !== 'right') {
            if (logoWidth > iconsWidth) {
                iconsWidth = logoWidth
            } else {
                logoWidth = iconsWidth
            }
        }
        return logoWidth + navWidth + iconsWidth
    }
    const headerSection = {
        onLoad() {
            sections$s[this.id] = new Header(this.container)
        },
        onUnload() {
            sections$s[this.id].onUnload()
        },
    };
    register('header', [headerSection, hoverDisclosure, drawer]);
    const selectors$z = {
        trigger: '[data-collapsible-trigger]',
    };
    const classes$p = {
        isExpanded: 'is-expanded',
    };
    const accordionSection = {
        onBlockSelect(e) {
            const trigger = e.target.querySelector(selectors$z.trigger);
            requestAnimationFrame( () => {
                if (!trigger.classList.contains(classes$p.isExpanded)) {
                    trigger.dispatchEvent(new Event('click'))
                }
            }
            )
        },
    };
    register('accordions', [accordionSection, collapsible]);
    const selectors$y = {
        button: '[data-share-button]',
        tooltip: '[data-share-button-tooltip]',
    };
    const classes$o = {
        visible: 'is-visible',
        hiding: 'is-hiding',
    };
    const sections$r = {};
    class ShareButton {
        constructor(container) {
            this.container = container;
            this.button = this.container.querySelector(selectors$y.button);
            this.tooltip = this.container.querySelector(selectors$y.tooltip);
            this.transitionSpeed = 200;
            this.hideTransitionTimeout = 0;
            this.init()
        }
        init() {
            if (this.button) {
                this.button.addEventListener('click', () => {
                    let targetUrl = window.location.href;
                    if (this.button.dataset.shareLink) {
                        targetUrl = this.button.dataset.shareLink
                    }
                    if (!this.tooltip.classList.contains(classes$o.visible)) {
                        navigator.clipboard.writeText(targetUrl).then( () => {
                            this.tooltip.classList.add(classes$o.visible);
                            setTimeout( () => {
                                this.tooltip.classList.add(classes$o.hiding);
                                this.tooltip.classList.remove(classes$o.visible);
                                if (this.hideTransitionTimeout) {
                                    clearTimeout(this.hideTransitionTimeout)
                                }
                                this.hideTransitionTimeout = setTimeout( () => {
                                    this.tooltip.classList.remove(classes$o.hiding)
                                }
                                , this.transitionSpeed)
                            }
                            , 1500)
                        }
                        )
                    }
                }
                )
            }
        }
    }
    const shareButton = {
        onLoad() {
            sections$r[this.id] = new ShareButton(this.container)
        },
    };
    register('article', [shareButton]);
    const selectors$x = {
        videoPlay: '[data-video-play]',
    };
    const attributes$l = {
        videoPlayValue: 'data-video-play',
    };
    class VideoPlay {
        constructor(container) {
            this.container = container;
            this.videoPlay = this.container.querySelectorAll(selectors$x.videoPlay);
            this.a11y = a11y;
            this.init()
        }
        init() {
            if (this.videoPlay.length) {
                this.videoPlay.forEach( (element) => {
                    element.addEventListener('click', (e) => {
                        if (element.hasAttribute(attributes$l.videoPlayValue) && element.getAttribute(attributes$l.videoPlayValue).trim() !== '') {
                            e.preventDefault();
                            const items = [{
                                html: element.getAttribute(attributes$l.videoPlayValue),
                            }, ];
                            const options = {
                                mainClass: 'pswp--video',
                            };
                            this.a11y.state.trigger = element;
                            new LoadPhotoswipe(items,options)
                        }
                    }
                    )
                }
                )
            }
        }
    }
    const videoPlay = {
        onLoad() {
            new VideoPlay(this.container)
        },
    };
    const selectors$w = {
        header: '[data-site-header]',
        main: '[data-main]',
    };
    let sections$q = {};
    class ZoomAnimation {
        constructor(container) {
            this.container = container;
            this.header = document.querySelector(selectors$w.header);
            this.init()
        }
        init() {
            if (this.container.dataset.zoomAnimation !== 'true') {
                return
            }
            const observedElement = this.container;
            const firstSection = document.body.querySelector(selectors$w.main).children[0];
            const isFirstSection = this.container.parentNode === firstSection;
            const hasTransparentHeader = this.header?.dataset.transparent == 'true';
            const renderZoomEffect = () => {
                const headerHeight = isFirstSection & hasTransparentHeader ? 0 : parseInt(this.header?.dataset.height || this.header?.offsetHeight);
                const rect = observedElement.getBoundingClientRect();
                const sectionHeight = observedElement.offsetHeight;
                const scrolled = isFirstSection ? headerHeight - rect.top : headerHeight - rect.top + window.innerHeight;
                const scrolledPercentage = scrolled / sectionHeight;
                let transitionSpeed = 0.1;
                if (isFirstSection) {
                    transitionSpeed *= 1.5
                }
                let scale = 1 + scrolledPercentage * transitionSpeed;
                scale = scale > 1 ? scale : 1;
                observedElement.style.setProperty('--scale', scale)
            }
            ;
            renderZoomEffect();
            this.zoomOnScrollEvent = throttle(renderZoomEffect, 5);
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0,
            };
            const intersectionCallback = (entry) => {
                if (entry[0].isIntersecting) {
                    window.addEventListener('scroll', this.zoomOnScrollEvent)
                } else {
                    window.removeEventListener('scroll', this.zoomOnScrollEvent)
                }
            }
            ;
            const observer = new IntersectionObserver(intersectionCallback,observerOptions);
            observer.observe(observedElement)
        }
        onUnload() {
            if (this.zoomOnScrollEvent !== null) {
                window.removeEventListener('scroll', this.zoomOnScrollEvent)
            }
        }
    }
    const zoomAnimation = {
        onLoad() {
            sections$q[this.id] = new ZoomAnimation(this.container)
        },
        onUnload() {
            sections$q[this.id].onUnload()
        },
    };
    const selectors$v = {
        imageWrapper: '[data-banner-image]',
        lazyImage: '.lazy-image',
    };
    const classes$n = {
        bannerNoCachedImages: 'banner--no-cached-images',
        bannerImgLoaded: 'banner--img-loaded',
        imgIn: 'img-in',
    };
    const sections$p = {};
    class BannerImage {
        constructor(section) {
            this.container = section.container;
            this.init()
        }
        init() {
            this.handleImageAnimation(!0)
        }
        handleImageAnimation(onLoad=!1) {
            if (!onLoad) {
                this.container.classList.remove(classes$n.bannerNoCachedImages);
                this.container.classList.remove(classes$n.bannerImgLoaded);
                return
            }
            const imageWrapper = this.container.querySelector(selectors$v.imageWrapper);
            const img = imageWrapper.querySelectorAll(selectors$v.lazyImage);
            const imgComplete = this.container.classList.contains(classes$n.imgIn);
            if (img.length && !imgComplete) {
                this.container.classList.add(classes$n.bannerNoCachedImages);
                const onImageTransitionEnd = (event) => {
                    requestAnimationFrame( () => this.container.classList.add(classes$n.bannerImgLoaded));
                    img[0].removeEventListener('transitionend', onImageTransitionEnd)
                }
                ;
                img[0].addEventListener('transitionend', onImageTransitionEnd)
            }
        }
        onReorder() {
            this.handleImageAnimation(!1)
        }
        onUnload() {
            this.handleImageAnimation(!1)
        }
    }
    const bannerImage = {
        onLoad() {
            sections$p[this.id] = new BannerImage(this)
        },
        onReorder(e) {
            sections$p[this.id].onReorder(e)
        },
        onUnload(e) {
            sections$p[this.id].onUnload(e)
        },
    };
    register('banner-image', [bannerImage, zoomAnimation, videoPlay]);
    const selectors$u = {
        scrollSpy: '[data-scroll-spy]',
    };
    const classes$m = {
        selected: 'is-selected',
        isFullHeight: 'is-full-height',
    };
    const attributes$k = {
        scrollSpy: 'data-scroll-spy',
        scrollSpyPrevent: 'data-scroll-spy-prevent',
        mobile: 'data-scroll-spy-mobile',
        desktop: 'data-scroll-spy-desktop',
    };
    const sections$o = {};
    class ScrollSpy {
        constructor(section, element) {
            this.container = section;
            this.element = element;
            if (!this.element)
                return;
            this.anchorSelector = `[${attributes$k.scrollSpy}="#${this.element.id}"]`;
            this.anchor = this.container.querySelector(this.anchorSelector);
            this.anchors = this.container.querySelectorAll(`[${attributes$k.scrollSpy}]`);
            if (!this.anchor)
                return;
            this.scrollCallback = () => this.onScroll();
            this.init()
        }
        init() {
            this.onScroll();
            document.addEventListener('theme:scroll', this.scrollCallback);
            document.addEventListener('theme:resize:width', this.scrollCallback)
        }
        isEligible() {
            if (this.container.hasAttribute(attributes$k.scrollSpyPrevent))
                return !1;
            return ((isMobile() && this.anchor.hasAttribute(attributes$k.mobile)) || (isDesktop() && this.anchor.hasAttribute(attributes$k.desktop)) || (!this.anchor.hasAttribute(attributes$k.desktop) && !this.anchor.hasAttribute(attributes$k.mobile)))
        }
        onScroll() {
            if (!this.isEligible())
                return;
            this.top = this.element.getBoundingClientRect().top;
            this.bottom = this.element.getBoundingClientRect().bottom;
            const windowHeight = Math.round(window.innerHeight);
            const scrollTop = Math.round(window.scrollY);
            const scrollBottom = scrollTop + windowHeight;
            const elementOffsetTopPoint = Math.round(this.top + scrollTop);
            const elementHeight = this.element.offsetHeight;
            const elementOffsetBottomPoint = elementOffsetTopPoint + elementHeight;
            const isBottomOfElementPassed = elementOffsetBottomPoint < scrollTop;
            const isTopOfElementReached = elementOffsetTopPoint < scrollBottom;
            const isInView = isTopOfElementReached && !isBottomOfElementPassed;
            if (!isInView)
                return;
            if (this.anchor.parentNode.offsetHeight <= elementHeight) {
                this.container.style.setProperty('--sticky-position', `${window.innerHeight / 2 - elementHeight / 2}px`)
            } else {
                this.container.classList.add(classes$m.isFullHeight)
            }
            this.anchorTop = this.anchor.getBoundingClientRect().top;
            this.anchorBottom = this.anchor.getBoundingClientRect().bottom;
            const anchorTopPassedElementTop = this.top < this.anchorTop;
            const anchorBottomPassedElementBottom = this.bottom < this.anchorBottom;
            const shouldBeActive = anchorTopPassedElementTop && !anchorBottomPassedElementBottom;
            if (!shouldBeActive)
                return;
            this.anchors.forEach( (anchor) => {
                if (!anchor.matches(this.anchorSelector)) {
                    anchor.classList.remove(classes$m.selected)
                }
            }
            );
            this.anchor.classList.add(classes$m.selected)
        }
        onUnload() {
            document.removeEventListener('theme:scroll', this.scrollCallback);
            document.removeEventListener('theme:resize:width', this.scrollCallback)
        }
    }
    const scrollSpy = {
        onLoad() {
            sections$o[this.id] = [];
            const elements = this.container.querySelectorAll(selectors$u.scrollSpy);
            elements.forEach( (element) => {
                const scrollSpy = this.container.querySelector(element.getAttribute(attributes$k.scrollSpy));
                sections$o[this.id].push(new ScrollSpy(this.container,scrollSpy))
            }
            )
        },
        onUnload() {
            sections$o[this.id].forEach( (element) => {
                if (typeof element.onUnload === 'function') {
                    element.onUnload()
                }
            }
            )
        },
    };
    const selectors$t = {
        banner: '[data-banner]',
        sliderContent: '[data-slider-content]',
        sliderMedia: '[data-slider-media]',
        links: 'a, button',
    };
    const attributes$j = {
        index: 'data-index',
        tabIndex: 'tabindex',
        singleImage: 'data-slider-single-image',
        scrollSpyPrevent: 'data-scroll-spy-prevent',
    };
    const classes$l = {
        isSelected: 'is-selected',
    };
    const settings$2 = {
        row: 'row',
        columns: 'columns',
    };
    let sections$n = {};
    class BannerWithTextColumns {
        constructor(section) {
            this.container = section.container;
            this.sliderContent = this.container.querySelector(selectors$t.sliderContent);
            this.singleImageEnabled = this.sliderContent?.hasAttribute(attributes$j.singleImage);
            this.banners = this.container.querySelectorAll(selectors$t.banner);
            this.links = this.container.querySelectorAll('a');
            this.sliderMedia = this.container.querySelector(selectors$t.sliderMedia);
            this.flktyContent = null;
            this.flktyMedia = null;
            this.onResizeCallback = () => this.handleSlidersOnResize();
            this.appearance = this.container.dataset.appearance;
            if (this.appearance === settings$2.columns) {
                this.handleColumnsLayout()
            } else {
                this.handleRowLayout()
            }
        }
        listen() {
            document.addEventListener('theme:resize:width', this.onResizeCallback);
            this.links.forEach( (link) => {
                link.addEventListener('focus', () => {
                    const selectedIndex = Number(link.closest(selectors$t.banner).getAttribute(attributes$j.index));
                    if (window.innerWidth >= theme.sizes.small) {
                        this.sync(selectedIndex)
                    }
                }
                )
            }
            );
            this.banners.forEach( (slide) => {
                slide.addEventListener('mouseenter', () => {
                    const selectedIndex = Number(slide.getAttribute(attributes$j.index));
                    if (window.innerWidth >= theme.sizes.small && !window.theme.touch) {
                        this.sync(selectedIndex)
                    }
                }
                );
                slide.addEventListener('pointerup', () => {
                    const selectedIndex = Number(slide.getAttribute(attributes$j.index));
                    if (window.innerWidth >= theme.sizes.small && window.theme.touch) {
                        this.sync(selectedIndex)
                    }
                }
                )
            }
            )
        }
        handleColumnsLayout() {
            if (this.sliderContent.children.length <= 1)
                return;
            let isDraggable = window.innerWidth < window.theme.sizes.small;
            if (this.sliderMedia.children.length > 1) {
                this.flktyMedia = new Flickity(this.sliderMedia,{
                    draggable: !1,
                    wrapAround: !1,
                    fade: !0,
                    prevNextButtons: !1,
                    adaptiveHeight: !1,
                    pageDots: !1,
                    setGallerySize: !1,
                    on: {
                        change: (index) => {
                            this.handleGroupItemsNavigation(index, this.flktyContent)
                        }
                        ,
                    },
                });
                flickitySmoothScrolling(this.sliderMedia)
            }
            this.flktyContent = new Flickity(this.sliderContent,{
                draggable: isDraggable,
                prevNextButtons: !1,
                pageDots: !0,
                cellAlign: 'left',
                adaptiveHeight: !1,
                imagesLoaded: !0,
                on: {
                    ready: () => {
                        this.listen();
                        this.slidesTabIndex()
                    }
                    ,
                    change: (index) => {
                        if (window.innerWidth < theme.sizes.small && !this.singleImageEnabled) {
                            this.flktyMedia.select(index)
                        }
                        this.slidesTabIndex();
                        this.handleGroupItemsNavigation(index, this.flktyMedia)
                    }
                    ,
                },
            });
            flickitySmoothScrolling(this.sliderContent)
        }
        handleRowLayout() {
            const isSingleMedia = this.sliderMedia.children.length <= 1;
            if (isSingleMedia || isMobile()) {
                this.updateState(0);
                this.listen();
                return
            }
            this.initMediaSlider()
        }
        initMediaSlider() {
            this.flktyMedia = new Flickity(this.sliderMedia,{
                draggable: !0,
                wrapAround: !1,
                fade: !0,
                prevNextButtons: !1,
                adaptiveHeight: !1,
                pageDots: !1,
                setGallerySize: !1,
                on: {
                    ready: () => {
                        this.updateState(0);
                        this.listen()
                    }
                    ,
                    change: (index) => {
                        this.updateState(index)
                    }
                    ,
                },
            });
            flickitySmoothScrolling(this.sliderMedia)
        }
        handleGroupItemsNavigation(index, sliderToSync=null) {
            if (sliderToSync === null)
                return;
            requestAnimationFrame( () => {
                if (index !== sliderToSync.selectedIndex) {
                    sliderToSync.select(index)
                }
            }
            )
        }
        slidesTabIndex() {
            if (!this.sliderContent)
                return;
            const slider = Flickity.data(this.sliderContent);
            slider.cells.forEach( (slide) => {
                let tabIndex = '-1';
                if (slide.element.classList.contains(classes$l.isSelected)) {
                    tabIndex = '0'
                }
                slide.element.querySelectorAll(selectors$t.links).forEach( (link) => {
                    link.setAttribute(attributes$j.tabIndex, tabIndex)
                }
                )
            }
            )
        }
        sync(index=0) {
            if (this.appearance === settings$2.columns) {
                this.flktyContent.selectCell(index)
            } else {
                this.updateState(index)
            }
            if (this.flktyMedia) {
                this.flktyMedia.selectCell(index)
            }
        }
        updateState(index=0) {
            this.banners.forEach( (element) => {
                const elementIndex = Number(element.getAttribute(attributes$j.index));
                element.classList.toggle(classes$l.isSelected, elementIndex === index)
            }
            )
        }
        handleSlidersOnResize() {
            const isLayoutRow = this.appearance === settings$2.row;
            if (isLayoutRow) {
                if (isMobile() && this.flktyMedia) {
                    this.flktyMedia.destroy();
                    this.flktyMedia = null;
                    return
                }
                if (isDesktop() && !this.flktyMedia) {
                    this.initMediaSlider();
                    return
                }
            }
            if (this.flktyContent) {
                this.flktyContent.resize();
                this.toggleDraggable()
            }
            if (this.flktyMedia) {
                this.flktyMedia.resize()
            }
        }
        toggleDraggable() {
            this.flktyContent.options.draggable = window.innerWidth < window.theme.sizes.small;
            this.flktyContent.updateDraggable()
        }
        onBlockSelect(event) {
            const selectedIndex = parseInt([...event.target.parentNode.children].indexOf(event.target));
            this.sync(selectedIndex);
            if (this.appearance === settings$2.row) {
                const target = this.sliderMedia.children[selectedIndex];
                const targetOffsetTop = Math.round(target.getBoundingClientRect().top);
                this.container.setAttribute(attributes$j.scrollSpyPrevent, '');
                setTimeout( () => scrollTo(targetOffsetTop), 400);
                setTimeout( () => this.container.removeAttribute(attributes$j.scrollSpyPrevent), 1000)
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.onResizeCallback)
        }
    }
    const BannerWithTextColumnsSection = {
        onLoad() {
            sections$n[this.id] = new BannerWithTextColumns(this)
        },
        onBlockSelect(event) {
            sections$n[this.id].onBlockSelect(event)
        },
    };
    register('banner-with-text-columns', [BannerWithTextColumnsSection, scrollSpy]);
    register('blog-posts', ajaxify);
    const selectors$s = {
        slider: '[data-slider]',
        sliderItem: '[data-slider-item]',
        sliderItemImage: '[data-media-container]',
        links: 'a, button',
        flickityButton: '.flickity-button',
    };
    const classes$k = {
        carouselInactive: 'carousel--inactive',
        carouselResize: 'carousel--resize',
    };
    const attributes$i = {
        tabIndex: 'tabindex',
    };
    const sections$m = {};
    class ColumnsWithImage {
        constructor(section) {
            this.container = section.container;
            this.slider = this.container.querySelector(selectors$s.slider);
            this.flkty = null;
            this.gutter = 0;
            this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
            this.listen()
        }
        initSlider() {
            this.slider.classList.remove(classes$k.carouselInactive);
            this.flkty = new Flickity(this.slider,{
                pageDots: !1,
                cellAlign: 'left',
                groupCells: !0,
                contain: !0,
                on: {
                    ready: () => {
                        this.setSliderArrowsPosition(this.slider);
                        setTimeout( () => {
                            this.changeTabIndex();
                            this.flkty.resize()
                        }
                        , 0)
                    }
                    ,
                    change: () => {
                        this.changeTabIndex()
                    }
                    ,
                },
            });
            Flickity.prototype._createResizeClass = function() {
                this.element.classList.add(classes$k.carouselResize)
            }
            ;
            Flickity.createMethods.push('_createResizeClass');
            const resize = Flickity.prototype.resize;
            Flickity.prototype.resize = function() {
                this.element.classList.remove(classes$k.carouselResize);
                resize.call(this);
                this.element.classList.add(classes$k.carouselResize)
            }
        }
        destroySlider() {
            this.slider.classList.add(classes$k.carouselInactive);
            if (this.flkty !== null) {
                this.flkty.destroy();
                this.flkty = null
            }
        }
        checkSlidesSize() {
            const sliderItemStyle = this.container.querySelector(selectors$s.sliderItem).currentStyle || window.getComputedStyle(this.container.querySelector(selectors$s.sliderItem));
            this.gutter = parseInt(sliderItemStyle.marginRight);
            const containerWidth = this.slider.offsetWidth;
            const itemsWidth = this.getItemsWidth();
            const itemsOverflowViewport = containerWidth < itemsWidth;
            if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
                this.initSlider()
            } else {
                this.destroySlider()
            }
        }
        changeTabIndex() {
            const selectedElementsIndex = this.flkty.selectedIndex;
            this.flkty.slides.forEach( (slide, index) => {
                slide.cells.forEach( (cell) => {
                    cell.element.querySelectorAll(selectors$s.links).forEach( (link) => {
                        link.setAttribute(attributes$i.tabIndex, selectedElementsIndex === index ? '0' : '-1')
                    }
                    )
                }
                )
            }
            )
        }
        getItemsWidth() {
            let itemsWidth = 0;
            const slides = this.slider.querySelectorAll(selectors$s.sliderItem);
            if (slides.length) {
                slides.forEach( (item) => {
                    itemsWidth += item.offsetWidth + this.gutter
                }
                )
            }
            return itemsWidth
        }
        listen() {
            if (this.slider) {
                this.checkSlidesSize();
                document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize)
            }
        }
        setSliderArrowsPosition(slider) {
            const arrows = slider.querySelectorAll(selectors$s.flickityButton);
            const image = slider.querySelector(selectors$s.sliderItemImage);
            if (arrows.length && image) {
                arrows.forEach( (arrow) => {
                    arrow.style.top = `${image.offsetHeight / 2}px`
                }
                )
            }
        }
        onBlockSelect(evt) {
            if (this.flkty !== null) {
                const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
                const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
                const groupIndex = Math.floor(index / slidesPerPage);
                this.flkty.select(groupIndex)
            } else {
                const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
                const sliderPadding = parseInt(sliderStyle.paddingLeft);
                const blockPositionLeft = evt.target.offsetLeft - sliderPadding;
                this.slider.scrollTo({
                    top: 0,
                    left: blockPositionLeft,
                    behavior: 'smooth',
                })
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize)
        }
    }
    const ColumnsWithImageSection = {
        onLoad() {
            sections$m[this.id] = new ColumnsWithImage(this)
        },
        onUnload(e) {
            sections$m[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$m[this.id].onBlockSelect(e)
        },
    };
    register('columns-with-image', [ColumnsWithImageSection, videoPlay]);
    const selectors$r = {
        formMessageClose: '[data-form-message-close]',
        formMessageWrapper: '[data-form-message]',
    };
    const classes$j = {
        hideDown: 'hide-down',
        notificationVisible: 'notification-visible',
    };
    let sections$l = {};
    class ContactForm {
        constructor(section) {
            this.container = section.container;
            this.closeButton = this.container.querySelector(selectors$r.formMessageClose);
            this.messageWrapper = this.container.querySelector(selectors$r.formMessageWrapper);
            if (this.messageWrapper) {
                this.hidePopups();
                this.closeFormMessage();
                this.autoHideMessage()
            }
        }
        hidePopups() {
            document.body.classList.add(classes$j.notificationVisible)
        }
        showPopups() {
            document.body.classList.remove(classes$j.notificationVisible)
        }
        closeFormMessage() {
            this.closeButton.addEventListener('click', this.closeMessage.bind(this))
        }
        closeMessage(e) {
            e.preventDefault();
            this.messageWrapper.classList.add(classes$j.hideDown);
            this.showPopups()
        }
        autoHideMessage() {
            setTimeout( () => {
                this.messageWrapper.classList.add(classes$j.hideDown);
                this.showPopups()
            }
            , 10000)
        }
    }
    const contactFormSection = {
        onLoad() {
            sections$l[this.id] = new ContactForm(this)
        },
    };
    register('contact-form', contactFormSection);
    const selectors$q = {
        time: 'time',
        days: '[data-days]',
        hours: '[data-hours]',
        minutes: '[data-minutes]',
        seconds: '[data-seconds]',
        sectionType: '[data-section-type]',
        shopifySection: '.shopify-section',
        aosItem: '[data-aos]',
    };
    const classes$i = {
        countdownTimerShowMessage: 'countdown-timer--show-message',
        hideCountdown: 'hide-countdown',
        aosAnimate: 'aos-animate',
        aosLoading: 'aos-loading',
        countdown: 'countdown',
    };
    const attributes$h = {
        expirationBehavior: 'data-expiration-behavior',
        leadingZero: 'data-leading-zero',
    };
    const settings$1 = {
        hide: 'hide',
        showMessage: 'show-message',
    };
    class CountdownTimer extends HTMLElement {
        constructor() {
            super();
            this.section = this.closest(selectors$q.sectionType);
            this.shopifySection = this.closest(selectors$q.shopifySection);
            this.expirationBehavior = this.getAttribute(attributes$h.expirationBehavior);
            this.leadingZero = this.hasAttribute(attributes$h.leadingZero);
            this.time = this.querySelector(selectors$q.time);
            this.endDate = Date.parse(this.time.dateTime);
            this.days = this.querySelector(selectors$q.days);
            this.hours = this.querySelector(selectors$q.hours);
            this.minutes = this.querySelector(selectors$q.minutes);
            this.seconds = this.querySelector(selectors$q.seconds);
            this.daysInMs = 1000 * 60 * 60 * 24;
            this.hoursInMs = this.daysInMs / 24;
            this.minutesInMs = this.hoursInMs / 60;
            this.secondsInMs = this.minutesInMs / 60;
            this.isLoading = !0;
            this.shouldHideOnComplete = this.expirationBehavior === settings$1.hide;
            this.shouldShowMessage = this.expirationBehavior === settings$1.showMessage;
            this.isAnimated = !1;
            this.update = this.update.bind(this)
        }
        connectedCallback() {
            this.init()
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        init() {
            if (isNaN(this.endDate)) {
                this.onComplete();
                return
            }
            if (this.endDate <= Date.now()) {
                this.onComplete();
                return
            }
            if (this.section.classList.contains(classes$i.countdown)) {
                this.onLoad(!0)
            }
            this.interval = setInterval(this.update, 1000)
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        convertTime(timeInMs) {
            const days = this.formatDigits(parseInt(timeInMs / this.daysInMs, 10));
            timeInMs -= days * this.daysInMs;
            const hours = this.formatDigits(parseInt(timeInMs / this.hoursInMs, 10));
            timeInMs -= hours * this.hoursInMs;
            const minutes = this.formatDigits(parseInt(timeInMs / this.minutesInMs, 10));
            timeInMs -= minutes * this.minutesInMs;
            const seconds = this.formatDigits(parseInt(timeInMs / this.secondsInMs, 10));
            return {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
            }
        }
        formatDigits(number) {
            if (number < 10 && this.leadingZero)
                number = '0' + number;
            return number
        }
        render(timer) {
            this.days.textContent = timer.days;
            this.hours.textContent = timer.hours;
            this.minutes.textContent = timer.minutes;
            this.seconds.textContent = timer.seconds
        }
        onComplete() {
            this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            });
            if (this.shouldHideOnComplete) {
                this.shopifySection.classList.add(classes$i.hideCountdown)
            }
            if (this.shouldShowMessage) {
                this.classList.add(classes$i.countdownTimerShowMessage)
            }
        }
        triggerAnimations() {
            if (theme.settings.animations == 'false')
                return;
            this.section.querySelectorAll(selectors$q.aosItem).forEach( (element) => {
                if (this.isAnimated)
                    element.classList.add(classes$i.aosAnimate);
            }
            )
        }
        removeAnimations() {
            this.section.querySelectorAll(selectors$q.aosItem).forEach( (element) => {
                requestAnimationFrame( () => {
                    if (element.classList.contains(classes$i.aosAnimate)) {
                        element.classList.remove(classes$i.aosAnimate);
                        this.isAnimated = !0
                    }
                }
                )
            }
            )
        }
        onLoad(init) {
            if (init) {
                this.removeAnimations();
                return
            }
            this.isLoading = !1;
            this.triggerAnimations()
        }
        update() {
            const currentDate = Date.now();
            const timeDiff = this.endDate - currentDate;
            if (timeDiff <= 0) {
                this.stopTimer();
                this.onComplete();
                return
            }
            const remainingTime = this.convertTime(timeDiff);
            this.render(remainingTime);
            if (this.isLoading)
                this.onLoad(!1);
        }
    }
    register('countdown', [zoomAnimation, videoPlay]);
    if (!customElements.get('countdown-timer')) {
        customElements.define('countdown-timer', CountdownTimer)
    }
    const selectors$p = {
        videoId: '[data-video-id]',
        videoPlayer: '[data-video-player]',
        videoTemplate: '[data-video-template]',
        videoAutoplay: '[data-video-autoplay]',
        videoWrapper: '[data-video-wrapper]',
        videoPlayButton: '[data-video-bg-play]',
    };
    const classes$h = {
        loading: 'is-loading',
        paused: 'is-paused',
    };
    const sections$k = {};
    class VideoBackground {
        constructor(container) {
            this.container = container;
            this.videoId = this.container.querySelector(selectors$p.videoId);
            this.videoPlayer = this.container.querySelector(selectors$p.videoPlayer);
            this.videoTemplate = this.container.querySelector(selectors$p.videoTemplate);
            this.videoPlayButton = this.container.querySelector(selectors$p.videoPlayButton);
            this.init()
        }
        init() {
            if (!this.videoId)
                return;
            const videoObserver = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    if (entry.isIntersecting) {
                        const videoMarkup = this.videoTemplate.innerHTML;
                        this.videoPlayer.innerHTML = videoMarkup;
                        this.video = this.container.querySelector(selectors$p.videoAutoplay);
                        this.videoPlayer.classList.remove(classes$h.loading);
                        this.container.classList.add(classes$h.paused);
                        this.listen();
                        observer.unobserve(entry.target)
                    }
                }
                )
            }
            ,{
                root: null,
                rootMargin: '300px',
                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
            });
            videoObserver.observe(this.videoPlayer);
            if (this.videoPlayButton) {
                this.videoPlayButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.video?.play()
                }
                )
            }
        }
        listen() {
            this.video.addEventListener('play', () => {
                this.container.classList.remove(classes$h.paused)
            }
            );
            this.container.addEventListener('touchstart', () => {
                this.video.play()
            }
            , {
                passive: !0
            })
        }
    }
    const videoBackground = {
        onLoad() {
            sections$k[this.id] = [];
            const videoWrappers = this.container.querySelectorAll(selectors$p.videoWrapper);
            videoWrappers.forEach( (videoWrapper) => {
                sections$k[this.id].push(new VideoBackground(videoWrapper))
            }
            )
        },
    };
    class PopupCookie {
        constructor(name, value) {
            this.configuration = {
                expires: null,
                path: '/',
                domain: window.location.hostname,
                sameSite: 'none',
                secure: !0,
            };
            this.name = name;
            this.value = value
        }
        write() {
            const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find( (row) => row.startsWith(this.name));
            if (hasCookie || document.cookie.indexOf('; ') === -1) {
                document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
            }
        }
        read() {
            if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find( (row) => row.startsWith(this.name))) {
                const returnCookie = document.cookie.split('; ').find( (row) => row.startsWith(this.name)).split('=')[1];
                return returnCookie
            } else {
                return !1
            }
        }
        destroy() {
            if (document.cookie.split('; ').find( (row) => row.startsWith(this.name))) {
                document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
            }
        }
    }
    const selectors$o = {
        newsletterForm: '[data-newsletter-form]',
        popup: '[data-popup]',
    };
    const classes$g = {
        success: 'has-success',
        error: 'has-error',
    };
    const attributes$g = {
        storageNewsletterFormId: 'newsletter_form_id',
    };
    const sections$j = {};
    class Newsletter {
        constructor(newsletter) {
            this.newsletter = newsletter;
            this.sessionStorage = window.sessionStorage;
            this.popup = this.newsletter.closest(selectors$o.popup);
            this.stopSubmit = !0;
            this.isChallengePage = !1;
            this.formID = null;
            this.formIdSuccess = null;
            this.checkForChallengePage();
            this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);
            if (!this.isChallengePage) {
                this.init()
            }
        }
        init() {
            this.newsletter.addEventListener('submit', this.newsletterSubmit);
            this.showMessage()
        }
        newsletterSubmitEvent(e) {
            if (this.stopSubmit) {
                e.preventDefault();
                this.removeStorage();
                this.writeStorage();
                this.stopSubmit = !1;
                this.newsletter.submit()
            }
        }
        checkForChallengePage() {
            this.isChallengePage = window.location.pathname === theme.routes.root + 'challenge'
        }
        writeStorage() {
            if (this.sessionStorage !== undefined) {
                this.sessionStorage.setItem(attributes$g.storageNewsletterFormId, this.newsletter.id)
            }
        }
        readStorage() {
            this.formID = this.sessionStorage.getItem(attributes$g.storageNewsletterFormId)
        }
        removeStorage() {
            this.sessionStorage.removeItem(attributes$g.storageNewsletterFormId)
        }
        showMessage() {
            this.readStorage();
            if (this.newsletter.id === this.formID) {
                const newsletter = document.getElementById(this.formID);
                const submissionSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
                const submissionFailure = window.location.search.indexOf('accepts_marketing') !== -1;
                if (submissionSuccess) {
                    newsletter.classList.remove(classes$g.error);
                    newsletter.classList.add(classes$g.success);
                    if (this.popup) {
                        this.cookie = new PopupCookie(this.popup.dataset.cookieName,'user_has_closed');
                        this.cookie.write()
                    }
                } else if (submissionFailure) {
                    newsletter.classList.remove(classes$g.success);
                    newsletter.classList.add(classes$g.error)
                }
                if (submissionSuccess || submissionFailure) {
                    this.scrollToForm(newsletter)
                }
            }
        }
        scrollToForm(newsletter) {
            const rect = newsletter.getBoundingClientRect();
            const isVisible = visibilityHelper.isElementPartiallyVisible(newsletter) || visibilityHelper.isElementTotallyVisible(newsletter);
            if (!isVisible) {
                setTimeout( () => {
                    window.scrollTo({
                        top: rect.top,
                        left: 0,
                        behavior: 'smooth',
                    })
                }
                , 400)
            }
        }
        onUnload() {
            this.newsletter.removeEventListener('submit', this.newsletterSubmit)
        }
    }
    const newsletterSection = {
        onLoad() {
            sections$j[this.id] = [];
            const newsletters = this.container.querySelectorAll(selectors$o.newsletterForm);
            newsletters.forEach( (form) => {
                sections$j[this.id].push(new Newsletter(form))
            }
            )
        },
        onUnload() {
            sections$j[this.id].forEach( (form) => {
                if (typeof form.onUnload === 'function') {
                    form.onUnload()
                }
            }
            )
        },
    };
    const selectors$n = {
        product: '[data-product]',
        productSlider: '[data-slider]',
        productSlide: '[data-slide]',
        productGridItemImage: '[data-product-media-container]',
        flickityButton: '.flickity-button',
        item: '[data-slide]',
        links: 'a, button',
    };
    const attributes$f = {
        tabIndex: 'tabindex',
    };
    const sections$i = {};
    class CustomContent {
        constructor(container) {
            this.container = container;
            this.product = this.container.querySelectorAll(selectors$n.product);
            this.productSlider = this.container.querySelectorAll(selectors$n.productSlider);
            this.checkSliderOnResize = () => this.checkSlider();
            this.resizeSliderEvent = (event) => this.resizeSlider(event);
            this.flkty = [];
            this.videoObj = [];
            this.quickViewObj = [];
            this.listen()
        }
        checkSlider() {
            if (window.innerWidth >= theme.sizes.small) {
                this.productSlider.forEach( (slider) => {
                    this.initProductSlider(slider)
                }
                )
            } else {
                this.productSlider.forEach( (slider) => {
                    this.destroyProductSlider(slider)
                }
                )
            }
        }
        initProductSlider(slider) {
            const slidesCount = slider.querySelectorAll(selectors$n.productSlide).length;
            const sliderId = slider.dataset.slider;
            if (slidesCount > 1) {
                if (this.flkty[sliderId] === undefined || !this.flkty[sliderId].isActive) {
                    this.flkty[sliderId] = new Flickity(slider,{
                        prevNextButtons: !0,
                        adaptiveHeight: !0,
                        pageDots: !0,
                        wrapAround: !0,
                        on: {
                            ready: () => {
                                this.setSliderArrowsPosition(slider)
                            }
                            ,
                            change: (index) => {
                                this.flkty[sliderId].cells.forEach( (slide, i) => {
                                    slide.element.querySelectorAll(selectors$n.links).forEach( (link) => {
                                        link.setAttribute(attributes$f.tabIndex, i === index ? '0' : '-1')
                                    }
                                    )
                                }
                                )
                            }
                            ,
                        },
                    })
                } else {
                    this.setSliderArrowsPosition(slider)
                }
            }
        }
        destroyProductSlider(slider) {
            const sliderId = slider.dataset.slider;
            if (typeof this.flkty[sliderId] === 'object') {
                this.flkty[sliderId].destroy()
            }
        }
        setSliderArrowsPosition(slider) {
            const arrows = slider.querySelectorAll(selectors$n.flickityButton);
            const image = slider.querySelector(selectors$n.productGridItemImage);
            if (arrows.length && image) {
                arrows.forEach( (arrow) => {
                    arrow.style.top = `${image.offsetHeight / 2}px`
                }
                )
            }
        }
        resizeSlider(event) {
            const slider = event.target;
            const flkty = Flickity.data(slider) || null;
            if (!flkty)
                return;
            flkty.resize()
        }
        listen() {
            this.checkSlider();
            document.addEventListener('theme:resize:width', this.checkSliderOnResize);
            this.productSlider.forEach( (slider) => {
                slider.addEventListener('theme:slider:resize', this.resizeSliderEvent)
            }
            )
        }
        onUnload() {
            if (this.flkty) {
                for (const key in this.flkty) {
                    if (this.flkty.hasOwnProperty(key)) {
                        this.flkty[key].destroy()
                    }
                }
            }
            document.removeEventListener('theme:resize:width', this.checkSliderOnResize);
            this.productSlider.forEach( (slider) => {
                slider.removeEventListener('theme:slider:resize', this.resizeSliderEvent)
            }
            )
        }
    }
    const CustomContentSection = {
        onLoad() {
            sections$i[this.id] = new CustomContent(this.container)
        },
        onUnload(e) {
            sections$i[this.id].onUnload(e)
        },
    };
    register('custom-content', [CustomContentSection, newsletterSection, videoPlay, tooltip, videoBackground, productGrid]);
    const selectors$m = {
        slider: '[data-slider]',
        sliderItem: '[data-slide]',
        productGridItemImage: '[data-product-media-container]',
        links: 'a, button',
        flickityButton: '.flickity-button',
        promo: '[data-promo]',
        productGridItems: '[data-product-block]',
    };
    const classes$f = {
        carousel: 'carousel',
        carouselInactive: 'carousel--inactive',
        isLastSlideVisible: 'is-last-slide-visible',
        featuredCollection: 'featured-collection',
        promoFullWidth: 'collection-promo--full',
        promoTwoItemsWidth: 'collection-promo--two-columns',
    };
    const attributes$e = {
        sliderId: 'data-slider-id',
        showImage: 'data-slider-show-image',
        tabIndex: 'tabindex',
    };
    const sections$h = {};
    class GridSlider {
        constructor(container) {
            this.container = container;
            this.columns = parseInt(this.container.dataset.columns);
            this.sliders = this.container.querySelectorAll(selectors$m.slider);
            this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
            this.resetSliderEvent = (e) => this.resetSlider(e);
            this.resizeSliderEvent = (event) => this.resizeSlider(event);
            this.flkty = [];
            this.listen();
            this.handleLastSlideOverlayOnMobile()
        }
        initSlider(slider) {
            const sliderId = slider.getAttribute(attributes$e.sliderId);
            slider.classList.remove(classes$f.carouselInactive);
            if (this.flkty[sliderId] === undefined || !this.flkty[sliderId].isActive) {
                this.flkty[sliderId] = new Flickity(slider,{
                    pageDots: !1,
                    cellSelector: selectors$m.sliderItem,
                    cellAlign: 'left',
                    groupCells: !0,
                    contain: !0,
                    wrapAround: !1,
                    adaptiveHeight: !1,
                    on: {
                        ready: () => {
                            this.setSliderArrowsPosition(slider);
                            setTimeout( () => {
                                this.changeTabIndex(slider)
                            }
                            , 0)
                        }
                        ,
                        change: () => {
                            this.changeTabIndex(slider)
                        }
                        ,
                    },
                });
                this.handleLastSlideOverlayOnTablet(slider)
            } else {
                this.setSliderArrowsPosition(slider)
            }
        }
        destroySlider(slider) {
            const sliderId = slider.getAttribute(attributes$e.sliderId);
            if (slider.classList.contains(classes$f.carousel)) {
                slider.classList.add(classes$f.carouselInactive)
            }
            if (typeof this.flkty[sliderId] === 'object') {
                this.flkty[sliderId].destroy()
            }
        }
        resetSlider(e) {
            const slider = e.target;
            const sliderId = slider.getAttribute(attributes$e.sliderId);
            if (typeof this.flkty[sliderId] === 'object') {
                this.flkty[sliderId].select(0, !1, !0)
            } else {
                slider.scrollTo({
                    left: 0,
                    behavior: 'instant',
                })
            }
        }
        resizeSlider(event) {
            const slider = event.target;
            const flkty = Flickity.data(slider) || null;
            if (!flkty)
                return;
            flkty.resize()
        }
        checkSlidesSize() {
            if (this.sliders.length) {
                this.sliders.forEach( (slider) => {
                    const columns = this.columns;
                    const isDesktop = window.innerWidth >= theme.sizes.large;
                    const isTablet = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
                    const slides = slider.querySelectorAll(selectors$m.sliderItem);
                    let itemsCount = slides.length;
                    const promos = slider.querySelectorAll(selectors$m.promo);
                    if (promos.length && isDesktop) {
                        promos.forEach( (promo) => {
                            if (promo.classList.contains(classes$f.promoFullWidth)) {
                                itemsCount += columns - 1
                            } else if (promo.classList.contains(classes$f.promoTwoItemsWidth)) {
                                itemsCount += 1
                            }
                        }
                        )
                    }
                    if (slider.hasAttribute(attributes$e.showImage)) {
                        itemsCount += 1
                    }
                    if ((isDesktop && itemsCount > columns) || (isTablet && itemsCount > 2)) {
                        this.initSlider(slider);
                        this.getTallestProductGridItem(slider)
                    } else {
                        this.destroySlider(slider)
                    }
                }
                )
            }
        }
        changeTabIndex(slider) {
            const sliderId = slider.getAttribute(attributes$e.sliderId);
            const selectedElementsIndex = this.flkty[sliderId].selectedIndex;
            this.flkty[sliderId].slides.forEach( (slide, index) => {
                slide.cells.forEach( (cell) => {
                    cell.element.querySelectorAll(selectors$m.links).forEach( (link) => {
                        link.setAttribute(attributes$e.tabIndex, selectedElementsIndex === index ? '0' : '-1')
                    }
                    )
                }
                )
            }
            )
        }
        setSliderArrowsPosition(slider) {
            const arrows = slider.querySelectorAll(selectors$m.flickityButton);
            const image = slider.querySelector(selectors$m.productGridItemImage);
            if (arrows.length && image) {
                arrows.forEach( (arrow) => {
                    arrow.style.top = `${image.offsetHeight / 2}px`
                }
                )
            }
        }
        handleLastSlideOverlayOnTablet(slider) {
            const sliderId = slider.getAttribute(attributes$e.sliderId);
            this.flkty[sliderId].on('select', () => {
                const isTablet = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
                if (!isTablet)
                    return;
                const selectedIndex = this.flkty[sliderId].selectedIndex;
                const sliderGroups = this.flkty[sliderId].slides.length - 1;
                const isLastSliderGroup = sliderGroups === selectedIndex;
                slider.parentNode.classList.toggle(classes$f.isLastSlideVisible, isLastSliderGroup)
            }
            )
        }
        getTallestProductGridItem(slider) {
            const promos = slider.querySelectorAll(selectors$m.promo);
            if (promos.length) {
                const productGridItems = slider.querySelectorAll(selectors$m.productGridItems);
                const tallestGridItemHeight = Math.max(...Array.from(productGridItems).map(productGridItem => productGridItem.offsetHeight));
                slider.style.setProperty('--carousel-promo-height', `${tallestGridItemHeight}px`)
            }
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach( (slider) => {
                slider.addEventListener('scroll', (event) => {
                    const isMobile = window.innerWidth < theme.sizes.small;
                    if (!isMobile)
                        return;
                    const offsetWidth = event.target.offsetWidth;
                    const lastSlide = Array.from(slider.children).pop();
                    const rect = lastSlide.getBoundingClientRect();
                    const isLastSlideVisible = rect.left + 80 < offsetWidth;
                    slider.parentNode.classList.toggle(classes$f.isLastSlideVisible, isLastSlideVisible)
                }
                )
            }
            )
        }
        listen() {
            if (this.sliders.length) {
                this.checkSlidesSize();
                document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
                this.sliders.forEach( (slider) => {
                    slider.addEventListener('theme:tab:change', this.resetSliderEvent);
                    slider.addEventListener('theme:slider:resize', this.resizeSliderEvent)
                }
                )
            }
        }
        onBlockSelect(evt) {
            const slider = evt.target.closest(selectors$m.slider);
            const flkty = Flickity.data(slider) || null;
            if (!slider) {
                return
            }
            let parent = evt.target.parentNode;
            let target = evt.target;
            if (this.container.classList.contains(classes$f.featuredCollection)) {
                parent = parent.parentNode;
                target = target.parentNode
            }
            if (flkty !== null && flkty.isActive) {
                const index = parseInt([...parent.children].indexOf(target));
                const slidesPerPage = parseInt(flkty.slides[0].cells.length);
                const groupIndex = Math.floor(index / slidesPerPage);
                flkty.select(groupIndex)
            } else {
                const sliderStyle = slider.currentStyle || window.getComputedStyle(slider);
                const sliderPadding = parseInt(sliderStyle.paddingLeft);
                const blockPositionLeft = target.offsetLeft - sliderPadding;
                slider.scrollTo({
                    top: 0,
                    left: blockPositionLeft,
                    behavior: 'smooth',
                })
            }
        }
        onUnload() {
            if (this.flkty) {
                for (const key in this.flkty) {
                    if (this.flkty.hasOwnProperty(key)) {
                        this.flkty[key].destroy()
                    }
                }
            }
            document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
            if (this.sliders.length) {
                this.sliders.forEach( (slider) => {
                    slider.removeEventListener('theme:tab:change', this.resetSliderEvent);
                    slider.removeEventListener('theme:slider:resize', this.resizeSliderEvent)
                }
                )
            }
        }
    }
    const gridSlider = {
        onLoad() {
            sections$h[this.id] = [];
            const els = this.container.querySelectorAll(selectors$m.slider);
            els.forEach( (el) => {
                sections$h[this.id].push(new GridSlider(this.container))
            }
            )
        },
        onUnload() {
            sections$h[this.id].forEach( (el) => {
                if (typeof el.onUnload === 'function') {
                    el.onUnload()
                }
            }
            )
        },
        onBlockSelect(e) {
            sections$h[this.id].forEach( (el) => {
                if (typeof el.onBlockSelect === 'function') {
                    el.onBlockSelect(e)
                }
            }
            )
        },
    };
    register('featured-collection', [productGrid, tooltip, gridSlider]);
    register('featured-video', [videoPlay, videoBackground]);
    const selectors$l = {
        shopPayWrapper: '[data-shop-pay-wrapper]',
        shopLoginButton: 'shop-login-button',
        shopFollowButton: 'shop-follow-button',
        followOnShopButton: 'follow-on-shop-button',
        heartIcon: 'heart-icon',
        shopLogo: 'shop-logo',
    };
    const sections$g = {};
    class ShopPayLink {
        constructor(container) {
            this.container = container;
            this.shopPayWrapper = document.querySelector(selectors$l.shopPayWrapper);
            this.shopLoginButton = document.querySelector(selectors$l.shopLoginButton);
            this.init()
        }
        init() {
            if (!this.shopLoginButton || !this.shopPayWrapper)
                return;
            const bgColor = this.shopPayWrapper.dataset.bg || 'transparent';
            const textColor = this.shopPayWrapper.dataset.text || '#fff';
            const hoverColor = this.shopPayWrapper.dataset.hover || '#fff';
            this.mainButtonStyles = `
      :host {
        --bg-color: ${bgColor};
        --text-color: ${textColor};
        --hover-color: ${hoverColor};
      }

      .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--text-color);
        transition: border 0.3s ease;
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }

      .button {
        background: transparent;
        color: var(--text-color);
      }

      .following-text {
        color: var(--text-color);
      }

      .button--following:focus-visible,
      .button--following:hover {
        background: var(--bg-color);
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }
    `;
            this.svgIconsStyles = `
      :host {
        color: ${textColor};
      }
    `;
            customElements.whenDefined(selectors$l.shopLoginButton).then( (res) => {
                requestAnimationFrame( () => {
                    const shadowRoot1 = this.shopLoginButton.shadowRoot;
                    const shopFollowButton = shadowRoot1?.querySelector(selectors$l.shopFollowButton);
                    const shadowRoot2 = shopFollowButton?.shadowRoot;
                    const followOnShopButton = shadowRoot2?.querySelector(selectors$l.followOnShopButton);
                    const shadowRoot3 = followOnShopButton?.shadowRoot;
                    if (shadowRoot3)
                        this.overwriteStyles(shadowRoot3.host.shadowRoot, this.mainButtonStyles);
                    const heartIcon = shadowRoot3.querySelector(selectors$l.heartIcon);
                    const shadowRoot4 = heartIcon?.shadowRoot;
                    const shopLogo = shadowRoot3.querySelector(selectors$l.shopLogo);
                    const shadowRoot5 = shopLogo?.shadowRoot;
                    if (shadowRoot4)
                        this.overwriteStyles(shadowRoot4.host.shadowRoot, this.svgIconsStyles);
                    if (shadowRoot5)
                        this.overwriteStyles(shadowRoot5.host.shadowRoot, this.svgIconsStyles);
                }
                )
            }
            )
        }
        overwriteStyles(element, styles) {
            let style = document.createElement('style');
            style.innerHTML = styles;
            element.appendChild(style)
        }
    }
    const shopPayLink = {
        onLoad() {
            sections$g[this.id] = new ShopPayLink(this.container)
        },
    };
    const selectors$k = {
        wave: ':scope > [data-wave]',
        main: '[data-main]',
        trigger: '[data-collapsible-trigger-mobile]',
        footerParallax: '[data-parallax="footer"]',
    };
    const classes$e = {
        isExpanded: 'is-expanded',
        wavy: 'wavy',
        shadow: 'parallax-shadow',
        mainParallax: 'main-content--parallax',
        footerParallax: 'section-footer--parallax',
        mainContent: 'main-content',
        shopifySection: 'shopify-section',
    };
    const attributes$d = {
        bg: '--bg',
        footerBg: '--footer-bg',
        parallax: 'data-parallax',
        parallaxWavy: 'data-parallax-wavy',
        parallaxSafari: 'data-parallax-disable-on-safari',
    };
    const sections$f = {};
    class Footer {
        constructor(section) {
            this.container = section.container;
            this.main = document.querySelector(selectors$k.main);
            this.footerParallax = null;
            this.wavyEnabled = this.container.hasAttribute(attributes$d.parallaxWavy);
            this.parentContainer = this.container.parentNode;
            this.resizeEvent = () => this.resize();
            this.unloadEvent = () => this.onUnload();
            if (this.container.hasAttribute(attributes$d.parallax) && !this.main.classList.contains(classes$e.mainParallax)) {
                this.init();
                document.addEventListener('theme:resize', this.resizeEvent);
                document.addEventListener('theme:footer:unload', this.unloadEvent)
            }
        }
        init() {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && this.container.hasAttribute(attributes$d.parallaxSafari);
            if (this.isViewportSmaller() || window.innerWidth < theme.sizes.small || isSafari)
                return;
            const bgColor = getComputedStyle(this.container).getPropertyValue(attributes$d.bg);
            this.parentContainer.style.setProperty('--footer-parallax-height', `auto`);
            let prevSection = this.parentContainer.previousElementSibling;
            if (prevSection) {
                if (!prevSection.classList.contains(classes$e.shopifySection) && !prevSection.classList.contains(classes$e.mainContent)) {
                    prevSection = prevSection.previousElementSibling
                }
                if (this.wavyEnabled) {
                    const oldWaves = prevSection.querySelectorAll(selectors$k.wave);
                    [...oldWaves].map( (wave) => wave.remove());
                    const wave = this.container.querySelector(selectors$k.wave);
                    prevSection.append(wave.cloneNode(!0));
                    prevSection.classList.add(classes$e.wavy);
                    this.container.classList.remove(classes$e.wavy)
                } else {
                    prevSection.classList.add(classes$e.shadow)
                }
                prevSection.style.setProperty(attributes$d.footerBg, bgColor)
            }
            this.parentContainer.style.setProperty('--footer-parallax-height', `${this.container.clientHeight}px`);
            this.main.classList.add(classes$e.mainParallax);
            this.parentContainer.classList.add(classes$e.footerParallax);
            this.footerParallax = new ParallaxElement(this.container)
        }
        resize() {
            this.parentContainer.style.setProperty('--footer-parallax-height', `auto`);
            if (this.isViewportSmaller() || window.innerWidth < theme.sizes.small || !this.footerParallax) {
                this.onUnload(!0)
            }
            this.parentContainer.style.setProperty('--footer-parallax-height', `${this.container.clientHeight}px`)
        }
        isViewportSmaller() {
            const viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
            const footerHeight = this.container.clientHeight;
            let waveHeight = 0;
            if (this.wavyEnabled) {
                waveHeight = 50
            }
            return viewportHeight < footerHeight + waveHeight
        }
        onBlockSelect(e) {
            const trigger = e.target.querySelector(selectors$k.trigger);
            requestAnimationFrame( () => {
                if (trigger && !trigger.classList.contains(classes$e.isExpanded)) {
                    trigger.dispatchEvent(new Event('click'))
                }
            }
            )
        }
        onBlockDeselect(e) {
            const trigger = e.target.querySelector(selectors$k.trigger);
            requestAnimationFrame( () => {
                if (trigger && trigger.classList.contains(classes$e.isExpanded)) {
                    trigger.dispatchEvent(new Event('click'))
                }
            }
            )
        }
        onUnload(reset=!1) {
            document.removeEventListener('theme:resize', this.resizeEvent);
            document.removeEventListener('theme:footer:unload', this.unloadEvent);
            if (this.footerParallax) {
                this.footerParallax.unload();
                if (reset) {
                    removeFooterWave(this.parentContainer)
                }
            }
            if (this.footerParallax || reset) {
                setTimeout( () => {
                    const shopifyInstances = Shopify.theme.sections.instances;
                    const parallaxFooters = document.querySelectorAll(selectors$k.footerParallax);
                    const footerInstance = shopifyInstances.filter( (instance) => instance.container === parallaxFooters[0]);
                    this.main.classList.remove(classes$e.mainParallax);
                    this.parentContainer.classList.remove(classes$e.footerParallax);
                    if (footerInstance[0]) {
                        footerInstance[0].onLoad()
                    }
                }
                )
            }
        }
    }
    const footerSection = {
        onLoad() {
            sections$f[this.id] = new Footer(this)
        },
        onBlockSelect(e) {
            sections$f[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            sections$f[this.id].onBlockDeselect(e)
        },
        onReorder() {
            sections$f[this.id].onUnload()
        },
        onUnload() {
            sections$f[this.id].onUnload()
        },
    };
    register('footer', [popoutSection, newsletterSection, collapsible, footerSection, shopPayLink]);
    const selectors$j = {
        slider: '[data-slider]',
    };
    let sections$e = {};
    class IconsRow {
        constructor(section) {
            this.container = section.container;
            this.slider = this.container.querySelector(selectors$j.slider)
        }
        onBlockSelect(evt) {
            const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
            const sliderPadding = parseInt(sliderStyle.paddingLeft);
            const blockPositionLeft = evt.target.offsetLeft - sliderPadding;
            this.slider.scrollTo({
                top: 0,
                left: blockPositionLeft,
                behavior: 'smooth',
            })
        }
    }
    const iconsRowSection = {
        onLoad() {
            sections$e[this.id] = new IconsRow(this)
        },
        onBlockSelect(e) {
            sections$e[this.id].onBlockSelect(e)
        },
    };
    register('icons-row', iconsRowSection);
    const selectors$i = {
        item: '[data-accordion-item]',
        button: '[data-accordion-button]',
    };
    const classes$d = {
        isActive: 'is-active',
        toAnimate: 'to-animate',
        isAnimating: 'is-animating',
    };
    const sections$d = {};
    class ImageAccordions {
        constructor(section) {
            this.container = section.container;
            this.controller = new AbortController();
            this.imageAccordionsItems = this.container.querySelectorAll(selectors$i.item);
            this.buttons = this.container.querySelectorAll(selectors$i.button);
            this.accordionExpandEvent = (item) => this.accordionExpand(item);
            this.accordionFocusEvent = (item) => this.accordionFocus(item);
            this.init()
        }
        init() {
            this.triggerLoadingAnimation();
            this.imageAccordionsItems.forEach( (item) => {
                item.addEventListener('mouseenter', this.accordionExpandEvent.bind(this, item))
            }
            );
            this.buttons.forEach( (button) => {
                button.addEventListener('focusin', this.accordionFocusEvent.bind(this, button))
            }
            )
        }
        triggerLoadingAnimation() {
            if (theme.settings.animationsEnabled == 'false' || isMobile())
                return;
            const onAnimationEnd = (event) => {
                if (event.animationName === 'expandAccordion') {
                    this.accordionExpand(this.imageAccordionsItems[0]);
                    this.container.classList.remove(classes$d.toAnimate);
                    this.container.classList.remove(classes$d.isAnimating);
                    this.container.removeEventListener('animationend', onAnimationEnd)
                }
            }
            ;
            const onTransitionEnd = (event) => {
                requestAnimationFrame( () => {
                    if (event.target === this.container) {
                        this.container.classList.add(classes$d.isAnimating);
                        this.container.removeEventListener('transitionend', onTransitionEnd)
                    }
                }
                )
            }
            ;
            this.container.addEventListener('transitionend', onTransitionEnd, {
                signal: this.controller.signal
            });
            this.container.addEventListener('animationend', onAnimationEnd, {
                signal: this.controller.signal
            })
        }
        accordionExpand(item) {
            if (!item.classList.contains(classes$d.isActive)) {
                this.imageAccordionsItems.forEach( (item) => {
                    item.classList.remove(classes$d.isActive)
                }
                );
                item.classList.add(classes$d.isActive)
            }
        }
        accordionFocus(button) {
            button.closest(selectors$i.item).dispatchEvent(new Event('mouseenter'))
        }
        onBlockSelect(event) {
            const element = event.target;
            if (!element)
                return;
            this.controller.abort();
            this.container.classList.remove(classes$d.toAnimate, classes$d.isAnimating);
            this.accordionExpand(element);
            if (!isMobile())
                return;
            element.parentNode.scrollTo({
                top: 0,
                left: element.offsetLeft,
                behavior: 'smooth',
            })
        }
    }
    const imageAccordionsSection = {
        onLoad() {
            sections$d[this.id] = new ImageAccordions(this)
        },
        onBlockSelect(event) {
            sections$d[this.id].onBlockSelect(event)
        },
    };
    register('image-accordions', imageAccordionsSection);
    register('image-with-text', videoPlay);
    register('list-collections', gridSlider);
    const sections$c = {};
    const selectors$h = {
        slider: '[data-slider-gallery]',
        sliderNav: '[data-slider-info]',
        item: '[data-slide-item]',
    };
    class Locations {
        constructor(section) {
            this.container = section.container;
            this.slider = this.container.querySelector(selectors$h.slider);
            this.sliderNav = this.container.querySelector(selectors$h.sliderNav);
            this.initSlider()
        }
        initSlider() {
            const slidesCount = this.container.querySelectorAll(selectors$h.item).length;
            let flkty = Flickity.data(this.slider) || null;
            let flktyNav = Flickity.data(this.sliderNav) || null;
            if (slidesCount <= 1) {
                return
            }
            flkty = new Flickity(this.slider,{
                fade: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
                pageDots: !1,
            });
            flickitySmoothScrolling(this.slider);
            flktyNav = new Flickity(this.sliderNav,{
                fade: !0,
                wrapAround: !0,
                imagesLoaded: !0,
                asNavFor: this.slider,
                prevNextButtons: !0,
                pageDots: !1,
            });
            flktyNav.on('change', () => {
                flkty.selectCell(flktyNav.selectedIndex)
            }
            );
            flkty.on('change', () => {
                flktyNav.selectCell(flkty.selectedIndex)
            }
            )
        }
        onBlockSelect(evt) {
            const flkty = Flickity.data(this.slider) || null;
            const flktyNav = Flickity.data(this.sliderNav) || null;
            const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
            if (flkty !== null) {
                flkty.select(index)
            }
            if (flktyNav !== null) {
                flktyNav.select(index)
            }
        }
    }
    const LocationsSection = {
        onLoad() {
            sections$c[this.id] = new Locations(this)
        },
        onBlockSelect(e) {
            sections$c[this.id].onBlockSelect(e)
        },
    };
    register('locations', LocationsSection);
    const sections$b = {};
    const selectors$g = {
        slider: '[data-slider]',
        sliderItem: '[data-slide-item]',
        pointer: '[data-pointer]',
        productGridItemImage: '[data-product-media-container]',
        quickViewItemHolder: '[data-quick-view-item-holder]',
        flickityButton: '.flickity-button',
        links: 'a, button',
        tooltip: '[data-tooltip]',
    };
    const attributes$c = {
        pointer: 'data-pointer',
        hotspot: 'data-hotspot',
        tabIndex: 'tabindex',
    };
    const classes$c = {
        productGridItemImageHover: 'product-grid-item__image--hovered',
        pointerSelected: 'pointer--selected',
        isSelected: 'is-selected',
        isActive: 'is-active',
        popupOpen: 'pswp--open',
    };
    class Look {
        constructor(container) {
            this.container = container;
            this.slider = this.container.querySelector(selectors$g.slider);
            this.slides = this.container.querySelectorAll(selectors$g.sliderItem);
            this.pointers = this.container.querySelectorAll(selectors$g.pointer);
            this.flkty = null;
            this.observer = null;
            this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
            this.resizeSliderEvent = (event) => this.resizeSlider(event);
            this.pointersInit = (event) => this.dotPointers(event);
            this.pointersOver = (event) => this.dotPointerIn(event);
            this.pointersOut = (event) => this.dotPointerOut(event);
            this.debouncedBlockSelectCallback = debounce( (event) => this.debouncedBlockSelect(event), 500);
            this.quickViewPopup = new QuickViewPopup(this.container);
            this.listen()
        }
        listen() {
            if (this.slider) {
                this.checkSlidesSize();
                document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
                this.slider.addEventListener('theme:slider:resize', this.resizeSliderEvent)
            }
            if (this.pointers.length > 0) {
                this.pointers.forEach( (pointer) => {
                    pointer.addEventListener('click', this.pointersInit);
                    pointer.addEventListener('mouseover', this.pointersOver);
                    pointer.addEventListener('mouseleave', this.pointersOut)
                }
                )
            }
        }
        checkSlidesSize() {
            const isDesktop = window.innerWidth >= theme.sizes.small;
            if (this.container.classList.contains('look-new-section')) {
                this.initSlider()
            } else {
                this.initTooltips();
                if (isDesktop) {
                    if (this.slides.length > 2) {
                        this.initSlider()
                    } else {
                        this.destroySlider();
                        this.slidesTabIndex()
                    }
                    return
                }
                if (!isDesktop && this.slides.length > 1) {
                    this.initSlider();
                    return
                }
                this.destroySlider()
            }
        }
        initTooltips() {
            this.tooltips = this.container.querySelectorAll(selectors$g.tooltip);
            this.tooltips.forEach( (tooltip) => {
                new Tooltip(tooltip)
            }
            )
        }
        initSlider() {
            if (this.flkty === null) {
                this.flkty = new Flickity(this.slider,{
                    prevNextButtons: !0,
                    wrapAround: !0,
                    adaptiveHeight: !1,
                    cellAlign: 'left',
                    groupCells: !1,
                    contain: !0,
                    on: {
                        ready: () => {
                            this.slidesTabIndex();
                            this.setSliderArrowsPosition();
                            this.dotPointers()
                        }
                        ,
                        change: () => {
                            this.slidesTabIndex();
                            this.dotPointers()
                        }
                        ,
                    },
                });
                return
            }
            this.setSliderArrowsPosition()
        }
        setSliderArrowsPosition() {
            const isDesktop = window.innerWidth >= theme.sizes.small;
            if (!isDesktop)
                return;
            const arrows = this.slider.querySelectorAll(selectors$g.flickityButton);
            const image = this.slider.querySelector(selectors$g.productGridItemImage);
            if (arrows.length && image) {
                arrows.forEach( (arrow) => {
                    arrow.style.top = `${image.offsetHeight / 2}px`
                }
                )
            }
        }
        slidesTabIndex() {
            if (this.slides.length < 3) {
                this.slider.querySelectorAll(selectors$g.links).forEach( (link) => {
                    link.setAttribute(attributes$c.tabIndex, '0')
                }
                );
                return
            }
            const slider = Flickity.data(this.slider);
            slider.cells.forEach( (slide) => {
                let tabIndex = '-1';
                if (slide.element.classList.contains(classes$c.isSelected)) {
                    tabIndex = '0'
                }
                slide.element.querySelectorAll(selectors$g.links).forEach( (link) => {
                    link.setAttribute(attributes$c.tabIndex, tabIndex)
                }
                )
            }
            )
        }
        destroySlider() {
            if (typeof this.flkty === 'object' && this.flkty !== null) {
                this.flkty.destroy();
                this.flkty = null
            }
        }
        resizeSlider(event) {
            const slider = event.target;
            const flkty = Flickity.data(slider) || null;
            if (!flkty)
                return;
            flkty.resize()
        }
        dotPointers(event) {
            if (this.pointers.length === 0)
                return;
            this.pointers.forEach( (button) => {
                button.classList.remove(classes$c.pointerSelected)
            }
            );
            if (event) {
                const dotIndex = event.target.getAttribute(attributes$c.pointer);
                this.flkty?.select(dotIndex);
                return
            }
            const slideIndex = this.flkty == null ? 0 : this.flkty.selectedIndex;
            if (slideIndex >= 0) {
                this.pointers[slideIndex].classList.add(classes$c.pointerSelected)
            }
        }
        dotPointerIn(event) {
            const dotIndex = event.target.getAttribute(attributes$c.pointer);
            const image = this.slides[dotIndex].querySelector(selectors$g.productGridItemImage);
            const isTouch = matchMedia('(pointer:coarse)').matches;
            const isMobile = window.innerWidth < theme.sizes.small;
            if (!isMobile && !isTouch) {
                this.observeImage(image)
            }
            this.pointers.forEach( (pointer) => {
                pointer.style.setProperty('--look-animation', 'none')
            }
            )
        }
        dotPointerOut(event) {
            const dotIndex = event.target.getAttribute(attributes$c.pointer);
            const image = this.slides[dotIndex].querySelector(selectors$g.productGridItemImage);
            image.classList.remove(classes$c.productGridItemImageHover);
            image.dispatchEvent(new Event('mouseleave'));
            if (this.observer) {
                this.observer.disconnect()
            }
            this.pointers.forEach( (pointer) => {
                pointer.style.removeProperty('--look-animation')
            }
            )
        }
        observeImage(image) {
            this.observer = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    const target = entry.target;
                    const outsideWrapper = entry.intersectionRatio == 0;
                    if (!outsideWrapper) {
                        target.dispatchEvent(new Event('mouseenter'));
                        target.classList.add(classes$c.productGridItemImageHover)
                    }
                }
                )
            }
            ,{
                root: this.slider,
                threshold: [0.95, 1],
            });
            this.observer.observe(image)
        }
        triggerClick(target) {
            requestAnimationFrame( () => target.dispatchEvent(new Event('click')))
        }
        destroyQuickViewPopup() {
            const pswpElement = this.quickViewPopup?.loadPhotoswipe?.pswpElement;
            if (!pswpElement)
                return;
            if (pswpElement.classList.contains(classes$c.popupOpen)) {
                this.quickViewPopup.loadPhotoswipe.popup.close()
            }
        }
        onBlockSelect(event) {
            this.debouncedBlockSelectCallback(event)
        }
        debouncedBlockSelect(event) {
            const pswpElement = this.quickViewPopup?.loadPhotoswipe?.pswpElement;
            if (!pswpElement) {
                setTimeout( () => this.triggerClick(event.target), 400);
                return
            }
            setTimeout( () => {
                if (pswpElement.classList.contains(classes$c.popupOpen)) {
                    const holder = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${attributes$c.hotspot}="${event.target.getAttribute(attributes$c.hotspot)}"]`);
                    const quickViewItemHolders = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(selectors$g.quickViewItemHolder);
                    holder.classList.add(classes$c.isActive);
                    quickViewItemHolders.forEach( (element) => {
                        if (element !== holder) {
                            element.classList.remove(classes$c.isActive)
                        }
                    }
                    )
                } else {
                    this.triggerClick(event.target)
                }
            }
            )
        }
        onUnload() {
            this.destroyQuickViewPopup();
            document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
            if (this.slider) {
                this.slider.removeEventListener('theme:slider:resize', this.resizeSliderEvent)
            }
        }
        onDeselect() {
            this.destroyQuickViewPopup()
        }
    }
    const lookSection = {
        onLoad() {
            sections$b[this.id] = new Look(this.container)
        },
        onUnload() {
            sections$b[this.id].onUnload()
        },
        onBlockSelect(event) {
            sections$b[this.id].onBlockSelect(event)
        },
        onDeselect() {
            sections$b[this.id].onDeselect()
        },
    };
    register('look', [lookSection]);
    const selectors$f = {
        grid: '[data-grid]',
    };
    const mosaicSection = {
        onBlockSelect(e) {
            const grid = e.target.closest(selectors$f.grid);
            const wrapperStyle = grid.currentStyle || window.getComputedStyle(grid);
            const wrapperPadding = parseInt(wrapperStyle.paddingLeft);
            const blockPositionLeft = e.target.offsetLeft - wrapperPadding;
            grid.scrollTo({
                top: 0,
                left: blockPositionLeft,
                behavior: 'smooth',
            })
        },
    };
    register('mosaic', mosaicSection);
    register('newsletter', newsletterSection);
    register('overlapping-images', [videoPlay, parallaxSection]);
    const selectors$e = {
        toggleAdmin: '[data-toggle-admin]',
        toggleNewsletter: '[data-toggle-newsletter]',
        adminForm: '[data-form-admin]',
        newsletterForm: '[data-form-newsletter]',
    };
    let sections$a = {};
    class Password {
        constructor(section) {
            this.container = section.container;
            this.toggleAdmin = this.container.querySelector(selectors$e.toggleAdmin);
            this.toggleNewsletter = this.container.querySelector(selectors$e.toggleNewsletter);
            this.adminForm = this.container.querySelector(selectors$e.adminForm);
            this.newsletterForm = this.container.querySelector(selectors$e.newsletterForm);
            this.adminErrors = this.adminForm.querySelector('.errors');
            this.newsletterErrors = this.newsletterForm.querySelector('.errors');
            this.init()
        }
        init() {
            this.toggleAdmin.addEventListener('click', (e) => {
                e.preventDefault();
                this.showPasswordForm()
            }
            );
            this.toggleNewsletter.addEventListener('click', (e) => {
                e.preventDefault();
                this.hidePasswordForm()
            }
            );
            if (window.location.hash == '#login' || this.adminErrors) {
                this.showPasswordForm()
            } else {
                this.hidePasswordForm()
            }
        }
        showPasswordForm() {
            showElement(this.adminForm);
            hideElement(this.newsletterForm);
            window.location.hash = '#login'
        }
        hidePasswordForm() {
            showElement(this.newsletterForm);
            hideElement(this.adminForm);
            window.location.hash = ''
        }
    }
    const passwordSection = {
        onLoad() {
            sections$a[this.id] = new Password(this)
        },
    };
    register('password-template', passwordSection);
    const selectors$d = {
        largePromo: '[data-large-promo]',
        largePromoInner: '[data-large-promo-inner]',
        tracking: '[data-tracking-consent]',
        trackingInner: '[data-tracking-consent-inner]',
        trackingAccept: '[data-confirm-cookies]',
        popupBar: '[data-popup-bar]',
        popupBarHolder: '[data-popup-bar-holder]',
        popupBarToggle: '[data-popup-bar-toggle]',
        popupBody: '[data-popup-body]',
        popupClose: '[data-popup-close]',
        popupUnderlay: '[data-popup-underlay]',
        newsletterForm: '[data-newsletter-form]',
    };
    const attributes$b = {
        cookieName: 'data-cookie-name',
        targetReferrer: 'data-target-referrer',
        preventScrollLock: 'data-prevent-scroll-lock',
    };
    const classes$b = {
        success: 'has-success',
        error: 'has-error',
        selected: 'selected',
        hasBlockSelected: 'has-block-selected',
        expanded: 'popup--expanded',
        visible: 'popup--visible',
        mobile: 'mobile',
        desktop: 'desktop',
        popupBar: 'popup--bar',
        barIsVisible: 'popup-bar-is-visible',
    };
    let sections$9 = {};
    let scrollLockTimer = 0;
    let activePopups = 0;
    let popups = [];
    class DelayShow {
        constructor(popupContainer, popup) {
            this.popupContainer = popupContainer;
            this.popup = popup;
            this.popupBody = popup.querySelector(selectors$d.popupBody);
            this.delay = popupContainer.dataset.popupDelay;
            this.isSubmitted = window.location.href.indexOf('accepts_marketing') !== -1 || window.location.href.indexOf('customer_posted=true') !== -1;
            this.a11y = a11y;
            this.showPopupOnScrollEvent = () => this.showPopupOnScroll();
            if (this.delay === 'always' || this.isSubmitted) {
                this.always()
            }
            if (this.delay && this.delay.includes('delayed') && !this.isSubmitted) {
                const seconds = this.delay.includes('_') ? parseInt(this.delay.split('_')[1]) : 10;
                this.delayed(seconds)
            }
            if (this.delay === 'bottom' && !this.isSubmitted) {
                this.bottom()
            }
            if (this.delay === 'idle' && !this.isSubmitted) {
                this.idle()
            }
        }
        always() {
            this.showPopup()
        }
        delayed(seconds=10) {
            setTimeout( () => {
                this.showPopup()
            }
            , seconds * 1000)
        }
        bottom() {
            document.addEventListener('theme:scroll', this.showPopupOnScrollEvent)
        }
        idle() {
            const isTargetValid = this.checkPopupTarget() === !0;
            if (!isTargetValid) {
                return
            }
            let timer = 0;
            let idleTime = 60000;
            const documentEvents = ['mousemove', 'mousedown', 'click', 'touchmove', 'touchstart', 'touchend', 'keydown', 'keypress'];
            const windowEvents = ['load', 'resize', 'scroll'];
            const startTimer = () => {
                timer = setTimeout( () => {
                    timer = 0;
                    this.showPopup()
                }
                , idleTime);
                documentEvents.forEach( (eventType) => {
                    document.addEventListener(eventType, resetTimer)
                }
                );
                windowEvents.forEach( (eventType) => {
                    window.addEventListener(eventType, resetTimer)
                }
                )
            }
            ;
            const resetTimer = () => {
                if (timer) {
                    clearTimeout(timer)
                }
                documentEvents.forEach( (eventType) => {
                    document.removeEventListener(eventType, resetTimer)
                }
                );
                windowEvents.forEach( (eventType) => {
                    window.removeEventListener(eventType, resetTimer)
                }
                );
                startTimer()
            }
            ;
            startTimer()
        }
        showPopup() {
            const popupElement = {
                id: this.popup.id,
                body: this.popupBody
            };
            popups.push(popupElement);
            const isTargetValid = this.checkPopupTarget() === !0;
            if (isTargetValid) {
                activePopups += 1;
                this.popup.classList.add(classes$b.visible);
                if (this.popup.classList.contains(classes$b.popupBar)) {
                    document.body.classList.add(classes$b.barIsVisible)
                }
                this.a11y.trapFocus({
                    container: this.popupBody,
                });
                if (this.popup.hasAttribute(attributes$b.preventScrollLock)) {
                    return !1
                }
                this.scrollLock()
            }
        }
        checkPopupTarget() {
            const targetMobile = this.popup.parentNode.classList.contains(classes$b.mobile);
            const targetDesktop = this.popup.parentNode.classList.contains(classes$b.desktop);
            if ((targetMobile && window.innerWidth >= theme.sizes.small) || (targetDesktop && window.innerWidth < theme.sizes.small)) {
                return !1
            } else {
                return !0
            }
        }
        scrollLock() {
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: this.popupBody
            }))
        }
        showPopupOnScroll() {
            if (window.scrollY + window.innerHeight >= document.body.clientHeight) {
                this.showPopup();
                document.removeEventListener('theme:scroll', this.showPopupOnScrollEvent)
            }
        }
        onUnload() {
            document.removeEventListener('theme:scroll', this.showPopupOnScrollEvent)
        }
    }
    class TargetReferrer {
        constructor(el) {
            this.popupContainer = el;
            this.locationPath = location.href;
            if (!this.popupContainer.hasAttribute(attributes$b.targetReferrer)) {
                return !1
            }
            if (this.locationPath.indexOf(this.popupContainer.getAttribute(attributes$b.targetReferrer)) === -1 && !window.Shopify.designMode) {
                this.popupContainer.parentNode.removeChild(this.popupContainer)
            }
        }
    }
    class LargePopup {
        constructor(el) {
            this.popupContainer = el;
            this.popup = this.popupContainer.querySelector(selectors$d.largePromoInner);
            this.popupBody = this.popup.querySelector(selectors$d.popupBody);
            this.popupId = this.popup.id;
            this.close = this.popup.querySelector(selectors$d.popupClose);
            this.underlay = this.popup.querySelector(selectors$d.popupUnderlay);
            this.form = this.popup.querySelector(selectors$d.newsletterForm);
            this.cookie = new PopupCookie(this.popupContainer.dataset.cookieName,'user_has_closed');
            this.isTargeted = new TargetReferrer(this.popupContainer);
            this.a11y = a11y;
            this.init()
        }
        init() {
            const cookieExists = this.cookie.read() !== !1;
            if (!cookieExists || window.Shopify.designMode) {
                if (!window.Shopify.designMode) {
                    new DelayShow(this.popupContainer,this.popup)
                } else {
                    this.showPopup()
                }
                if (this.form) {
                    setTimeout( () => {
                        if (this.form.classList.contains(classes$b.success)) {
                            this.showPopupIfNoCookie();
                            activePopups -= 1
                        }
                    }
                    )
                }
                this.initClosers()
            }
        }
        checkPopupTarget() {
            const targetMobile = this.popup.parentNode.classList.contains(classes$b.mobile);
            const targetDesktop = this.popup.parentNode.classList.contains(classes$b.desktop);
            if ((targetMobile && window.innerWidth >= theme.sizes.small) || (targetDesktop && window.innerWidth < theme.sizes.small)) {
                return !1
            } else {
                return !0
            }
        }
        showPopupIfNoCookie() {
            this.showPopup()
        }
        initClosers() {
            this.close.addEventListener('click', this.closePopup.bind(this));
            this.underlay.addEventListener('click', this.closePopup.bind(this));
            this.popupContainer.addEventListener('keyup', (event) => {
                if (event.code === theme.keyboardKeys.ESCAPE) {
                    this.closePopup(event)
                }
            }
            )
        }
        closePopup(event) {
            event.preventDefault();
            this.hidePopup();
            this.cookie.write()
        }
        scrollLock() {
            this.resetScrollUnlock();
            this.a11y.trapFocus({
                container: this.popupBody,
            });
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: this.popupBody
            }))
        }
        scrollUnlock() {
            this.resetScrollUnlock();
            scrollLockTimer = setTimeout( () => {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                    bubbles: !0
                }))
            }
            , 300)
        }
        resetScrollUnlock() {
            if (scrollLockTimer) {
                clearTimeout(scrollLockTimer)
            }
        }
        showPopup() {
            const isTargetValid = this.checkPopupTarget() === !0;
            const popupElement = {
                id: this.popupId,
                body: this.popup
            };
            popups.push(popupElement);
            if (isTargetValid) {
                activePopups += 1;
                this.popup.classList.add(classes$b.visible);
                this.scrollLock()
            }
        }
        hidePopup() {
            this.popup.classList.remove(classes$b.visible);
            const popupIndex = popups.findIndex( (x) => x.id === this.popupId);
            activePopups -= 1;
            popups.splice(popupIndex, 1);
            if (activePopups == 1 && document.body.classList.contains(classes$b.barIsVisible)) {
                this.scrollUnlock()
            } else if (activePopups < 1) {
                this.scrollUnlock();
                this.a11y.removeTrapFocus()
            } else if (popups.length > 0) {
                const nextPopup = popups[popups.length - 1].body;
                this.a11y.trapFocus({
                    container: nextPopup,
                })
            }
        }
        onBlockSelect(evt) {
            if (this.popupContainer.contains(evt.target) && !this.popup.classList.contains(classes$b.visible)) {
                this.popup.classList.add(classes$b.selected);
                this.popupContainer.classList.add(classes$b.hasBlockSelected);
                this.showPopup()
            }
        }
        onBlockDeselect(evt) {
            if (this.popupContainer.contains(evt.target)) {
                this.popup.classList.remove(classes$b.selected);
                this.popupContainer.classList.remove(classes$b.hasBlockSelected);
                this.hidePopup()
            }
        }
        onUnload() {
            this.scrollUnlock()
        }
        onDeselect() {
            this.popup.classList.remove(classes$b.selected);
            this.popupContainer.classList.remove(classes$b.hasBlockSelected);
            this.hidePopup()
        }
    }
    class Tracking {
        constructor(el) {
            this.popupContainer = el;
            this.popup = this.popupContainer.querySelector(selectors$d.trackingInner);
            this.popupId = this.popup.id;
            this.close = this.popup.querySelector(selectors$d.popupClose);
            this.acceptButton = this.popup.querySelector(selectors$d.trackingAccept);
            this.enable = this.popupContainer.dataset.enable === 'true';
            this.a11y = a11y;
            window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1',
            }, ], (error) => {
                if (error) {
                    throw error
                }
                const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
                const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
                this.enableTracking = !userCanBeTracked && userTrackingConsent === 'no_interaction' && this.enable;
                if (window.Shopify.designMode) {
                    this.enableTracking = !0
                }
                this.init()
            }
            )
        }
        init() {
            if (this.enableTracking) {
                this.showPopup()
            }
            this.clickEvents()
        }
        clickEvents() {
            this.close.addEventListener('click', (event) => {
                event.preventDefault();
                window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.hidePopup())
            }
            );
            this.acceptButton.addEventListener('click', (event) => {
                event.preventDefault();
                window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.hidePopup())
            }
            );
            document.addEventListener('trackingConsentAccepted', () => {
                console.log('trackingConsentAccepted event fired')
            }
            )
        }
        showPopup() {
            const popupElement = {
                id: this.popupId,
                body: this.popup
            };
            popups.push(popupElement);
            this.popup.classList.add(classes$b.visible);
            this.a11y.trapFocus({
                container: this.popup,
            })
        }
        hidePopup() {
            this.popup.classList.remove(classes$b.visible);
            const popupIndex = popups.findIndex( (x) => x.id === this.popupId);
            popups.splice(popupIndex, 1);
            if (activePopups < 1) {
                this.a11y.removeTrapFocus()
            } else if (popups.length > 0) {
                const nextPopup = popups[popups.length - 1].body;
                this.a11y.trapFocus({
                    container: nextPopup,
                })
            }
        }
        onBlockSelect(evt) {
            if (this.popupContainer.contains(evt.target) && this.enableTracking && !this.popup.classList.contains(classes$b.visible)) {
                this.showPopup();
                this.popup.classList.add(classes$b.selected);
                this.popup.parentNode.classList.add(classes$b.hasBlockSelected)
            }
        }
        onBlockDeselect(evt) {
            if (this.popupContainer.contains(evt.target)) {
                this.popup.classList.remove(classes$b.selected);
                this.popupContainer.classList.remove(classes$b.hasBlockSelected);
                this.hidePopup()
            }
        }
        onDeselect() {
            this.popup.classList.remove(classes$b.selected);
            this.popupContainer.classList.remove(classes$b.hasBlockSelected);
            this.hidePopup()
        }
    }
    class PopupBar {
        constructor(el) {
            this.popupContainer = el;
            this.popup = this.popupContainer.querySelector(selectors$d.popupBarHolder);
            this.popupBody = this.popup.querySelector(selectors$d.popupBody);
            this.popupId = this.popup.id;
            this.close = this.popup.querySelector(selectors$d.popupClose);
            this.underlay = this.popup.querySelector(selectors$d.popupUnderlay);
            this.toggle = this.popup.querySelector(selectors$d.popupBarToggle);
            this.cookie = new PopupCookie(this.popupContainer.dataset.cookieName,'user_has_closed');
            this.form = this.popup.querySelector(selectors$d.newsletterForm);
            this.isTargeted = new TargetReferrer(this.popupContainer);
            this.a11y = a11y;
            this.init()
        }
        init() {
            const cookieExists = this.cookie.read() !== !1;
            if (!cookieExists || window.Shopify.designMode) {
                if (!window.Shopify.designMode) {
                    new DelayShow(this.popupContainer,this.popup)
                } else {
                    this.showPopup()
                }
                this.initPopupToggleButton();
                this.initClosers();
                if (this.form) {
                    setTimeout( () => {
                        if (this.form.classList.contains(classes$b.success)) {
                            this.showPopupIfNoCookie()
                        }
                        if (this.form.classList.contains(classes$b.error)) {
                            this.toggle.dispatchEvent(new Event('click'))
                        }
                    }
                    )
                }
            }
        }
        checkPopupTarget() {
            const targetMobile = this.popup.parentNode.classList.contains(classes$b.mobile);
            const targetDesktop = this.popup.parentNode.classList.contains(classes$b.desktop);
            if ((targetMobile && window.innerWidth >= theme.sizes.small) || (targetDesktop && window.innerWidth < theme.sizes.small)) {
                return !1
            } else {
                return !0
            }
        }
        showPopupIfNoCookie() {
            this.showPopup();
            this.toggle.dispatchEvent(new Event('click'))
        }
        initPopupToggleButton() {
            this.toggle.addEventListener('click', (event) => {
                event.preventDefault();
                this.popup.classList.toggle(classes$b.expanded);
                if (this.popup.classList.contains(classes$b.expanded)) {
                    this.scrollLock()
                } else {
                    this.scrollUnlock()
                }
            }
            )
        }
        showPopup() {
            const popupElement = {
                id: this.popupId,
                body: this.popup
            };
            popups.push(popupElement);
            this.a11y.trapFocus({
                container: this.popupBody,
            });
            const isTargetValid = this.checkPopupTarget() === !0;
            if (isTargetValid) {
                activePopups += 1;
                document.body.classList.add(classes$b.barIsVisible);
                this.popup.classList.add(classes$b.visible)
            }
        }
        hidePopup() {
            this.popup.classList.remove(classes$b.visible);
            document.body.classList.remove(classes$b.barIsVisible);
            const popupIndex = popups.findIndex( (x) => x.id === this.popupId);
            popups.splice(popupIndex, 1);
            if (activePopups >= 1) {
                activePopups -= 1
            }
            if (activePopups < 1) {
                this.scrollUnlock();
                this.a11y.removeTrapFocus()
            } else if (popups.length > 0) {
                const nextPopup = popups[popups.length - 1].body;
                this.a11y.trapFocus({
                    container: nextPopup,
                })
            }
        }
        initClosers() {
            this.close.addEventListener('click', this.closePopup.bind(this));
            this.underlay.addEventListener('click', () => this.toggle.dispatchEvent(new Event('click')));
            this.popupContainer.addEventListener('keyup', (event) => {
                if (event.code === theme.keyboardKeys.ESCAPE) {
                    this.popup.classList.remove(classes$b.expanded);
                    this.scrollUnlock()
                }
            }
            )
        }
        closePopup(event) {
            event.preventDefault();
            this.cookie.write();
            this.hidePopup()
        }
        scrollLock() {
            document.dispatchEvent(new CustomEvent('theme:scroll:lock',{
                bubbles: !0,
                detail: this.popupBody
            }))
        }
        scrollUnlock() {
            this.resetScrollUnlock();
            scrollLockTimer = setTimeout( () => {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock',{
                    bubbles: !0
                }))
            }
            , 300)
        }
        resetScrollUnlock() {
            if (scrollLockTimer) {
                clearTimeout(scrollLockTimer)
            }
        }
        onBlockSelect(evt) {
            if (this.popupContainer.contains(evt.target) && !this.popup.classList.contains(classes$b.visible)) {
                this.showPopup();
                this.popup.classList.add(classes$b.expanded);
                this.popup.classList.add(classes$b.selected);
                this.popup.parentNode.classList.add(classes$b.hasBlockSelected);
                this.resetScrollUnlock();
                this.scrollLock()
            }
        }
        onBlockDeselect(evt) {
            if (this.popupContainer.contains(evt.target)) {
                this.popup.classList.remove(classes$b.expanded);
                this.popup.classList.remove(classes$b.selected);
                this.popup.parentNode.classList.remove(classes$b.hasBlockSelected);
                this.hidePopup()
            }
        }
        onUnload() {
            this.scrollUnlock()
        }
        onDeselect() {
            this.popup.classList.remove(classes$b.expanded);
            this.popup.classList.remove(classes$b.selected);
            this.popup.parentNode.classList.remove(classes$b.hasBlockSelected);
            this.hidePopup()
        }
    }
    const popupSection = {
        onLoad() {
            sections$9[this.id] = [];
            if (window.Shopify.designMode) {
                activePopups = 0
            }
            const popupsLarge = this.container.querySelectorAll(selectors$d.largePromo);
            if (popupsLarge.length) {
                popupsLarge.forEach( (el) => {
                    sections$9[this.id].push(new LargePopup(el))
                }
                )
            }
            const popupBars = this.container.querySelectorAll(selectors$d.popupBar);
            if (popupBars.length) {
                popupBars.forEach( (el) => {
                    sections$9[this.id].push(new PopupBar(el))
                }
                )
            }
            const cookiesPopups = this.container.querySelectorAll(selectors$d.tracking);
            if (cookiesPopups.length) {
                cookiesPopups.forEach( (el) => {
                    sections$9[this.id].push(new Tracking(el))
                }
                )
            }
        },
        onDeselect() {
            sections$9[this.id].forEach( (el) => {
                if (typeof el.onDeselect === 'function') {
                    el.onDeselect()
                }
            }
            )
        },
        onBlockSelect(evt) {
            sections$9[this.id].forEach( (el) => {
                if (typeof el.onBlockSelect === 'function') {
                    el.onBlockSelect(evt)
                }
            }
            )
        },
        onBlockDeselect(evt) {
            sections$9[this.id].forEach( (el) => {
                if (typeof el.onBlockDeselect === 'function') {
                    el.onBlockDeselect(evt)
                }
            }
            )
        },
        onUnload(evt) {
            sections$9[this.id].forEach( (el) => {
                if (typeof el.onUnload === 'function') {
                    el.onUnload(evt)
                }
            }
            )
        },
    };
    register('popups', [popupSection, newsletterSection]);
    const selectors$c = {
        pressItems: '[data-press-items]',
        logoSlider: '[data-logo-slider]',
        logoSlide: '[data-logo-slide]',
        links: 'a, button',
    };
    const attributes$a = {
        logoSlide: 'data-logo-index',
        tabIndex: 'tabindex',
    };
    let sections$8 = {};
    class Press {
        constructor(section) {
            this.container = section.container;
            this.slider = this.container.querySelector(selectors$c.pressItems);
            this.sliderNav = this.container.querySelector(selectors$c.logoSlider);
            this.sliderResizeEvent = () => this.checkSlides();
            this.initSlider();
            this.checkSlides();
            window.addEventListener('load', this.resizeSlider.bind(this));
            document.addEventListener('theme:resize:width', this.sliderResizeEvent)
        }
        checkSlides() {
            const containerWidth = this.container.offsetWidth;
            const slides = this.container.querySelectorAll(selectors$c.logoSlide);
            const sliderNav = Flickity.data(this.sliderNav) || null;
            if (sliderNav !== null) {
                sliderNav.options.draggable = !1;
                sliderNav.options.wrapAround = !1;
                sliderNav.options.contain = !0;
                if (this.getSlidesWidth() > containerWidth && slides.length > 2) {
                    sliderNav.options.draggable = !0;
                    sliderNav.options.wrapAround = !0;
                    sliderNav.options.contain = !1
                }
                sliderNav.resize();
                sliderNav.updateDraggable()
            }
        }
        getSlidesWidth() {
            const slides = this.container.querySelectorAll(selectors$c.logoSlide);
            let slidesTotalWidth = 0;
            if (slides.length) {
                slides.forEach( (slide) => {
                    slidesTotalWidth += slide.offsetWidth
                }
                )
            }
            return slidesTotalWidth
        }
        initSlider() {
            let flkty = Flickity.data(this.slider) || null;
            let flktyNav = Flickity.data(this.sliderNav) || null;
            const duration = parseInt(this.container.dataset.duration);
            const autoplay = this.container.dataset.autoplay === 'true' ? duration : !1;
            flkty = new Flickity(this.slider,{
                fade: !0,
                wrapAround: !0,
                adaptiveHeight: !1,
                prevNextButtons: !1,
                pageDots: !1,
                autoPlay: autoplay,
            });
            flktyNav = new Flickity(this.sliderNav,{
                draggable: !1,
                wrapAround: !1,
                contain: !0,
                imagesLoaded: !0,
                asNavFor: this.slider,
                prevNextButtons: !1,
                adaptiveHeight: !1,
                pageDots: !1,
                on: {
                    ready: () => {
                        const slides = this.container.querySelectorAll(selectors$c.logoSlide);
                        slides.forEach( (slide) => {
                            slide.addEventListener('keyup', (event) => {
                                if (event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER || event.code === theme.keyboardKeys.SPACE) {
                                    const selectedIndex = Number(slide.getAttribute(attributes$a.logoSlide));
                                    flkty.selectCell(selectedIndex)
                                }
                            }
                            )
                        }
                        )
                    }
                    ,
                },
            });
            flickitySmoothScrolling(this.slider);
            flickitySmoothScrolling(this.sliderNav);
            flktyNav.on('change', (index) => {
                flkty.selectCell(index)
            }
            );
            flkty.on('change', (index) => {
                flktyNav.selectCell(index);
                flkty.cells.forEach( (slide, i) => {
                    slide.element.querySelectorAll(selectors$c.links).forEach( (link) => {
                        link.setAttribute(attributes$a.tabIndex, i === index ? '0' : '-1')
                    }
                    )
                }
                )
            }
            )
        }
        resizeSlider() {
            const hasSlider = Flickity.data(this.slider);
            if (hasSlider) {
                hasSlider.resize()
            }
        }
        onBlockSelect(event) {
            const slider = Flickity.data(this.slider) || null;
            const sliderNav = Flickity.data(this.sliderNav) || null;
            const index = parseInt([...event.target.parentNode.children].indexOf(event.target));
            if (slider !== null) {
                slider.select(index);
                slider.pausePlayer()
            }
            if (sliderNav !== null) {
                sliderNav.select(index)
            }
        }
        onBlockDeselect() {
            const slider = Flickity.data(this.slider) || null;
            const autoplay = this.container.dataset.autoplay === 'true';
            if (autoplay && slider !== null) {
                slider.playPlayer()
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.sliderResizeEvent)
        }
    }
    const pressSection = {
        onLoad() {
            sections$8[this.id] = new Press(this)
        },
        onUnload(e) {
            sections$8[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$8[this.id].onBlockSelect(e)
        },
        onBlockDeselect() {
            sections$8[this.id].onBlockDeselect()
        },
    };
    register('press', pressSection);
    const selectors$b = {
        slideshow: '[data-product-single-media-slider]',
        productInfo: '[data-product-info]',
        headerSticky: '[data-header-sticky]',
        headerHeight: '[data-header-height]',
    };
    const classes$a = {
        sticky: 'is-sticky',
    };
    const attributes$9 = {
        stickyEnabled: 'data-sticky-enabled',
    };
    window.theme.variables = {
        productPageSticky: !1,
    };
    const sections$7 = {};
    class ProductSticky {
        constructor(section) {
            this.container = section.container;
            this.stickyEnabled = this.container.getAttribute(attributes$9.stickyEnabled) === 'true';
            this.productInfo = this.container.querySelector(selectors$b.productInfo);
            this.stickyScrollTop = 0;
            this.scrollLastPosition = 0;
            this.stickyDefaultTop = 0;
            this.currentPoint = 0;
            this.defaultTopBottomSpacings = 30;
            this.scrollTop = window.scrollY;
            this.scrollDirectionDown = !0;
            this.requestAnimationSticky = null;
            this.stickyFormLoad = !0;
            this.stickyFormLastHeight = null;
            this.onChangeCounter = 0;
            this.scrollEvent = (e) => this.scrollEvents(e);
            this.resizeEvent = (e) => this.resizeEvents(e);
            this.init()
        }
        init() {
            if (this.stickyEnabled) {
                this.stickyScrollCheck();
                document.addEventListener('theme:resize', this.resizeEvent)
            }
            this.initSticky()
        }
        initSticky() {
            if (theme.variables.productPageSticky) {
                this.requestAnimationSticky = requestAnimationFrame( () => this.calculateStickyPosition());
                this.productInfo.addEventListener('theme:form:sticky', (e) => {
                    this.removeAnimationFrame();
                    this.requestAnimationSticky = requestAnimationFrame( () => this.calculateStickyPosition(e))
                }
                );
                document.addEventListener('theme:scroll', this.scrollEvent)
            }
        }
        scrollEvents(e) {
            if (e.detail !== null) {
                this.scrollTop = e.detail.position;
                this.scrollDirectionDown = e.detail.down
            }
            if (!this.requestAnimationSticky) {
                this.requestAnimationSticky = requestAnimationFrame( () => this.calculateStickyPosition())
            }
        }
        resizeEvents() {
            this.stickyScrollCheck();
            document.removeEventListener('theme:scroll', this.scrollEvent);
            this.initSticky()
        }
        stickyScrollCheck() {
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const isDesktop = windowWidth >= window.theme.sizes.large;
            const targetProductInfo = this.container.querySelector(selectors$b.productInfo);
            if (!targetProductInfo)
                return;
            if (isDesktop) {
                const productInfo = this.container.querySelector(selectors$b.productInfo);
                const slideshow = this.container.querySelector(selectors$b.slideshow);
                if (!productInfo || !slideshow)
                    return;
                const productCopyHeight = productInfo.offsetHeight;
                const productImagesHeight = slideshow.offsetHeight;
                if (productCopyHeight < productImagesHeight) {
                    theme.variables.productPageSticky = !0;
                    targetProductInfo.classList.add(classes$a.sticky)
                } else {
                    theme.variables.productPageSticky = !1;
                    targetProductInfo.classList.remove(classes$a.sticky)
                }
            } else {
                theme.variables.productPageSticky = !1;
                targetProductInfo.classList.remove(classes$a.sticky)
            }
        }
        calculateStickyPosition(e=null) {
            const eventExist = Boolean(e && e.detail);
            const isAccordion = Boolean(eventExist && e.detail.element && e.detail.element === 'accordion');
            const productInfoHeight = this.productInfo.offsetHeight;
            const heightDifference = window.innerHeight - productInfoHeight - this.defaultTopBottomSpacings;
            const scrollDifference = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (this.scrollDirectionDown) {
                this.stickyScrollTop -= scrollDifference
            } else {
                this.stickyScrollTop += scrollDifference
            }
            if (this.stickyFormLoad) {
                if (document.querySelector(selectors$b.headerSticky) && document.querySelector(selectors$b.headerHeight)) {
                    this.stickyDefaultTop = parseInt(document.querySelector(selectors$b.headerHeight).getBoundingClientRect().height)
                } else {
                    this.stickyDefaultTop = this.defaultTopBottomSpacings
                }
                this.stickyScrollTop = this.stickyDefaultTop
            }
            this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, heightDifference), this.stickyDefaultTop);
            const differencePoint = this.stickyScrollTop - this.currentPoint;
            this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + differencePoint * 0.5;
            this.productInfo.style.setProperty('--sticky-top', `${this.currentPoint}px`);
            this.scrollLastPosition = this.scrollTop;
            this.stickyFormLoad = !1;
            if ((isAccordion && this.onChangeCounter <= 10) || (isAccordion && this.stickyFormLastHeight !== productInfoHeight) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)) {
                if (isAccordion) {
                    this.onChangeCounter += 1
                }
                if (isAccordion && this.stickyFormLastHeight !== productInfoHeight) {
                    this.onChangeCounter = 11
                }
                this.requestAnimationSticky = requestAnimationFrame( () => this.calculateStickyPosition(e))
            } else if (this.requestAnimationSticky) {
                this.removeAnimationFrame()
            }
            this.stickyFormLastHeight = productInfoHeight
        }
        removeAnimationFrame() {
            if (this.requestAnimationSticky) {
                cancelAnimationFrame(this.requestAnimationSticky);
                this.requestAnimationSticky = null;
                this.onChangeCounter = 0
            }
        }
        onUnload() {
            if (this.stickyEnabled) {
                document.removeEventListener('theme:resize', this.resizeEvent)
            }
            if (theme.variables.productPageSticky) {
                document.removeEventListener('theme:scroll', this.scrollEvent)
            }
        }
    }
    const productStickySection = {
        onLoad() {
            sections$7[this.id] = new ProductSticky(this)
        },
        onUnload() {
            sections$7[this.id].onUnload()
        },
    };
    const selectors$a = {
        mediaContainer: '[data-product-single-media-group]',
        productMediaSlider: '[data-product-single-media-slider]',
        zoomWrapper: '[data-zoom-wrapper]',
    };
    const classes$9 = {
        popupClass: 'pswp-zoom-gallery',
        popupClassNoThumbs: 'pswp-zoom-gallery--single',
        isMoving: 'is-moving',
    };
    const attributes$8 = {
        dataImageWidth: 'data-image-width',
        dataImageHeight: 'data-image-height',
    };
    class Zoom {
        constructor(container) {
            this.container = container;
            this.mediaContainer = this.container.querySelector(selectors$a.mediaContainer);
            this.slider = this.container.querySelector(selectors$a.productMediaSlider);
            this.zoomWrappers = this.container.querySelectorAll(selectors$a.zoomWrapper);
            this.zoomEnable = this.mediaContainer.dataset.gallery === 'true';
            this.a11y = a11y;
            if (this.zoomEnable) {
                this.init()
            }
        }
        init() {
            if (this.zoomWrappers.length) {
                this.zoomWrappers.forEach( (element, i) => {
                    element.addEventListener('click', (e) => {
                        e.preventDefault();
                        const isMoving = this.slider && this.slider.classList.contains(classes$9.isMoving);
                        if (!isMoving) {
                            this.a11y.state.trigger = element;
                            this.createZoom(i)
                        }
                    }
                    )
                }
                )
            }
        }
        createZoom(indexImage) {
            const instance = this;
            let items = [];
            let counter = 0;
            this.zoomWrappers.forEach( (elementImage) => {
                const imgSrc = elementImage.getAttribute('href');
                const imgWidth = parseInt(elementImage.getAttribute(attributes$8.dataImageWidth));
                const imgHeight = parseInt(elementImage.getAttribute(attributes$8.dataImageHeight));
                items.push({
                    src: imgSrc,
                    w: imgWidth,
                    h: imgHeight,
                    msrc: imgSrc,
                });
                counter += 1;
                if (instance.zoomWrappers.length === counter) {
                    let popupClass = `${classes$9.popupClass}`;
                    if (counter === 1) {
                        popupClass = `${classes$9.popupClass} ${classes$9.popupClassNoThumbs}`
                    }
                    const options = {
                        barsSize: {
                            top: 60,
                            bottom: 60
                        },
                        history: !1,
                        focus: !1,
                        index: indexImage,
                        mainClass: popupClass,
                        showHideOpacity: !0,
                        showAnimationDuration: 250,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !1,
                        closeEl: !0,
                        closeElClasses: ['caption-close'],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        openAtZoomLevel: 1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                    };
                    new LoadPhotoswipe(items,options)
                }
            }
            )
        }
    }
    const selectors$9 = {
        complementaryProducts: '[data-complementary-products]',
        buttonQuickView: '[data-button-quick-view]',
    };
    const attributes$7 = {
        url: 'data-url',
    };
    class ComplementaryProducts extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting)
                    return;
                observer.unobserve(this);
                if (this.hasAttribute(attributes$7.url) && this.getAttribute(attributes$7.url) !== '') {
                    fetch(this.getAttribute(attributes$7.url)).then( (response) => response.text()).then( (text) => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const recommendations = html.querySelector(selectors$9.complementaryProducts);
                        if (recommendations && recommendations.innerHTML.trim().length) {
                            this.innerHTML = recommendations.innerHTML
                        }
                        if (html.querySelector(selectors$9.buttonQuickView)) {
                            new QuickViewPopup(this)
                        }
                    }
                    ).catch( (e) => {
                        console.error(e)
                    }
                    )
                }
            }
            ;
            new IntersectionObserver(handleIntersection.bind(this),{
                rootMargin: '0px 0px 400px 0px'
            }).observe(this)
        }
    }
    const selectors$8 = {
        recipientCheckbox: '[data-recipient-checkbox]',
        recipientEmail: '[data-recipient-email]',
        recipientName: '[data-recipient-name]',
        recipientMessage: '[data-recipient-message]',
        recipientSendOn: '[data-recipient-send-on]',
        recipientControl: '[data-recipient-control]',
        recipientOffset: '[data-recipient-offset]',
        productForm: '[data-product-form]',
        cartDrawer: '[data-cart-drawer]',
    };
    const classes$8 = {
        quickViewVisible: 'js-quick-view-visible',
    };
    class RecipientForm extends HTMLElement {
        constructor() {
            super();
            this.recipientCheckbox = this.querySelector(selectors$8.recipientCheckbox);
            this.recipientControl = this.querySelector(selectors$8.recipientControl);
            this.recipientControl.disabled = !0;
            this.recipientEmail = this.querySelector(selectors$8.recipientEmail);
            this.recipientName = this.querySelector(selectors$8.recipientName);
            this.recipientMessage = this.querySelector(selectors$8.recipientMessage);
            this.recipientSendOn = this.querySelector(selectors$8.recipientSendOn);
            this.recipientOffset = this.querySelector(selectors$8.recipientOffset);
            if (this.recipientOffset)
                this.recipientOffset.value = new Date().getTimezoneOffset();
            this.cartDrawer = document.querySelector(selectors$8.cartDrawer);
            this.onChangeEvent = (event) => this.onChange(event);
            this.onCartAddedEvent = () => this.onCartAdded()
        }
        connectedCallback() {
            if (!this.recipientCheckbox)
                return;
            this.disableInputFields();
            this.recipientCheckbox.addEventListener('change', this.onChangeEvent);
            document.addEventListener('theme:cart:added', this.onCartAddedEvent)
        }
        onChange(event) {
            if (!event.target.checked) {
                this.clearInputFields();
                this.disableInputFields();
                return
            }
            this.enableInputFields()
        }
        onCartAdded() {
            const scrollToPosition = this.closest(selectors$8.productForm).offsetTop;
            const isQuickBuyForm = document.body.classList.contains(classes$8.quickViewVisible);
            const isRecipientFormActive = this.recipientCheckbox.checked === !0;
            if (!isRecipientFormActive)
                return;
            if (!isQuickBuyForm) {
                window.scrollTo({
                    top: scrollToPosition,
                    left: 0,
                    behavior: 'smooth',
                })
            }
            const onCartDrawerTransitionEnd = (event) => {
                if (event.target !== this.cartDrawer)
                    return;
                requestAnimationFrame( () => {
                    this.recipientCheckbox.checked = !1;
                    this.recipientCheckbox.dispatchEvent(new Event('change'))
                }
                );
                this.cartDrawer.removeEventListener('transitionend', onCartDrawerTransitionEnd)
            }
            ;
            this.cartDrawer.addEventListener('transitionend', onCartDrawerTransitionEnd)
        }
        inputFields() {
            return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn]
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset]
        }
        clearInputFields() {
            this.inputFields().forEach( (field) => (field.value = ''))
        }
        enableInputFields() {
            this.disableableFields().forEach( (field) => (field.disabled = !1))
        }
        disableInputFields() {
            this.disableableFields().forEach( (field) => (field.disabled = !0))
        }
        disconnectedCallback() {
            this.recipientCheckbox.removeEventListener('change', this.onChangeEvent);
            document.removeEventListener('theme:cart:added', this.onCartAddedEvent)
        }
    }
    const selectors$7 = {
        option: '[data-option]',
        popout: '[data-popout]',
        productMediaSlider: '[data-product-single-media-slider]',
        productMediaThumb: '[data-thumbnail-id]',
        productMediaThumbs: '[data-product-single-media-thumbs]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productModel: '[data-model]',
        productSingleThumbnailLink: '.product-single__thumbnail-link',
        deferredMedia: '[data-deferred-media]',
        deferredMediaButton: '[data-deferred-media-button]',
        modalScrollContainer: '[data-tabs-holder]',
        tooltip: '[data-tooltip]',
        productRating: '[data-product-rating]',
        productReviews: '#shopify-product-reviews',
        links: 'a, button',
        upsellProduct: '[data-upsell-holder]',
        upsellProductSlider: '[data-upsell-slider]',
        featureSlider: '[data-slider]',
        productJson: '[data-product-json]',
    };
    const classes$7 = {
        featuredProduct: 'featured-product',
        featuredProductOnboarding: 'featured-product--onboarding',
        hasMediaActive: 'has-media-active',
        isSelected: 'is-selected',
        mediaHidden: 'media--hidden',
        noOutline: 'no-outline',
        hasPopup: 'has-popup',
        isMoving: 'is-moving',
    };
    const attributes$6 = {
        mediaId: 'data-media-id',
        sectionId: 'data-section-id',
        thumbId: 'data-thumbnail-id',
        dataTallLayout: 'data-tall-layout',
        loaded: 'loaded',
        tabindex: 'tabindex',
    };
    const sections$6 = {};
    class Product {
        constructor(section) {
            this.container = section.container;
            this.sectionId = this.container.getAttribute(attributes$6.sectionId);
            this.tallLayout = this.container.getAttribute(attributes$6.dataTallLayout) === 'true';
            this.featureSliders = this.container.querySelectorAll(selectors$7.featureSlider);
            this.flkty = null;
            this.flktyNav = null;
            this.isFlickityDragging = !1;
            this.enableHistoryState = !this.container.classList.contains(classes$7.featuredProduct);
            this.checkSliderOnResize = () => this.checkSlider();
            this.flktyNavOnResize = () => this.resizeFlickityNav();
            this.scrollToReviews();
            this.initUpsellSlider();
            this.initFeatureSlider();
            new QuickViewPopup(this.container);
            if (this.container.classList.contains(classes$7.featuredProductOnboarding)) {
                return
            }
            const productJson = this.container.querySelector(selectors$7.productJson);
            if (productJson && productJson.innerHTML) {
                const productJsonHandle = JSON.parse(productJson.innerHTML).handle;
                let recentObj = {};
                if (productJsonHandle) {
                    recentObj = {
                        handle: productJsonHandle,
                    }
                }
                Shopify.Products.recordRecentlyViewed(recentObj)
            } else {
                Shopify.Products.recordRecentlyViewed()
            }
            new Zoom(this.container);
            this.productSlider();
            this.initMediaSwitch();
            this.initProductVideo();
            this.initProductModel();
            this.initShopifyXrLaunch()
        }
        productSlider() {
            this.checkSlider();
            document.addEventListener('theme:resize:width', this.checkSliderOnResize)
        }
        checkSlider() {
            if (!this.tallLayout || window.innerWidth < theme.sizes.large) {
                this.initProductSlider();
                return
            }
            this.destroyProductSlider()
        }
        resizeFlickityNav() {
            if (this.flktyNav !== null) {
                this.flktyNav.resize()
            }
        }
        initProductSlider() {
            const slider = this.container.querySelector(selectors$7.productMediaSlider);
            const thumbs = this.container.querySelector(selectors$7.productMediaThumbs);
            const media = this.container.querySelectorAll(selectors$7.productMediaWrapper);
            if (media.length > 1) {
                this.flkty = new Flickity(slider,{
                    wrapAround: !0,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    on: {
                        ready: () => {
                            slider.setAttribute(attributes$6.tabindex, '-1');
                            media.forEach( (item) => {
                                if (!item.classList.contains(classes$7.isSelected)) {
                                    const links = item.querySelectorAll(selectors$7.links);
                                    if (links.length) {
                                        links.forEach( (link) => {
                                            link.setAttribute(attributes$6.tabindex, '-1')
                                        }
                                        )
                                    }
                                }
                            }
                            )
                        }
                        ,
                        dragStart: () => {
                            slider.classList.add(classes$7.isMoving)
                        }
                        ,
                        dragMove: () => {
                            this.isFlickityDragging = !0
                        }
                        ,
                        staticClick: () => {
                            this.isFlickityDragging = !1
                        }
                        ,
                        settle: (index) => {
                            const currentSlide = this.flkty.selectedElement;
                            const mediaId = currentSlide.getAttribute(attributes$6.mediaId);
                            this.flkty.cells.forEach( (slide, i) => {
                                const links = slide.element.querySelectorAll(selectors$7.links);
                                if (links.length) {
                                    links.forEach( (link) => {
                                        link.setAttribute(attributes$6.tabindex, i === index ? '0' : '-1')
                                    }
                                    )
                                }
                            }
                            );
                            this.switchMedia(mediaId);
                            slider.classList.remove(classes$7.isMoving)
                        }
                        ,
                    },
                });
                if (media.length) {
                    media.forEach( (el) => {
                        el.addEventListener('theme:media:play', () => {
                            this.flkty.options.draggable = !1;
                            this.flkty.updateDraggable();
                            el.closest(selectors$7.productMediaSlider).classList.add(classes$7.hasMediaActive)
                        }
                        );
                        el.addEventListener('theme:media:pause', () => {
                            this.flkty.options.draggable = !0;
                            this.flkty.updateDraggable();
                            el.closest(selectors$7.productMediaSlider).classList.remove(classes$7.hasMediaActive)
                        }
                        )
                    }
                    )
                }
                flickitySmoothScrolling(slider);
                if (thumbs !== null) {
                    this.flktyNav = new Flickity(thumbs,{
                        asNavFor: slider,
                        contain: !0,
                        pageDots: !1,
                        prevNextButtons: !1,
                        resize: !0,
                        on: {
                            ready: () => {
                                thumbs.setAttribute(attributes$6.tabindex, '-1')
                            }
                            ,
                        },
                    });
                    if (this.flktyNav !== null) {
                        document.addEventListener('theme:resize:width', this.flktyNavOnResize)
                    }
                    flickitySmoothScrolling(thumbs);
                    const thumbLinks = this.container.querySelectorAll(selectors$7.productSingleThumbnailLink);
                    if (thumbLinks.length) {
                        thumbLinks.forEach( (el) => {
                            el.addEventListener('click', (e) => {
                                e.preventDefault()
                            }
                            )
                        }
                        )
                    }
                }
            }
        }
        destroyProductSlider() {
            if (this.flkty !== null) {
                this.flkty.destroy();
                this.flktyNav.destroy();
                this.flkty = null;
                this.flktyNav = null
            }
        }
        initUpsellSlider() {
            const slider = this.container.querySelector(selectors$7.upsellProductSlider);
            const items = this.container.querySelectorAll(selectors$7.upsellProduct);
            if (items.length > 1) {
                const flktyUpsell = new Flickity(slider,{
                    wrapAround: !0,
                    pageDots: !0,
                    adaptiveHeight: !0,
                    prevNextButtons: !1,
                });
                flktyUpsell.on('change', (index) => {
                    flktyUpsell.cells.forEach( (slide, i) => {
                        const links = slide.element.querySelectorAll(selectors$7.links);
                        if (links.length) {
                            links.forEach( (link) => {
                                link.setAttribute(attributes$6.tabindex, i === index ? '0' : '-1')
                            }
                            )
                        }
                    }
                    )
                }
                )
            }
        }
        initFeatureSlider() {
            this.featureSliders.forEach( (featureSliders) => {
                const featureSlideIndex = Array.from(featureSliders.children);
                if (featureSlideIndex.length > 1) {
                    this.flktyFeature = new Flickity(featureSliders,{
                        wrapAround: !0,
                        pageDots: !0,
                        adaptiveHeight: !0,
                        prevNextButtons: !1,
                    })
                }
            }
            )
        }
        handleMediaFocus(event) {
            if (event.code !== theme.keyboardKeys.ENTER && event.code !== theme.keyboardKeys.TAB) {
                return
            }
            const mediaId = event.currentTarget.getAttribute(attributes$6.thumbId);
            const activeSlide = this.container.querySelector(`[${attributes$6.mediaId}="${mediaId}"]`);
            const slideIndex = parseInt([...activeSlide.parentNode.children].indexOf(activeSlide));
            const slider = this.container.querySelector(selectors$7.productMediaSlider);
            const sliderNav = this.container.querySelector(selectors$7.productMediaThumbs);
            const flkty = Flickity.data(slider) || null;
            const flktyNav = Flickity.data(sliderNav) || null;
            if (flkty && flkty.isActive && slideIndex > -1 && (event.code === theme.keyboardKeys.ENTER || event.code === theme.keyboardKeys.NUMPADENTER)) {
                flkty.select(slideIndex)
            }
            if (flktyNav && flktyNav.isActive && slideIndex > -1) {
                flktyNav.select(slideIndex)
            }
        }
        switchMedia(mediaId) {
            const mediaItems = document.querySelectorAll(`${selectors$7.productMediaWrapper}`);
            const selectedMedia = this.container.querySelector(`${selectors$7.productMediaWrapper}[${attributes$6.mediaId}="${mediaId}"]`);
            const isFocusEnabled = !document.body.classList.contains(classes$7.noOutline);
            if (mediaItems.length) {
                mediaItems.forEach( (media) => {
                    media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                        bubbles: !0
                    });
                    media.classList.add(classes$7.mediaHidden)
                }
                )
            }
            if (isFocusEnabled) {
                selectedMedia.focus()
            }
            selectedMedia.closest(selectors$7.productMediaSlider).classList.remove(classes$7.hasMediaActive);
            selectedMedia.classList.remove(classes$7.mediaHidden);
            selectedMedia.dispatchEvent(new CustomEvent('theme:media:visible'), {
                bubbles: !0
            });
            const deferredMedia = selectedMedia.querySelector(selectors$7.deferredMedia);
            if (deferredMedia && deferredMedia.getAttribute(attributes$6.loaded) !== 'true') {
                selectedMedia.querySelector(selectors$7.deferredMediaButton).dispatchEvent(new Event('click'))
            }
        }
        initMediaSwitch() {
            const productThumbImages = this.container.querySelectorAll(selectors$7.productMediaThumb);
            if (productThumbImages.length) {
                productThumbImages.forEach( (el) => {
                    el.addEventListener('keyup', this.handleMediaFocus.bind(this));
                    el.addEventListener('click', (e) => {
                        e.preventDefault()
                    }
                    )
                }
                )
            }
        }
        initProductVideo() {
            this.videos = new ProductVideo(this.container)
        }
        initProductModel() {
            const modelItems = this.container.querySelectorAll(selectors$7.productModel);
            if (modelItems.length) {
                modelItems.forEach( (element) => {
                    theme.ProductModel.init(element, this.sectionId)
                }
                )
            }
        }
        initShopifyXrLaunch() {
            document.addEventListener('shopify_xr_launch', () => {
                const currentMedia = this.container.querySelector(`${selectors$7.productModel}:not(.${classes$7.mediaHidden})`);
                currentMedia.dispatchEvent(new CustomEvent('xrLaunch'))
            }
            )
        }
        onUnload() {
            if (this.flktyNav !== null) {
                document.removeEventListener('theme:resize:width', this.flktyNavOnResize)
            }
            document.removeEventListener('theme:resize:width', this.checkSliderOnResize)
        }
        scrollToReviews() {
            const productRating = this.container.querySelector(selectors$7.productRating);
            const events = ['click', 'keydown'];
            if (!productRating) {
                return
            }
            events.forEach( (eventName) => {
                productRating.addEventListener(eventName, (event) => {
                    if ((event.code !== theme.keyboardKeys.ENTER && event.code !== theme.keyboardKeys.NUMPADENTER) || event.type != 'click') {
                        const reviewsContainer = document.querySelector(selectors$7.productReviews);
                        if (!reviewsContainer) {
                            return
                        }
                        reviewsContainer.scrollIntoView({
                            behavior: 'smooth'
                        })
                    }
                }
                )
            }
            )
        }
        onBlockSelect(event) {
            const flkty = Flickity.data(event.target.closest(selectors$7.featureSlider));
            const index = parseInt([...event.target.parentNode.children].indexOf(event.target));
            if (flkty) {
                flkty.select(index)
            }
        }
    }
    const productSection = {
        onLoad() {
            sections$6[this.id] = new Product(this)
        },
        onUnload: function() {
            sections$6[this.id].onUnload()
        },
        onBlockSelect(event) {
            sections$6[this.id].onBlockSelect(event)
        },
    };
    register('product-template', [productFormSection, productSection, swatchSection, swatchesContainer, shareButton, collapsible, tooltip, popoutSection, drawer, productStickySection]);
    register('featured-product', [productFormSection, productSection, swatchSection, swatchesContainer, shareButton, collapsible, tooltip, popoutSection, drawer, productStickySection]);
    if (!customElements.get('complementary-products')) {
        customElements.define('complementary-products', ComplementaryProducts)
    }
    if (!customElements.get('recipient-form')) {
        customElements.define('recipient-form', RecipientForm)
    }
    const attributes$5 = {
        href: 'href',
        mediaId: 'data-media-id',
        deferredMediaLoaded: 'data-deferred-media-loaded',
    };
    const selectors$6 = {
        deferredMedia: '[data-deferred-media]',
        deferredMediaButton: '[data-deferred-media-button]',
        productContentWrapper: '[data-product-content-wrapper]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productModel: '[data-model]',
        productLink: '[data-product-link]',
        productSingleMediaImage: '[data-product-single-media-image]',
        sliderContents: '[data-slider-contents]',
        sliderImages: '[data-slider-images]',
        tabButton: '[data-tab-button]',
        tabItem: '[data-tab-item]',
        circleText: '[data-circle-text]',
    };
    const classes$6 = {
        aosAnimate: 'aos-animate',
        tabButtonActive: 'products-list__nav__button--active',
        tabItemActive: 'products-list__item--active',
        mediaHidden: 'media--hidden',
        isDisabled: 'is-disabled',
    };
    const sections$5 = {};
    class ProductsList {
        constructor(section) {
            this.container = section.container;
            this.sectionId = this.container.dataset.sectionId;
            this.tabButtons = this.container.querySelectorAll(selectors$6.tabButton);
            this.tabItems = this.container.querySelectorAll(selectors$6.tabItem);
            this.slidersImages = this.container.querySelectorAll(selectors$6.sliderImages);
            this.slidersContents = this.container.querySelectorAll(selectors$6.sliderContents);
            this.videos = [];
            this.flktyImages = [];
            this.flktyContent = [];
            this.sliderResizeEvent = () => this.resizeSlider();
            this.initButtons();
            this.initSliders();
            this.initProductVideos();
            this.initProductModel();
            this.initShopifyXrLaunch();
            this.listen()
        }
        listen() {
            if (this.slidersImages.length > 0 || this.slidersContents.length > 0) {
                document.addEventListener('theme:resize', this.sliderResizeEvent)
            }
        }
        resizeSlider() {
            if (this.flktyImages.length > 0) {
                requestAnimationFrame( () => {
                    this.flktyImages.forEach( (flktyImages) => flktyImages.resize())
                }
                )
            }
            if (this.flktyContent.length > 0) {
                requestAnimationFrame( () => {
                    this.flktyContent.forEach( (flktyContent) => flktyContent.resize())
                }
                )
            }
        }
        initButtons() {
            if (this.tabButtons.length) {
                this.tabButtons.forEach( (tabButton) => {
                    tabButton.addEventListener('click', (e) => {
                        if (tabButton.classList.contains(classes$6.tabButtonActive)) {
                            return
                        }
                        const currentTabAnchor = tabButton.getAttribute(attributes$5.href);
                        const currentTab = this.container.querySelector(currentTabAnchor);
                        const currentMedia = currentTab.querySelector(selectors$6.productMediaWrapper);
                        const mediaId = currentMedia ? currentMedia.dataset.mediaId : null;
                        const currentCircleText = currentTab.querySelector(selectors$6.circleText);
                        this.tabButtons.forEach( (button) => {
                            button.classList.remove(classes$6.tabButtonActive)
                        }
                        );
                        this.tabItems.forEach( (item) => {
                            const circleText = item.querySelector(selectors$6.circleText);
                            item.classList.remove(classes$6.tabItemActive);
                            circleText?.classList.add(classes$6.isDisabled);
                            if (theme.settings.animationsEnabled) {
                                item.querySelectorAll(`.${classes$6.aosAnimate}`).forEach( (element) => {
                                    element.classList.remove(classes$6.aosAnimate);
                                    setTimeout( () => {
                                        element.classList.add(classes$6.aosAnimate)
                                    }
                                    )
                                }
                                )
                            }
                        }
                        );
                        tabButton.classList.add(classes$6.tabButtonActive);
                        currentTab.classList.add(classes$6.tabItemActive);
                        document.dispatchEvent(new CustomEvent('theme:resize'));
                        if (currentCircleText) {
                            currentCircleText.classList.remove(classes$6.isDisabled);
                            document.dispatchEvent(new CustomEvent('theme:scroll'))
                        }
                        this.handleProductVideos(currentTab, mediaId);
                        e.preventDefault()
                    }
                    )
                }
                )
            }
        }
        initSliders() {
            this.slidersImages.forEach( (sliderImages, idx) => {
                const contentsElement = sliderImages.closest(selectors$6.tabItem).querySelector(selectors$6.sliderContents);
                const flktyImages = new Flickity(sliderImages,{
                    fade: !0,
                    pageDots: !1,
                    prevNextButtons: !0,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    asNavFor: contentsElement,
                    on: {
                        change: (index) => {
                            if (this.flktyContent.length > 0) {
                                this.flktyContent[idx].select(index)
                            }
                        }
                        ,
                    },
                });
                flktyImages.on('settle', (index) => {
                    const elements = sliderImages.querySelectorAll(selectors$6.productMediaWrapper);
                    for (let i = 0; i < elements.length; i++) {
                        if (i === index) {
                            elements[i].querySelector(selectors$6.productSingleMediaImage).removeAttribute('tabindex')
                        } else {
                            elements[i].querySelector(selectors$6.productSingleMediaImage).setAttribute('tabindex', '-1')
                        }
                    }
                }
                );
                this.flktyImages.push(flktyImages)
            }
            );
            this.slidersContents.forEach( (sliderContent) => {
                const flktyContent = new Flickity(sliderContent,{
                    fade: !0,
                    pageDots: !1,
                    prevNextButtons: !1,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                });
                flktyContent.on('settle', (index) => {
                    const elements = sliderContent.querySelectorAll(selectors$6.productContentWrapper);
                    for (let i = 0; i < elements.length; i++) {
                        if (i === index) {
                            elements[i].querySelectorAll(selectors$6.productLink).forEach( (element) => {
                                element.removeAttribute('tabindex')
                            }
                            )
                        } else {
                            elements[i].querySelectorAll(selectors$6.productLink).forEach( (element) => {
                                element.setAttribute('tabindex', '-1')
                            }
                            )
                        }
                    }
                }
                );
                this.flktyContent.push(flktyContent)
            }
            )
        }
        initProductVideos() {
            this.tabItems.forEach( (item) => {
                if (item.classList.contains(classes$6.tabItemActive)) {
                    this.handleProductVideos(item)
                }
            }
            )
        }
        loadVideos(container, mediaId=null) {
            const videoObserver = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    if (entry.isIntersecting) {
                        const productVideo = new ProductVideo(container);
                        this.videos.push(productVideo);
                        container.setAttribute(attributes$5.deferredMediaLoaded, '');
                        this.playToggle(mediaId);
                        observer.unobserve(entry.target)
                    }
                }
                )
            }
            ,{
                root: null,
                rootMargin: '300px',
                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
            });
            videoObserver.observe(container)
        }
        handleProductVideos(container, mediaId=null) {
            if (!container.hasAttribute(attributes$5.deferredMediaLoaded)) {
                this.loadVideos(container, mediaId);
                return
            }
            this.playToggle(mediaId)
        }
        playToggle(mediaId) {
            this.videos.forEach( (element) => {
                if (typeof element.pauseContainerMedia === 'function' && mediaId) {
                    element.pauseContainerMedia(mediaId, this.container);
                    this.switchMedia(mediaId)
                }
                if (!mediaId && Object.keys(element.players).length === 0) {
                    this.pauseContainerMedia(this.container)
                }
            }
            )
        }
        switchMedia(mediaId) {
            const selectedMedia = this.container.querySelector(`${selectors$6.productMediaWrapper}[${attributes$5.mediaId}="${mediaId}"]`);
            const isFocusEnabled = !document.body.classList.contains(classes$6.noOutline);
            if (isFocusEnabled) {
                selectedMedia.focus()
            }
            selectedMedia.classList.remove(classes$6.mediaHidden);
            selectedMedia.dispatchEvent(new CustomEvent('theme:media:visible'), {
                bubbles: !0
            })
        }
        pauseContainerMedia(container) {
            const mediaItems = container.querySelectorAll(selectors$6.productMediaWrapper);
            if (mediaItems.length === 0)
                return;
            mediaItems.forEach( (media) => {
                media.dispatchEvent(new CustomEvent('theme:media:hidden'), {
                    bubbles: !0
                });
                media.classList.add(classes$6.mediaHidden)
            }
            )
        }
        initProductModel() {
            const modelItems = this.container.querySelectorAll(selectors$6.productModel);
            if (modelItems.length) {
                modelItems.forEach( (element) => {
                    theme.ProductModel.init(element, this.sectionId)
                }
                )
            }
        }
        initShopifyXrLaunch() {
            document.addEventListener('shopify_xr_launch', () => {
                const currentMedia = this.container.querySelector(`${selectors$6.productModel}:not(.${classes$6.mediaHidden})`);
                currentMedia.dispatchEvent(new CustomEvent('xrLaunch'))
            }
            )
        }
        onBlockSelect(evt) {
            evt.target.dispatchEvent(new Event('click'))
        }
        onUnload() {
            if (this.slidersImages.length > 0 || this.slidersContents.length > 0) {
                document.removeEventListener('theme:resize', this.sliderResizeEvent)
            }
        }
    }
    const productsListSection = {
        onLoad() {
            sections$5[this.id] = new ProductsList(this)
        },
        onUnload() {
            sections$5[this.id].onUnload()
        },
        onBlockSelect(e) {
            sections$5[this.id].onBlockSelect(e)
        },
    };
    register('products-list', [productsListSection, parallaxSection]);
    const selectors$5 = {
        product: '[data-product-block]',
        relatedProducts: '[data-related-products]',
        recentlyViewed: '[data-recent-wrapper]',
        recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
        slider: '[data-slider]',
        slide: '[data-slide]',
        aos: '[data-aos]',
        tabsHolder: '[data-tabs-holder]',
        tabsLink: '[data-tabs-link]',
        tab: '[data-tab]',
        tooltip: '[data-tooltip]',
    };
    const attributes$4 = {
        sectionId: 'data-section-id',
        productId: 'data-product-id',
        limit: 'data-limit',
        minimum: 'data-minimum',
        tabsLink: 'data-tabs-link',
        columnsMobile: 'data-column-mobile',
    };
    const classes$5 = {
        hidden: 'hidden',
        aosAnimate: 'aos-animate',
        oneWhole: 'mobile--one-whole',
        oneHalf: 'mobile--one-half',
    };
    const sections$4 = {};
    class RelatedProducts {
        constructor(section) {
            this.section = section;
            this.sectionId = section.id;
            this.container = section.container;
            this.related();
            this.recent();
            this.tabs = new Tabs(this.container)
        }
        related() {
            this.relatedProducts = this.container.querySelector(selectors$5.relatedProducts);
            if (!this.relatedProducts) {
                return
            }
            const sectionId = this.container.getAttribute(attributes$4.sectionId);
            const productId = this.container.getAttribute(attributes$4.productId);
            const limit = this.container.getAttribute(attributes$4.limit);
            const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;
            fetch(requestUrl).then( (response) => {
                if (!response.ok) {
                    const error = new Error(response.status);
                    this.hideRelated();
                    throw error
                }
                return response.text()
            }
            ).then( (data) => {
                const createdElement = document.createElement('div');
                createdElement.innerHTML = data;
                const inner = createdElement.querySelector(selectors$5.relatedProducts);
                if (!inner)
                    return;
                if (inner.querySelectorAll(selectors$5.product).length) {
                    this.relatedProducts.innerHTML = inner.innerHTML;
                    this.relatedProductGrid = new ProductGrid(this.relatedProducts);
                    this.relatedGridSlider = new GridSlider(this.container);
                    this.initTooltips(this.relatedProducts)
                }
            }
            )
        }
        recent() {
            const recentlyViewed = this.container.querySelector(selectors$5.recentlyViewed);
            const howManyToshow = recentlyViewed ? parseInt(recentlyViewed.getAttribute(attributes$4.limit)) : 4;
            Shopify.Products.showRecentlyViewed({
                howManyToShow: howManyToshow,
                wrapperId: `recently-viewed-products-${this.sectionId}`,
                section: this.section,
                onComplete: (wrapper, section) => {
                    const container = section.container;
                    const recentlyViewedHolder = container.querySelector(selectors$5.recentlyViewed);
                    const recentlyViewedWrapper = container.querySelector(selectors$5.recentlyViewedWrapper);
                    const recentProducts = wrapper.querySelectorAll(selectors$5.product);
                    const aosItem = recentlyViewedHolder.querySelectorAll(selectors$5.aos);
                    const slider = recentlyViewedHolder.querySelector(selectors$5.slider);
                    const minimumNumberProducts = recentlyViewedHolder.hasAttribute(attributes$4.minimum) ? parseInt(recentlyViewedHolder.getAttribute(attributes$4.minimum)) : 1;
                    const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
                    const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;
                    const columnsMobile = slider.getAttribute(attributes$4.columnsMobile);
                    if (checkRecentInRelated || checkRecentOutsideRelated) {
                        this.recentProductGrid = new ProductGrid(recentlyViewedHolder);
                        this.initTooltips(recentlyViewedHolder);
                        if (checkRecentOutsideRelated) {
                            container.classList.remove(classes$5.hidden)
                        }
                        if (slider) {
                            this.recentGridSlider = new GridSlider(container);
                            requestAnimationFrame( () => {
                                this.recentGridSlider.sliders.forEach( (slider) => {
                                    slider.dispatchEvent(new CustomEvent('theme:slider:resize',{
                                        bubbles: !0
                                    }));
                                    this.recentGridSlider.setSliderArrowsPosition(slider)
                                }
                                )
                            }
                            );
                            slider.querySelectorAll(selectors$5.slide).forEach(slides => {
                                if (columnsMobile == 2) {
                                    slides.classList.add(classes$5.oneHalf);
                                    slides.classList.remove(classes$5.oneWhole)
                                } else {
                                    slides.classList.add(classes$5.oneWhole);
                                    slides.classList.remove(classes$5.oneHalf)
                                }
                            }
                            )
                        }
                        let itemsSet = [];
                        recentlyViewedHolder.addEventListener('theme:target:animate', (event) => {
                            itemsSet.push(event.detail);
                            if (itemsSet.length === aosItem.length) {
                                requestAnimationFrame( () => aosItem.forEach( (item) => item.classList.add(classes$5.aosAnimate)))
                            }
                        }
                        )
                    }
                }
                ,
            })
        }
        hideRelated() {
            const tab = this.relatedProducts.closest(selectors$5.tab);
            const tabsHolder = this.relatedProducts.closest(selectors$5.tabsHolder);
            const tabsLink = tabsHolder.querySelector(`[${attributes$4.tabsLink}="${tab.dataset.tab}"]`);
            tab.remove();
            if (!tabsLink)
                return;
            tabsLink.remove();
            tabsHolder.querySelector(selectors$5.tabsLink).dispatchEvent(new Event('click'));
            this.tabs.customScrollbar.unload();
            requestAnimationFrame( () => {
                this.tabs.customScrollbar = new CustomScrollbar(this.tabs.container)
            }
            )
        }
        initTooltips(container) {
            this.tooltips = container.querySelectorAll(selectors$5.tooltip);
            this.tooltips.forEach( (tooltip) => {
                new Tooltip(tooltip)
            }
            )
        }
        onDeselect() {
            if (this.relatedProductGrid)
                this.relatedProductGrid.onDeselect();
            if (this.recentProductGrid)
                this.recentProductGrid.onDeselect();
        }
        onBlockSelect(event) {
            const element = event.target;
            const tab = this.container.querySelectorAll(selectors$5.tab);
            if (!element || tab.length < 2)
                return;
            element.dispatchEvent(new Event('click'));
            element.parentNode.scrollTo({
                top: 0,
                left: element.offsetLeft - element.clientWidth,
                behavior: 'smooth',
            })
        }
        onUnload() {
            if (this.relatedProductGrid)
                this.relatedProductGrid.onUnload();
            if (this.relatedGridSlider)
                this.relatedGridSlider.onUnload();
            if (this.recentProductGrid)
                this.recentProductGrid.onUnload();
            if (this.recentGridSlider)
                this.recentGridSlider.onUnload();
        }
    }
    const relatedProductsSection = {
        onLoad() {
            sections$4[this.id] = new RelatedProducts(this)
        },
        onDeselect() {
            sections$4[this.id].onDeselect()
        },
        onBlockSelect(event) {
            sections$4[this.id].onBlockSelect(event)
        },
        onUnload() {
            sections$4[this.id].onUnload()
        },
    };
    register('related-products', relatedProductsSection);
    register('recent-products', relatedProductsSection);
    const sections$3 = {};
    const selectors$4 = {
        slider: '[data-slider]',
        sliderItem: '[data-item]',
        buttonProductsShow: '[data-button-show]',
        buttonProductsHide: '[data-button-hide]',
        itemProducts: '[data-item-products]',
        itemProductSlider: '[data-item-products-slider]',
        itemProduct: '[data-item-product]',
        links: 'a, button',
    };
    const classes$4 = {
        itemActive: 'blog-item--active',
        itemProductsVisible: 'blog-item__products--visible',
        featuredBlogSlider: 'shoppable-blog__slider',
        flickityEnabled: 'flickity-enabled',
        isSelected: 'is-selected',
    };
    const attributes$3 = {
        slider: 'data-slider',
        slidePosition: 'data-slide-position',
        sectionId: 'data-section-id',
        tabIndex: 'tabindex',
    };
    class ShoppableBlog {
        constructor(section) {
            this.container = section.container;
            this.flkty = null;
            this.slider = this.container.querySelector(selectors$4.slider);
            this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
            this.isFullWidth = this.container.hasAttribute(attributes$3.fullWidth);
            this.gutter = 0;
            this.a11y = a11y;
            this.clickOutsideItemEvent = (e) => {
                const clickOutsideSliderItem = !(e.target.matches(selectors$4.sliderItem) || e.target.closest(selectors$4.sliderItem));
                if (clickOutsideSliderItem) {
                    const sliderItem = this.container.querySelectorAll(selectors$4.sliderItem);
                    if (sliderItem.length) {
                        sliderItem.forEach( (item) => {
                            const itemProducts = item.querySelector(selectors$4.itemProducts);
                            if (itemProducts) {
                                itemProducts.classList.remove(classes$4.itemProductsVisible);
                                this.changeTabIndex(itemProducts)
                            }
                            item.classList.remove(classes$4.itemActive)
                        }
                        )
                    }
                }
            }
            ;
            this.bindButtons();
            this.listen()
        }
        initSlider() {
            this.flkty = new Flickity(this.slider,{
                prevNextButtons: !0,
                pageDots: !1,
                cellAlign: 'left',
                wrapAround: !1,
                groupCells: !0,
                contain: !0,
                on: {
                    ready: () => {
                        this.handleFocus()
                    }
                    ,
                },
            });
            this.flkty.on('change', () => {
                const slides = this.container.querySelectorAll(selectors$4.sliderItem);
                this.handleFocus();
                if (slides.length) {
                    slides.forEach( (el) => {
                        const itemProducts = el.querySelector(selectors$4.itemProducts);
                        el.classList.remove(classes$4.itemActive);
                        if (itemProducts) {
                            el.querySelector(selectors$4.itemProducts).classList.remove(classes$4.itemProductsVisible)
                        }
                    }
                    )
                }
                if (this.flkty && !this.flkty.options.draggable) {
                    this.flkty.options.draggable = !0;
                    this.flkty.updateDraggable()
                }
            }
            )
        }
        destroySlider() {
            if (this.flkty !== null) {
                this.flkty.destroy();
                this.flkty = null
            }
        }
        checkSlidesSize() {
            const sliderItemStyle = this.container.querySelector(selectors$4.sliderItem).currentStyle || window.getComputedStyle(this.container.querySelector(selectors$4.sliderItem));
            this.gutter = parseInt(sliderItemStyle.marginRight);
            const containerWidth = this.slider.offsetWidth + this.gutter;
            const itemsWidth = this.getItemsWidth();
            const itemsOverflowViewport = containerWidth < itemsWidth;
            if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
                this.initSlider()
            } else {
                this.destroySlider()
            }
        }
        getItemsWidth() {
            let itemsWidth = 0;
            const slides = this.slider.querySelectorAll(selectors$4.sliderItem);
            if (slides.length) {
                slides.forEach( (item) => {
                    itemsWidth += item.offsetWidth + this.gutter
                }
                )
            }
            return itemsWidth
        }
        bindButtons() {
            const itemProductSlider = this.container.querySelectorAll(selectors$4.itemProductSlider);
            const buttonProductsShow = this.container.querySelectorAll(selectors$4.buttonProductsShow);
            const buttonProductsHide = this.container.querySelectorAll(selectors$4.buttonProductsHide);
            if (buttonProductsShow.length) {
                buttonProductsShow.forEach( (button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.container.querySelectorAll(selectors$4.sliderItem).forEach( (item) => {
                            const itemProducts = item.querySelector(selectors$4.itemProducts);
                            item.classList.remove(classes$4.itemActive);
                            if (itemProducts) {
                                itemProducts.classList.remove(classes$4.itemProductsVisible);
                                this.changeTabIndex(itemProducts)
                            }
                        }
                        );
                        const item = button.closest(selectors$4.sliderItem);
                        const itemProducts = item.querySelector(selectors$4.itemProducts);
                        item.classList.add(classes$4.itemActive);
                        if (itemProducts) {
                            itemProducts.classList.add(classes$4.itemProductsVisible);
                            this.changeTabIndex(itemProducts, 'enable');
                            const itemProductsSlider = itemProducts.querySelector(selectors$4.itemProductSlider);
                            const allSlides = itemProductsSlider.querySelectorAll(selectors$4.itemProduct);
                            const sliderActive = itemProductsSlider.classList.contains(classes$4.flickityEnabled);
                            if (sliderActive) {
                                const currentSlide = itemProductsSlider.querySelector(`.${classes$4.isSelected}`);
                                const currentSlideIndex = currentSlide.getAttribute(attributes$3.slidePosition);
                                allSlides.forEach( (slide, i) => {
                                    slide.setAttribute(attributes$3.tabIndex, i === currentSlideIndex ? '0' : '-1')
                                }
                                )
                            }
                        }
                        if (this.flkty !== null) {
                            this.flkty.options.draggable = !1;
                            this.flkty.updateDraggable()
                        }
                        this.a11y.state.trigger = button
                    }
                    )
                }
                )
            }
            if (buttonProductsHide.length) {
                buttonProductsHide.forEach( (button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const item = button.closest(selectors$4.sliderItem);
                        const itemProducts = item.querySelector(selectors$4.itemProducts);
                        item.classList.remove(classes$4.itemActive);
                        if (itemProducts) {
                            itemProducts.classList.remove(classes$4.itemProductsVisible);
                            this.changeTabIndex(itemProducts)
                        }
                        if (this.flkty !== null) {
                            this.flkty.options.draggable = !0;
                            this.flkty.updateDraggable()
                        }
                        this.a11y.state.trigger.focus()
                    }
                    )
                }
                )
            }
            if (itemProductSlider.length) {
                itemProductSlider.forEach( (slider) => {
                    const countSlides = slider.querySelectorAll(selectors$4.itemProduct).length;
                    if (countSlides > 1) {
                        const flktyProducts = new Flickity(slider,{
                            prevNextButtons: !0,
                            contain: !0,
                            pageDots: !1,
                            wrapAround: !0,
                            on: {
                                change: (index) => {
                                    flktyProducts.cells.forEach( (slide, i) => {
                                        slide.element.querySelectorAll(selectors$4.links).forEach( (link) => {
                                            link.setAttribute(attributes$3.tabIndex, i === index ? '0' : '-1')
                                        }
                                        )
                                    }
                                    )
                                }
                                ,
                            },
                        })
                    }
                }
                )
            }
            this.slider.addEventListener('keyup', (event) => {
                if (event.code === theme.keyboardKeys.ESCAPE) {
                    const sliderItem = event.target.hasAttribute(attributes$3.slider) ? event.target.querySelectorAll(selectors$4.sliderItem) : event.target.closest(selectors$4.slider).querySelectorAll(selectors$4.sliderItem);
                    if (sliderItem.length) {
                        sliderItem.forEach( (item) => {
                            const itemProducts = item.querySelector(selectors$4.itemProducts);
                            item.classList.remove(classes$4.itemActive);
                            if (itemProducts) {
                                itemProducts.classList.remove(classes$4.itemProductsVisible);
                                this.changeTabIndex(itemProducts)
                            }
                        }
                        );
                        if (this.flkty) {
                            this.flkty.options.draggable = !0;
                            this.flkty.updateDraggable()
                        }
                    }
                    this.a11y.state.trigger.focus()
                }
            }
            )
        }
        handleFocus() {
            const sliderItems = this.container.querySelectorAll(selectors$4.sliderItem);
            if (sliderItems.length) {
                sliderItems.forEach( (item) => {
                    const selected = item.classList.contains(classes$4.isSelected);
                    const itemProducts = item.querySelector(selectors$4.itemProducts);
                    if (!selected) {
                        this.changeTabIndex(item);
                        if (itemProducts) {
                            itemProducts.classList.remove(classes$4.itemProductsVisible)
                        }
                    } else {
                        this.changeTabIndex(item, 'enable');
                        if (itemProducts) {
                            this.changeTabIndex(itemProducts)
                        }
                    }
                }
                )
            }
        }
        listen() {
            if (this.slider) {
                this.checkSlidesSize();
                document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize)
            }
            document.addEventListener('mousedown', this.clickOutsideItemEvent)
        }
        changeTabIndex(items, state='') {
            const tabIndex = state === 'enable' ? '0' : '-1';
            items.querySelectorAll(selectors$4.links).forEach( (link) => {
                link.setAttribute(attributes$3.tabIndex, tabIndex)
            }
            )
        }
        onBlockSelect(evt) {
            if (this.flkty !== null) {
                const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
                const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
                const groupIndex = Math.floor(index / slidesPerPage);
                this.flkty.select(groupIndex)
            } else {
                const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
                const sliderPadding = parseInt(sliderStyle.paddingLeft);
                const blockPositionLeft = evt.target.offsetLeft - sliderPadding;
                this.slider.scrollTo({
                    top: 0,
                    left: blockPositionLeft,
                    behavior: 'smooth',
                })
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
            document.removeEventListener('mousedown', this.clickOutsideItemEvent)
        }
    }
    const shoppableBlogSection = {
        onLoad() {
            sections$3[this.id] = new ShoppableBlog(this)
        },
        onUnload(e) {
            sections$3[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$3[this.id].onBlockSelect(e)
        },
    };
    register('shoppable-blog', shoppableBlogSection);
    const selectors$3 = {
        arrowScrollDown: '[data-scroll-down]',
        header: '[data-site-header]',
        item: '[data-slide]',
        links: 'a, button',
        slider: '[data-slider]',
        lazyImage: '.lazy-image',
    };
    const attributes$2 = {
        style: 'data-style',
        currentStyle: 'data-current-style',
        tabIndex: 'tabindex',
        slidePosition: 'data-slide-position',
    };
    const classes$3 = {
        headerFixed: 'site-header--fixed',
        sliderNoCachedImages: 'slider--no-cached-images',
        sliderImgLoaded: 'slider--img-loaded',
        imgIn: 'img-in',
    };
    const sections$2 = {};
    class Slider {
        constructor(section) {
            this.container = section.container;
            this.header = document.querySelector(selectors$3.header);
            this.flkty = null;
            this.resizeEvent = () => {
                this.flkty.resize()
            }
            ;
            this.initSlider();
            this.bindScrollButton()
        }
        initSlider() {
            const slidesCount = this.container.querySelectorAll(selectors$3.item).length;
            const duration = parseInt(this.container.dataset.duration);
            const pageDots = this.container.dataset.pageDots === 'true' && slidesCount > 1;
            const prevNextButtons = this.container.dataset.navArrows === 'true' && slidesCount > 1;
            let autoplay = this.container.dataset.autoplay === 'true';
            if (autoplay) {
                autoplay = duration
            }
            if (slidesCount > 1) {
                this.flkty = new Flickity(this.container,{
                    fade: !0,
                    cellSelector: selectors$3.item,
                    autoPlay: autoplay,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    setGallerySize: !0,
                    imagesLoaded: !0,
                    pageDots: pageDots,
                    prevNextButtons: prevNextButtons,
                    on: {
                        ready: () => {
                            const currentStyle = this.container.querySelector(`${selectors$3.item}[${attributes$2.slidePosition}="1"]`).getAttribute(attributes$2.style);
                            this.container.setAttribute(attributes$2.currentStyle, currentStyle);
                            requestAnimationFrame(this.resizeEvent);
                            document.addEventListener('theme:vars', this.resizeEvent);
                            this.handleFirstSlideAnimation(!0)
                        }
                        ,
                        change: (index) => {
                            const currentSlide = this.flkty.selectedElement;
                            const currentStyle = currentSlide.getAttribute(attributes$2.style);
                            this.container.setAttribute(attributes$2.currentStyle, currentStyle);
                            this.handleFirstSlideAnimation(!1);
                            this.flkty.cells.forEach( (slide, i) => {
                                slide.element.querySelectorAll(selectors$3.links).forEach( (link) => {
                                    link.setAttribute(attributes$2.tabIndex, i === index ? '0' : '-1')
                                }
                                )
                            }
                            )
                        }
                        ,
                    },
                });
                flickitySmoothScrolling(this.container)
            } else if (slidesCount === 1) {
                const currentStyle = this.container.querySelector(selectors$3.item).getAttribute(attributes$2.style);
                this.container.setAttribute(attributes$2.currentStyle, currentStyle)
            }
        }
        handleFirstSlideAnimation(onLoad=!1) {
            if (!onLoad) {
                this.container.classList.remove(classes$3.sliderNoCachedImages);
                this.container.classList.remove(classes$3.sliderImgLoaded);
                return
            }
            const firstSlide = this.container.querySelectorAll(selectors$3.item)[0];
            const slideImage = firstSlide.querySelectorAll(selectors$3.lazyImage);
            const slideImgComplete = this.container.classList.contains(classes$3.imgIn);
            if (slideImage.length && !slideImgComplete) {
                this.container.classList.add(classes$3.sliderNoCachedImages);
                const onImageTransitionEnd = (event) => {
                    requestAnimationFrame( () => this.container.classList.add(classes$3.sliderImgLoaded));
                    slideImage[0].removeEventListener('transitionend', onImageTransitionEnd)
                }
                ;
                slideImage[0].addEventListener('transitionend', onImageTransitionEnd)
            }
        }
        bindScrollButton() {
            const arrowDown = this.container.querySelector(selectors$3.arrowScrollDown);
            if (arrowDown) {
                arrowDown.addEventListener('click', (e) => {
                    e.preventDefault();
                    const headerHeight = this.header.classList.contains(classes$3.headerFixed) ? 60 : 0;
                    const scrollToPosition = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - headerHeight));
                    window.scrollTo({
                        top: scrollToPosition,
                        left: 0,
                        behavior: 'smooth',
                    })
                }
                )
            }
        }
        onBlockSelect(evt) {
            const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
            if (this.flkty !== null) {
                this.flkty.select(index);
                this.flkty.pausePlayer()
            }
        }
        onBlockDeselect(evt) {
            const autoplay = evt.target.closest(selectors$3.slider).dataset.autoplay === 'true';
            if (autoplay && this.flkty !== null) {
                this.flkty.playPlayer()
            }
        }
        onReorder() {
            this.handleFirstSlideAnimation(!1);
            if (this.flkty !== null) {
                this.flkty.resize()
            }
        }
        onUnload() {
            this.handleFirstSlideAnimation(!1);
            if (this.flkty !== null) {
                document.removeEventListener('theme:vars', this.resizeEvent);
                this.flkty.destroy();
                this.flkty = null
            }
        }
    }
    const slider = {
        onLoad() {
            sections$2[this.id] = new Slider(this)
        },
        onReorder(e) {
            sections$2[this.id].onReorder(e)
        },
        onUnload(e) {
            sections$2[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$2[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            sections$2[this.id].onBlockDeselect(e)
        },
    };
    register('slider', [slider, videoPlay, zoomAnimation]);
    const selectors$2 = {
        wrapper: '[data-sticky-wrapper]',
        aside: '[data-sticky-aside]',
        inner: '[data-sticky-inner]',
        content: '[data-sticky-content]',
        text: '[data-sticky-text]',
        textInner: '[data-sticky-text-inner]',
        image: '[data-sticky-image]',
        images: '[data-sticky-images]',
        imageWrapper: '.image-wrapper',
        dot: '[data-sticky-dot]',
    };
    const attributes$1 = {
        withGaps: 'data-sticky-with-gaps',
        singleText: 'data-sticky-single-text',
        index: 'data-index',
    };
    const settings = {
        intersectionRatio: 0.5,
        scrollDirection: {
            horizontal: 'horizontal',
            horizontalReversed: 'horizontal-reversed',
            vertical: 'vertical',
            verticalReversed: 'vertical-reversed',
        },
        typeOfIntersecting: {
            maxVisibility: 'maximum-visibility-of-each-image-in-viewport',
            middleOfViewport: 'image-in-the-middle-of-viewport',
        },
    };
    const classes$2 = {
        isActive: 'is-active',
    };
    const sections$1 = {};
    class StickyImagesAndText {
        constructor(section) {
            this.container = section.container;
            this.scrollDirection = this.container.dataset.scrollDirection;
            this.horizontalScroll = this.scrollDirection === settings.scrollDirection.horizontal || this.scrollDirection === settings.scrollDirection.horizontalReversed;
            this.verticalScroll = this.scrollDirection === settings.scrollDirection.vertical || this.scrollDirection === settings.scrollDirection.verticalReversed;
            this.reverseDirection = this.scrollDirection === settings.scrollDirection.horizontalReversed || this.scrollDirection === settings.scrollDirection.verticalReversed;
            this.direction = this.reverseDirection ? 1 : -1;
            this.withGaps = this.container.hasAttribute(attributes$1.withGaps);
            this.singleText = this.container.hasAttribute(attributes$1.singleText);
            this.image = this.container.querySelectorAll(selectors$2.image);
            this.text = this.container.querySelectorAll(selectors$2.text);
            this.textInner = this.container.querySelectorAll(selectors$2.textInner);
            this.images = this.container.querySelector(selectors$2.images);
            this.dot = this.container.querySelectorAll(selectors$2.dot);
            this.aside = this.container.querySelector(selectors$2.aside);
            this.inner = this.container.querySelector(selectors$2.inner);
            this.content = this.container.querySelector(selectors$2.content);
            this.wrapper = this.container.querySelector(selectors$2.wrapper);
            this.performAnimation = null;
            this.lastOffset = 0;
            this.activeIndex = 0;
            this.lastActiveIndex = this.activeIndex;
            if (!this.wrapper)
                return;
            this.onScrollCallback = () => this.onScroll();
            this.onResizeCallback = () => this.onResize();
            this.calculateImagesOffsetCallback = () => this.calculateImagesOffset();
            this.init()
        }
        init() {
            this.getTypeOfIntersecting();
            this.observeImagesIntersecting();
            this.calculateHeights();
            this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback);
            requestAnimationFrame( () => this.calculateHeights());
            document.addEventListener('theme:scroll', this.onScrollCallback);
            document.addEventListener('theme:resize:width', this.onResizeCallback);
            this.syncDots()
        }
        getTypeOfIntersecting() {
            this.typeOfIntersecting = settings.typeOfIntersecting.maxVisibility;
            this.fractionOfViewport = this.image[0].offsetHeight / window.innerHeight;
            if (!this.verticalScroll || isMobile())
                return;
            if (this.fractionOfViewport < 0.6) {
                this.typeOfIntersecting = settings.typeOfIntersecting.middleOfViewport
            }
        }
        observeImagesIntersecting() {
            this.observersCollection = new Set();
            this.compareIntersectionRatio = [];
            this.maxVisibility = 0;
            this.observer = new IntersectionObserver( (entries, observer) => {
                entries.forEach( (entry) => {
                    const target = entry.target;
                    const targetHeight = target.offsetHeight;
                    const intersectionRatio = entry.intersectionRatio;
                    const isIntersecting = entry.isIntersecting;
                    const currentStats = {
                        target: entry.target,
                        intersectionRatio: entry.intersectionRatio,
                    };
                    const checkMaxVisibility = this.typeOfIntersecting === settings.typeOfIntersecting.maxVisibility;
                    let intersectAt = settings.intersectionRatio;
                    if (this.windowHeight <= targetHeight) {
                        intersectAt = 0
                    }
                    if (checkMaxVisibility && isIntersecting) {
                        this.observersCollection.forEach( (item) => {
                            if (item.target === entry.target) {
                                this.observersCollection.delete(item)
                            }
                        }
                        );
                        this.observersCollection.add(currentStats);
                        this.compareIntersectionRatio = [...this.observersCollection].map( (item) => item.intersectionRatio);
                        this.maxVisibility = Math.max(...this.compareIntersectionRatio)
                    }
                    if (isIntersecting && intersectionRatio > intersectAt) {
                        if (checkMaxVisibility && this.maxVisibility === intersectionRatio) {
                            this.maxVisibilityItem = [...this.observersCollection].find( (item) => item.intersectionRatio === this.maxVisibility);
                            this.activeIndex = Number(this.maxVisibilityItem.target.dataset.index);
                            if (this.lastActiveIndex !== this.activeIndex) {
                                this.sync();
                                this.lastActiveIndex = this.activeIndex
                            }
                        }
                    }
                }
                )
            }
            ,{
                root: null,
                rootMargin: '0px',
                threshold: [0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1],
            });
            this.image.forEach( (image) => this.observer.observe(image))
        }
        onScroll() {
            if (!this.performAnimation) {
                this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)
            }
            if (this.typeOfIntersecting === settings.typeOfIntersecting.middleOfViewport) {
                this.image.forEach( (image) => this.checkImagePositionInViewport(image))
            }
        }
        removeAnimationFrame() {
            if (this.performAnimation) {
                cancelAnimationFrame(this.performAnimation);
                this.performAnimation = null
            }
        }
        checkImagePositionInViewport(element) {
            if (!element)
                return;
            const windowHeight = window.innerHeight;
            const scrollTop = window.scrollY;
            const scrollMiddle = scrollTop + windowHeight / 2;
            const scrollBottom = scrollTop + windowHeight;
            const elementOffsetTopPoint = Math.round(element.getBoundingClientRect().top + scrollTop);
            const elementHeight = element.offsetHeight;
            const elementOffsetBottomPoint = elementOffsetTopPoint + elementHeight;
            const isBottomOfElementPassed = elementOffsetBottomPoint < scrollTop;
            const isTopOfElementReached = elementOffsetTopPoint < scrollBottom;
            const isInView = isTopOfElementReached && !isBottomOfElementPassed;
            if (!isInView)
                return;
            if (scrollMiddle > elementOffsetTopPoint && elementOffsetBottomPoint > scrollMiddle) {
                this.activeIndex = Number(element.dataset.index);
                if (this.lastActiveIndex !== this.activeIndex) {
                    this.sync();
                    this.lastActiveIndex = this.activeIndex
                }
            }
        }
        calculateImagesOffset() {
            const asideTop = this.aside.getBoundingClientRect().top - this.headerHeight;
            const stickyStartingPoint = asideTop - this.innerStickyTop;
            let percent = 0;
            let offset = 0;
            const triggerPoint = !this.hasShortImages ? asideTop : stickyStartingPoint;
            if (triggerPoint < 0) {
                percent = (triggerPoint / this.bottomEndingPoint) * -1 * 100
            } else if (triggerPoint >= 0) {
                percent = 0
            } else {
                percent = 100
            }
            offset = percent > 100 ? 100 : percent;
            offset *= this.image.length - 1;
            if (isMobile() || this.horizontalScroll) {
                this.aside.style.setProperty('--translateX', `${Number(offset * this.direction).toFixed(2)}%`)
            }
            if (this.lastOffset !== offset) {
                this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)
            } else if (this.performAnimation) {
                this.removeAnimationFrame()
            }
            this.lastOffset = offset
        }
        calculateHeights() {
            let {stickyHeaderHeight, windowHeight} = readHeights();
            this.headerHeight = stickyHeaderHeight || 0;
            this.windowHeight = windowHeight || window.innerHeight;
            if (this.text.length > 0) {
                const contentPaddingTop = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue('padding-top')) : 0;
                const contentPaddingBottom = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue('padding-bottom')) : 0;
                const textElementsHeights = [...this.text].map( (element) => element.offsetHeight + contentPaddingTop + contentPaddingBottom);
                const textInnerElementsHeights = [...this.textInner].map( (element) => element.offsetHeight);
                const maxTextHeight = Math.max(...textElementsHeights);
                const maxTextInnerHeight = Math.max(...textInnerElementsHeights);
                const highestText = isMobile() ? maxTextInnerHeight : maxTextHeight;
                const textElementsHeightsSum = textElementsHeights.reduce( (a, b) => a + b, 0);
                const averageTextHeight = Math.floor(textElementsHeightsSum / textElementsHeights.length) || this.text[0].offsetHeight;
                this.container.style.removeProperty('--average-text-height');
                this.container.style.setProperty('--average-text-height', `${averageTextHeight}px`);
                this.container.style.removeProperty('--highest-text');
                this.container.style.setProperty('--highest-text', `${highestText}px`)
            }
            this.imagesHeight = this.images.offsetHeight;
            this.hasShortImages = !1;
            if (this.image.length > 0) {
                this.imgHeight = this.image[0].querySelector(selectors$2.imageWrapper).offsetHeight;
                this.imgPadding = parseInt(window.getComputedStyle(this.image[0]).getPropertyValue('padding-top'));
                this.container.style.removeProperty('--images-height');
                this.container.style.setProperty('--images-height', `${this.imagesHeight}px`);
                this.container.style.removeProperty('--img-height');
                this.container.style.setProperty('--img-height', `${this.imgHeight + 2 * this.imgPadding}px`)
            }
            this.asideHeight = this.aside.offsetHeight;
            this.asidePadding = parseInt(window.getComputedStyle(this.aside).getPropertyValue('padding-top'));
            this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2;
            this.innerStickyTop = parseInt(window.getComputedStyle(this.inner).getPropertyValue('top')) - this.headerHeight - this.breathingSpace;
            this.gutters = this.withGaps || isMobile() ? 2 * this.asidePadding : 0;
            this.minHeightForEndingPoing = this.imagesHeight + this.gutters;
            if (!isMobile() && this.horizontalScroll) {
                this.minHeightForEndingPoing = this.windowHeight - this.headerHeight;
                this.hasShortImages = this.fractionOfViewport <= 0.6;
                if (this.hasShortImages) {
                    this.minHeightForEndingPoing = this.imagesHeight - this.innerStickyTop + this.breathingSpace * 3
                }
            }
            this.bottomEndingPoint = this.asideHeight - this.minHeightForEndingPoing
        }
        refreshImagesOffsetValues() {
            requestAnimationFrame( () => {
                requestAnimationFrame( () => {
                    document.dispatchEvent(new CustomEvent('theme:scroll'))
                }
                )
            }
            )
        }
        onResize() {
            this.calculateHeights();
            requestAnimationFrame( () => this.calculateHeights());
            this.getTypeOfIntersecting();
            this.refreshImagesOffsetValues()
        }
        sync() {
            const textsToSync = !this.singleText ? this.text : [];
            [...this.image, ...textsToSync, ...this.dot].forEach( (element) => {
                const elementIndex = Number(element.getAttribute(attributes$1.index));
                element.classList.toggle(classes$2.isActive, elementIndex === Number(this.activeIndex))
            }
            )
        }
        syncDots() {
            this.dot.forEach( (element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    const activeIndex = Number(event.target.dataset.index);
                    const imageToScrollTo = this.image[activeIndex];
                    const targetOffsetTop = Math.round(imageToScrollTo.getBoundingClientRect().top + window.scrollY);
                    const targetHeight = imageToScrollTo.offsetHeight;
                    const containerTop = this.wrapper.offsetTop;
                    const imagesHeight = this.images.offsetHeight;
                    const scrollOffset = containerTop + imagesHeight * activeIndex;
                    let distance = scrollOffset - this.headerHeight;
                    if (this.verticalScroll && isDesktop()) {
                        distance = targetOffsetTop - this.headerHeight;
                        if (this.typeOfIntersecting === settings.typeOfIntersecting.middleOfViewport) {
                            distance = targetOffsetTop - window.innerHeight / 2 + targetHeight / 2 - this.headerHeight
                        }
                    }
                    window.scrollTo({
                        top: distance,
                        left: 0,
                        behavior: 'smooth',
                    })
                }
                )
            }
            )
        }
        onUnload() {
            this.image.forEach( (image) => this.observer.unobserve(image));
            document.removeEventListener('theme:scroll', this.onScrollCallback);
            document.removeEventListener('theme:resize:width', this.onResizeCallback)
        }
        onBlockSelect(event) {
            const activeIndex = Number(event.target.dataset.index);
            const targetOffsetTop = Math.round(event.target.getBoundingClientRect().top + window.scrollY);
            const targetHeight = event.target.offsetHeight;
            const containerTop = this.wrapper.offsetTop;
            const imagesHeight = this.images.offsetHeight;
            const scrollOffset = containerTop + imagesHeight * activeIndex;
            let distance = scrollOffset - this.headerHeight;
            if (this.verticalScroll && isDesktop()) {
                distance = targetOffsetTop - this.headerHeight;
                if (this.typeOfIntersecting === settings.typeOfIntersecting.middleOfViewport) {
                    distance = targetOffsetTop - window.innerHeight / 2 + targetHeight / 2 - this.headerHeight
                }
            }
            setTimeout( () => {
                window.scrollTo({
                    top: distance,
                    left: 0,
                    behavior: 'smooth',
                })
            }
            , 500)
        }
    }
    const stickyImagesAndText = {
        onLoad() {
            sections$1[this.id] = new StickyImagesAndText(this)
        },
        onUnload() {
            sections$1[this.id].onUnload()
        },
        onBlockSelect(event) {
            sections$1[this.id].onBlockSelect(event)
        },
    };
    register('sticky-images-and-text', [stickyImagesAndText, videoPlay]);
    register('subcollections', gridSlider);
    register('tab-collections', [productGrid, gridSlider, tabs]);
    const sections = {};
    const selectors$1 = {
        slider: '[data-slider]',
        item: '[data-item]',
    };
    const classes$1 = {
        flickityEnabled: 'flickity-enabled',
    };
    const attributes = {
        sectionId: 'data-section-id',
    };
    class Testimonials {
        constructor(section) {
            this.container = section.container;
            this.sectionId = this.container.getAttribute(attributes.sectionId);
            this.slider = this.container.querySelector(selectors$1.slider);
            this.sliderResizeEvent = () => this.initSlider();
            this.flkty = null;
            this.initSlider();
            document.addEventListener('theme:resize:width', this.sliderResizeEvent)
        }
        initSlider() {
            const slidesCount = this.slider.querySelectorAll(selectors$1.item).length;
            let flickityEnabled = this.slider.classList.contains(classes$1.flickityEnabled);
            if ((slidesCount == 2 && window.innerWidth >= theme.sizes.small) || slidesCount == 1 || window.innerWidth < theme.sizes.small) {
                if (flickityEnabled) {
                    this.flkty.destroy()
                }
                return
            }
            this.flkty = new Flickity(this.slider,{
                cellSelector: selectors$1.item,
                prevNextButtons: !0,
                pageDots: !1,
                groupCells: !0,
                cellAlign: 'left',
                contain: !0,
                adaptiveHeight: !1,
            });
            this.flkty.resize();
            const isLargerThanVw = this.flkty.slideableWidth > this.flkty.size.width;
            if (!isLargerThanVw) {
                this.flkty.destroy()
            }
        }
        onBlockSelect(evt) {
            if (this.flkty !== null) {
                const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
                const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
                const groupIndex = Math.floor(index / slidesPerPage);
                this.flkty.select(groupIndex)
            } else {
                const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
                const sliderPadding = parseInt(sliderStyle.paddingLeft);
                const blockPositionLeft = evt.target.offsetLeft - sliderPadding;
                this.slider.scrollTo({
                    top: 0,
                    left: blockPositionLeft,
                    behavior: 'smooth',
                })
            }
        }
        onUnload() {
            document.removeEventListener('theme:resize:width', this.sliderResizeEvent)
        }
    }
    const TestimonialsSection = {
        onLoad() {
            sections[this.id] = new Testimonials(this)
        },
        onUnload(e) {
            sections[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections[this.id].onBlockSelect(e)
        },
    };
    register('testimonials', TestimonialsSection);
    const classes = {
        noOutline: 'no-outline',
    };
    const selectors = {
        inPageLink: '[data-skip-content]',
        linkesWithOnlyHash: 'a[href="#"]',
    };
    class Accessibility {
        constructor() {
            this.init()
        }
        init() {
            this.body = document.body;
            this.inPageLink = document.querySelector(selectors.inPageLink);
            this.linkesWithOnlyHash = document.querySelectorAll(selectors.linkesWithOnlyHash);
            this.isFocused = !1;
            this.focusHash();
            this.bindInPageLinks();
            this.clickEvents();
            this.focusEvents();
            this.focusEventsOff()
        }
        clickEvents() {
            if (this.inPageLink) {
                this.inPageLink.addEventListener('click', (event) => {
                    event.preventDefault()
                }
                )
            }
            if (this.linkesWithOnlyHash) {
                this.linkesWithOnlyHash.forEach( (item) => {
                    item.addEventListener('click', (event) => {
                        event.preventDefault()
                    }
                    )
                }
                )
            }
        }
        focusEvents() {
            document.addEventListener('keyup', (event) => {
                if (event.code !== theme.keyboardKeys.TAB) {
                    return
                }
                this.body.classList.remove(classes.noOutline);
                this.isFocused = !0
            }
            )
        }
        focusEventsOff() {
            document.addEventListener('mousedown', () => {
                this.body.classList.add(classes.noOutline);
                this.isFocused = !1
            }
            )
        }
        forceFocus(element, options) {
            options = options || {};
            var savedTabIndex = element.tabIndex;
            element.tabIndex = -1;
            element.dataset.tabIndex = savedTabIndex;
            element.focus();
            if (typeof options.className !== 'undefined') {
                element.classList.add(options.className)
            }
            element.addEventListener('blur', callback);
            function callback(event) {
                event.target.removeEventListener(event.type, callback);
                element.tabIndex = savedTabIndex;
                delete element.dataset.tabIndex;
                if (typeof options.className !== 'undefined') {
                    element.classList.remove(options.className)
                }
            }
        }
        focusHash(options) {
            options = options || {};
            let hash = window.location.hash;
            if (typeof theme.settings.newHash !== 'undefined') {
                hash = theme.settings.newHash;
                window.location.hash = `#${hash}`
            }
            const element = document.getElementById(hash.slice(1));
            if (element && options.ignore && element.matches(options.ignore)) {
                return !1
            }
            if (hash && element) {
                this.forceFocus(element, options)
            }
        }
        bindInPageLinks(options) {
            options = options || {};
            const links = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));
            function queryCheck(selector) {
                return document.getElementById(selector) !== null
            }
            return links.filter( (link) => {
                if (link.hash === '#' || link.hash === '') {
                    return !1
                }
                if (options.ignore && link.matches(options.ignore)) {
                    return !1
                }
                if (!queryCheck(link.hash.substr(1))) {
                    return !1
                }
                var element = document.querySelector(link.hash);
                if (!element) {
                    return !1
                }
                link.addEventListener('click', () => {
                    this.forceFocus(element, options)
                }
                );
                return !0
            }
            )
        }
    }
    const getScrollbarWidth = () => {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        document.body.appendChild(outer);
        const inner = document.createElement('div');
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return scrollbarWidth
    }
    ;
    document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);
    document.addEventListener('DOMContentLoaded', function() {
        load('*');
        new Accessibility();
        if (!customElements.get('product-grid-item-swatch') && window.theme.settings.enableColorSwatchesCollection) {
            customElements.define('product-grid-item-swatch', GridSwatch)
        }
        const hasNativeSmoothScroll = 'scrollBehavior'in document.documentElement.style;
        if (!hasNativeSmoothScroll) {
            loadScript({
                url: theme.assets.smoothscroll
            })
        }
        var footerSliders = document.querySelectorAll('.footer-block.footer-block--menu.slider_on_mob .footer-links');
        footerSliders.forEach(function(item) {
            var footerFlkty = new Flickity(item,{
                contain: !0,
                wrapAround: !0,
                pageDots: !0,
                prevNextButtons: !1,
                autoPlay: 3000,
                watchCSS: !0
            })
        })
    });
    class AnchorLink extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            var anchorBlock = document.querySelector(".anchor-for-products");
            if (anchorBlock) {
                var sectionIsVisible = anchorBlock.closest(".shopify-section").offsetWidth > 0 ? true : !1;
                if (sectionIsVisible) {
                    var anchroLink = document.createElement("a");
                    anchroLink.setAttribute("href", "javascript:void(0);");
                    anchroLink.innerHTML = this.getAttribute("data-text");
                    this.appendChild(anchroLink);
                    this.removeAttribute("hidden");
                    anchroLink.addEventListener("click", function() {
                        anchorBlock.scrollIntoView()
                    })
                }
            }
        }
    }
    if (!customElements.get('anchor-link')) {
        customElements.define('anchor-link', AnchorLink)
    }
    var shopAvailabilityShopsEl = document.querySelector('.shop_availability_popup_content_shops');
    if (shopAvailabilityShopsEl != null) {
        var productHandle = shopAvailabilityShopsEl.getAttribute("data-product-handle");
        var productID = shopAvailabilityShopsEl.getAttribute("data-product-id");
        var varinatID = shopAvailabilityShopsEl.getAttribute("data-variant-id");
        async function fetchShopAvailabilityJSON(handle, productID) {
            const response = await fetch('https://rest.locationinventory.info/v1/inventory?shop=roseanna-dev.myshopify.com&handle=' + handle + '&id=' + productID);
            const shopAvailabilityJSON = await response.json();
            return shopAvailabilityJSON
        }
        fetchShopAvailabilityJSON(productHandle, productID).then(shopAvailabilityJSON => {
            shopAvailabilityJSON.variantLocations.forEach(function(i, mainIndex) {
                var div = document.createElement('div');
                div.classList.add("shop-availability-container");
                div.setAttribute("data-variant-id", i.variant);
                if (varinatID != i.variant) {
                    div.setAttribute("hidden", "")
                }
                i.inventoryLocations.forEach(function(j, index) {
                    if (j.location.name.indexOf("Roseanna") != -1) {
                        if (j.quantity > 0) {
                            var stock_text = window.theme.strings.shop_availability_popup_in_stock_text;
                            var stockClass = "available-in-store"
                        } else {
                            var stock_text = window.theme.strings.shop_availability_popup_out_of_stock_text;
                            var stockClass = "unavailable-in-store"
                        }
                        if (j.location.name == 'Roseanna - Galeries Lafayette') {
                            var storeInfo = window.theme.strings.store_info_1
                        } else if (j.location.name == 'Roseanna - Le Bon Marché') {
                            var storeInfo = window.theme.strings.store_info_2
                        } else if (j.location.name == 'Roseanna - Rue Froissart') {
                            var storeInfo = window.theme.strings.store_info_3
                        }
                        div.innerHTML += '<div class="shop-availability-wrapper">' + '<div class="shop-availability-wrapper-content">' + '<h5>' + j.location.name + '</h5>' + '<div class="' + stockClass + ' mobile-only"><span class="availability-dot"></span><span>' + stock_text + '</span></div>' + '<div class="shop-availability-accordion">' + '<button class="product__accordion__title font-body" aria-controls="ProductAccordion--' + j.location.id + '-' + mainIndex + '-' + index + '" data-collapsible-trigger="" aria-expanded="false">' + j.location.address1 + ', ' + j.location.zip + ' ' + j.location.city + ' <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 12 7"><path d="M10.4844 2L6.24173 6.24264L1.99909 2" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 12 7"><path d="M10.4844 2L6.24173 6.24264L1.99909 2" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>' + '<div class="product__accordion__content" id="ProductAccordion--' + j.location.id + '-' + mainIndex + '-' + index + '" data-collapsible-container="" aria-expanded="false">' + '<div class="product__accordion__inner rte" data-collapsible-content="">' + storeInfo + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="' + stockClass + ' desktop-only"><span class="availability-dot"></span><span>' + stock_text + '</span></div>' + '</div>'
                    }
                });
                shopAvailabilityShopsEl.appendChild(div);
                var accordions = new Collapsible(div)
            })
        }
        );
        var shopAvailabilityPopupContent = shopAvailabilityShopsEl.closest(".shop_availability_popup_content");
        if (shopAvailabilityPopupContent) {
            shopAvailabilityPopupContent.querySelectorAll("input[data-single-option-selector]").forEach(function(input) {
                input.addEventListener("change", function(event) {
                    var originalID = input.getAttribute("data-original-id");
                    document.querySelector("#" + originalID).checked = !0;
                    document.querySelector("#" + originalID).dispatchEvent(new Event('change',{
                        'bubbles': !0
                    }));
                    document.querySelector("#" + originalID + "-desktop").checked = !0;
                    document.querySelector("#" + originalID + "-mobile").checked = !0
                })
            })
        }
    }
}
)(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate);
document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('scroll', function() {
        var submitButton = document.querySelector('.product-single__details .product__submit__add[type="submit"]');
        var productStickyForm = document.querySelector('.product-sticky-form');
        if (submitButton != null && productStickyForm != null) {
            var submitButtonPosition = submitButton.getBoundingClientRect().top + submitButton.offsetHeight;
            var scrollPosition = window.scrollY;
            if (submitButtonPosition < 0) {
                productStickyForm.classList.add('show')
            } else {
                productStickyForm.classList.remove('show')
            }
        }
    });
    if (document.querySelector(".template-product")) {
        function getCookieCustom(name) {
            let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : undefined
        }
        function setCookieCustom(name, value, options={}) {
            options = {
                path: '/',
                ...options
            };
            if (options.expires instanceof Date) {
                options.expires = options.expires.toUTCString()
            }
            let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
            for (let optionKey in options) {
                updatedCookie += "; " + optionKey;
                let optionValue = options[optionKey];
                if (optionValue !== !0) {
                    updatedCookie += "=" + optionValue
                }
            }
            document.cookie = updatedCookie
        }
        function deleteCookieCustom(name) {
            setCookieCustom(name, "", {
                'max-age': -1
            })
        }
        var pageviewCountValue = getCookieCustom("pageview_count");
        if (typeof pageviewCountValue == "undefined") {
            let date = new Date(Date.now() + 86400e3);
            setCookieCustom('pageview_count', "1", {
                'expires': date
            })
        } else {
            pageviewCountValue = +pageviewCountValue + 1;
            let date = new Date(Date.now() + 86400e3);
            setCookieCustom('pageview_count', pageviewCountValue.toString(), {
                'expires': date
            })
        }
    }
})